window.MISTER_LATENCY_DATA = {
  "generatedAt": "2026-09-18T05:32:51Z",
  "schemaVersion": 8,
  "sources": {
    "public": {
      "available": true,
      "file": "results/latency_cleaned_export.csv",
      "count": 441
    },
    "sheet": {
      "available": true,
      "count": 461,
      "linkedItems": 337
    },
    "private": {
      "available": false,
      "files": []
    }
  },
  "summary": {
    "totalItems": 176,
    "publishedItems": 176,
    "privateItems": 0,
    "rawCaptureItems": 53,
    "rawCoveragePct": 30.1,
    "linkedItems": 121,
    "bestAverageMs": 0.69,
    "medianAverageMs": 4.984,
    "medianSameFramePct": 70.095,
    "resultTypes": {
      "published": 176
    },
    "connectionKinds": {
      "Wired": 147,
      "Wireless": 29
    },
    "categories": {
      "Arcade Stick": 23,
      "Arcade Stick Encoder": 19,
      "Controller": 101,
      "Controller Adapter": 30,
      "Controller Conversion": 2,
      "Supergun": 1
    },
    "averageTiers": {
      "Bronze": 24,
      "Copper": 11,
      "Diamond": 17,
      "Gold": 42,
      "Platinum": 29,
      "Rust": 3,
      "Silver": 50
    },
    "connectionTags": {
      "Wired": 147,
      "Wireless": 3,
      "Wireless 2.4GHz": 12,
      "Wireless BT": 14
    },
    "outputModes": {
      "DInput": 130,
      "DInput, PS3": 5,
      "DInput, PS4": 1,
      "DInput, Switch": 2,
      "DInput, Wii U": 1,
      "DInput, Xbox One": 1,
      "DInput, XInput": 7,
      "macOS": 1,
      "PS4": 1,
      "Switch": 1,
      "Unknown": 20,
      "XInput": 5,
      "XInput, Switch": 1
    },
    "rankClasses": {
      "Arcade Stick Encoder": 19,
      "Controller Adapter": 30,
      "Controller Conversion": 2,
      "Supergun": 1,
      "Wired Arcade Stick": 21,
      "Wired Controller": 76,
      "Wireless Arcade Stick": 2,
      "Wireless Controller": 25
    },
    "saleStatuses": {
      "Actively sold": 123,
      "Discontinued": 12,
      "Unknown": 41
    },
    "sourceStatuses": {
      "Closed Source": 170,
      "Open Source": 6
    },
    "deviceTypes": {
      "Wired Controller": 76,
      "Wireless Controller": 25,
      "Controller Adapter": 30,
      "Genesis Controller": 4,
      "NES Controller": 2,
      "SNES Controller": 4,
      "N64 Controller": 2,
      "GameCube Controller": 2,
      "Neo Geo Controller": 2,
      "PSX Controller": 1,
      "Wii Classic Controller": 2,
      "Controller Conversion": 2,
      "Wired Arcade Stick": 21,
      "Wireless Arcade Stick": 2,
      "Arcade Stick Encoder": 19,
      "Supergun": 1
    }
  },
  "items": [
    {
      "id": "published-buffalo-ibuffalo-classic",
      "name": "Buffalo - iBuffalo Classic",
      "measurementName": "Buffalo iBuffalo Classic [Wired USB]",
      "deviceNorm": "buffalo ibuffalo classic",
      "make": "Buffalo",
      "model": "iBuffalo Classic",
      "link": "https://amzn.to/2X1pUrV",
      "amazon": "",
      "buyUrl": "https://amzn.to/2X1pUrV",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 1,
      "modeRank": 1,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 0.69,
      "sdMs": 0.1,
      "maxMs": 1.19,
      "minMs": 0.19,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 95.86,
      "observedSameFramePct": 95.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "buffalo - ibuffalo classic buffalo ibuffalo classic buffalo ibuffalo classic wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no diamond 00-01ms (diamond) actively sold closed source mister / pc buy link buffalo ibuffalo classic [wired usb] buffalo - ibuffalo classic buffalo ibuffalo classic [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller diamond controller 4 no published published actively sold closed source buffalo - ibuffalo classic buffalo ibuffalo classic buffalo ibuffalo classic wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no diamond 00-01ms (diamond) actively sold closed source mister / pc buy link buffalo ibuffalo classic [wired usb]",
      "controllerGroupKey": "published|buffalo ibuffalo classic",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-buffalo-ibuffalo-classic",
          "name": "Buffalo - iBuffalo Classic",
          "measurementName": "Buffalo iBuffalo Classic [Wired USB]",
          "averageMs": 0.69,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.86,
          "observedSameFramePct": 95.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 1,
          "modeRank": 1,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2X1pUrV",
          "link": "https://amzn.to/2X1pUrV",
          "amazon": "",
          "joystickId": "",
          "searchText": "buffalo - ibuffalo classic buffalo ibuffalo classic buffalo ibuffalo classic wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no diamond 00-01ms (diamond) actively sold closed source mister / pc buy link buffalo ibuffalo classic [wired usb]"
        }
      ]
    },
    {
      "id": "published-bootsector-retropad32",
      "name": "bootsector - RetroPad32",
      "measurementName": "bootsector RetroPad32 [Wired USB]",
      "deviceNorm": "bootsector retropad32",
      "make": "bootsector",
      "model": "RetroPad32",
      "link": "http://www.brunofreitas.com/node/84",
      "amazon": "",
      "buyUrl": "http://www.brunofreitas.com/node/84",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 2,
      "modeRank": 1,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "5/27/2020",
      "dateAddedSort": "2020-05-27",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 0.711,
      "sdMs": 0.289,
      "maxMs": 1.248,
      "minMs": 0.2,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 95.73,
      "observedSameFramePct": 95.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0810:1001",
      "searchText": "bootsector - retropad32 bootsector retropad32 bootsector retropad32 wired usb wired wired usb dinput wired dinput dinput controller adapter controller adapter published published controller adapter - - - diamond 00-01ms (diamond) actively sold closed source mister / pc 0810:1001 buy link bootsector retropad32 [wired usb] bootsector - retropad32 bootsector retropad32 [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter'] controller adapter diamond controller adapter - - - published published actively sold closed source bootsector - retropad32 bootsector retropad32 bootsector retropad32 wired usb wired wired usb dinput wired dinput dinput controller adapter published published controller adapter - - - diamond 00-01ms (diamond) actively sold closed source mister / pc 0810:1001 buy link bootsector retropad32 [wired usb]",
      "controllerGroupKey": "published|bootsector retropad32",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-bootsector-retropad32",
          "name": "bootsector - RetroPad32",
          "measurementName": "bootsector RetroPad32 [Wired USB]",
          "averageMs": 0.711,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.73,
          "observedSameFramePct": 95.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 2,
          "modeRank": 1,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "http://www.brunofreitas.com/node/84",
          "link": "http://www.brunofreitas.com/node/84",
          "amazon": "",
          "joystickId": "0810:1001",
          "searchText": "bootsector - retropad32 bootsector retropad32 bootsector retropad32 wired usb wired wired usb dinput wired dinput dinput controller adapter published published controller adapter - - - diamond 00-01ms (diamond) actively sold closed source mister / pc 0810:1001 buy link bootsector retropad32 [wired usb]"
        }
      ]
    },
    {
      "id": "published-misteraddons-mistercade",
      "name": "MisterAddons - MiSTercade",
      "measurementName": "MisterAddons MiSTercade [Wired USB]",
      "deviceNorm": "misteraddons mistercade",
      "make": "MisterAddons",
      "model": "MiSTercade",
      "link": "https://misteraddons.com/products/mistercade-v2-kit-mister-fpga-jamma-arcade-kit",
      "amazon": "",
      "buyUrl": "https://misteraddons.com/products/mistercade-v2-kit-mister-fpga-jamma-arcade-kit",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 3,
      "modeRank": 1,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "8/22/2020",
      "dateAddedSort": "2020-08-22",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 0.738,
      "sdMs": 0.289,
      "maxMs": 1.272,
      "minMs": 0.216,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 95.57,
      "observedSameFramePct": 95.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "16d0:10be",
      "searchText": "misteraddons - mistercade misteraddons mistercade misteraddons mistercade wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - - - diamond 00-01ms (diamond) actively sold closed source mister / pc 16d0:10be buy link misteraddons mistercade [wired usb] misteraddons - mistercade misteraddons mistercade [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder diamond arcade stick encoder - - - published published actively sold closed source misteraddons - mistercade misteraddons mistercade misteraddons mistercade wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - diamond 00-01ms (diamond) actively sold closed source mister / pc 16d0:10be buy link misteraddons mistercade [wired usb]",
      "controllerGroupKey": "published|misteraddons mistercade",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-misteraddons-mistercade",
          "name": "MisterAddons - MiSTercade",
          "measurementName": "MisterAddons MiSTercade [Wired USB]",
          "averageMs": 0.738,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.57,
          "observedSameFramePct": 95.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 3,
          "modeRank": 1,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "8/22/2020",
          "dateAddedSort": "2020-08-22",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/mistercade-v2-kit-mister-fpga-jamma-arcade-kit",
          "link": "https://misteraddons.com/products/mistercade-v2-kit-mister-fpga-jamma-arcade-kit",
          "amazon": "",
          "joystickId": "16d0:10be",
          "searchText": "misteraddons - mistercade misteraddons mistercade misteraddons mistercade wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - diamond 00-01ms (diamond) actively sold closed source mister / pc 16d0:10be buy link misteraddons mistercade [wired usb]"
        }
      ]
    },
    {
      "id": "published-gamescare-multi-console-arcade-stick-large",
      "name": "GamesCare - Multi Console Arcade Stick (Large)",
      "measurementName": "GamesCare Multi Console Arcade Stick (Large) [Wired USB]",
      "deviceNorm": "gamescare multi console arcade stick large",
      "make": "GamesCare",
      "model": "Multi Console Arcade Stick (Large)",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 4,
      "modeRank": 2,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "12/16/2021",
      "dateAddedSort": "2021-12-16",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 0.739,
      "sdMs": 0.29,
      "maxMs": 1.25,
      "minMs": 0.22,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 95.57,
      "observedSameFramePct": 95.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "gamescare - multi console arcade stick (large) gamescare multi console arcade stick large gamescare multi console arcade stick (large) wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - - - diamond 00-01ms (diamond) unknown closed source mister / pc 045e:028e gamescare multi console arcade stick (large) [wired usb] gamescare - multi console arcade stick (large) gamescare multi console arcade stick (large) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder diamond arcade stick encoder - - - published published unknown closed source gamescare - multi console arcade stick (large) gamescare multi console arcade stick large gamescare multi console arcade stick (large) wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - diamond 00-01ms (diamond) unknown closed source mister / pc 045e:028e gamescare multi console arcade stick (large) [wired usb]",
      "controllerGroupKey": "published|gamescare multi console arcade stick large",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-gamescare-multi-console-arcade-stick-large",
          "name": "GamesCare - Multi Console Arcade Stick (Large)",
          "measurementName": "GamesCare Multi Console Arcade Stick (Large) [Wired USB]",
          "averageMs": 0.739,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.57,
          "observedSameFramePct": 95.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 4,
          "modeRank": 2,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "12/16/2021",
          "dateAddedSort": "2021-12-16",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "gamescare - multi console arcade stick (large) gamescare multi console arcade stick large gamescare multi console arcade stick (large) wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - diamond 00-01ms (diamond) unknown closed source mister / pc 045e:028e gamescare multi console arcade stick (large) [wired usb]"
        }
      ]
    },
    {
      "id": "published-rp2040-ls-30-rotary-encoder",
      "name": "RP2040 LS-30 rotary encoder",
      "measurementName": "atrac17 + DJHardRich RP2040 LS-30 Rotary Encoder [Wired USB]",
      "deviceNorm": "rp2040 ls 30 rotary encoder",
      "make": "atrac17 + DJHardRich",
      "model": "RP2040 LS-30 Rotary Encoder",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 5,
      "modeRank": 3,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "9/24/2022",
      "dateAddedSort": "2022-09-24",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 0.747,
      "sdMs": 0.422,
      "maxMs": 15.36,
      "minMs": 0.24,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 95.52,
      "observedSameFramePct": 95.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Open Source",
      "isOpenSource": true,
      "sourceUrl": "https://github.com/va7deo/SNK68/tree/main/dev/rp2040",
      "joystickId": "2e8a:000a",
      "searchText": "rp2040 ls-30 rotary encoder rp2040 ls 30 rotary encoder atrac17 + djhardrich rp2040 ls-30 rotary encoder wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - - - diamond 00-01ms (diamond) unknown open source open source https://github.com/va7deo/snk68/tree/main/dev/rp2040 mister / pc 2e8a:000a atrac17 + djhardrich rp2040 ls-30 rotary encoder [wired usb] atrac17 + djhardrich - rp2040 ls-30 rotary encoder atrac17 + djhardrich rp2040 ls-30 rotary encoder [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder diamond arcade stick encoder - - - published published unknown open source open source https://github.com/va7deo/snk68/tree/main/dev/rp2040 atrac17 + djhardrich - rp2040 ls-30 rotary encoder atrac17 djhardrich rp2040 ls 30 rotary encoder atrac17 + djhardrich rp2040 ls-30 rotary encoder wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - diamond 00-01ms (diamond) unknown open source open source https://github.com/va7deo/snk68/tree/main/dev/rp2040 mister / pc 2e8a:000a atrac17 + djhardrich rp2040 ls-30 rotary encoder [wired usb]",
      "controllerGroupKey": "published|rp2040 ls 30 rotary encoder",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-atrac17-djhardrich-rp2040-ls-30-rotary-encoder",
          "name": "atrac17 + DJHardRich - RP2040 LS-30 Rotary Encoder",
          "measurementName": "atrac17 + DJHardRich RP2040 LS-30 Rotary Encoder [Wired USB]",
          "averageMs": 0.747,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.52,
          "observedSameFramePct": 95.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 5,
          "modeRank": 3,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "9/24/2022",
          "dateAddedSort": "2022-09-24",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "https://github.com/va7deo/SNK68/tree/main/dev/rp2040",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "2e8a:000a",
          "searchText": "atrac17 + djhardrich - rp2040 ls-30 rotary encoder atrac17 djhardrich rp2040 ls 30 rotary encoder atrac17 + djhardrich rp2040 ls-30 rotary encoder wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - diamond 00-01ms (diamond) unknown open source open source https://github.com/va7deo/snk68/tree/main/dev/rp2040 mister / pc 2e8a:000a atrac17 + djhardrich rp2040 ls-30 rotary encoder [wired usb]"
        }
      ]
    },
    {
      "id": "published-daemonbite-controller-adapter",
      "name": "DaemonBite - Controller Adapter",
      "measurementName": "DaemonBite Genesis to USB Adapter [Genesis 3 Button]",
      "deviceNorm": "daemonbite controller adapter",
      "make": "DaemonBite",
      "model": "Genesis to USB Adapter",
      "link": "https://www.daemonbite.com/product/sega-genesis-mega-drive-controller-to-usb-adapter/",
      "amazon": "",
      "buyUrl": "https://www.daemonbite.com/product/sega-genesis-mega-drive-controller-to-usb-adapter/",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Genesis 3 Button",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 6,
      "modeRank": 2,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "Genesis Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 0.75,
      "sdMs": 0.29,
      "maxMs": 1.28,
      "minMs": 0.24,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 95.5,
      "observedSameFramePct": 95.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Discontinued",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "2341:8036",
      "searchText": "daemonbite - controller adapter daemonbite controller adapter daemonbite genesis to usb adapter wired usb wired genesis 3 button dinput wired dinput dinput controller adapter genesis controller controller adapter published published controller adapter - no - diamond 00-01ms (diamond) discontinued closed source mister / pc 2341:8036 buy link daemonbite genesis to usb adapter [genesis 3 button] daemonbite - genesis to usb adapter daemonbite genesis to usb adapter [genesis 3 button] wired usb wired wired genesis 3 button dinput dinput dinput ['controller adapter', 'genesis controller'] controller adapter diamond controller adapter - no - published published discontinued closed source daemonbite - genesis to usb adapter daemonbite genesis to usb adapter daemonbite genesis to usb adapter wired usb wired genesis 3 button dinput wired dinput dinput controller adapter genesis controller published published controller adapter - no - diamond 00-01ms (diamond) discontinued closed source mister / pc 2341:8036 buy link daemonbite genesis to usb adapter [genesis 3 button] daemonbite - pc engine to usb adapter daemonbite pc engine to usb adapter [nec pi-pd6 2 button] wired usb wired wired nec pi-pd6 2 button dinput dinput dinput ['controller adapter', 'pc engine controller'] controller adapter diamond controller adapter - no - published published discontinued closed source daemonbite - pc engine to usb adapter daemonbite pc engine to usb adapter daemonbite pc engine to usb adapter wired usb wired nec pi-pd6 2 button dinput wired dinput dinput controller adapter pc engine controller published published controller adapter - no - diamond 00-01ms (diamond) discontinued closed source mister / pc 2474:56:00 daemonbite pc engine to usb adapter [nec pi-pd6 2 button] daemonbite - dual genesis to usb adapter daemonbite dual genesis to usb adapter [genesis 3 button] wired usb wired wired genesis 3 button dinput dinput dinput ['controller adapter', 'genesis controller'] controller adapter diamond controller adapter - no - published published discontinued closed source daemonbite - dual genesis to usb adapter daemonbite dual genesis to usb adapter daemonbite dual genesis to usb adapter wired usb wired genesis 3 button dinput wired dinput dinput controller adapter genesis controller published published controller adapter - no - diamond 00-01ms (diamond) discontinued closed source mister / pc 2341:8036 buy link daemonbite dual genesis to usb adapter [genesis 3 button] daemonbite - saturn to usb adapter daemonbite saturn to usb adapter [saturn japanese (171-6830b)] wired usb wired wired saturn japanese (171-6830b) dinput dinput dinput ['controller adapter', 'saturn controller'] controller adapter diamond controller adapter - no - published published discontinued closed source daemonbite - saturn to usb adapter daemonbite saturn to usb adapter daemonbite saturn to usb adapter wired usb wired saturn japanese (171-6830b) dinput wired dinput dinput controller adapter saturn controller published published controller adapter - no - diamond 00-01ms (diamond) discontinued closed source mister / pc 2341:8036 daemonbite saturn to usb adapter [saturn japanese (171-6830b)] daemonbite - snes / sfc to usb adapter daemonbite snes / sfc to usb adapter [snes] wired usb wired wired snes dinput dinput dinput ['controller adapter', 'snes controller'] controller adapter platinum controller adapter - no - published published discontinued closed source daemonbite - snes / sfc to usb adapter daemonbite snes sfc to usb adapter daemonbite snes / sfc to usb adapter wired usb wired snes dinput wired dinput dinput controller adapter snes controller published published controller adapter - no - platinum 01-05ms (platinum) discontinued closed source mister / pc 2341:8036 buy link daemonbite snes / sfc to usb adapter [snes] daemonbite - dual genesis to usb adapter daemonbite dual genesis to usb adapter [genesis 6 button] wired usb wired wired genesis 6 button dinput dinput dinput ['controller adapter', 'genesis controller'] controller adapter platinum controller adapter - no - published published discontinued closed source daemonbite - dual genesis to usb adapter daemonbite dual genesis to usb adapter daemonbite dual genesis to usb adapter wired usb wired genesis 6 button dinput wired dinput dinput controller adapter genesis controller published published controller adapter - no - platinum 01-05ms (platinum) discontinued closed source mister / pc 2341:8036 buy link daemonbite dual genesis to usb adapter [genesis 6 button]",
      "controllerGroupKey": "|daemonbite controller adapter",
      "modeVariantCount": 6,
      "modeVariants": [
        {
          "id": "published-daemonbite-genesis-to-usb-adapter",
          "name": "DaemonBite - Genesis to USB Adapter",
          "measurementName": "DaemonBite Genesis to USB Adapter [Genesis 3 Button]",
          "averageMs": 0.75,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.5,
          "observedSameFramePct": 95.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Genesis 3 Button",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Genesis Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 6,
          "modeRank": 2,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.daemonbite.com/product/sega-genesis-mega-drive-controller-to-usb-adapter/",
          "link": "https://www.daemonbite.com/product/sega-genesis-mega-drive-controller-to-usb-adapter/",
          "amazon": "",
          "joystickId": "2341:8036",
          "searchText": "daemonbite - genesis to usb adapter daemonbite genesis to usb adapter daemonbite genesis to usb adapter wired usb wired genesis 3 button dinput wired dinput dinput controller adapter genesis controller published published controller adapter - no - diamond 00-01ms (diamond) discontinued closed source mister / pc 2341:8036 buy link daemonbite genesis to usb adapter [genesis 3 button]"
        },
        {
          "id": "published-daemonbite-pc-engine-to-usb-adapter",
          "name": "DaemonBite - PC Engine to USB Adapter",
          "measurementName": "DaemonBite PC Engine to USB Adapter [NEC PI-PD6 2 Button]",
          "averageMs": 0.781,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.31,
          "observedSameFramePct": 95.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "NEC PI-PD6 2 Button",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "PC Engine Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 11,
          "modeRank": 5,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "7/2/2020",
          "dateAddedSort": "2020-07-02",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "2474:56:00",
          "searchText": "daemonbite - pc engine to usb adapter daemonbite pc engine to usb adapter daemonbite pc engine to usb adapter wired usb wired nec pi-pd6 2 button dinput wired dinput dinput controller adapter pc engine controller published published controller adapter - no - diamond 00-01ms (diamond) discontinued closed source mister / pc 2474:56:00 daemonbite pc engine to usb adapter [nec pi-pd6 2 button]"
        },
        {
          "id": "published-daemonbite-dual-genesis-to-usb-adapter",
          "name": "DaemonBite - Dual Genesis to USB Adapter",
          "measurementName": "DaemonBite Dual Genesis to USB Adapter [Genesis 3 Button]",
          "averageMs": 0.783,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.3,
          "observedSameFramePct": 95.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Genesis 3 Button",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Genesis Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 12,
          "modeRank": 6,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "6/2/2020",
          "dateAddedSort": "2020-06-02",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.daemonbite.com/product/sega-genesis-mega-drive-controller-to-usb-adapter/",
          "link": "https://www.daemonbite.com/product/sega-genesis-mega-drive-controller-to-usb-adapter/",
          "amazon": "",
          "joystickId": "2341:8036",
          "searchText": "daemonbite - dual genesis to usb adapter daemonbite dual genesis to usb adapter daemonbite dual genesis to usb adapter wired usb wired genesis 3 button dinput wired dinput dinput controller adapter genesis controller published published controller adapter - no - diamond 00-01ms (diamond) discontinued closed source mister / pc 2341:8036 buy link daemonbite dual genesis to usb adapter [genesis 3 button]"
        },
        {
          "id": "published-daemonbite-saturn-to-usb-adapter",
          "name": "DaemonBite - Saturn to USB Adapter",
          "measurementName": "DaemonBite Saturn to USB Adapter [Saturn Japanese (171-6830B)]",
          "averageMs": 0.799,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.21,
          "observedSameFramePct": 95.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Saturn Japanese (171-6830B)",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Saturn Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 14,
          "modeRank": 8,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "6/2/2020",
          "dateAddedSort": "2020-06-02",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "2341:8036",
          "searchText": "daemonbite - saturn to usb adapter daemonbite saturn to usb adapter daemonbite saturn to usb adapter wired usb wired saturn japanese (171-6830b) dinput wired dinput dinput controller adapter saturn controller published published controller adapter - no - diamond 00-01ms (diamond) discontinued closed source mister / pc 2341:8036 daemonbite saturn to usb adapter [saturn japanese (171-6830b)]"
        },
        {
          "id": "published-daemonbite-snes-sfc-to-usb-adapter",
          "name": "DaemonBite - SNES / SFC to USB Adapter",
          "measurementName": "DaemonBite SNES / SFC to USB Adapter [SNES]",
          "averageMs": 1.111,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 93.33,
          "observedSameFramePct": 93.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "SNES",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "SNES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 53,
          "modeRank": 23,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "6/2/2020",
          "dateAddedSort": "2020-06-02",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.daemonbite.com/product/snes-controller-to-usb-adapter/",
          "link": "https://www.daemonbite.com/product/snes-controller-to-usb-adapter/",
          "amazon": "",
          "joystickId": "2341:8036",
          "searchText": "daemonbite - snes / sfc to usb adapter daemonbite snes sfc to usb adapter daemonbite snes / sfc to usb adapter wired usb wired snes dinput wired dinput dinput controller adapter snes controller published published controller adapter - no - platinum 01-05ms (platinum) discontinued closed source mister / pc 2341:8036 buy link daemonbite snes / sfc to usb adapter [snes]"
        },
        {
          "id": "published-daemonbite-dual-genesis-to-usb-adapter-2",
          "name": "DaemonBite - Dual Genesis to USB Adapter",
          "measurementName": "DaemonBite Dual Genesis to USB Adapter [Genesis 6 Button]",
          "averageMs": 1.604,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 90.38,
          "observedSameFramePct": 90.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Genesis 6 Button",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Genesis Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 73,
          "modeRank": 32,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "6/2/2020",
          "dateAddedSort": "2020-06-02",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.daemonbite.com/product/sega-genesis-mega-drive-controller-to-usb-adapter/",
          "link": "https://www.daemonbite.com/product/sega-genesis-mega-drive-controller-to-usb-adapter/",
          "amazon": "",
          "joystickId": "2341:8036",
          "searchText": "daemonbite - dual genesis to usb adapter daemonbite dual genesis to usb adapter daemonbite dual genesis to usb adapter wired usb wired genesis 6 button dinput wired dinput dinput controller adapter genesis controller published published controller adapter - no - platinum 01-05ms (platinum) discontinued closed source mister / pc 2341:8036 buy link daemonbite dual genesis to usb adapter [genesis 6 button]"
        }
      ]
    },
    {
      "id": "published-daemonbite-arcade-controller",
      "name": "DaemonBite - Arcade Controller",
      "measurementName": "DaemonBite Arcade Controller [Wired USB]",
      "deviceNorm": "daemonbite arcade controller",
      "make": "DaemonBite",
      "model": "Arcade Controller",
      "link": "https://github.com/MickGyver/DaemonBite-Arcade-Encoder",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 7,
      "modeRank": 4,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "5/30/2020",
      "dateAddedSort": "2020-05-30",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 0.758,
      "sdMs": 0.289,
      "maxMs": 1.264,
      "minMs": 0.236,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 95.45,
      "observedSameFramePct": 95.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Discontinued",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "https://github.com/MickGyver/DaemonBite-Arcade-Encoder",
      "joystickId": "2341:8036",
      "searchText": "daemonbite - arcade controller daemonbite arcade controller daemonbite arcade controller wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - - - diamond 00-01ms (diamond) discontinued closed source https://github.com/mickgyver/daemonbite-arcade-encoder mister / pc 2341:8036 daemonbite arcade controller [wired usb] daemonbite - arcade controller daemonbite arcade controller [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder diamond arcade stick encoder - - - published published discontinued closed source https://github.com/mickgyver/daemonbite-arcade-encoder daemonbite - arcade controller daemonbite arcade controller daemonbite arcade controller wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - diamond 00-01ms (diamond) discontinued closed source https://github.com/mickgyver/daemonbite-arcade-encoder mister / pc 2341:8036 daemonbite arcade controller [wired usb]",
      "controllerGroupKey": "published|daemonbite arcade controller",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-daemonbite-arcade-controller",
          "name": "DaemonBite - Arcade Controller",
          "measurementName": "DaemonBite Arcade Controller [Wired USB]",
          "averageMs": 0.758,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.45,
          "observedSameFramePct": 95.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 7,
          "modeRank": 4,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "5/30/2020",
          "dateAddedSort": "2020-05-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "https://github.com/MickGyver/DaemonBite-Arcade-Encoder",
          "buyUrl": "",
          "link": "https://github.com/MickGyver/DaemonBite-Arcade-Encoder",
          "amazon": "",
          "joystickId": "2341:8036",
          "searchText": "daemonbite - arcade controller daemonbite arcade controller daemonbite arcade controller wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - diamond 00-01ms (diamond) discontinued closed source https://github.com/mickgyver/daemonbite-arcade-encoder mister / pc 2341:8036 daemonbite arcade controller [wired usb]"
        }
      ]
    },
    {
      "id": "published-reflex-adapt-classic2usb",
      "name": "Reflex - Adapt Classic2USB",
      "measurementName": "Reflex Adapt Classic2USB [Neo-Geo]",
      "deviceNorm": "reflex adapt classic2usb",
      "make": "Reflex",
      "model": "Adapt Classic2USB",
      "link": "https://misteraddons.com/products/reflex-adapt",
      "amazon": "",
      "buyUrl": "https://misteraddons.com/products/reflex-adapt",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Neo Geo",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 8,
      "modeRank": 3,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "7/18/2026",
      "dateAddedSort": "2026-07-18",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "Neo Geo Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "Platinum",
      "averageMs": 0.766,
      "sdMs": 0.286,
      "maxMs": 1.44,
      "minMs": 0.24,
      "p99Ms": 1.27,
      "sampleCount": 2000,
      "sameFramePct": 95.4,
      "observedSameFramePct": 95.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Open Source",
      "isOpenSource": true,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired neo geo dinput wired dinput dinput controller adapter neo geo controller controller adapter published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [neo-geo] reflex - adapt classic2usb reflex adapt classic2usb [neo-geo] wired usb wired wired neo geo dinput dinput dinput ['controller adapter', 'neo geo controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired neo geo dinput wired dinput dinput controller adapter neo geo controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [neo-geo] reflex - adapt classic2usb reflex adapt classic2usb [sms] wired usb wired wired sms 1p dinput dinput dinput ['controller adapter', 'sms controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired sms 1p dinput wired dinput dinput controller adapter sms controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [sms] reflex - adapt classic2usb reflex adapt classic2usb [nes] wired usb wired wired nes 1p dinput dinput dinput ['controller adapter', 'nes controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired nes 1p dinput wired dinput dinput controller adapter nes controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [nes] reflex - adapt classic2usb reflex adapt classic2usb [saturn] wired usb wired wired saturn 1p dinput dinput dinput ['controller adapter', 'saturn controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired saturn 1p dinput wired dinput dinput controller adapter saturn controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [saturn] reflex - adapt classic2usb reflex adapt classic2usb [snes] wired usb wired wired snes 1p dinput dinput dinput ['controller adapter', 'snes controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired snes 1p dinput wired dinput dinput controller adapter snes controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [snes] reflex - adapt classic2usb reflex adapt classic2usb [genesis] wired usb wired wired genesis 1p dinput dinput dinput ['controller adapter', 'genesis controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired genesis 1p dinput wired dinput dinput controller adapter genesis controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [genesis] reflex - adapt classic2usb reflex adapt classic2usb [pc engine] wired usb wired wired pce 1p dinput dinput dinput ['controller adapter', 'pc engine controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired pce 1p dinput wired dinput dinput controller adapter pc engine controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [pc engine] reflex - adapt classic2usb reflex adapt classic2usb [virtual boy] wired usb wired wired virtual boy 1p dinput dinput dinput ['controller adapter', 'virtual boy controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired virtual boy 1p dinput wired dinput dinput controller adapter virtual boy controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [virtual boy] reflex - adapt classic2usb reflex adapt classic2usb [jaguar] wired usb wired wired jaguar dinput dinput dinput ['controller adapter', 'jaguar controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired jaguar dinput wired dinput dinput controller adapter jaguar controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [jaguar] reflex - adapt classic2usb reflex adapt classic2usb [wii classic] wired usb wired wired wii classic 1p dinput dinput dinput ['controller adapter', 'wii classic controller'] controller adapter platinum platinum controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired wii classic 1p dinput wired dinput dinput controller adapter wii classic controller published published controller adapter platinum platinum 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [wii classic] reflex - adapt classic2usb reflex adapt classic2usb [n64] wired usb wired wired n64 1p dinput dinput dinput ['controller adapter', 'n64 controller'] controller adapter platinum gold controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired n64 1p dinput wired dinput dinput controller adapter n64 controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [n64] reflex - adapt classic2usb reflex adapt classic2usb [gamecube] wired usb wired wired gamecube 1p dinput dinput dinput ['controller adapter', 'gamecube controller'] controller adapter platinum gold controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired gamecube 1p dinput wired dinput dinput controller adapter gamecube controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [gamecube] reflex - adapt classic2usb reflex adapt classic2usb [psx] wired usb wired wired psx 1p digital dinput dinput dinput ['controller adapter', 'psx controller'] controller adapter platinum gold controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired psx 1p digital dinput wired dinput dinput controller adapter psx controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [psx] reflex - adapt classic2usb reflex adapt classic2usb [dreamcast] wired usb wired wired dreamcast 1p dinput dinput dinput ['controller adapter', 'dreamcast controller'] controller adapter gold gold controller adapter published published actively sold open source open source reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired dreamcast 1p dinput wired dinput dinput controller adapter dreamcast controller published published controller adapter gold gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [dreamcast]",
      "controllerGroupKey": "|reflex adapt classic2usb",
      "modeVariantCount": 14,
      "modeVariants": [
        {
          "id": "published-reflex-adapt-classic2usb",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [Neo-Geo]",
          "averageMs": 0.766,
          "averageTier": "Diamond",
          "p99Ms": 1.27,
          "p99Tier": "Platinum",
          "sameFramePct": 95.4,
          "observedSameFramePct": 95.4,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Neo Geo",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Neo Geo Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 8,
          "modeRank": 3,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired neo geo dinput wired dinput dinput controller adapter neo geo controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [neo-geo]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-2",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [SMS]",
          "averageMs": 0.815,
          "averageTier": "Diamond",
          "p99Ms": 1.32,
          "p99Tier": "Platinum",
          "sameFramePct": 95.11,
          "observedSameFramePct": 95.1,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "SMS 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "SMS Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 16,
          "modeRank": 9,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired sms 1p dinput wired dinput dinput controller adapter sms controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [sms]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-3",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [NES]",
          "averageMs": 0.883,
          "averageTier": "Diamond",
          "p99Ms": 1.52,
          "p99Tier": "Platinum",
          "sameFramePct": 94.7,
          "observedSameFramePct": 94.7,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "NES 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "NES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 32,
          "modeRank": 12,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired nes 1p dinput wired dinput dinput controller adapter nes controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [nes]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-4",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [Saturn]",
          "averageMs": 0.886,
          "averageTier": "Diamond",
          "p99Ms": 1.6,
          "p99Tier": "Platinum",
          "sameFramePct": 94.68,
          "observedSameFramePct": 94.7,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Saturn 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Saturn Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 33,
          "modeRank": 13,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired saturn 1p dinput wired dinput dinput controller adapter saturn controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [saturn]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-5",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [SNES]",
          "averageMs": 0.89,
          "averageTier": "Diamond",
          "p99Ms": 1.59,
          "p99Tier": "Platinum",
          "sameFramePct": 94.66,
          "observedSameFramePct": 94.7,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "SNES 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "SNES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 34,
          "modeRank": 14,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired snes 1p dinput wired dinput dinput controller adapter snes controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [snes]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-6",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [Genesis]",
          "averageMs": 0.899,
          "averageTier": "Diamond",
          "p99Ms": 1.58,
          "p99Tier": "Platinum",
          "sameFramePct": 94.61,
          "observedSameFramePct": 94.6,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Genesis 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Genesis Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 36,
          "modeRank": 16,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired genesis 1p dinput wired dinput dinput controller adapter genesis controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [genesis]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-7",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [PC Engine]",
          "averageMs": 0.916,
          "averageTier": "Diamond",
          "p99Ms": 1.52,
          "p99Tier": "Platinum",
          "sameFramePct": 94.5,
          "observedSameFramePct": 94.5,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "PCE 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "PC Engine Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 37,
          "modeRank": 17,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired pce 1p dinput wired dinput dinput controller adapter pc engine controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [pc engine]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-8",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [Virtual Boy]",
          "averageMs": 0.917,
          "averageTier": "Diamond",
          "p99Ms": 1.55,
          "p99Tier": "Platinum",
          "sameFramePct": 94.5,
          "observedSameFramePct": 94.5,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Virtual Boy 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Virtual Boy Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 38,
          "modeRank": 18,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired virtual boy 1p dinput wired dinput dinput controller adapter virtual boy controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [virtual boy]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-9",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [Jaguar]",
          "averageMs": 0.949,
          "averageTier": "Diamond",
          "p99Ms": 1.46,
          "p99Tier": "Platinum",
          "sameFramePct": 94.31,
          "observedSameFramePct": 94.3,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Jaguar",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Jaguar Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 40,
          "modeRank": 20,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired jaguar dinput wired dinput dinput controller adapter jaguar controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [jaguar]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-10",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [Wii Classic]",
          "averageMs": 1.176,
          "averageTier": "Platinum",
          "p99Ms": 1.92,
          "p99Tier": "Platinum",
          "sameFramePct": 92.94,
          "observedSameFramePct": 92.9,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wii Classic 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Wii Classic Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 54,
          "modeRank": 24,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired wii classic 1p dinput wired dinput dinput controller adapter wii classic controller published published controller adapter platinum platinum 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [wii classic]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-11",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [N64]",
          "averageMs": 1.427,
          "averageTier": "Platinum",
          "p99Ms": 2.41,
          "p99Tier": "Gold",
          "sameFramePct": 91.44,
          "observedSameFramePct": 91.4,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "N64 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "N64 Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 66,
          "modeRank": 27,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired n64 1p dinput wired dinput dinput controller adapter n64 controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [n64]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-12",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [GameCube]",
          "averageMs": 1.604,
          "averageTier": "Platinum",
          "p99Ms": 2.42,
          "p99Tier": "Gold",
          "sameFramePct": 90.38,
          "observedSameFramePct": 90.4,
          "sampleCount": 500,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "GameCube 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "GameCube Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 74,
          "modeRank": 33,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired gamecube 1p dinput wired dinput dinput controller adapter gamecube controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [gamecube]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-13",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [PSX]",
          "averageMs": 1.625,
          "averageTier": "Platinum",
          "p99Ms": 2.42,
          "p99Tier": "Gold",
          "sameFramePct": 90.25,
          "observedSameFramePct": 90.3,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "PSX 1P Digital",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "PSX Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 75,
          "modeRank": 34,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired psx 1p digital dinput wired dinput dinput controller adapter psx controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [psx]"
        },
        {
          "id": "published-reflex-adapt-classic2usb-14",
          "name": "Reflex - Adapt Classic2USB",
          "measurementName": "Reflex Adapt Classic2USB [Dreamcast]",
          "averageMs": 2.978,
          "averageTier": "Gold",
          "p99Ms": 4.62,
          "p99Tier": "Gold",
          "sameFramePct": 82.13,
          "observedSameFramePct": 82.1,
          "sampleCount": 2000,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Dreamcast 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Dreamcast Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 109,
          "modeRank": 47,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2026",
          "dateAddedSort": "2026-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt classic2usb reflex adapt classic2usb reflex adapt classic2usb wired usb wired dreamcast 1p dinput wired dinput dinput controller adapter dreamcast controller published published controller adapter gold gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex adapt classic2usb [dreamcast]"
        }
      ]
    },
    {
      "id": "published-brook-universal-fighting-board",
      "name": "Brook - Universal Fighting Board",
      "measurementName": "Brook Universal Fighting Board [Wired USB Wii U]",
      "deviceNorm": "brook universal fighting board",
      "make": "Brook",
      "model": "Universal Fighting Board",
      "link": "https://amzn.to/3tJGR9Z",
      "amazon": "",
      "buyUrl": "https://amzn.to/3tJGR9Z",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Wii U",
      "outputMode": "DInput, Wii U",
      "connectionTag": "Wired",
      "modeLabel": "DInput, Wii U",
      "modeDisplay": "DInput, Wii U",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 9,
      "modeRank": 5,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "9/12/2020",
      "dateAddedSort": "2020-09-12",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 0.767,
      "sdMs": 0.297,
      "maxMs": 2.196,
      "minMs": 0.236,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 95.4,
      "observedSameFramePct": 95.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0F0D:0092",
      "searchText": "brook - universal fighting board brook universal fighting board brook universal fighting board wired usb wired wired usb wii u dinput, wii u wired dinput, wii u dinput, wii u arcade stick encoder arcade stick encoder published published arcade stick encoder - - diamond 00-01ms (diamond) actively sold closed source mister / pc 0f0d:0092 buy link brook universal fighting board [wired usb wii u] brook - universal fighting board brook universal fighting board [wired usb wii u] wired usb wired wired wired usb wii u dinput, wii u dinput, wii u dinput, wii u ['arcade stick encoder'] arcade stick encoder diamond arcade stick encoder - - published published actively sold closed source brook - universal fighting board brook universal fighting board brook universal fighting board wired usb wired wired usb wii u dinput, wii u wired dinput, wii u dinput, wii u arcade stick encoder published published arcade stick encoder - - diamond 00-01ms (diamond) actively sold closed source mister / pc 0f0d:0092 buy link brook universal fighting board [wired usb wii u] brook - universal fighting board brook universal fighting board [wired usb ps3] wired usb wired wired wired usb ps3 dinput, ps3 dinput, ps3 dinput, ps3 ['arcade stick encoder'] arcade stick encoder diamond arcade stick encoder - - published published actively sold closed source brook - universal fighting board brook universal fighting board brook universal fighting board wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 arcade stick encoder published published arcade stick encoder - - diamond 00-01ms (diamond) actively sold closed source mister / pc 0f0d:0022 buy link brook universal fighting board [wired usb ps3] brook - universal fighting board brook universal fighting board [wired usb ps4] wired usb wired wired wired usb ps4 dinput, ps4 dinput, ps4 dinput, ps4 ['arcade stick encoder'] arcade stick encoder diamond arcade stick encoder - - published published actively sold closed source brook - universal fighting board brook universal fighting board brook universal fighting board wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 arcade stick encoder published published arcade stick encoder - - diamond 00-01ms (diamond) actively sold closed source mister / pc ps4 0c12:0c30 buy link brook universal fighting board [wired usb ps4] brook - universal fighting board brook universal fighting board [wired usb xbox 360] wired usb wired wired wired usb xbox 360 dinput, xbox 360 dinput, xbox 360 dinput, xbox 360 ['arcade stick encoder'] arcade stick encoder diamond arcade stick encoder - - published published actively sold closed source brook - universal fighting board brook universal fighting board brook universal fighting board wired usb wired wired usb xbox 360 dinput, xbox 360 wired dinput, xbox 360 dinput, xbox 360 arcade stick encoder published published arcade stick encoder - - diamond 00-01ms (diamond) actively sold closed source mister / pc 045e:028e buy link brook universal fighting board [wired usb xbox 360]",
      "controllerGroupKey": "published|brook universal fighting board",
      "modeVariantCount": 4,
      "modeVariants": [
        {
          "id": "published-brook-universal-fighting-board",
          "name": "Brook - Universal Fighting Board",
          "measurementName": "Brook Universal Fighting Board [Wired USB Wii U]",
          "averageMs": 0.767,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.4,
          "observedSameFramePct": 95.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Wii U",
          "outputMode": "DInput, Wii U",
          "modeLabel": "DInput, Wii U",
          "modeDisplay": "DInput, Wii U",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 9,
          "modeRank": 5,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "",
          "dateAdded": "9/12/2020",
          "dateAddedSort": "2020-09-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3tJGR9Z",
          "link": "https://amzn.to/3tJGR9Z",
          "amazon": "",
          "joystickId": "0F0D:0092",
          "searchText": "brook - universal fighting board brook universal fighting board brook universal fighting board wired usb wired wired usb wii u dinput, wii u wired dinput, wii u dinput, wii u arcade stick encoder published published arcade stick encoder - - diamond 00-01ms (diamond) actively sold closed source mister / pc 0f0d:0092 buy link brook universal fighting board [wired usb wii u]"
        },
        {
          "id": "published-brook-universal-fighting-board-2",
          "name": "Brook - Universal Fighting Board",
          "measurementName": "Brook Universal Fighting Board [Wired USB PS3]",
          "averageMs": 0.813,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.12,
          "observedSameFramePct": 95.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PS3",
          "outputMode": "DInput, PS3",
          "modeLabel": "DInput, PS3",
          "modeDisplay": "DInput, PS3",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 15,
          "modeRank": 6,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "",
          "dateAdded": "9/12/2020",
          "dateAddedSort": "2020-09-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3tJGR9Z",
          "link": "https://amzn.to/3tJGR9Z",
          "amazon": "",
          "joystickId": "0F0D:0022",
          "searchText": "brook - universal fighting board brook universal fighting board brook universal fighting board wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 arcade stick encoder published published arcade stick encoder - - diamond 00-01ms (diamond) actively sold closed source mister / pc 0f0d:0022 buy link brook universal fighting board [wired usb ps3]"
        },
        {
          "id": "published-brook-universal-fighting-board-3",
          "name": "Brook - Universal Fighting Board",
          "measurementName": "Brook Universal Fighting Board [Wired USB PS4]",
          "averageMs": 0.818,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.09,
          "observedSameFramePct": 95.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PS4",
          "outputMode": "DInput, PS4",
          "modeLabel": "DInput, PS4",
          "modeDisplay": "DInput, PS4",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 18,
          "modeRank": 7,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "",
          "dateAdded": "9/12/2020",
          "dateAddedSort": "2020-09-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3tJGR9Z",
          "link": "https://amzn.to/3tJGR9Z",
          "amazon": "",
          "joystickId": "0c12:0c30",
          "searchText": "brook - universal fighting board brook universal fighting board brook universal fighting board wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 arcade stick encoder published published arcade stick encoder - - diamond 00-01ms (diamond) actively sold closed source mister / pc ps4 0c12:0c30 buy link brook universal fighting board [wired usb ps4]"
        },
        {
          "id": "published-brook-universal-fighting-board-4",
          "name": "Brook - Universal Fighting Board",
          "measurementName": "Brook Universal Fighting Board [Wired USB Xbox 360]",
          "averageMs": 0.857,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 94.86,
          "observedSameFramePct": 94.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Xbox 360",
          "outputMode": "DInput, Xbox 360",
          "modeLabel": "DInput, Xbox 360",
          "modeDisplay": "DInput, Xbox 360",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 29,
          "modeRank": 10,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "",
          "dateAdded": "9/12/2020",
          "dateAddedSort": "2020-09-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3tJGR9Z",
          "link": "https://amzn.to/3tJGR9Z",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "brook - universal fighting board brook universal fighting board brook universal fighting board wired usb wired wired usb xbox 360 dinput, xbox 360 wired dinput, xbox 360 dinput, xbox 360 arcade stick encoder published published arcade stick encoder - - diamond 00-01ms (diamond) actively sold closed source mister / pc 045e:028e buy link brook universal fighting board [wired usb xbox 360]"
        }
      ]
    },
    {
      "id": "published-reflex-adapt",
      "name": "Reflex - Adapt",
      "measurementName": "Reflex - Adapt [Neo Geo]",
      "deviceNorm": "reflex adapt",
      "make": "Reflex",
      "model": "Adapt",
      "link": "https://misteraddons.com/products/reflex-adapt",
      "amazon": "",
      "buyUrl": "https://misteraddons.com/products/reflex-adapt",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Neo Geo",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 10,
      "modeRank": 4,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "9/1/2023",
      "dateAddedSort": "2023-09-01",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "Neo Geo Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "Platinum",
      "averageMs": 0.77,
      "sdMs": 0.302,
      "maxMs": 5.32,
      "minMs": 0.25,
      "p99Ms": 1.26,
      "sampleCount": 2128,
      "sameFramePct": 95.38,
      "observedSameFramePct": 95.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Open Source",
      "isOpenSource": true,
      "sourceUrl": "",
      "joystickId": "16D0:127E:ReflexNeoGeo",
      "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired neo geo dinput wired dinput dinput controller adapter neo geo controller controller adapter published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc 16d0:127e:reflexneogeo raw capture buy link reflex - adapt [neo geo] reflex - adapt reflex - adapt [neo geo] wired usb wired wired neo geo dinput dinput dinput ['controller adapter', 'neo geo controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired neo geo dinput wired dinput dinput controller adapter neo geo controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - adapt [neo geo] reflex - adapt reflex - adapt [sms 1p] wired usb wired wired sms 1p dinput dinput dinput ['controller adapter', 'sms controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired sms 1p dinput wired dinput dinput controller adapter sms controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - adapt [sms 1p] reflex - adapt reflex - adapt [pce 1p] wired usb wired wired pce 1p dinput dinput dinput ['controller adapter', 'pc engine controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired pce 1p dinput wired dinput dinput controller adapter pc engine controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - adapt [pce 1p] reflex - adapt reflex - adapt [saturn 1p] wired usb wired wired saturn 1p dinput dinput dinput ['controller adapter', 'saturn controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired saturn 1p dinput wired dinput dinput controller adapter saturn controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - adapt [saturn 1p] reflex - adapt reflex - adapt [genesis 1p] wired usb wired wired genesis 1p dinput dinput dinput ['controller adapter', 'genesis controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired genesis 1p dinput wired dinput dinput controller adapter genesis controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - adapt [genesis 1p] reflex - adapt reflex - adapt [jaguar] wired usb wired wired jaguar dinput dinput dinput ['controller adapter', 'jaguar controller'] controller adapter diamond platinum controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired jaguar dinput wired dinput dinput controller adapter jaguar controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - adapt [jaguar] reflex - adapt reflex - adapt [n64 1p] wired usb wired wired n64 1p dinput dinput dinput ['controller adapter', 'n64 controller'] controller adapter platinum platinum controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired n64 1p dinput wired dinput dinput controller adapter n64 controller published published controller adapter platinum platinum 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [n64 1p] reflex - adapt 3do reflex adapt 3do [wired usb dinput] wired usb wired wired wired usb dinput dinput dinput dinput ['controller adapter', '3do controller'] controller adapter platinum controller adapter - published published actively sold open source open source reflex - adapt 3do reflex adapt 3do reflex adapt 3do wired usb wired wired usb dinput dinput wired dinput dinput controller adapter 3do controller published published controller adapter - platinum 01-05ms (platinum) actively sold open source open source 16d0:127e_reflex3d0 buy link reflex adapt 3do [wired usb dinput] reflex - adapt reflex - adapt [wii classic 1p] wired usb wired wired wii classic 1p dinput dinput dinput ['controller adapter', 'wii classic controller'] controller adapter platinum gold controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired wii classic 1p dinput wired dinput dinput controller adapter wii classic controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [wii classic 1p] reflex - adapt reflex - adapt [snes 1p] wired usb wired wired snes 1p dinput dinput dinput ['controller adapter', 'snes controller'] controller adapter platinum gold controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired snes 1p dinput wired dinput dinput controller adapter snes controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [snes 1p] reflex - adapt reflex - adapt [virtual boy 1p] wired usb wired wired virtual boy 1p dinput dinput dinput ['controller adapter', 'virtual boy controller'] controller adapter platinum gold controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired virtual boy 1p dinput wired dinput dinput controller adapter virtual boy controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [virtual boy 1p] reflex - adapt reflex - adapt [nes 1p] wired usb wired wired nes 1p dinput dinput dinput ['controller adapter', 'nes controller'] controller adapter platinum gold controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired nes 1p dinput wired dinput dinput controller adapter nes controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [nes 1p] reflex - adapt reflex - adapt [psx 1p digital] wired usb wired wired psx 1p digital dinput dinput dinput ['controller adapter', 'psx controller'] controller adapter gold gold controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired psx 1p digital dinput wired dinput dinput controller adapter psx controller published published controller adapter gold gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [psx 1p digital] reflex - adapt reflex - adapt [gamecube 1p] wired usb wired wired gamecube 1p dinput dinput dinput ['controller adapter', 'gamecube controller'] controller adapter gold gold controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired gamecube 1p dinput wired dinput dinput controller adapter gamecube controller published published controller adapter gold gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [gamecube 1p] reflex - adapt reflex - adapt [saturn 3d 1p] wired usb wired wired saturn 3d 1p dinput dinput dinput ['controller adapter', 'saturn 3d controller'] controller adapter silver bronze controller adapter published published actively sold open source open source reflex - adapt reflex adapt reflex adapt wired usb wired saturn 3d 1p dinput wired dinput dinput controller adapter saturn 3d controller published published controller adapter silver bronze 05-10ms (gold) actively sold open source open source mister / pc raw capture buy link reflex - adapt [saturn 3d 1p]",
      "controllerGroupKey": "|reflex adapt",
      "modeVariantCount": 15,
      "modeVariants": [
        {
          "id": "published-reflex-adapt",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [Neo Geo]",
          "averageMs": 0.77,
          "averageTier": "Diamond",
          "p99Ms": 1.26,
          "p99Tier": "Platinum",
          "sameFramePct": 95.38,
          "observedSameFramePct": 95.4,
          "sampleCount": 2128,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Neo Geo",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Neo Geo Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 10,
          "modeRank": 4,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "16D0:127E:ReflexNeoGeo",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired neo geo dinput wired dinput dinput controller adapter neo geo controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - adapt [neo geo]"
        },
        {
          "id": "published-reflex-adapt-2",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [SMS 1P]",
          "averageMs": 0.784,
          "averageTier": "Diamond",
          "p99Ms": 1.28,
          "p99Tier": "Platinum",
          "sameFramePct": 95.3,
          "observedSameFramePct": 95.3,
          "sampleCount": 2139,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "SMS 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "SMS Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 13,
          "modeRank": 7,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "16D0:127E:ReflexSMS",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired sms 1p dinput wired dinput dinput controller adapter sms controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - adapt [sms 1p]"
        },
        {
          "id": "published-reflex-adapt-3",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [PCE 1P]",
          "averageMs": 0.844,
          "averageTier": "Diamond",
          "p99Ms": 1.35,
          "p99Tier": "Platinum",
          "sameFramePct": 94.94,
          "observedSameFramePct": 94.9,
          "sampleCount": 3053,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "PCE 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "PC Engine Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 28,
          "modeRank": 11,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "16D0:127E:ReflexPCE",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired pce 1p dinput wired dinput dinput controller adapter pc engine controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - adapt [pce 1p]"
        },
        {
          "id": "published-reflex-adapt-4",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [Saturn 1P]",
          "averageMs": 0.891,
          "averageTier": "Diamond",
          "p99Ms": 1.42,
          "p99Tier": "Platinum",
          "sameFramePct": 94.65,
          "observedSameFramePct": 94.7,
          "sampleCount": 2026,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Saturn 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Saturn Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 35,
          "modeRank": 15,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "16D0:127E:ReflexSat",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired saturn 1p dinput wired dinput dinput controller adapter saturn controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - adapt [saturn 1p]"
        },
        {
          "id": "published-reflex-adapt-5",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [Genesis 1P]",
          "averageMs": 0.934,
          "averageTier": "Diamond",
          "p99Ms": 1.46,
          "p99Tier": "Platinum",
          "sameFramePct": 94.4,
          "observedSameFramePct": 94.4,
          "sampleCount": 7641,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Genesis 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Genesis Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 39,
          "modeRank": 19,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "16D0:127E:ReflexSat",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired genesis 1p dinput wired dinput dinput controller adapter genesis controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - adapt [genesis 1p]"
        },
        {
          "id": "published-reflex-adapt-6",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [Jaguar]",
          "averageMs": 0.97,
          "averageTier": "Diamond",
          "p99Ms": 1.51,
          "p99Tier": "Platinum",
          "sameFramePct": 94.18,
          "observedSameFramePct": 94.2,
          "sampleCount": 2065,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Jaguar",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Jaguar Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 41,
          "modeRank": 21,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "16D0:127E:ReflexJag",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired jaguar dinput wired dinput dinput controller adapter jaguar controller published published controller adapter diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - adapt [jaguar]"
        },
        {
          "id": "published-reflex-adapt-7",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [N64 1P]",
          "averageMs": 1.062,
          "averageTier": "Platinum",
          "p99Ms": 1.64,
          "p99Tier": "Platinum",
          "sameFramePct": 93.63,
          "observedSameFramePct": 93.6,
          "sampleCount": 2104,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "N64 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "N64 Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 50,
          "modeRank": 22,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "9/1/2023",
          "dateAddedSort": "2023-09-01",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired n64 1p dinput wired dinput dinput controller adapter n64 controller published published controller adapter platinum platinum 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [n64 1p]"
        },
        {
          "id": "published-reflex-adapt-3do",
          "name": "Reflex - Adapt 3DO",
          "measurementName": "Reflex Adapt 3DO [Wired USB Dinput]",
          "averageMs": 1.22,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 92.68,
          "observedSameFramePct": 92.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "3DO Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 55,
          "modeRank": 25,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt?_pos=3&_psq=reflex&_ss=e&_v=1.0",
          "link": "https://misteraddons.com/products/reflex-adapt?_pos=3&_psq=reflex&_ss=e&_v=1.0",
          "amazon": "",
          "joystickId": "16D0:127E_Reflex3D0",
          "searchText": "reflex - adapt 3do reflex adapt 3do reflex adapt 3do wired usb wired wired usb dinput dinput wired dinput dinput controller adapter 3do controller published published controller adapter - platinum 01-05ms (platinum) actively sold open source open source 16d0:127e_reflex3d0 buy link reflex adapt 3do [wired usb dinput]"
        },
        {
          "id": "published-reflex-adapt-8",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [Wii Classic 1P]",
          "averageMs": 1.341,
          "averageTier": "Platinum",
          "p99Ms": 2.158,
          "p99Tier": "Gold",
          "sameFramePct": 91.95,
          "observedSameFramePct": 92.0,
          "sampleCount": 2026,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wii Classic 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Wii Classic Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 60,
          "modeRank": 26,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "16D0:127E:ReflexWii",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired wii classic 1p dinput wired dinput dinput controller adapter wii classic controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [wii classic 1p]"
        },
        {
          "id": "published-reflex-adapt-9",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [SNES 1P]",
          "averageMs": 1.479,
          "averageTier": "Platinum",
          "p99Ms": 2.13,
          "p99Tier": "Gold",
          "sameFramePct": 91.13,
          "observedSameFramePct": 91.1,
          "sampleCount": 3180,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "SNES 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "SNES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 68,
          "modeRank": 28,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "16D0:127E:ReflexSNESNTT",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired snes 1p dinput wired dinput dinput controller adapter snes controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [snes 1p]"
        },
        {
          "id": "published-reflex-adapt-10",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [Virtual Boy 1P]",
          "averageMs": 1.56,
          "averageTier": "Platinum",
          "p99Ms": 2.26,
          "p99Tier": "Gold",
          "sameFramePct": 90.64,
          "observedSameFramePct": 90.6,
          "sampleCount": 2032,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Virtual Boy 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Virtual Boy Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 70,
          "modeRank": 29,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "16D0:127E:ReflexSNESNTT",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired virtual boy 1p dinput wired dinput dinput controller adapter virtual boy controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [virtual boy 1p]"
        },
        {
          "id": "published-reflex-adapt-11",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [NES 1P]",
          "averageMs": 1.565,
          "averageTier": "Platinum",
          "p99Ms": 2.242,
          "p99Tier": "Gold",
          "sameFramePct": 90.61,
          "observedSameFramePct": 90.6,
          "sampleCount": 2383,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "NES 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "NES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 71,
          "modeRank": 30,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "16D0:127E:ReflexSNESNTT",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired nes 1p dinput wired dinput dinput controller adapter nes controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [nes 1p]"
        },
        {
          "id": "published-reflex-adapt-12",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [PSX 1P Digital]",
          "averageMs": 2.066,
          "averageTier": "Gold",
          "p99Ms": 3.4,
          "p99Tier": "Gold",
          "sameFramePct": 87.6,
          "observedSameFramePct": 87.6,
          "sampleCount": 4493,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "PSX 1P Digital",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "PSX Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 96,
          "modeRank": 41,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "16D0:127E:ReflexPSDS1",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired psx 1p digital dinput wired dinput dinput controller adapter psx controller published published controller adapter gold gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [psx 1p digital]"
        },
        {
          "id": "published-reflex-adapt-13",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [GameCube 1P]",
          "averageMs": 2.781,
          "averageTier": "Gold",
          "p99Ms": 3.647,
          "p99Tier": "Gold",
          "sameFramePct": 83.31,
          "observedSameFramePct": 83.3,
          "sampleCount": 3129,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "GameCube 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "GameCube Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 104,
          "modeRank": 44,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "16D0:127E:ReflexGC",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired gamecube 1p dinput wired dinput dinput controller adapter gamecube controller published published controller adapter gold gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link reflex - adapt [gamecube 1p]"
        },
        {
          "id": "published-reflex-adapt-14",
          "name": "Reflex - Adapt",
          "measurementName": "Reflex - Adapt [Saturn 3D 1P]",
          "averageMs": 6.959,
          "averageTier": "Silver",
          "p99Ms": 12.503,
          "p99Tier": "Bronze",
          "sameFramePct": 58.25,
          "observedSameFramePct": 58.2,
          "sampleCount": 2096,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Saturn 3D 1P",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Saturn 3D Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 209,
          "modeRank": 58,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt",
          "link": "https://misteraddons.com/products/reflex-adapt",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - adapt reflex adapt reflex adapt wired usb wired saturn 3d 1p dinput wired dinput dinput controller adapter saturn 3d controller published published controller adapter silver bronze 05-10ms (gold) actively sold open source open source mister / pc raw capture buy link reflex - adapt [saturn 3d 1p]"
        }
      ]
    },
    {
      "id": "published-timville-triple-controller",
      "name": "Timville - Triple Controller",
      "measurementName": "Timville - Triple Controller",
      "deviceNorm": "timville triple controller",
      "make": "Timville",
      "model": "Triple Controller",
      "link": "https://www.tindie.com/products/timville/triple-controller-classic-gaming-usb-adapter/",
      "amazon": "",
      "buyUrl": "https://www.tindie.com/products/timville/triple-controller-classic-gaming-usb-adapter/",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 11,
      "modeRank": 5,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "12/16/2021",
      "dateAddedSort": "2021-12-16",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "Platinum",
      "averageMs": 0.816,
      "sdMs": 0.295,
      "maxMs": 1.44,
      "minMs": 0.24,
      "p99Ms": 1.359,
      "sampleCount": 2611,
      "sameFramePct": 95.1,
      "observedSameFramePct": 95.1,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Open Source",
      "isOpenSource": true,
      "sourceUrl": "",
      "joystickId": "2341:8036",
      "searchText": "timville - triple controller timville triple controller timville triple controller wired usb wired dinput wired dinput dinput controller adapter controller adapter published published controller adapter - - diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc 2341:8036 raw capture buy link timville - triple controller timville - triple controller timville - triple controller wired usb wired wired dinput dinput dinput ['controller adapter'] controller adapter diamond platinum controller adapter - - published published actively sold open source open source timville - triple controller timville triple controller timville triple controller wired usb wired dinput wired dinput dinput controller adapter published published controller adapter - - diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link timville - triple controller",
      "controllerGroupKey": "published|timville triple controller",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-timville-triple-controller",
          "name": "Timville - Triple Controller",
          "measurementName": "Timville - Triple Controller",
          "averageMs": 0.816,
          "averageTier": "Diamond",
          "p99Ms": 1.359,
          "p99Tier": "Platinum",
          "sameFramePct": 95.1,
          "observedSameFramePct": 95.1,
          "sampleCount": 2611,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 17,
          "modeRank": 10,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "",
          "dateAdded": "12/16/2021",
          "dateAddedSort": "2021-12-16",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://www.tindie.com/products/timville/triple-controller-classic-gaming-usb-adapter/",
          "link": "https://www.tindie.com/products/timville/triple-controller-classic-gaming-usb-adapter/",
          "amazon": "",
          "joystickId": "2341:8036",
          "searchText": "timville - triple controller timville triple controller timville triple controller wired usb wired dinput wired dinput dinput controller adapter published published controller adapter - - diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link timville - triple controller"
        }
      ]
    },
    {
      "id": "published-reflex-encode-fightboard-gp2040-ce",
      "name": "Reflex Encode Fightboard (GP2040-CE)",
      "measurementName": "Reflex Encode Fightboard [Wired USB Xinput]",
      "deviceNorm": "reflex encode fightboard gp2040 ce",
      "make": "Reflex",
      "model": "Encode Fightboard",
      "link": "https://misteraddons.com/products/reflex-encode-fighting-board",
      "amazon": "",
      "buyUrl": "https://misteraddons.com/products/reflex-encode-fighting-board",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Xinput",
      "outputMode": "DInput, XInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput, XInput",
      "modeDisplay": "DInput, XInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 12,
      "modeRank": 6,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "7/12/2024",
      "dateAddedSort": "2024-07-12",
      "platforms": [],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 0.82,
      "sdMs": 0.29,
      "maxMs": 1.4,
      "minMs": 0.26,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 95.08,
      "observedSameFramePct": 95.1,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Open Source",
      "isOpenSource": true,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "reflex encode fightboard (gp2040-ce) reflex encode fightboard gp2040 ce reflex encode fightboard wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput arcade stick encoder arcade stick encoder published published arcade stick encoder - diamond 00-01ms (diamond) actively sold open source open source 045e:028e buy link reflex encode fightboard [wired usb xinput] reflex - encode fightboard reflex encode fightboard [wired usb xinput] wired usb wired wired wired usb xinput dinput, xinput dinput, xinput dinput, xinput ['arcade stick encoder'] arcade stick encoder diamond arcade stick encoder - published published actively sold open source open source reflex - encode fightboard reflex encode fightboard reflex encode fightboard wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput arcade stick encoder published published arcade stick encoder - diamond 00-01ms (diamond) actively sold open source open source 045e:028e buy link reflex encode fightboard [wired usb xinput] reflex - encode fightboard v1 reflex - encode fightboard v1 wired usb wired wired dinput dinput dinput ['arcade stick encoder'] arcade stick encoder diamond platinum arcade stick encoder published published actively sold open source open source reflex - encode fightboard v1 reflex encode fightboard v1 reflex encode fightboard v1 wired usb wired dinput wired dinput dinput arcade stick encoder published published arcade stick encoder diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - encode fightboard v1",
      "controllerGroupKey": "|reflex encode fightboard gp2040 ce",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-reflex-encode-fightboard",
          "name": "Reflex - Encode Fightboard",
          "measurementName": "Reflex Encode Fightboard [Wired USB Xinput]",
          "averageMs": 0.82,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 95.08,
          "observedSameFramePct": 95.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Xinput",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 19,
          "modeRank": 8,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-encode-fighting-board",
          "link": "https://misteraddons.com/products/reflex-encode-fighting-board",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "reflex - encode fightboard reflex encode fightboard reflex encode fightboard wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput arcade stick encoder published published arcade stick encoder - diamond 00-01ms (diamond) actively sold open source open source 045e:028e buy link reflex encode fightboard [wired usb xinput]"
        },
        {
          "id": "published-reflex-encode-fightboard-v1",
          "name": "Reflex - Encode Fightboard V1",
          "measurementName": "Reflex - Encode Fightboard V1",
          "averageMs": 0.821,
          "averageTier": "Diamond",
          "p99Ms": 1.34,
          "p99Tier": "Platinum",
          "sameFramePct": 95.07,
          "observedSameFramePct": 95.1,
          "sampleCount": 2477,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 20,
          "modeRank": 9,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-encode-fighting-board",
          "link": "https://misteraddons.com/products/reflex-encode-fighting-board",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - encode fightboard v1 reflex encode fightboard v1 reflex encode fightboard v1 wired usb wired dinput wired dinput dinput arcade stick encoder published published arcade stick encoder diamond platinum 00-01ms (diamond) actively sold open source open source mister / pc raw capture buy link reflex - encode fightboard v1"
        }
      ]
    },
    {
      "id": "published-reflex-ctrl",
      "name": "Reflex CTRL",
      "measurementName": "Reflex - CTRL SNES [Switch]",
      "deviceNorm": "reflex ctrl",
      "make": "Reflex",
      "model": "CTRL SNES",
      "link": "https://misteraddons.com/products/reflex-ctrl",
      "amazon": "",
      "buyUrl": "https://misteraddons.com/products/reflex-ctrl",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Switch",
      "outputMode": "Switch",
      "connectionTag": "Wired",
      "modeLabel": "Switch",
      "modeDisplay": "USB",
      "rankMode": "Controller Conversion",
      "overallRank": 13,
      "modeRank": 1,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Conversion",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "7/12/2024",
      "dateAddedSort": "2024-07-12",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Conversion"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "Platinum",
      "averageMs": 0.839,
      "sdMs": 0.291,
      "maxMs": 1.57,
      "minMs": 0.27,
      "p99Ms": 1.35,
      "sampleCount": 8264,
      "sameFramePct": 94.97,
      "observedSameFramePct": 95.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "reflex ctrl reflex ctrl reflex ctrl snes wired usb wired switch switch wired switch usb controller conversion controller conversion published published controller conversion diamond platinum 00-01ms (diamond) actively sold closed source mister / pc raw capture buy link reflex - ctrl snes [switch] reflex - ctrl snes reflex - ctrl snes [switch] wired usb wired wired switch switch switch usb ['controller conversion'] controller conversion diamond platinum controller conversion published published actively sold closed source reflex - ctrl snes reflex ctrl snes reflex ctrl snes wired usb wired switch switch wired switch usb controller conversion published published controller conversion diamond platinum 00-01ms (diamond) actively sold closed source mister / pc raw capture buy link reflex - ctrl snes [switch] reflex - ctrl snes reflex - ctrl snes [xinput] wired usb wired wired xinput xinput xinput usb ['controller conversion'] controller conversion diamond platinum controller conversion published published actively sold closed source reflex - ctrl snes reflex ctrl snes reflex ctrl snes wired usb wired xinput xinput wired xinput usb controller conversion published published controller conversion diamond platinum 00-01ms (diamond) actively sold closed source mister / pc raw capture buy link reflex - ctrl snes [xinput] reflex - ctrl reflex ctrl [dinput] wired usb wired wired dinput dinput dinput usb ['controller conversion'] controller conversion diamond controller conversion - published published actively sold closed source reflex - ctrl reflex ctrl reflex ctrl wired usb wired dinput dinput wired dinput usb controller conversion published published controller conversion - diamond 00-01ms (diamond) actively sold closed source 10c4:82c0 buy link reflex ctrl [dinput] reflex - ctrl reflex ctrl [switch] wired usb wired wired switch switch switch usb ['controller conversion'] controller conversion diamond controller conversion - published published actively sold closed source reflex - ctrl reflex ctrl reflex ctrl wired usb wired switch switch wired switch usb controller conversion published published controller conversion - diamond 00-01ms (diamond) actively sold closed source 0f0d:0092 buy link reflex ctrl [switch] reflex - ctrl reflex ctrl [xinput] wired usb wired wired xinput xinput xinput usb ['controller conversion'] controller conversion diamond controller conversion - published published actively sold closed source reflex - ctrl reflex ctrl reflex ctrl wired usb wired xinput xinput wired xinput usb controller conversion published published controller conversion - diamond 00-01ms (diamond) actively sold closed source 045e:028e buy link reflex ctrl [xinput] reflex - ctrl snes reflex - ctrl snes [dinput] wired usb wired wired dinput dinput dinput usb ['controller conversion'] controller conversion diamond platinum controller conversion published published actively sold closed source reflex - ctrl snes reflex ctrl snes reflex ctrl snes wired usb wired dinput dinput wired dinput usb controller conversion published published controller conversion diamond platinum 00-01ms (diamond) actively sold closed source mister / pc raw capture buy link reflex - ctrl snes [dinput]",
      "controllerGroupKey": "|reflex ctrl",
      "modeVariantCount": 6,
      "modeVariants": [
        {
          "id": "published-reflex-ctrl-snes",
          "name": "Reflex - CTRL SNES",
          "measurementName": "Reflex - CTRL SNES [Switch]",
          "averageMs": 0.839,
          "averageTier": "Diamond",
          "p99Ms": 1.35,
          "p99Tier": "Platinum",
          "sameFramePct": 94.97,
          "observedSameFramePct": 95.0,
          "sampleCount": 8264,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Switch",
          "outputMode": "Switch",
          "modeLabel": "Switch",
          "modeDisplay": "USB",
          "deviceTypes": [
            "Controller Conversion"
          ],
          "rankMode": "Controller Conversion",
          "overallRank": 21,
          "modeRank": 1,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Conversion",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-ctrl",
          "link": "https://misteraddons.com/products/reflex-ctrl",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - ctrl snes reflex ctrl snes reflex ctrl snes wired usb wired switch switch wired switch usb controller conversion published published controller conversion diamond platinum 00-01ms (diamond) actively sold closed source mister / pc raw capture buy link reflex - ctrl snes [switch]"
        },
        {
          "id": "published-reflex-ctrl-snes-2",
          "name": "Reflex - CTRL SNES",
          "measurementName": "Reflex - CTRL SNES [Xinput]",
          "averageMs": 0.839,
          "averageTier": "Diamond",
          "p99Ms": 1.35,
          "p99Tier": "Platinum",
          "sameFramePct": 94.97,
          "observedSameFramePct": 95.0,
          "sampleCount": 3444,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Xinput",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "USB",
          "deviceTypes": [
            "Controller Conversion"
          ],
          "rankMode": "Controller Conversion",
          "overallRank": 22,
          "modeRank": 2,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Conversion",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-ctrl",
          "link": "https://misteraddons.com/products/reflex-ctrl",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - ctrl snes reflex ctrl snes reflex ctrl snes wired usb wired xinput xinput wired xinput usb controller conversion published published controller conversion diamond platinum 00-01ms (diamond) actively sold closed source mister / pc raw capture buy link reflex - ctrl snes [xinput]"
        },
        {
          "id": "published-reflex-ctrl",
          "name": "Reflex - CTRL",
          "measurementName": "Reflex CTRL [Dinput]",
          "averageMs": 0.84,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 94.96,
          "observedSameFramePct": 95.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "USB",
          "deviceTypes": [
            "Controller Conversion"
          ],
          "rankMode": "Controller Conversion",
          "overallRank": 24,
          "modeRank": 3,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Conversion",
          "faceButtons": "-",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt?_pos=3&_psq=reflex&_ss=e&_v=1.31",
          "link": "https://misteraddons.com/products/reflex-adapt?_pos=3&_psq=reflex&_ss=e&_v=1.31",
          "amazon": "",
          "joystickId": "10C4:82C0",
          "searchText": "reflex - ctrl reflex ctrl reflex ctrl wired usb wired dinput dinput wired dinput usb controller conversion published published controller conversion - diamond 00-01ms (diamond) actively sold closed source 10c4:82c0 buy link reflex ctrl [dinput]"
        },
        {
          "id": "published-reflex-ctrl-2",
          "name": "Reflex - CTRL",
          "measurementName": "Reflex CTRL [Switch]",
          "averageMs": 0.84,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 94.96,
          "observedSameFramePct": 95.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Switch",
          "outputMode": "Switch",
          "modeLabel": "Switch",
          "modeDisplay": "USB",
          "deviceTypes": [
            "Controller Conversion"
          ],
          "rankMode": "Controller Conversion",
          "overallRank": 25,
          "modeRank": 4,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Conversion",
          "faceButtons": "-",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt?_pos=3&_psq=reflex&_ss=e&_v=1.32",
          "link": "https://misteraddons.com/products/reflex-adapt?_pos=3&_psq=reflex&_ss=e&_v=1.32",
          "amazon": "",
          "joystickId": "0F0D:0092",
          "searchText": "reflex - ctrl reflex ctrl reflex ctrl wired usb wired switch switch wired switch usb controller conversion published published controller conversion - diamond 00-01ms (diamond) actively sold closed source 0f0d:0092 buy link reflex ctrl [switch]"
        },
        {
          "id": "published-reflex-ctrl-3",
          "name": "Reflex - CTRL",
          "measurementName": "Reflex CTRL [Xinput]",
          "averageMs": 0.84,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 94.96,
          "observedSameFramePct": 95.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Xinput",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "USB",
          "deviceTypes": [
            "Controller Conversion"
          ],
          "rankMode": "Controller Conversion",
          "overallRank": 26,
          "modeRank": 5,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Conversion",
          "faceButtons": "-",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/12/2024",
          "dateAddedSort": "2024-07-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-adapt?_pos=3&_psq=reflex&_ss=e&_v=1.33",
          "link": "https://misteraddons.com/products/reflex-adapt?_pos=3&_psq=reflex&_ss=e&_v=1.33",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "reflex - ctrl reflex ctrl reflex ctrl wired usb wired xinput xinput wired xinput usb controller conversion published published controller conversion - diamond 00-01ms (diamond) actively sold closed source 045e:028e buy link reflex ctrl [xinput]"
        },
        {
          "id": "published-reflex-ctrl-snes-3",
          "name": "Reflex - CTRL SNES",
          "measurementName": "Reflex - CTRL SNES [Dinput]",
          "averageMs": 0.842,
          "averageTier": "Diamond",
          "p99Ms": 1.36,
          "p99Tier": "Platinum",
          "sameFramePct": 94.95,
          "observedSameFramePct": 94.9,
          "sampleCount": 8135,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "USB",
          "deviceTypes": [
            "Controller Conversion"
          ],
          "rankMode": "Controller Conversion",
          "overallRank": 27,
          "modeRank": 6,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Conversion",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://misteraddons.com/products/reflex-ctrl",
          "link": "https://misteraddons.com/products/reflex-ctrl",
          "amazon": "",
          "joystickId": "",
          "searchText": "reflex - ctrl snes reflex ctrl snes reflex ctrl snes wired usb wired dinput dinput wired dinput usb controller conversion published published controller conversion diamond platinum 00-01ms (diamond) actively sold closed source mister / pc raw capture buy link reflex - ctrl snes [dinput]"
        }
      ]
    },
    {
      "id": "published-8bitdo-sfc30-1st-rev",
      "name": "8BitDo - SFC30 (1st Rev.)",
      "measurementName": "8BitDo SFC30 (1st Rev.) [Wired USB]",
      "deviceNorm": "8bitdo sfc30 1st rev",
      "make": "8BitDo",
      "model": "SFC30 (1st Rev.)",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 14,
      "modeRank": 2,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "3.40",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 0.84,
      "sdMs": 0.108,
      "maxMs": 1.34,
      "minMs": 0.32,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 94.96,
      "observedSameFramePct": 95.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "8bitdo - sfc30 (1st rev.) 8bitdo sfc30 1st rev 8bitdo sfc30 (1st rev.) wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no 3.40 diamond 00-01ms (diamond) unknown closed source mister / pc 8bitdo sfc30 (1st rev.) [wired usb] 8bitdo - sfc30 (1st rev.) 8bitdo sfc30 (1st rev.) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller diamond controller 4 no 3.40 published published unknown closed source 8bitdo - sfc30 (1st rev.) 8bitdo sfc30 1st rev 8bitdo sfc30 (1st rev.) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.40 diamond 00-01ms (diamond) unknown closed source mister / pc 8bitdo sfc30 (1st rev.) [wired usb]",
      "controllerGroupKey": "published|8bitdo sfc30 1st rev",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-8bitdo-sfc30-1st-rev",
          "name": "8BitDo - SFC30 (1st Rev.)",
          "measurementName": "8BitDo SFC30 (1st Rev.) [Wired USB]",
          "averageMs": 0.84,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 94.96,
          "observedSameFramePct": 95.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 23,
          "modeRank": 2,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - sfc30 (1st rev.) 8bitdo sfc30 1st rev 8bitdo sfc30 (1st rev.) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.40 diamond 00-01ms (diamond) unknown closed source mister / pc 8bitdo sfc30 (1st rev.) [wired usb]"
        }
      ]
    },
    {
      "id": "published-8bitdo-nes30",
      "name": "8BitDo - NES30",
      "measurementName": "8BitDo NES30 [Wired USB]",
      "deviceNorm": "8bitdo nes30",
      "make": "8BitDo",
      "model": "NES30",
      "link": "https://amzn.to/3Xc7xgW",
      "amazon": "",
      "buyUrl": "https://amzn.to/3Xc7xgW",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 15,
      "modeRank": 3,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "3.25",
      "dateAdded": "5/27/2020",
      "dateAddedSort": "2020-05-27",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 0.87,
      "sdMs": 0.29,
      "maxMs": 1.38,
      "minMs": 0.356,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 94.78,
      "observedSameFramePct": 94.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "2dc8:ab12",
      "searchText": "8bitdo - nes30 8bitdo nes30 8bitdo nes30 wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no 3.25 diamond 00-01ms (diamond) actively sold closed source mister / pc switch 2dc8:ab12 buy link 8bitdo nes30 [wired usb] 8bitdo - nes30 8bitdo nes30 [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller diamond controller 4 no 3.25 published published actively sold closed source 8bitdo - nes30 8bitdo nes30 8bitdo nes30 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.25 diamond 00-01ms (diamond) actively sold closed source mister / pc switch 2dc8:ab12 buy link 8bitdo nes30 [wired usb] 8bitdo - nes30 8bitdo nes30 [8bitdo usb adapter dinput] fw 4.10 bluetooth wireless wireless bt 8bitdo usb adapter dinput dinput dinput dinput ['wireless controller'] wireless controller silver controller 4 no 3.25 published published actively sold closed source 8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.25 silver 05-10ms (gold) actively sold closed source mister / pc 2dc8:3100 buy link 8bitdo nes30 [8bitdo usb adapter dinput] fw 4.10 8bitdo - nes30 8bitdo nes30 [8bitdo usb adapter switch] fw 4.10 bluetooth wireless wireless bt 8bitdo usb adapter switch dinput, switch dinput, switch dinput, switch ['wireless controller'] wireless controller silver controller 4 no 3.25 published published actively sold closed source 8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless 8bitdo usb adapter switch dinput, switch wireless bt dinput, switch dinput, switch wireless controller published published controller 4 no 3.25 silver 05-10ms (gold) actively sold closed source mister / pc switch 054c:05c4 buy link 8bitdo nes30 [8bitdo usb adapter switch] fw 4.10 8bitdo - nes30 8bitdo nes30 [8bitdo usb adapter x-input] fw 4.10 bluetooth wireless wireless bt 8bitdo usb adapter x-input dinput, xinput dinput, xinput dinput, xinput ['wireless controller'] wireless controller silver controller 4 no 3.25 published published actively sold closed source 8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless 8bitdo usb adapter x-input dinput, xinput wireless bt dinput, xinput dinput, xinput wireless controller published published controller 4 no 3.25 silver 05-10ms (gold) actively sold closed source mister / pc 045e:028e buy link 8bitdo nes30 [8bitdo usb adapter x-input] fw 4.10 8bitdo - nes30 8bitdo nes30 [bt (csr8510) macos] bluetooth wireless wireless bt bt (csr8510) macos macos macos macos ['wireless controller'] wireless controller silver controller 4 no 3.25 published published actively sold closed source 8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless bt (csr8510) macos macos wireless bt macos macos wireless controller published published controller 4 no 3.25 silver 05-10ms (gold) actively sold closed source mister / pc buy link 8bitdo nes30 [bt (csr8510) macos] 8bitdo - nes30 8bitdo nes30 [8bitdo usb adapter dinput] fw 4.20 bluetooth wireless wireless bt 8bitdo usb adapter dinput dinput dinput dinput ['wireless controller'] wireless controller bronze controller 4 no 3.25 published published actively sold closed source 8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.25 bronze 10-15ms (silver) actively sold closed source mister / pc 054c:05c4 buy link 8bitdo nes30 [8bitdo usb adapter dinput] fw 4.20 8bitdo - nes30 8bitdo nes30 [bt (csr8510) switch] bluetooth wireless wireless bt bt (csr8510) switch switch switch switch ['wireless controller'] wireless controller bronze controller 4 no 3.25 published published actively sold closed source 8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless bt (csr8510) switch switch wireless bt switch switch wireless controller published published controller 4 no 3.25 bronze 10-15ms (silver) actively sold closed source mister / pc switch buy link 8bitdo nes30 [bt (csr8510) switch] 8bitdo - nes30 8bitdo nes30 [bt (csr8510) android] bluetooth wireless wireless bt bt (csr8510) android android android android ['wireless controller'] wireless controller bronze controller 4 no 3.25 published published actively sold closed source 8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless bt (csr8510) android android wireless bt android android wireless controller published published controller 4 no 3.25 bronze 15-20ms (bronze) actively sold closed source mister / pc buy link 8bitdo nes30 [bt (csr8510) android] 8bitdo - nes30 8bitdo nes30 [bt (csr8510) windows] bluetooth wireless wireless bt bt (csr8510) windows dinput dinput dinput ['wireless controller'] wireless controller bronze controller 4 no 3.25 published published actively sold closed source 8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless bt (csr8510) windows dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.25 bronze 15-20ms (bronze) actively sold closed source mister / pc 045e:02e0 buy link 8bitdo nes30 [bt (csr8510) windows]",
      "controllerGroupKey": "published|8bitdo nes30",
      "modeVariantCount": 9,
      "modeVariants": [
        {
          "id": "published-8bitdo-nes30",
          "name": "8BitDo - NES30",
          "measurementName": "8BitDo NES30 [Wired USB]",
          "averageMs": 0.87,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 94.78,
          "observedSameFramePct": 94.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 30,
          "modeRank": 3,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.25",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xc7xgW",
          "link": "https://amzn.to/3Xc7xgW",
          "amazon": "",
          "joystickId": "2dc8:ab12",
          "searchText": "8bitdo - nes30 8bitdo nes30 8bitdo nes30 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.25 diamond 00-01ms (diamond) actively sold closed source mister / pc switch 2dc8:ab12 buy link 8bitdo nes30 [wired usb]"
        },
        {
          "id": "published-8bitdo-nes30-2",
          "name": "8BitDo - NES30",
          "measurementName": "8BitDo NES30 [8BitDo USB Adapter Dinput] FW 4.10",
          "averageMs": 5.671,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 65.97,
          "observedSameFramePct": 66.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 174,
          "modeRank": 7,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.25",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xc7xgW",
          "link": "https://amzn.to/3Xc7xgW",
          "amazon": "",
          "joystickId": "2dc8:3100",
          "searchText": "8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.25 silver 05-10ms (gold) actively sold closed source mister / pc 2dc8:3100 buy link 8bitdo nes30 [8bitdo usb adapter dinput] fw 4.10"
        },
        {
          "id": "published-8bitdo-nes30-3",
          "name": "8BitDo - NES30",
          "measurementName": "8BitDo NES30 [8BitDo USB Adapter Switch] FW 4.10",
          "averageMs": 5.724,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 65.66,
          "observedSameFramePct": 65.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter Switch",
          "outputMode": "DInput, Switch",
          "modeLabel": "DInput, Switch",
          "modeDisplay": "DInput, Switch",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 175,
          "modeRank": 8,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.25",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xc7xgW",
          "link": "https://amzn.to/3Xc7xgW",
          "amazon": "",
          "joystickId": "054c:05c4",
          "searchText": "8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless 8bitdo usb adapter switch dinput, switch wireless bt dinput, switch dinput, switch wireless controller published published controller 4 no 3.25 silver 05-10ms (gold) actively sold closed source mister / pc switch 054c:05c4 buy link 8bitdo nes30 [8bitdo usb adapter switch] fw 4.10"
        },
        {
          "id": "published-8bitdo-nes30-4",
          "name": "8BitDo - NES30",
          "measurementName": "8BitDo NES30 [8BitDo USB Adapter X-Input] FW 4.10",
          "averageMs": 5.777,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 65.34,
          "observedSameFramePct": 65.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter X-Input",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 177,
          "modeRank": 9,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.25",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xc7xgW",
          "link": "https://amzn.to/3Xc7xgW",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless 8bitdo usb adapter x-input dinput, xinput wireless bt dinput, xinput dinput, xinput wireless controller published published controller 4 no 3.25 silver 05-10ms (gold) actively sold closed source mister / pc 045e:028e buy link 8bitdo nes30 [8bitdo usb adapter x-input] fw 4.10"
        },
        {
          "id": "published-8bitdo-nes30-5",
          "name": "8BitDo - NES30",
          "measurementName": "8BitDo NES30 [BT (CSR8510) MacOS]",
          "averageMs": 9.761,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 41.43,
          "observedSameFramePct": 41.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) MacOS",
          "outputMode": "macOS",
          "modeLabel": "macOS",
          "modeDisplay": "macOS",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 235,
          "modeRank": 26,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.25",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xc7xgW",
          "link": "https://amzn.to/3Xc7xgW",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless bt (csr8510) macos macos wireless bt macos macos wireless controller published published controller 4 no 3.25 silver 05-10ms (gold) actively sold closed source mister / pc buy link 8bitdo nes30 [bt (csr8510) macos]"
        },
        {
          "id": "published-8bitdo-nes30-6",
          "name": "8BitDo - NES30",
          "measurementName": "8BitDo NES30 [8BitDo USB Adapter Dinput] FW 4.20",
          "averageMs": 10.632,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 36.21,
          "observedSameFramePct": 36.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 247,
          "modeRank": 36,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.25",
          "dateAdded": "6/6/2020",
          "dateAddedSort": "2020-06-06",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xc7xgW",
          "link": "https://amzn.to/3Xc7xgW",
          "amazon": "",
          "joystickId": "054c:05c4",
          "searchText": "8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.25 bronze 10-15ms (silver) actively sold closed source mister / pc 054c:05c4 buy link 8bitdo nes30 [8bitdo usb adapter dinput] fw 4.20"
        },
        {
          "id": "published-8bitdo-nes30-7",
          "name": "8BitDo - NES30",
          "measurementName": "8BitDo NES30 [BT (CSR8510) Switch]",
          "averageMs": 14.885,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 10.69,
          "observedSameFramePct": 20.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Switch",
          "outputMode": "Switch",
          "modeLabel": "Switch",
          "modeDisplay": "Switch",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 280,
          "modeRank": 53,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.25",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xc7xgW",
          "link": "https://amzn.to/3Xc7xgW",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless bt (csr8510) switch switch wireless bt switch switch wireless controller published published controller 4 no 3.25 bronze 10-15ms (silver) actively sold closed source mister / pc switch buy link 8bitdo nes30 [bt (csr8510) switch]"
        },
        {
          "id": "published-8bitdo-nes30-8",
          "name": "8BitDo - NES30",
          "measurementName": "8BitDo NES30 [BT (CSR8510) Android]",
          "averageMs": 15.215,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 8.71,
          "observedSameFramePct": 19.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Android",
          "outputMode": "Android",
          "modeLabel": "Android",
          "modeDisplay": "Android",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 285,
          "modeRank": 57,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.25",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xc7xgW",
          "link": "https://amzn.to/3Xc7xgW",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless bt (csr8510) android android wireless bt android android wireless controller published published controller 4 no 3.25 bronze 15-20ms (bronze) actively sold closed source mister / pc buy link 8bitdo nes30 [bt (csr8510) android]"
        },
        {
          "id": "published-8bitdo-nes30-9",
          "name": "8BitDo - NES30",
          "measurementName": "8BitDo NES30 [BT (CSR8510) Windows]",
          "averageMs": 15.811,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 5.13,
          "observedSameFramePct": 17.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Windows",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 290,
          "modeRank": 61,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.25",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xc7xgW",
          "link": "https://amzn.to/3Xc7xgW",
          "amazon": "",
          "joystickId": "045e:02e0",
          "searchText": "8bitdo - nes30 8bitdo nes30 8bitdo nes30 bluetooth wireless bt (csr8510) windows dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.25 bronze 15-20ms (bronze) actively sold closed source mister / pc 045e:02e0 buy link 8bitdo nes30 [bt (csr8510) windows]"
        }
      ]
    },
    {
      "id": "published-8bitdo-sn30-model-80ba",
      "name": "8BitDo - SN30 (Model 80BA)",
      "measurementName": "8BitDo SN30 (Model 80BA) [Wired USB] FW 4.1",
      "deviceNorm": "8bitdo sn30 model 80ba",
      "make": "8BitDo",
      "model": "SN30 (Model 80BA)",
      "link": "https://amzn.to/3Xh44hb",
      "amazon": "",
      "buyUrl": "https://amzn.to/3Xh44hb",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 16,
      "modeRank": 4,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "3.40",
      "dateAdded": "5/27/2020",
      "dateAddedSort": "2020-05-27",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "00-01ms (Diamond)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 0.873,
      "sdMs": 0.289,
      "maxMs": 1.388,
      "minMs": 0.356,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 94.76,
      "observedSameFramePct": 94.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "2dc8:ab20",
      "searchText": "8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no 3.40 diamond 00-01ms (diamond) actively sold closed source mister / pc 2dc8:ab20 buy link 8bitdo sn30 (model 80ba) [wired usb] fw 4.1 8bitdo - sn30 (model 80ba) 8bitdo sn30 (model 80ba) [wired usb] fw 4.1 wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller diamond controller 4 no 3.40 published published actively sold closed source 8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.40 diamond 00-01ms (diamond) actively sold closed source mister / pc 2dc8:ab20 buy link 8bitdo sn30 (model 80ba) [wired usb] fw 4.1 8bitdo - sn30 (model 80ba) 8bitdo sn30 (model 80ba) [bt (csr8510) macos] fw 4.1 bluetooth wireless wireless bt bt (csr8510) macos macos macos macos ['wireless controller'] wireless controller silver controller 4 no 3.40 published published actively sold closed source 8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) bluetooth wireless bt (csr8510) macos macos wireless bt macos macos wireless controller published published controller 4 no 3.40 silver 05-10ms (gold) actively sold closed source mister / pc 05cc:05c4 buy link 8bitdo sn30 (model 80ba) [bt (csr8510) macos] fw 4.1 8bitdo - sn30 (model 80ba) 8bitdo sn30 (model 80ba) [8bitdo usb adapter x-input] fw 4.1 bluetooth wireless wireless bt 8bitdo usb adapter x-input dinput, xinput dinput, xinput dinput, xinput ['wireless controller'] wireless controller bronze controller 4 no 3.40 published published actively sold closed source 8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) bluetooth wireless 8bitdo usb adapter x-input dinput, xinput wireless bt dinput, xinput dinput, xinput wireless controller published published controller 4 no 3.40 bronze 10-15ms (silver) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 (model 80ba) [8bitdo usb adapter x-input] fw 4.1 8bitdo - sn30 (model 80ba) 8bitdo sn30 (model 80ba) [8bitdo usb adapter dinput] fw 4.1 bluetooth wireless wireless bt 8bitdo usb adapter dinput dinput dinput dinput ['wireless controller'] wireless controller bronze controller 4 no 3.40 published published actively sold closed source 8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.40 bronze 10-15ms (silver) actively sold closed source mister / pc 2dc8:3100 buy link 8bitdo sn30 (model 80ba) [8bitdo usb adapter dinput] fw 4.1 8bitdo - sn30 (model 80ba) 8bitdo sn30 (model 80ba) [bt (csr8510) android] fw 4.1 bluetooth wireless wireless bt bt (csr8510) android android android android ['wireless controller'] wireless controller bronze controller 4 no 3.40 published published actively sold closed source 8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) bluetooth wireless bt (csr8510) android android wireless bt android android wireless controller published published controller 4 no 3.40 bronze 15-20ms (bronze) actively sold closed source mister / pc 2dc8:2840 buy link 8bitdo sn30 (model 80ba) [bt (csr8510) android] fw 4.1 8bitdo - sn30 (model 80ba) 8bitdo sn30 (model 80ba) [bt (csr8510) windows] fw 4.1 bluetooth wireless wireless bt bt (csr8510) windows dinput dinput dinput ['wireless controller'] wireless controller bronze controller 4 no 3.40 published published actively sold closed source 8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) bluetooth wireless bt (csr8510) windows dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.40 bronze 15-20ms (bronze) actively sold closed source mister / pc 045e:02e0 buy link 8bitdo sn30 (model 80ba) [bt (csr8510) windows] fw 4.1",
      "controllerGroupKey": "published|8bitdo sn30 model 80ba",
      "modeVariantCount": 6,
      "modeVariants": [
        {
          "id": "published-8bitdo-sn30-model-80ba",
          "name": "8BitDo - SN30 (Model 80BA)",
          "measurementName": "8BitDo SN30 (Model 80BA) [Wired USB] FW 4.1",
          "averageMs": 0.873,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 94.76,
          "observedSameFramePct": 94.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 31,
          "modeRank": 4,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xh44hb",
          "link": "https://amzn.to/3Xh44hb",
          "amazon": "",
          "joystickId": "2dc8:ab20",
          "searchText": "8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.40 diamond 00-01ms (diamond) actively sold closed source mister / pc 2dc8:ab20 buy link 8bitdo sn30 (model 80ba) [wired usb] fw 4.1"
        },
        {
          "id": "published-8bitdo-sn30-model-80ba-2",
          "name": "8BitDo - SN30 (Model 80BA)",
          "measurementName": "8BitDo SN30 (Model 80BA) [BT (CSR8510) MacOS] FW 4.1",
          "averageMs": 9.824,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 41.06,
          "observedSameFramePct": 41.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) MacOS",
          "outputMode": "macOS",
          "modeLabel": "macOS",
          "modeDisplay": "macOS",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 237,
          "modeRank": 28,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xh44hb",
          "link": "https://amzn.to/3Xh44hb",
          "amazon": "",
          "joystickId": "05cc:05c4",
          "searchText": "8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) bluetooth wireless bt (csr8510) macos macos wireless bt macos macos wireless controller published published controller 4 no 3.40 silver 05-10ms (gold) actively sold closed source mister / pc 05cc:05c4 buy link 8bitdo sn30 (model 80ba) [bt (csr8510) macos] fw 4.1"
        },
        {
          "id": "published-8bitdo-sn30-model-80ba-3",
          "name": "8BitDo - SN30 (Model 80BA)",
          "measurementName": "8BitDo SN30 (Model 80BA) [8BitDo USB Adapter X-Input] FW 4.1",
          "averageMs": 10.586,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 36.48,
          "observedSameFramePct": 36.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter X-Input",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 244,
          "modeRank": 34,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "6/6/2020",
          "dateAddedSort": "2020-06-06",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xh44hb",
          "link": "https://amzn.to/3Xh44hb",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) bluetooth wireless 8bitdo usb adapter x-input dinput, xinput wireless bt dinput, xinput dinput, xinput wireless controller published published controller 4 no 3.40 bronze 10-15ms (silver) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 (model 80ba) [8bitdo usb adapter x-input] fw 4.1"
        },
        {
          "id": "published-8bitdo-sn30-model-80ba-4",
          "name": "8BitDo - SN30 (Model 80BA)",
          "measurementName": "8BitDo SN30 (Model 80BA) [8BitDo USB Adapter Dinput] FW 4.1",
          "averageMs": 10.607,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 36.36,
          "observedSameFramePct": 36.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 246,
          "modeRank": 35,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "6/6/2020",
          "dateAddedSort": "2020-06-06",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xh44hb",
          "link": "https://amzn.to/3Xh44hb",
          "amazon": "",
          "joystickId": "2dc8:3100",
          "searchText": "8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.40 bronze 10-15ms (silver) actively sold closed source mister / pc 2dc8:3100 buy link 8bitdo sn30 (model 80ba) [8bitdo usb adapter dinput] fw 4.1"
        },
        {
          "id": "published-8bitdo-sn30-model-80ba-5",
          "name": "8BitDo - SN30 (Model 80BA)",
          "measurementName": "8BitDo SN30 (Model 80BA) [BT (CSR8510) Android] FW 4.1",
          "averageMs": 15.22,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 8.68,
          "observedSameFramePct": 20.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Android",
          "outputMode": "Android",
          "modeLabel": "Android",
          "modeDisplay": "Android",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 286,
          "modeRank": 58,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xh44hb",
          "link": "https://amzn.to/3Xh44hb",
          "amazon": "",
          "joystickId": "2dc8:2840",
          "searchText": "8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) bluetooth wireless bt (csr8510) android android wireless bt android android wireless controller published published controller 4 no 3.40 bronze 15-20ms (bronze) actively sold closed source mister / pc 2dc8:2840 buy link 8bitdo sn30 (model 80ba) [bt (csr8510) android] fw 4.1"
        },
        {
          "id": "published-8bitdo-sn30-model-80ba-6",
          "name": "8BitDo - SN30 (Model 80BA)",
          "measurementName": "8BitDo SN30 (Model 80BA) [BT (CSR8510) Windows] FW 4.1",
          "averageMs": 15.811,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 5.13,
          "observedSameFramePct": 17.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Windows",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 291,
          "modeRank": 62,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Xh44hb",
          "link": "https://amzn.to/3Xh44hb",
          "amazon": "",
          "joystickId": "045e:02e0",
          "searchText": "8bitdo - sn30 (model 80ba) 8bitdo sn30 model 80ba 8bitdo sn30 (model 80ba) bluetooth wireless bt (csr8510) windows dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.40 bronze 15-20ms (bronze) actively sold closed source mister / pc 045e:02e0 buy link 8bitdo sn30 (model 80ba) [bt (csr8510) windows] fw 4.1"
        }
      ]
    },
    {
      "id": "published-8bitdo-n30-arcade-stick",
      "name": "8BitDo - N30 Arcade Stick",
      "measurementName": "8BitDo N30 Arcade Stick [Wired USB Xinput]",
      "deviceNorm": "8bitdo n30 arcade stick",
      "make": "8BitDo",
      "model": "N30 Arcade Stick",
      "link": "https://amzn.to/2ZiAPNX",
      "amazon": "",
      "buyUrl": "https://amzn.to/2ZiAPNX",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Xinput",
      "outputMode": "DInput, XInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput, XInput",
      "modeDisplay": "DInput, XInput",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 17,
      "modeRank": 1,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "8",
      "weightOz": "-",
      "dateAdded": "6/29/2020",
      "dateAddedSort": "2020-06-29",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Diamond",
      "p99Tier": "",
      "averageMs": 1.0,
      "sdMs": 0.289,
      "maxMs": 1.54,
      "minMs": 0.484,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 94.0,
      "observedSameFramePct": 94.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "8bitdo - n30 arcade stick 8bitdo n30 arcade stick 8bitdo n30 arcade stick wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired arcade stick wired arcade stick published published arcade stick 8 no - diamond 01-05ms (platinum) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo n30 arcade stick [wired usb xinput] 8bitdo - n30 arcade stick 8bitdo n30 arcade stick [wired usb xinput] wired usb wired wired wired usb xinput dinput, xinput dinput, xinput dinput, xinput ['wired arcade stick'] wired arcade stick diamond arcade stick 8 no - published published actively sold closed source 8bitdo - n30 arcade stick 8bitdo n30 arcade stick 8bitdo n30 arcade stick wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired arcade stick published published arcade stick 8 no - diamond 01-05ms (platinum) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo n30 arcade stick [wired usb xinput] 8bitdo - n30 arcade stick 8bitdo n30 arcade stick [wired usb dinput] wired usb wired wired wired usb dinput dinput dinput dinput ['wired arcade stick'] wired arcade stick platinum arcade stick 8 no - published published actively sold closed source 8bitdo - n30 arcade stick 8bitdo n30 arcade stick 8bitdo n30 arcade stick wired usb wired wired usb dinput dinput wired dinput dinput wired arcade stick published published arcade stick 8 no - platinum 01-05ms (platinum) actively sold closed source mister / pc 0c45:8101 buy link 8bitdo n30 arcade stick [wired usb dinput] 8bitdo - n30 arcade stick 8bitdo n30 arcade stick [bt (csr8510) windows] bluetooth wireless wireless bt bt (csr8510) windows dinput dinput dinput ['wireless arcade stick'] wireless arcade stick silver arcade stick 8 no published published actively sold closed source 8bitdo - n30 arcade stick 8bitdo n30 arcade stick 8bitdo n30 arcade stick bluetooth wireless bt (csr8510) windows dinput wireless bt dinput dinput wireless arcade stick published published arcade stick 8 no silver 05-10ms (gold) actively sold closed source mister / pc 045e:02e0 buy link 8bitdo n30 arcade stick [bt (csr8510) windows] 8bitdo - n30 arcade stick 8bitdo n30 arcade stick [bt (csr8510) macos] bluetooth wireless wireless bt bt (csr8510) macos macos macos macos ['wireless arcade stick'] wireless arcade stick bronze arcade stick 8 no published published actively sold closed source 8bitdo - n30 arcade stick 8bitdo n30 arcade stick 8bitdo n30 arcade stick bluetooth wireless bt (csr8510) macos macos wireless bt macos macos wireless arcade stick published published arcade stick 8 no bronze 15-20ms (bronze) actively sold closed source mister / pc 05cc:05c4 buy link 8bitdo n30 arcade stick [bt (csr8510) macos] 8bitdo - n30 arcade stick 8bitdo n30 arcade stick [bt (csr8510) switch] bluetooth wireless wireless bt bt (csr8510) switch switch switch switch ['wireless arcade stick'] wireless arcade stick bronze arcade stick 8 no published published actively sold closed source 8bitdo - n30 arcade stick 8bitdo n30 arcade stick 8bitdo n30 arcade stick bluetooth wireless bt (csr8510) switch switch wireless bt switch switch wireless arcade stick published published arcade stick 8 no bronze 15-20ms (bronze) actively sold closed source mister / pc switch 045e:02e0 buy link 8bitdo n30 arcade stick [bt (csr8510) switch]",
      "controllerGroupKey": "published|8bitdo n30 arcade stick",
      "modeVariantCount": 5,
      "modeVariants": [
        {
          "id": "published-8bitdo-n30-arcade-stick",
          "name": "8BitDo - N30 Arcade Stick",
          "measurementName": "8BitDo N30 Arcade Stick [Wired USB Xinput]",
          "averageMs": 1.0,
          "averageTier": "Diamond",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 94.0,
          "observedSameFramePct": 94.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Xinput",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 42,
          "modeRank": 1,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "6/29/2020",
          "dateAddedSort": "2020-06-29",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2ZiAPNX",
          "link": "https://amzn.to/2ZiAPNX",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - n30 arcade stick 8bitdo n30 arcade stick 8bitdo n30 arcade stick wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired arcade stick published published arcade stick 8 no - diamond 01-05ms (platinum) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo n30 arcade stick [wired usb xinput]"
        },
        {
          "id": "published-8bitdo-n30-arcade-stick-2",
          "name": "8BitDo - N30 Arcade Stick",
          "measurementName": "8BitDo N30 Arcade Stick [Wired USB Dinput]",
          "averageMs": 1.025,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 93.85,
          "observedSameFramePct": 93.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 45,
          "modeRank": 2,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "6/29/2020",
          "dateAddedSort": "2020-06-29",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2ZiAPNX",
          "link": "https://amzn.to/2ZiAPNX",
          "amazon": "",
          "joystickId": "0c45:8101",
          "searchText": "8bitdo - n30 arcade stick 8bitdo n30 arcade stick 8bitdo n30 arcade stick wired usb wired wired usb dinput dinput wired dinput dinput wired arcade stick published published arcade stick 8 no - platinum 01-05ms (platinum) actively sold closed source mister / pc 0c45:8101 buy link 8bitdo n30 arcade stick [wired usb dinput]"
        },
        {
          "id": "published-8bitdo-n30-arcade-stick-3",
          "name": "8BitDo - N30 Arcade Stick",
          "measurementName": "8BitDo N30 Arcade Stick [BT (CSR8510) Windows]",
          "averageMs": 6.305,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 62.17,
          "observedSameFramePct": 62.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Windows",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Arcade Stick"
          ],
          "rankMode": "Wireless Arcade Stick",
          "overallRank": 198,
          "modeRank": 2,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "6/29/2020",
          "dateAddedSort": "2020-06-29",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2ZiAPNX",
          "link": "https://amzn.to/2ZiAPNX",
          "amazon": "",
          "joystickId": "045e:02e0",
          "searchText": "8bitdo - n30 arcade stick 8bitdo n30 arcade stick 8bitdo n30 arcade stick bluetooth wireless bt (csr8510) windows dinput wireless bt dinput dinput wireless arcade stick published published arcade stick 8 no silver 05-10ms (gold) actively sold closed source mister / pc 045e:02e0 buy link 8bitdo n30 arcade stick [bt (csr8510) windows]"
        },
        {
          "id": "published-8bitdo-n30-arcade-stick-4",
          "name": "8BitDo - N30 Arcade Stick",
          "measurementName": "8BitDo N30 Arcade Stick [BT (CSR8510) MacOS]",
          "averageMs": 15.143,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 9.14,
          "observedSameFramePct": 19.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) MacOS",
          "outputMode": "macOS",
          "modeLabel": "macOS",
          "modeDisplay": "macOS",
          "deviceTypes": [
            "Wireless Arcade Stick"
          ],
          "rankMode": "Wireless Arcade Stick",
          "overallRank": 284,
          "modeRank": 6,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "6/29/2020",
          "dateAddedSort": "2020-06-29",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2ZiAPNX",
          "link": "https://amzn.to/2ZiAPNX",
          "amazon": "",
          "joystickId": "05cc:05c4",
          "searchText": "8bitdo - n30 arcade stick 8bitdo n30 arcade stick 8bitdo n30 arcade stick bluetooth wireless bt (csr8510) macos macos wireless bt macos macos wireless arcade stick published published arcade stick 8 no bronze 15-20ms (bronze) actively sold closed source mister / pc 05cc:05c4 buy link 8bitdo n30 arcade stick [bt (csr8510) macos]"
        },
        {
          "id": "published-8bitdo-n30-arcade-stick-5",
          "name": "8BitDo - N30 Arcade Stick",
          "measurementName": "8BitDo N30 Arcade Stick [BT (CSR8510) Switch]",
          "averageMs": 15.767,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 5.4,
          "observedSameFramePct": 18.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Switch",
          "outputMode": "Switch",
          "modeLabel": "Switch",
          "modeDisplay": "Switch",
          "deviceTypes": [
            "Wireless Arcade Stick"
          ],
          "rankMode": "Wireless Arcade Stick",
          "overallRank": 289,
          "modeRank": 7,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "6/29/2020",
          "dateAddedSort": "2020-06-29",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2ZiAPNX",
          "link": "https://amzn.to/2ZiAPNX",
          "amazon": "",
          "joystickId": "045e:02e0",
          "searchText": "8bitdo - n30 arcade stick 8bitdo n30 arcade stick 8bitdo n30 arcade stick bluetooth wireless bt (csr8510) switch switch wireless bt switch switch wireless arcade stick published published arcade stick 8 no bronze 15-20ms (bronze) actively sold closed source mister / pc switch 045e:02e0 buy link 8bitdo n30 arcade stick [bt (csr8510) switch]"
        }
      ]
    },
    {
      "id": "published-8bitdo-sn30-2-4g-snes-model-81ad",
      "name": "8BitDo - SN30 2.4G SNES (Model 81AD)",
      "measurementName": "8BitDo SN30 2.4G SNES (Model 81AD) [Wired USB]",
      "deviceNorm": "8bitdo sn30 2 4g snes model 81ad",
      "make": "8BitDo",
      "model": "SN30 2.4G SNES (Model 81AD)",
      "link": "https://amzn.to/2OK3hTO",
      "amazon": "",
      "buyUrl": "https://amzn.to/2OK3hTO",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 18,
      "modeRank": 5,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "3.15",
      "dateAdded": "7/20/2020",
      "dateAddedSort": "2020-07-20",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.003,
      "sdMs": 0.311,
      "maxMs": 1.684,
      "minMs": 0.328,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 93.98,
      "observedSameFramePct": 94.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "8bitdo - sn30 2.4g snes (model 81ad) 8bitdo sn30 2 4g snes model 81ad 8bitdo sn30 2.4g snes (model 81ad) wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no 3.15 platinum 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 2.4g snes (model 81ad) [wired usb] 8bitdo - sn30 2.4g snes (model 81ad) 8bitdo sn30 2.4g snes (model 81ad) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller platinum controller 4 no 3.15 published published actively sold closed source 8bitdo - sn30 2.4g snes (model 81ad) 8bitdo sn30 2 4g snes model 81ad 8bitdo sn30 2.4g snes (model 81ad) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.15 platinum 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 2.4g snes (model 81ad) [wired usb] 8bitdo - sn30 2.4g snes (model 81ad) 8bitdo sn30 2.4g snes (model 81ad) [daemonbite snes] 2.4 ghz console wireless wireless 2.4ghz daemonbite snes 2.4g 2.4 ghz console ['wireless controller'] wireless controller bronze controller 4 no 3.15 published published actively sold closed source 8bitdo - sn30 2.4g snes (model 81ad) 8bitdo sn30 2 4g snes model 81ad 8bitdo sn30 2.4g snes (model 81ad) 2.4 ghz console wireless daemonbite snes wireless 2.4ghz 2.4g 2.4 ghz console wireless controller published published controller 4 no 3.15 bronze 10-15ms (silver) actively sold closed source mister / pc 2341:8036 buy link 8bitdo sn30 2.4g snes (model 81ad) [daemonbite snes]",
      "controllerGroupKey": "published|8bitdo sn30 2 4g snes model 81ad",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-8bitdo-sn30-2-4g-snes-model-81ad",
          "name": "8BitDo - SN30 2.4G SNES (Model 81AD)",
          "measurementName": "8BitDo SN30 2.4G SNES (Model 81AD) [Wired USB]",
          "averageMs": 1.003,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 93.98,
          "observedSameFramePct": 94.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 43,
          "modeRank": 5,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.15",
          "dateAdded": "7/20/2020",
          "dateAddedSort": "2020-07-20",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2OK3hTO",
          "link": "https://amzn.to/2OK3hTO",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - sn30 2.4g snes (model 81ad) 8bitdo sn30 2 4g snes model 81ad 8bitdo sn30 2.4g snes (model 81ad) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.15 platinum 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 2.4g snes (model 81ad) [wired usb]"
        },
        {
          "id": "published-8bitdo-sn30-2-4g-snes-model-81ad-2",
          "name": "8BitDo - SN30 2.4G SNES (Model 81AD)",
          "measurementName": "8BitDo SN30 2.4G SNES (Model 81AD) [DaemonBite SNES]",
          "averageMs": 10.918,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 34.49,
          "observedSameFramePct": 34.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz Console",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "DaemonBite SNES",
          "outputMode": "",
          "modeLabel": "2.4G",
          "modeDisplay": "2.4 GHz Console",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 250,
          "modeRank": 38,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.15",
          "dateAdded": "7/20/2020",
          "dateAddedSort": "2020-07-20",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2OK3hTO",
          "link": "https://amzn.to/2OK3hTO",
          "amazon": "",
          "joystickId": "2341:8036",
          "searchText": "8bitdo - sn30 2.4g snes (model 81ad) 8bitdo sn30 2 4g snes model 81ad 8bitdo sn30 2.4g snes (model 81ad) 2.4 ghz console wireless daemonbite snes wireless 2.4ghz 2.4g 2.4 ghz console wireless controller published published controller 4 no 3.15 bronze 10-15ms (silver) actively sold closed source mister / pc 2341:8036 buy link 8bitdo sn30 2.4g snes (model 81ad) [daemonbite snes]"
        }
      ]
    },
    {
      "id": "published-retro-bit-genesis-8-button-usb",
      "name": "Retro-Bit - Genesis 8 Button USB",
      "measurementName": "Retro-Bit Genesis 8 Button USB [Wired USB]",
      "deviceNorm": "retro bit genesis 8 button usb",
      "make": "Retro-Bit",
      "model": "Genesis 8 Button USB",
      "link": "https://amzn.to/38iAajm",
      "amazon": "",
      "buyUrl": "https://amzn.to/38iAajm",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 19,
      "modeRank": 6,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "3.25",
      "dateAdded": "6/30/2020",
      "dateAddedSort": "2020-06-30",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.01,
      "sdMs": 0.46,
      "maxMs": 3.336,
      "minMs": 0.328,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 93.94,
      "observedSameFramePct": 93.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:0011",
      "searchText": "retro-bit - genesis 8 button usb retro bit genesis 8 button usb retro-bit genesis 8 button usb wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 no 3.25 platinum 01-05ms (platinum) actively sold closed source mister / pc switch 0079:0011 buy link retro-bit genesis 8 button usb [wired usb] retro-bit - genesis 8 button usb retro-bit genesis 8 button usb [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller platinum controller 6 no 3.25 published published actively sold closed source retro-bit - genesis 8 button usb retro bit genesis 8 button usb retro-bit genesis 8 button usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 3.25 platinum 01-05ms (platinum) actively sold closed source mister / pc switch 0079:0011 buy link retro-bit genesis 8 button usb [wired usb]",
      "controllerGroupKey": "published|retro bit genesis 8 button usb",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retro-bit-genesis-8-button-usb",
          "name": "Retro-Bit - Genesis 8 Button USB",
          "measurementName": "Retro-Bit Genesis 8 Button USB [Wired USB]",
          "averageMs": 1.01,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 93.94,
          "observedSameFramePct": 93.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 44,
          "modeRank": 6,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "3.25",
          "dateAdded": "6/30/2020",
          "dateAddedSort": "2020-06-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/38iAajm",
          "link": "https://amzn.to/38iAajm",
          "amazon": "",
          "joystickId": "0079:0011",
          "searchText": "retro-bit - genesis 8 button usb retro bit genesis 8 button usb retro-bit genesis 8 button usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 3.25 platinum 01-05ms (platinum) actively sold closed source mister / pc switch 0079:0011 buy link retro-bit genesis 8 button usb [wired usb]"
        }
      ]
    },
    {
      "id": "published-8bitdo-pce-2-4g-wireless-gamepad",
      "name": "8BitDo - PCE 2.4G Wireless Gamepad",
      "measurementName": "8BitDo PCE 2.4G Wireless Gamepad [Wired USB] FW 2.14",
      "deviceNorm": "8bitdo pce 2 4g wireless gamepad",
      "make": "8BitDo",
      "model": "PCE 2.4G Wireless Gamepad",
      "link": "https://amzn.to/36S6CZe",
      "amazon": "",
      "buyUrl": "https://amzn.to/36S6CZe",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 20,
      "modeRank": 7,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "2",
      "weightOz": "2.70",
      "dateAdded": "5/30/2020",
      "dateAddedSort": "2020-05-30",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.033,
      "sdMs": 0.345,
      "maxMs": 8.008,
      "minMs": 0.38,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 93.8,
      "observedSameFramePct": 93.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2 4g wireless gamepad 8bitdo pce 2.4g wireless gamepad wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 2 yes 2.70 platinum 01-05ms (platinum) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo pce 2.4g wireless gamepad [wired usb] fw 2.14 8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2.4g wireless gamepad [wired usb] fw 2.14 wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller platinum controller 2 yes 2.70 published published actively sold closed source 8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2 4g wireless gamepad 8bitdo pce 2.4g wireless gamepad wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 2 yes 2.70 platinum 01-05ms (platinum) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo pce 2.4g wireless gamepad [wired usb] fw 2.14 8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2.4g wireless gamepad [wired usb] fw 2.15 wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller platinum controller 2 yes 2.70 published published actively sold closed source 8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2 4g wireless gamepad 8bitdo pce 2.4g wireless gamepad wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 2 yes 2.70 platinum 01-05ms (platinum) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo pce 2.4g wireless gamepad [wired usb] fw 2.15 8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2.4g wireless gamepad [8bitdo 2.4g usb dongle] fw 2.15 2.4 ghz usb wireless wireless 2.4ghz 8bitdo 2.4g usb dongle dinput dinput dinput ['wireless controller'] wireless controller silver controller 2 yes 2.70 published published actively sold closed source 8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2 4g wireless gamepad 8bitdo pce 2.4g wireless gamepad 2.4 ghz usb wireless 8bitdo 2.4g usb dongle dinput wireless 2.4ghz dinput dinput wireless controller published published controller 2 yes 2.70 silver 05-10ms (gold) actively sold closed source mister / pc switch 0f0d:0138 buy link 8bitdo pce 2.4g wireless gamepad [8bitdo 2.4g usb dongle] fw 2.15 8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2.4g wireless gamepad [8bitdo 2.4g usb dongle] fw 2.14 2.4 ghz usb wireless wireless 2.4ghz 8bitdo 2.4g usb dongle dinput dinput dinput ['wireless controller'] wireless controller silver controller 2 yes 2.70 published published actively sold closed source 8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2 4g wireless gamepad 8bitdo pce 2.4g wireless gamepad 2.4 ghz usb wireless 8bitdo 2.4g usb dongle dinput wireless 2.4ghz dinput dinput wireless controller published published controller 2 yes 2.70 silver 05-10ms (gold) actively sold closed source mister / pc switch 0f0d:0138 buy link 8bitdo pce 2.4g wireless gamepad [8bitdo 2.4g usb dongle] fw 2.14",
      "controllerGroupKey": "published|8bitdo pce 2 4g wireless gamepad",
      "modeVariantCount": 4,
      "modeVariants": [
        {
          "id": "published-8bitdo-pce-2-4g-wireless-gamepad",
          "name": "8BitDo - PCE 2.4G Wireless Gamepad",
          "measurementName": "8BitDo PCE 2.4G Wireless Gamepad [Wired USB] FW 2.14",
          "averageMs": 1.033,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 93.8,
          "observedSameFramePct": 93.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 46,
          "modeRank": 7,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "2",
          "homeButton": "Yes",
          "weightOz": "2.70",
          "dateAdded": "5/30/2020",
          "dateAddedSort": "2020-05-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/36S6CZe",
          "link": "https://amzn.to/36S6CZe",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2 4g wireless gamepad 8bitdo pce 2.4g wireless gamepad wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 2 yes 2.70 platinum 01-05ms (platinum) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo pce 2.4g wireless gamepad [wired usb] fw 2.14"
        },
        {
          "id": "published-8bitdo-pce-2-4g-wireless-gamepad-2",
          "name": "8BitDo - PCE 2.4G Wireless Gamepad",
          "measurementName": "8BitDo PCE 2.4G Wireless Gamepad [Wired USB] FW 2.15",
          "averageMs": 1.05,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 93.7,
          "observedSameFramePct": 93.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 49,
          "modeRank": 10,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "2",
          "homeButton": "Yes",
          "weightOz": "2.70",
          "dateAdded": "5/30/2020",
          "dateAddedSort": "2020-05-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/36S6CZe",
          "link": "https://amzn.to/36S6CZe",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2 4g wireless gamepad 8bitdo pce 2.4g wireless gamepad wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 2 yes 2.70 platinum 01-05ms (platinum) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo pce 2.4g wireless gamepad [wired usb] fw 2.15"
        },
        {
          "id": "published-8bitdo-pce-2-4g-wireless-gamepad-3",
          "name": "8BitDo - PCE 2.4G Wireless Gamepad",
          "measurementName": "8BitDo PCE 2.4G Wireless Gamepad [8BitDo 2.4G USB Dongle] FW 2.15",
          "averageMs": 7.424,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 55.46,
          "observedSameFramePct": 55.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "8BitDo 2.4G USB Dongle",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 213,
          "modeRank": 17,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "2",
          "homeButton": "Yes",
          "weightOz": "2.70",
          "dateAdded": "5/30/2020",
          "dateAddedSort": "2020-05-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/36S6CZe",
          "link": "https://amzn.to/36S6CZe",
          "amazon": "",
          "joystickId": "0f0d:0138",
          "searchText": "8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2 4g wireless gamepad 8bitdo pce 2.4g wireless gamepad 2.4 ghz usb wireless 8bitdo 2.4g usb dongle dinput wireless 2.4ghz dinput dinput wireless controller published published controller 2 yes 2.70 silver 05-10ms (gold) actively sold closed source mister / pc switch 0f0d:0138 buy link 8bitdo pce 2.4g wireless gamepad [8bitdo 2.4g usb dongle] fw 2.15"
        },
        {
          "id": "published-8bitdo-pce-2-4g-wireless-gamepad-4",
          "name": "8BitDo - PCE 2.4G Wireless Gamepad",
          "measurementName": "8BitDo PCE 2.4G Wireless Gamepad [8BitDo 2.4G USB Dongle] FW 2.14",
          "averageMs": 7.57,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 54.58,
          "observedSameFramePct": 54.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "8BitDo 2.4G USB Dongle",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 214,
          "modeRank": 18,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "2",
          "homeButton": "Yes",
          "weightOz": "2.70",
          "dateAdded": "5/30/2020",
          "dateAddedSort": "2020-05-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/36S6CZe",
          "link": "https://amzn.to/36S6CZe",
          "amazon": "",
          "joystickId": "0f0d:0138",
          "searchText": "8bitdo - pce 2.4g wireless gamepad 8bitdo pce 2 4g wireless gamepad 8bitdo pce 2.4g wireless gamepad 2.4 ghz usb wireless 8bitdo 2.4g usb dongle dinput wireless 2.4ghz dinput dinput wireless controller published published controller 2 yes 2.70 silver 05-10ms (gold) actively sold closed source mister / pc switch 0f0d:0138 buy link 8bitdo pce 2.4g wireless gamepad [8bitdo 2.4g usb dongle] fw 2.14"
        }
      ]
    },
    {
      "id": "published-retro-bit-saturn-wired",
      "name": "Retro-Bit - Saturn Wired",
      "measurementName": "Retro-Bit Saturn Wired [Wired USB Dinput]",
      "deviceNorm": "retro bit saturn wired",
      "make": "Retro-Bit",
      "model": "Saturn Wired",
      "link": "https://amzn.to/3er6EtL",
      "amazon": "",
      "buyUrl": "https://amzn.to/3er6EtL",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Dinput",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 21,
      "modeRank": 8,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "3.05",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.045,
      "sdMs": 0.505,
      "maxMs": 3.816,
      "minMs": 0.348,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 93.73,
      "observedSameFramePct": 93.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:0011",
      "searchText": "retro-bit - saturn wired retro bit saturn wired retro-bit saturn wired wired usb wired wired usb dinput dinput wired dinput dinput wired controller wired controller published published controller 6 no 3.05 platinum 01-05ms (platinum) actively sold closed source mister / pc 0079:0011 buy link retro-bit saturn wired [wired usb dinput] retro-bit - saturn wired retro-bit saturn wired [wired usb dinput] wired usb wired wired wired usb dinput dinput dinput dinput ['wired controller'] wired controller platinum controller 6 no 3.05 published published actively sold closed source retro-bit - saturn wired retro bit saturn wired retro-bit saturn wired wired usb wired wired usb dinput dinput wired dinput dinput wired controller published published controller 6 no 3.05 platinum 01-05ms (platinum) actively sold closed source mister / pc 0079:0011 buy link retro-bit saturn wired [wired usb dinput] retro-bit - saturn wired retro-bit saturn wired [wired usb xinput] wired usb wired wired wired usb xinput dinput, xinput dinput, xinput dinput, xinput ['wired controller'] wired controller platinum controller 6 no 3.05 published published actively sold closed source retro-bit - saturn wired retro bit saturn wired retro-bit saturn wired wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired controller published published controller 6 no 3.05 platinum 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link retro-bit saturn wired [wired usb xinput]",
      "controllerGroupKey": "published|retro bit saturn wired",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-retro-bit-saturn-wired",
          "name": "Retro-Bit - Saturn Wired",
          "measurementName": "Retro-Bit Saturn Wired [Wired USB Dinput]",
          "averageMs": 1.045,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 93.73,
          "observedSameFramePct": 93.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 47,
          "modeRank": 8,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "3.05",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3er6EtL",
          "link": "https://amzn.to/3er6EtL",
          "amazon": "",
          "joystickId": "0079:0011",
          "searchText": "retro-bit - saturn wired retro bit saturn wired retro-bit saturn wired wired usb wired wired usb dinput dinput wired dinput dinput wired controller published published controller 6 no 3.05 platinum 01-05ms (platinum) actively sold closed source mister / pc 0079:0011 buy link retro-bit saturn wired [wired usb dinput]"
        },
        {
          "id": "published-retro-bit-saturn-wired-2",
          "name": "Retro-Bit - Saturn Wired",
          "measurementName": "Retro-Bit Saturn Wired [Wired USB Xinput]",
          "averageMs": 1.071,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 93.57,
          "observedSameFramePct": 93.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Xinput",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 52,
          "modeRank": 12,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "3.05",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3er6EtL",
          "link": "https://amzn.to/3er6EtL",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "retro-bit - saturn wired retro bit saturn wired retro-bit saturn wired wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired controller published published controller 6 no 3.05 platinum 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link retro-bit saturn wired [wired usb xinput]"
        }
      ]
    },
    {
      "id": "published-8bitdo-m30-genesis-mini-and-switch",
      "name": "8BitDo - M30 (Genesis Mini & Switch)",
      "measurementName": "8BitDo M30 (Genesis Mini & Switch) [Wired USB]",
      "deviceNorm": "8bitdo m30 genesis mini and switch",
      "make": "8BitDo",
      "model": "M30 (Genesis Mini & Switch)",
      "link": "https://amzn.to/3gjUswB",
      "amazon": "",
      "buyUrl": "https://amzn.to/3gjUswB",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 22,
      "modeRank": 9,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "4.00",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.05,
      "sdMs": 0.14,
      "maxMs": 1.62,
      "minMs": 0.47,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 93.7,
      "observedSameFramePct": 93.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "8bitdo - m30 (genesis mini & switch) 8bitdo m30 genesis mini and switch 8bitdo m30 (genesis mini & switch) wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 yes 4.00 platinum 01-05ms (platinum) actively sold closed source mister / pc switch buy link 8bitdo m30 (genesis mini & switch) [wired usb] 8bitdo - m30 (genesis mini & switch) 8bitdo m30 (genesis mini & switch) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller platinum controller 6 yes 4.00 published published actively sold closed source 8bitdo - m30 (genesis mini & switch) 8bitdo m30 genesis mini and switch 8bitdo m30 (genesis mini & switch) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 4.00 platinum 01-05ms (platinum) actively sold closed source mister / pc switch buy link 8bitdo m30 (genesis mini & switch) [wired usb] 8bitdo - m30 (genesis mini & switch) 8bitdo m30 (genesis mini & switch) [2.4 ghz usb] 2.4 ghz usb wireless wireless 2.4ghz 2.4 ghz usb dinput dinput dinput ['wireless controller'] wireless controller bronze controller 6 yes 4.00 published published actively sold closed source 8bitdo - m30 (genesis mini & switch) 8bitdo m30 genesis mini and switch 8bitdo m30 (genesis mini & switch) 2.4 ghz usb wireless 2.4 ghz usb dinput wireless 2.4ghz dinput dinput wireless controller published published controller 6 yes 4.00 bronze 10-15ms (silver) actively sold closed source mister / pc switch buy link 8bitdo m30 (genesis mini & switch) [2.4 ghz usb]",
      "controllerGroupKey": "published|8bitdo m30 genesis mini and switch",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-8bitdo-m30-genesis-mini-and-switch",
          "name": "8BitDo - M30 (Genesis Mini & Switch)",
          "measurementName": "8BitDo M30 (Genesis Mini & Switch) [Wired USB]",
          "averageMs": 1.05,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 93.7,
          "observedSameFramePct": 93.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 48,
          "modeRank": 9,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.00",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3gjUswB",
          "link": "https://amzn.to/3gjUswB",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - m30 (genesis mini & switch) 8bitdo m30 genesis mini and switch 8bitdo m30 (genesis mini & switch) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 4.00 platinum 01-05ms (platinum) actively sold closed source mister / pc switch buy link 8bitdo m30 (genesis mini & switch) [wired usb]"
        },
        {
          "id": "published-8bitdo-m30-genesis-mini-and-switch-2",
          "name": "8BitDo - M30 (Genesis Mini & Switch)",
          "measurementName": "8BitDo M30 (Genesis Mini & Switch) [2.4 GHz USB]",
          "averageMs": 10.8,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 35.2,
          "observedSameFramePct": 36.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "2.4 GHz USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 248,
          "modeRank": 37,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.00",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3gjUswB",
          "link": "https://amzn.to/3gjUswB",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - m30 (genesis mini & switch) 8bitdo m30 genesis mini and switch 8bitdo m30 (genesis mini & switch) 2.4 ghz usb wireless 2.4 ghz usb dinput wireless 2.4ghz dinput dinput wireless controller published published controller 6 yes 4.00 bronze 10-15ms (silver) actively sold closed source mister / pc switch buy link 8bitdo m30 (genesis mini & switch) [2.4 ghz usb]"
        }
      ]
    },
    {
      "id": "published-8bitdo-m30-genesis-de9",
      "name": "8BitDo - M30 (Genesis DE9)",
      "measurementName": "8BitDo M30 (Genesis DE9) [Wired USB]",
      "deviceNorm": "8bitdo m30 genesis de9",
      "make": "8BitDo",
      "model": "M30 (Genesis DE9)",
      "link": "https://amzn.to/2X5KZBL",
      "amazon": "",
      "buyUrl": "https://amzn.to/2X5KZBL",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 23,
      "modeRank": 10,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "4.00",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.065,
      "sdMs": 0.314,
      "maxMs": 1.792,
      "minMs": 0.34,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 93.61,
      "observedSameFramePct": 93.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "8bitdo - m30 (genesis de9) 8bitdo m30 genesis de9 8bitdo m30 (genesis de9) wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 yes 4.00 platinum 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link 8bitdo m30 (genesis de9) [wired usb] 8bitdo - m30 (genesis de9) 8bitdo m30 (genesis de9) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller platinum controller 6 yes 4.00 published published actively sold closed source 8bitdo - m30 (genesis de9) 8bitdo m30 genesis de9 8bitdo m30 (genesis de9) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 4.00 platinum 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link 8bitdo m30 (genesis de9) [wired usb] 8bitdo - m30 (genesis de9) 8bitdo m30 (genesis de9) [daemonbite genesis] 2.4 ghz console wireless wireless 2.4ghz daemonbite genesis 2.4g 2.4 ghz console ['wireless controller'] wireless controller gold controller 6 yes 4.00 published published actively sold closed source 8bitdo - m30 (genesis de9) 8bitdo m30 genesis de9 8bitdo m30 (genesis de9) 2.4 ghz console wireless daemonbite genesis wireless 2.4ghz 2.4g 2.4 ghz console wireless controller published published controller 6 yes 4.00 gold 01-05ms (platinum) actively sold closed source mister / pc 2341:8036 buy link 8bitdo m30 (genesis de9) [daemonbite genesis]",
      "controllerGroupKey": "published|8bitdo m30 genesis de9",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-8bitdo-m30-genesis-de9",
          "name": "8BitDo - M30 (Genesis DE9)",
          "measurementName": "8BitDo M30 (Genesis DE9) [Wired USB]",
          "averageMs": 1.065,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 93.61,
          "observedSameFramePct": 93.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 51,
          "modeRank": 11,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.00",
          "dateAdded": "5/30/2020",
          "dateAddedSort": "2020-05-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2X5KZBL",
          "link": "https://amzn.to/2X5KZBL",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - m30 (genesis de9) 8bitdo m30 genesis de9 8bitdo m30 (genesis de9) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 4.00 platinum 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link 8bitdo m30 (genesis de9) [wired usb]"
        },
        {
          "id": "published-8bitdo-m30-genesis-de9-2",
          "name": "8BitDo - M30 (Genesis DE9)",
          "measurementName": "8BitDo M30 (Genesis DE9) [DaemonBite Genesis]",
          "averageMs": 4.54,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 72.76,
          "observedSameFramePct": 72.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz Console",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "DaemonBite Genesis",
          "outputMode": "",
          "modeLabel": "2.4G",
          "modeDisplay": "2.4 GHz Console",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 145,
          "modeRank": 4,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.00",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2X5KZBL",
          "link": "https://amzn.to/2X5KZBL",
          "amazon": "",
          "joystickId": "2341:8036",
          "searchText": "8bitdo - m30 (genesis de9) 8bitdo m30 genesis de9 8bitdo m30 (genesis de9) 2.4 ghz console wireless daemonbite genesis wireless 2.4ghz 2.4g 2.4 ghz console wireless controller published published controller 6 yes 4.00 gold 01-05ms (platinum) actively sold closed source mister / pc 2341:8036 buy link 8bitdo m30 (genesis de9) [daemonbite genesis]"
        }
      ]
    },
    {
      "id": "published-mayflash-f300",
      "name": "Mayflash - F300",
      "measurementName": "Mayflash - F300 [DInput PS3 FW V1.23]",
      "deviceNorm": "mayflash f300",
      "make": "Mayflash",
      "model": "F300",
      "link": "https://amzn.to/2XMwcMB",
      "amazon": "",
      "buyUrl": "https://amzn.to/2XMwcMB",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "DInput PS3 FW V1.23",
      "outputMode": "DInput, PS3",
      "connectionTag": "Wired",
      "modeLabel": "DInput, PS3",
      "modeDisplay": "DInput, PS3",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 24,
      "modeRank": 2,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "7/16/2024",
      "dateAddedSort": "2024-07-16",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "Gold",
      "averageMs": 1.271,
      "sdMs": 0.416,
      "maxMs": 3.23,
      "minMs": 0.28,
      "p99Ms": 2.16,
      "sampleCount": 8804,
      "sameFramePct": 92.37,
      "observedSameFramePct": 92.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "mayflash - f300 mayflash f300 mayflash f300 wired usb wired dinput ps3 fw v1.23 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f300 [dinput ps3 fw v1.23] mayflash - f300 mayflash - f300 [dinput ps3 fw v1.23] wired usb wired wired dinput ps3 fw v1.23 dinput, ps3 dinput, ps3 dinput, ps3 ['wired arcade stick'] wired arcade stick platinum gold arcade stick published published actively sold closed source mayflash - f300 mayflash f300 mayflash f300 wired usb wired dinput ps3 fw v1.23 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f300 [dinput ps3 fw v1.23] mayflash - f300 mayflash - f300 [xinput switch fw v1.23] wired usb wired wired xinput switch fw v1.23 xinput, switch xinput, switch xinput, switch ['wired arcade stick'] wired arcade stick platinum gold arcade stick published published actively sold closed source mayflash - f300 mayflash f300 mayflash f300 wired usb wired xinput switch fw v1.23 xinput, switch wired xinput, switch xinput, switch wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f300 [xinput switch fw v1.23]",
      "controllerGroupKey": "published|mayflash f300",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-mayflash-f300",
          "name": "Mayflash - F300",
          "measurementName": "Mayflash - F300 [DInput PS3 FW V1.23]",
          "averageMs": 1.271,
          "averageTier": "Platinum",
          "p99Ms": 2.16,
          "p99Tier": "Gold",
          "sameFramePct": 92.37,
          "observedSameFramePct": 92.4,
          "sampleCount": 8804,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "DInput PS3 FW V1.23",
          "outputMode": "DInput, PS3",
          "modeLabel": "DInput, PS3",
          "modeDisplay": "DInput, PS3",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 56,
          "modeRank": 3,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/16/2024",
          "dateAddedSort": "2024-07-16",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2XMwcMB",
          "link": "https://amzn.to/2XMwcMB",
          "amazon": "",
          "joystickId": "",
          "searchText": "mayflash - f300 mayflash f300 mayflash f300 wired usb wired dinput ps3 fw v1.23 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f300 [dinput ps3 fw v1.23]"
        },
        {
          "id": "published-mayflash-f300-2",
          "name": "Mayflash - F300",
          "measurementName": "Mayflash - F300 [Xinput Switch FW V1.23]",
          "averageMs": 1.405,
          "averageTier": "Platinum",
          "p99Ms": 2.171,
          "p99Tier": "Gold",
          "sameFramePct": 91.57,
          "observedSameFramePct": 91.6,
          "sampleCount": 2393,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Xinput Switch FW V1.23",
          "outputMode": "XInput, Switch",
          "modeLabel": "XInput, Switch",
          "modeDisplay": "XInput, Switch",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 65,
          "modeRank": 10,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/16/2024",
          "dateAddedSort": "2024-07-16",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2XMwcMB",
          "link": "https://amzn.to/2XMwcMB",
          "amazon": "",
          "joystickId": "",
          "searchText": "mayflash - f300 mayflash f300 mayflash f300 wired usb wired xinput switch fw v1.23 xinput, switch wired xinput, switch xinput, switch wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f300 [xinput switch fw v1.23]"
        }
      ]
    },
    {
      "id": "published-mayflash-f300-elite",
      "name": "Mayflash - F300 Elite",
      "measurementName": "Mayflash - F300 Elite [Xinput Switch FW V1.10]",
      "deviceNorm": "mayflash f300 elite",
      "make": "Mayflash",
      "model": "F300 Elite",
      "link": "https://amzn.to/3y24gcl",
      "amazon": "",
      "buyUrl": "https://amzn.to/3y24gcl",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Xinput Switch FW V1.10",
      "outputMode": "XInput, Switch",
      "connectionTag": "Wired",
      "modeLabel": "XInput, Switch",
      "modeDisplay": "XInput, Switch",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 25,
      "modeRank": 3,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "7/16/2024",
      "dateAddedSort": "2024-07-16",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "Gold",
      "averageMs": 1.291,
      "sdMs": 0.442,
      "maxMs": 8.69,
      "minMs": 0.26,
      "p99Ms": 2.15,
      "sampleCount": 2547,
      "sameFramePct": 92.25,
      "observedSameFramePct": 92.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "mayflash - f300 elite mayflash f300 elite mayflash f300 elite wired usb wired xinput switch fw v1.10 xinput, switch wired xinput, switch xinput, switch wired arcade stick wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f300 elite [xinput switch fw v1.10] mayflash - f300 elite mayflash - f300 elite [xinput switch fw v1.10] wired usb wired wired xinput switch fw v1.10 xinput, switch xinput, switch xinput, switch ['wired arcade stick'] wired arcade stick platinum gold arcade stick published published actively sold closed source mayflash - f300 elite mayflash f300 elite mayflash f300 elite wired usb wired xinput switch fw v1.10 xinput, switch wired xinput, switch xinput, switch wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f300 elite [xinput switch fw v1.10] mayflash - f300 elite mayflash - f300 elite [dinput ps3 fw v1.10] wired usb wired wired dinput ps3 fw v1.10 dinput, ps3 dinput, ps3 dinput, ps3 ['wired arcade stick'] wired arcade stick platinum gold arcade stick published published actively sold closed source mayflash - f300 elite mayflash f300 elite mayflash f300 elite wired usb wired dinput ps3 fw v1.10 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f300 elite [dinput ps3 fw v1.10]",
      "controllerGroupKey": "published|mayflash f300 elite",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-mayflash-f300-elite",
          "name": "Mayflash - F300 Elite",
          "measurementName": "Mayflash - F300 Elite [Xinput Switch FW V1.10]",
          "averageMs": 1.291,
          "averageTier": "Platinum",
          "p99Ms": 2.15,
          "p99Tier": "Gold",
          "sameFramePct": 92.25,
          "observedSameFramePct": 92.3,
          "sampleCount": 2547,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Xinput Switch FW V1.10",
          "outputMode": "XInput, Switch",
          "modeLabel": "XInput, Switch",
          "modeDisplay": "XInput, Switch",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 57,
          "modeRank": 4,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/16/2024",
          "dateAddedSort": "2024-07-16",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3y24gcl",
          "link": "https://amzn.to/3y24gcl",
          "amazon": "",
          "joystickId": "",
          "searchText": "mayflash - f300 elite mayflash f300 elite mayflash f300 elite wired usb wired xinput switch fw v1.10 xinput, switch wired xinput, switch xinput, switch wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f300 elite [xinput switch fw v1.10]"
        },
        {
          "id": "published-mayflash-f300-elite-2",
          "name": "Mayflash - F300 Elite",
          "measurementName": "Mayflash - F300 Elite [DInput PS3 FW V1.10]",
          "averageMs": 1.339,
          "averageTier": "Platinum",
          "p99Ms": 2.16,
          "p99Tier": "Gold",
          "sameFramePct": 91.97,
          "observedSameFramePct": 92.0,
          "sampleCount": 2066,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "DInput PS3 FW V1.10",
          "outputMode": "DInput, PS3",
          "modeLabel": "DInput, PS3",
          "modeDisplay": "DInput, PS3",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 59,
          "modeRank": 5,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/16/2024",
          "dateAddedSort": "2024-07-16",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3y24gcl",
          "link": "https://amzn.to/3y24gcl",
          "amazon": "",
          "joystickId": "",
          "searchText": "mayflash - f300 elite mayflash f300 elite mayflash f300 elite wired usb wired dinput ps3 fw v1.10 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f300 elite [dinput ps3 fw v1.10]"
        }
      ]
    },
    {
      "id": "published-hori-fighting-commander-ps4-v2",
      "name": "Hori - Fighting Commander PS4 V2",
      "measurementName": "Hori Fighting Commander PS4 V2 [Wired USB PC]",
      "deviceNorm": "hori fighting commander ps4 v2",
      "make": "Hori",
      "model": "Fighting Commander PS4 V2",
      "link": "https://amzn.to/2AbyZFO",
      "amazon": "",
      "buyUrl": "https://amzn.to/2AbyZFO",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB PC",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 26,
      "modeRank": 11,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "5.35",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.332,
      "sdMs": 0.411,
      "maxMs": 2.304,
      "minMs": 0.372,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 92.01,
      "observedSameFramePct": 92.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0f0d:0086",
      "searchText": "hori - fighting commander ps4 v2 hori fighting commander ps4 v2 hori fighting commander ps4 v2 wired usb wired wired usb pc dinput wired dinput dinput wired controller wired controller published published controller 6 yes 5.35 platinum 01-05ms (platinum) actively sold closed source mister / pc 0f0d:0086 buy link hori fighting commander ps4 v2 [wired usb pc] hori - fighting commander ps4 v2 hori fighting commander ps4 v2 [wired usb pc] wired usb wired wired wired usb pc dinput dinput dinput ['wired controller'] wired controller platinum controller 6 yes 5.35 published published actively sold closed source hori - fighting commander ps4 v2 hori fighting commander ps4 v2 hori fighting commander ps4 v2 wired usb wired wired usb pc dinput wired dinput dinput wired controller published published controller 6 yes 5.35 platinum 01-05ms (platinum) actively sold closed source mister / pc 0f0d:0086 buy link hori fighting commander ps4 v2 [wired usb pc] hori - fighting commander ps4 v2 hori fighting commander ps4 v2 [wired usb ps3] wired usb wired wired wired usb ps3 dinput, ps3 dinput, ps3 dinput, ps3 ['wired controller'] wired controller gold controller 6 yes 5.35 published published actively sold closed source hori - fighting commander ps4 v2 hori fighting commander ps4 v2 hori fighting commander ps4 v2 wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired controller published published controller 6 yes 5.35 gold 01-05ms (platinum) actively sold closed source mister / pc 0f0d:0085 buy link hori fighting commander ps4 v2 [wired usb ps3] hori - fighting commander ps4 v2 hori fighting commander ps4 v2 [wired usb ps4] wired usb wired wired wired usb ps4 dinput, ps4 dinput, ps4 dinput, ps4 ['wired controller'] wired controller gold controller 6 yes 5.35 published published actively sold closed source hori - fighting commander ps4 v2 hori fighting commander ps4 v2 hori fighting commander ps4 v2 wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 wired controller published published controller 6 yes 5.35 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 0f0d:0084 buy link hori fighting commander ps4 v2 [wired usb ps4]",
      "controllerGroupKey": "published|hori fighting commander ps4 v2",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-hori-fighting-commander-ps4-v2",
          "name": "Hori - Fighting Commander PS4 V2",
          "measurementName": "Hori Fighting Commander PS4 V2 [Wired USB PC]",
          "averageMs": 1.332,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 92.01,
          "observedSameFramePct": 92.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PC",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 58,
          "modeRank": 13,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "5.35",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2AbyZFO",
          "link": "https://amzn.to/2AbyZFO",
          "amazon": "",
          "joystickId": "0f0d:0086",
          "searchText": "hori - fighting commander ps4 v2 hori fighting commander ps4 v2 hori fighting commander ps4 v2 wired usb wired wired usb pc dinput wired dinput dinput wired controller published published controller 6 yes 5.35 platinum 01-05ms (platinum) actively sold closed source mister / pc 0f0d:0086 buy link hori fighting commander ps4 v2 [wired usb pc]"
        },
        {
          "id": "published-hori-fighting-commander-ps4-v2-2",
          "name": "Hori - Fighting Commander PS4 V2",
          "measurementName": "Hori Fighting Commander PS4 V2 [Wired USB PS3]",
          "averageMs": 2.185,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 86.89,
          "observedSameFramePct": 86.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PS3",
          "outputMode": "DInput, PS3",
          "modeLabel": "DInput, PS3",
          "modeDisplay": "DInput, PS3",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 97,
          "modeRank": 21,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "5.35",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2AbyZFO",
          "link": "https://amzn.to/2AbyZFO",
          "amazon": "",
          "joystickId": "0f0d:0085",
          "searchText": "hori - fighting commander ps4 v2 hori fighting commander ps4 v2 hori fighting commander ps4 v2 wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired controller published published controller 6 yes 5.35 gold 01-05ms (platinum) actively sold closed source mister / pc 0f0d:0085 buy link hori fighting commander ps4 v2 [wired usb ps3]"
        },
        {
          "id": "published-hori-fighting-commander-ps4-v2-3",
          "name": "Hori - Fighting Commander PS4 V2",
          "measurementName": "Hori Fighting Commander PS4 V2 [Wired USB PS4]",
          "averageMs": 2.206,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 86.76,
          "observedSameFramePct": 86.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PS4",
          "outputMode": "DInput, PS4",
          "modeLabel": "DInput, PS4",
          "modeDisplay": "DInput, PS4",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 98,
          "modeRank": 22,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "5.35",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2AbyZFO",
          "link": "https://amzn.to/2AbyZFO",
          "amazon": "",
          "joystickId": "0f0d:0084",
          "searchText": "hori - fighting commander ps4 v2 hori fighting commander ps4 v2 hori fighting commander ps4 v2 wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 wired controller published published controller 6 yes 5.35 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 0f0d:0084 buy link hori fighting commander ps4 v2 [wired usb ps4]"
        }
      ]
    },
    {
      "id": "published-mayflash-f500-elite",
      "name": "Mayflash - F500 Elite",
      "measurementName": "Mayflash - F500 Elite [DInput PS3 SNK FW V1.12]",
      "deviceNorm": "mayflash f500 elite",
      "make": "Mayflash",
      "model": "F500 Elite",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "DInput PS3 SNK FW V1.12",
      "outputMode": "DInput, PS3",
      "connectionTag": "Wired",
      "modeLabel": "DInput, PS3",
      "modeDisplay": "DInput, PS3",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 27,
      "modeRank": 4,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "Gold",
      "averageMs": 1.35,
      "sdMs": 0.387,
      "maxMs": 2.32,
      "minMs": 0.39,
      "p99Ms": 2.18,
      "sampleCount": 2707,
      "sameFramePct": 91.9,
      "observedSameFramePct": 91.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "mayflash - f500 elite mayflash f500 elite mayflash f500 elite wired usb wired dinput ps3 snk fw v1.12 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) unknown closed source mister / pc raw capture mayflash - f500 elite [dinput ps3 snk fw v1.12] mayflash - f500 elite mayflash - f500 elite [dinput ps3 snk fw v1.12] wired usb wired wired dinput ps3 snk fw v1.12 dinput, ps3 dinput, ps3 dinput, ps3 ['wired arcade stick'] wired arcade stick platinum gold arcade stick published published unknown closed source mayflash - f500 elite mayflash f500 elite mayflash f500 elite wired usb wired dinput ps3 snk fw v1.12 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) unknown closed source mister / pc raw capture mayflash - f500 elite [dinput ps3 snk fw v1.12] mayflash - f500 elite mayflash - f500 elite [xinput fw v1.12] wired usb wired wired xinput fw v1.12 xinput xinput xinput ['wired arcade stick'] wired arcade stick platinum gold arcade stick published published unknown closed source mayflash - f500 elite mayflash f500 elite mayflash f500 elite wired usb wired xinput fw v1.12 xinput wired xinput xinput wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) unknown closed source mister / pc raw capture mayflash - f500 elite [xinput fw v1.12]",
      "controllerGroupKey": "published|mayflash f500 elite",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-mayflash-f500-elite",
          "name": "Mayflash - F500 Elite",
          "measurementName": "Mayflash - F500 Elite [DInput PS3 SNK FW V1.12]",
          "averageMs": 1.35,
          "averageTier": "Platinum",
          "p99Ms": 2.18,
          "p99Tier": "Gold",
          "sameFramePct": 91.9,
          "observedSameFramePct": 91.9,
          "sampleCount": 2707,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "DInput PS3 SNK FW V1.12",
          "outputMode": "DInput, PS3",
          "modeLabel": "DInput, PS3",
          "modeDisplay": "DInput, PS3",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 61,
          "modeRank": 6,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "mayflash - f500 elite mayflash f500 elite mayflash f500 elite wired usb wired dinput ps3 snk fw v1.12 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) unknown closed source mister / pc raw capture mayflash - f500 elite [dinput ps3 snk fw v1.12]"
        },
        {
          "id": "published-mayflash-f500-elite-2",
          "name": "Mayflash - F500 Elite",
          "measurementName": "Mayflash - F500 Elite [Xinput FW V1.12]",
          "averageMs": 1.35,
          "averageTier": "Platinum",
          "p99Ms": 2.18,
          "p99Tier": "Gold",
          "sameFramePct": 91.9,
          "observedSameFramePct": 91.9,
          "sampleCount": 2155,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Xinput FW V1.12",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "XInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 62,
          "modeRank": 7,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "mayflash - f500 elite mayflash f500 elite mayflash f500 elite wired usb wired xinput fw v1.12 xinput wired xinput xinput wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) unknown closed source mister / pc raw capture mayflash - f500 elite [xinput fw v1.12]"
        }
      ]
    },
    {
      "id": "published-mayflash-f500-v2",
      "name": "Mayflash - F500 V2",
      "measurementName": "Mayflash - F500 V2 [Xinput FW V1.14]",
      "deviceNorm": "mayflash f500 v2",
      "make": "Mayflash",
      "model": "F500 V2",
      "link": "https://amzn.to/3dMzOn5",
      "amazon": "",
      "buyUrl": "https://amzn.to/3dMzOn5",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Xinput FW V1.14",
      "outputMode": "XInput",
      "connectionTag": "Wired",
      "modeLabel": "XInput",
      "modeDisplay": "XInput",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 28,
      "modeRank": 5,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "7/16/2024",
      "dateAddedSort": "2024-07-16",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "Gold",
      "averageMs": 1.367,
      "sdMs": 0.381,
      "maxMs": 2.36,
      "minMs": 0.41,
      "p99Ms": 2.157,
      "sampleCount": 2834,
      "sameFramePct": 91.8,
      "observedSameFramePct": 91.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "mayflash - f500 v2 mayflash f500 v2 mayflash f500 v2 wired usb wired xinput fw v1.14 xinput wired xinput xinput wired arcade stick wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f500 v2 [xinput fw v1.14] mayflash - f500 v2 mayflash - f500 v2 [xinput fw v1.14] wired usb wired wired xinput fw v1.14 xinput xinput xinput ['wired arcade stick'] wired arcade stick platinum gold arcade stick published published actively sold closed source mayflash - f500 v2 mayflash f500 v2 mayflash f500 v2 wired usb wired xinput fw v1.14 xinput wired xinput xinput wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f500 v2 [xinput fw v1.14] mayflash - f500 v2 mayflash - f500 v2 [dinput ps3 snk fw v1.13] wired usb wired wired dinput ps3 snk fw v1.13 dinput, ps3 dinput, ps3 dinput, ps3 ['wired arcade stick'] wired arcade stick platinum gold arcade stick published published actively sold closed source mayflash - f500 v2 mayflash f500 v2 mayflash f500 v2 wired usb wired dinput ps3 snk fw v1.13 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f500 v2 [dinput ps3 snk fw v1.13]",
      "controllerGroupKey": "published|mayflash f500 v2",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-mayflash-f500-v2",
          "name": "Mayflash - F500 V2",
          "measurementName": "Mayflash - F500 V2 [Xinput FW V1.14]",
          "averageMs": 1.367,
          "averageTier": "Platinum",
          "p99Ms": 2.157,
          "p99Tier": "Gold",
          "sameFramePct": 91.8,
          "observedSameFramePct": 91.8,
          "sampleCount": 2834,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Xinput FW V1.14",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "XInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 63,
          "modeRank": 8,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/16/2024",
          "dateAddedSort": "2024-07-16",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3dMzOn5",
          "link": "https://amzn.to/3dMzOn5",
          "amazon": "",
          "joystickId": "",
          "searchText": "mayflash - f500 v2 mayflash f500 v2 mayflash f500 v2 wired usb wired xinput fw v1.14 xinput wired xinput xinput wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f500 v2 [xinput fw v1.14]"
        },
        {
          "id": "published-mayflash-f500-v2-2",
          "name": "Mayflash - F500 V2",
          "measurementName": "Mayflash - F500 V2 [DInput PS3 SNK FW V1.13]",
          "averageMs": 1.369,
          "averageTier": "Platinum",
          "p99Ms": 2.19,
          "p99Tier": "Gold",
          "sameFramePct": 91.79,
          "observedSameFramePct": 91.8,
          "sampleCount": 3353,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "DInput PS3 SNK FW V1.13",
          "outputMode": "DInput, PS3",
          "modeLabel": "DInput, PS3",
          "modeDisplay": "DInput, PS3",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 64,
          "modeRank": 9,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/16/2024",
          "dateAddedSort": "2024-07-16",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3dMzOn5",
          "link": "https://amzn.to/3dMzOn5",
          "amazon": "",
          "joystickId": "",
          "searchText": "mayflash - f500 v2 mayflash f500 v2 mayflash f500 v2 wired usb wired dinput ps3 snk fw v1.13 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link mayflash - f500 v2 [dinput ps3 snk fw v1.13]"
        }
      ]
    },
    {
      "id": "published-retroflag-genesis-usb-controller",
      "name": "Retroflag - Genesis USB Controller",
      "measurementName": "Retroflag Genesis USB Controller [Wired USB]",
      "deviceNorm": "retroflag genesis usb controller",
      "make": "Retroflag",
      "model": "Genesis USB Controller",
      "link": "https://amzn.to/30ZGuKZ",
      "amazon": "",
      "buyUrl": "https://amzn.to/30ZGuKZ",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 29,
      "modeRank": 12,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "",
      "dateAdded": "8/14/2020",
      "dateAddedSort": "2020-08-14",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.437,
      "sdMs": 0.328,
      "maxMs": 8.476,
      "minMs": 0.884,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 91.38,
      "observedSameFramePct": 91.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "retroflag - genesis usb controller retroflag genesis usb controller retroflag genesis usb controller wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 no platinum 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link retroflag genesis usb controller [wired usb] retroflag - genesis usb controller retroflag genesis usb controller [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller platinum controller 6 no published published actively sold closed source retroflag - genesis usb controller retroflag genesis usb controller retroflag genesis usb controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no platinum 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link retroflag genesis usb controller [wired usb]",
      "controllerGroupKey": "published|retroflag genesis usb controller",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retroflag-genesis-usb-controller",
          "name": "Retroflag - Genesis USB Controller",
          "measurementName": "Retroflag Genesis USB Controller [Wired USB]",
          "averageMs": 1.437,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 91.38,
          "observedSameFramePct": 91.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 67,
          "modeRank": 14,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/30ZGuKZ",
          "link": "https://amzn.to/30ZGuKZ",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "retroflag - genesis usb controller retroflag genesis usb controller retroflag genesis usb controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no platinum 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link retroflag genesis usb controller [wired usb]"
        }
      ]
    },
    {
      "id": "published-paradise-arcade-lono",
      "name": "Paradise Arcade - Lono",
      "measurementName": "Paradise Arcade Lono [Wired USB]",
      "deviceNorm": "paradise arcade lono",
      "make": "Paradise Arcade",
      "model": "Lono",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 30,
      "modeRank": 7,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "6/1/2020",
      "dateAddedSort": "2020-06-01",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.517,
      "sdMs": 0.345,
      "maxMs": 2.316,
      "minMs": 0.624,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 90.9,
      "observedSameFramePct": 90.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Discontinued",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "a1ff:1a21",
      "searchText": "paradise arcade - lono paradise arcade lono paradise arcade lono wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - yes - platinum 01-05ms (platinum) discontinued closed source mister / pc a1ff:1a21 paradise arcade lono [wired usb] paradise arcade - lono paradise arcade lono [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder platinum arcade stick encoder - yes - published published discontinued closed source paradise arcade - lono paradise arcade lono paradise arcade lono wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - yes - platinum 01-05ms (platinum) discontinued closed source mister / pc a1ff:1a21 paradise arcade lono [wired usb]",
      "controllerGroupKey": "published|paradise arcade lono",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-paradise-arcade-lono",
          "name": "Paradise Arcade - Lono",
          "measurementName": "Paradise Arcade Lono [Wired USB]",
          "averageMs": 1.517,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 90.9,
          "observedSameFramePct": 90.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 69,
          "modeRank": 11,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "Yes",
          "weightOz": "-",
          "dateAdded": "6/1/2020",
          "dateAddedSort": "2020-06-01",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "a1ff:1a21",
          "searchText": "paradise arcade - lono paradise arcade lono paradise arcade lono wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - yes - platinum 01-05ms (platinum) discontinued closed source mister / pc a1ff:1a21 paradise arcade lono [wired usb]"
        }
      ]
    },
    {
      "id": "published-raphnet-controller-adapter",
      "name": "Raphnet - Controller Adapter",
      "measurementName": "Raphnet - N64 - 1ms V3.6 - OEM N64",
      "deviceNorm": "raphnet controller adapter",
      "make": "Raphnet",
      "model": "N64 - 1ms V3.6 - OEM N64",
      "link": "https://www.raphnet-tech.com/products.php?category=Adapters",
      "amazon": "",
      "buyUrl": "https://www.raphnet-tech.com/products.php?category=Adapters",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 31,
      "modeRank": 6,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "N64 Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "Gold",
      "averageMs": 1.595,
      "sdMs": 0.414,
      "maxMs": 2.56,
      "minMs": 0.59,
      "p99Ms": 2.488,
      "sampleCount": 2223,
      "sameFramePct": 90.43,
      "observedSameFramePct": 90.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Open Source",
      "isOpenSource": true,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "raphnet - controller adapter raphnet controller adapter raphnet n64 - 1ms v3.6 - oem n64 wired usb wired usb dinput wired dinput dinput controller adapter n64 controller controller adapter published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link raphnet - n64 - 1ms v3.6 - oem n64 raphnet - n64 - 1ms v3.6 - oem n64 raphnet - n64 - 1ms v3.6 - oem n64 wired usb wired wired usb dinput dinput dinput ['controller adapter', 'n64 controller'] controller adapter platinum gold controller adapter published published actively sold open source open source raphnet - n64 - 1ms v3.6 - oem n64 raphnet n64 1ms v3 6 oem n64 raphnet n64 - 1ms v3.6 - oem n64 wired usb wired usb dinput wired dinput dinput controller adapter n64 controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link raphnet - n64 - 1ms v3.6 - oem n64 raphnet - pcengine controller to usb adapter raphnet pcengine controller to usb adapter [pc engine nec pi-pd6] wired usb wired wired pc engine nec pi-pd6 dinput dinput dinput ['controller adapter', 'pc engine controller'] controller adapter platinum controller adapter - no - published published actively sold open source open source raphnet - pcengine controller to usb adapter raphnet pcengine controller to usb adapter raphnet pcengine controller to usb adapter wired usb wired pc engine nec pi-pd6 dinput wired dinput dinput controller adapter pc engine controller published published controller adapter - no - platinum 01-05ms (platinum) actively sold open source open source mister / pc 289b:0050 buy link raphnet pcengine controller to usb adapter [pc engine nec pi-pd6] raphnet - snes controller to usb adapter raphnet snes controller to usb adapter [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter', 'snes controller'] controller adapter platinum controller adapter - no published published actively sold open source open source raphnet - snes controller to usb adapter raphnet snes controller to usb adapter raphnet snes controller to usb adapter wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller published published controller adapter - no platinum 01-05ms (platinum) actively sold open source open source mister / pc 289b:0056 buy link raphnet snes controller to usb adapter [wired usb] raphnet - classic controller to usb adapter - v3 raphnet classic controller to usb adapter - v3 [snes classic controller] wired usb wired wired snes classic controller dinput dinput dinput ['controller adapter', 'snes controller'] controller adapter platinum controller adapter - - - published published actively sold open source open source raphnet - classic controller to usb adapter - v3 raphnet classic controller to usb adapter v3 raphnet classic controller to usb adapter - v3 wired usb wired snes classic controller dinput wired dinput dinput controller adapter snes controller published published controller adapter - - - platinum 01-05ms (platinum) actively sold open source open source mister / pc 289b:0080 buy link raphnet classic controller to usb adapter - v3 [snes classic controller] raphnet - dreamcast - 1ms v2.02 - oem dc raphnet - dreamcast - 1ms v2.02 - oem dc wired usb wired wired usb dinput dinput dinput ['controller adapter', 'dreamcast controller'] controller adapter gold gold controller adapter published published actively sold open source open source raphnet - dreamcast - 1ms v2.02 - oem dc raphnet dreamcast 1ms v2 02 oem dc raphnet dreamcast - 1ms v2.02 - oem dc wired usb wired usb dinput wired dinput dinput controller adapter dreamcast controller published published controller adapter gold gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link raphnet - dreamcast - 1ms v2.02 - oem dc",
      "controllerGroupKey": "|raphnet controller adapter",
      "modeVariantCount": 5,
      "modeVariants": [
        {
          "id": "published-raphnet-n64-1ms-v3-6-oem-n64",
          "name": "Raphnet - N64 - 1ms V3.6 - OEM N64",
          "measurementName": "Raphnet - N64 - 1ms V3.6 - OEM N64",
          "averageMs": 1.595,
          "averageTier": "Platinum",
          "p99Ms": 2.488,
          "p99Tier": "Gold",
          "sameFramePct": 90.43,
          "observedSameFramePct": 90.4,
          "sampleCount": 2223,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "N64 Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 72,
          "modeRank": 31,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://www.raphnet-tech.com/products.php?category=Adapters",
          "link": "https://www.raphnet-tech.com/products.php?category=Adapters",
          "amazon": "",
          "joystickId": "",
          "searchText": "raphnet - n64 - 1ms v3.6 - oem n64 raphnet n64 1ms v3 6 oem n64 raphnet n64 - 1ms v3.6 - oem n64 wired usb wired usb dinput wired dinput dinput controller adapter n64 controller published published controller adapter platinum gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link raphnet - n64 - 1ms v3.6 - oem n64"
        },
        {
          "id": "published-raphnet-pcengine-controller-to-usb-adapter",
          "name": "Raphnet - PCEngine Controller to USB Adapter",
          "measurementName": "Raphnet PCEngine Controller to USB Adapter [PC Engine NEC PI-PD6]",
          "averageMs": 1.632,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 90.21,
          "observedSameFramePct": 90.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "PC Engine NEC PI-PD6",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "PC Engine Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 77,
          "modeRank": 36,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "6/30/2020",
          "dateAddedSort": "2020-06-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://www.raphnet-tech.com/products/pc_engine_to_usb_adapter/index.php",
          "link": "https://www.raphnet-tech.com/products/pc_engine_to_usb_adapter/index.php",
          "amazon": "",
          "joystickId": "289b:0050",
          "searchText": "raphnet - pcengine controller to usb adapter raphnet pcengine controller to usb adapter raphnet pcengine controller to usb adapter wired usb wired pc engine nec pi-pd6 dinput wired dinput dinput controller adapter pc engine controller published published controller adapter - no - platinum 01-05ms (platinum) actively sold open source open source mister / pc 289b:0050 buy link raphnet pcengine controller to usb adapter [pc engine nec pi-pd6]"
        },
        {
          "id": "published-raphnet-snes-controller-to-usb-adapter",
          "name": "Raphnet - SNES Controller to USB Adapter",
          "measurementName": "Raphnet SNES Controller to USB Adapter [Wired USB]",
          "averageMs": 1.646,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 90.12,
          "observedSameFramePct": 90.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "SNES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 78,
          "modeRank": 37,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://www.raphnet-tech.com/products/snes_to_usb_cable/index.php",
          "link": "https://www.raphnet-tech.com/products/snes_to_usb_cable/index.php",
          "amazon": "",
          "joystickId": "289b:0056",
          "searchText": "raphnet - snes controller to usb adapter raphnet snes controller to usb adapter raphnet snes controller to usb adapter wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller published published controller adapter - no platinum 01-05ms (platinum) actively sold open source open source mister / pc 289b:0056 buy link raphnet snes controller to usb adapter [wired usb]"
        },
        {
          "id": "published-raphnet-classic-controller-to-usb-adapter-v3",
          "name": "Raphnet - Classic Controller to USB adapter - V3",
          "measurementName": "Raphnet Classic Controller to USB adapter - V3 [SNES Classic Controller]",
          "averageMs": 1.804,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 89.18,
          "observedSameFramePct": 89.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "SNES Classic Controller",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "SNES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 93,
          "modeRank": 40,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://www.raphnet-tech.com/products/wusbmote_1player_adapter_v3/index.php",
          "link": "https://www.raphnet-tech.com/products/wusbmote_1player_adapter_v3/index.php",
          "amazon": "",
          "joystickId": "289b:0080",
          "searchText": "raphnet - classic controller to usb adapter - v3 raphnet classic controller to usb adapter v3 raphnet classic controller to usb adapter - v3 wired usb wired snes classic controller dinput wired dinput dinput controller adapter snes controller published published controller adapter - - - platinum 01-05ms (platinum) actively sold open source open source mister / pc 289b:0080 buy link raphnet classic controller to usb adapter - v3 [snes classic controller]"
        },
        {
          "id": "published-raphnet-dreamcast-1ms-v2-02-oem-dc",
          "name": "Raphnet - Dreamcast - 1ms v2.02 - OEM DC",
          "measurementName": "Raphnet - Dreamcast - 1ms v2.02 - OEM DC",
          "averageMs": 2.966,
          "averageTier": "Gold",
          "p99Ms": 4.56,
          "p99Tier": "Gold",
          "sameFramePct": 82.2,
          "observedSameFramePct": 82.2,
          "sampleCount": 2050,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Dreamcast Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 108,
          "modeRank": 46,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Open Source",
          "isOpenSource": true,
          "sourceUrl": "",
          "buyUrl": "https://www.raphnet-tech.com/products.php?category=Adapters",
          "link": "https://www.raphnet-tech.com/products.php?category=Adapters",
          "amazon": "",
          "joystickId": "",
          "searchText": "raphnet - dreamcast - 1ms v2.02 - oem dc raphnet dreamcast 1ms v2 02 oem dc raphnet dreamcast - 1ms v2.02 - oem dc wired usb wired usb dinput wired dinput dinput controller adapter dreamcast controller published published controller adapter gold gold 01-05ms (platinum) actively sold open source open source mister / pc raw capture buy link raphnet - dreamcast - 1ms v2.02 - oem dc"
        }
      ]
    },
    {
      "id": "published-bootsector-retrofi",
      "name": "bootsector - RetroFi",
      "measurementName": "bootsector RetroFi [2.4GHz USB]",
      "deviceNorm": "bootsector retrofi",
      "make": "bootsector",
      "model": "RetroFi",
      "link": "https://www.brunofreitas.com/node/95",
      "amazon": "",
      "buyUrl": "https://www.brunofreitas.com/node/95",
      "connection": "2.4 GHz USB",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "2.4GHz USB",
      "outputMode": "DInput",
      "connectionTag": "Wireless 2.4GHz",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 32,
      "modeRank": 7,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "12/24/2023",
      "dateAddedSort": "2023-12-24",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.63,
      "sdMs": 0.42,
      "maxMs": 5.66,
      "minMs": 0.8,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 90.22,
      "observedSameFramePct": 90.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Discontinued",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "bootsector - retrofi bootsector retrofi bootsector retrofi 2.4 ghz usb wireless 2.4ghz usb dinput wireless 2.4ghz dinput dinput controller adapter controller adapter published published controller adapter - - - platinum 01-05ms (platinum) discontinued closed source mister / pc buy link bootsector retrofi [2.4ghz usb] bootsector - retrofi bootsector retrofi [2.4ghz usb] 2.4 ghz usb wireless wireless 2.4ghz 2.4ghz usb dinput dinput dinput ['controller adapter'] controller adapter platinum controller adapter - - - published published discontinued closed source bootsector - retrofi bootsector retrofi bootsector retrofi 2.4 ghz usb wireless 2.4ghz usb dinput wireless 2.4ghz dinput dinput controller adapter published published controller adapter - - - platinum 01-05ms (platinum) discontinued closed source mister / pc buy link bootsector retrofi [2.4ghz usb]",
      "controllerGroupKey": "published|bootsector retrofi",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-bootsector-retrofi",
          "name": "bootsector - RetroFi",
          "measurementName": "bootsector RetroFi [2.4GHz USB]",
          "averageMs": 1.63,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 90.22,
          "observedSameFramePct": 90.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "2.4GHz USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 76,
          "modeRank": 35,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "12/24/2023",
          "dateAddedSort": "2023-12-24",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.brunofreitas.com/node/95",
          "link": "https://www.brunofreitas.com/node/95",
          "amazon": "",
          "joystickId": "",
          "searchText": "bootsector - retrofi bootsector retrofi bootsector retrofi 2.4 ghz usb wireless 2.4ghz usb dinput wireless 2.4ghz dinput dinput controller adapter published published controller adapter - - - platinum 01-05ms (platinum) discontinued closed source mister / pc buy link bootsector retrofi [2.4ghz usb]"
        }
      ]
    },
    {
      "id": "published-bootsector-lload",
      "name": "bootsector - LLOAD",
      "measurementName": "bootsector LLOAD [Wired USB]",
      "deviceNorm": "bootsector lload",
      "make": "bootsector",
      "model": "LLOAD",
      "link": "https://github.com/bootsector/LLOAD",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 33,
      "modeRank": 8,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.67,
      "sdMs": 0.1,
      "maxMs": 2.18,
      "minMs": 1.18,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 89.98,
      "observedSameFramePct": 90.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Discontinued",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "https://github.com/bootsector/LLOAD",
      "joystickId": "",
      "searchText": "bootsector - lload bootsector lload bootsector lload wired usb wired wired usb dinput wired dinput dinput controller adapter controller adapter published published controller adapter - - - platinum 01-05ms (platinum) discontinued closed source https://github.com/bootsector/lload mister / pc bootsector lload [wired usb] bootsector - lload bootsector lload [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter'] controller adapter platinum controller adapter - - - published published discontinued closed source https://github.com/bootsector/lload bootsector - lload bootsector lload bootsector lload wired usb wired wired usb dinput wired dinput dinput controller adapter published published controller adapter - - - platinum 01-05ms (platinum) discontinued closed source https://github.com/bootsector/lload mister / pc bootsector lload [wired usb]",
      "controllerGroupKey": "published|bootsector lload",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-bootsector-lload",
          "name": "bootsector - LLOAD",
          "measurementName": "bootsector LLOAD [Wired USB]",
          "averageMs": 1.67,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 89.98,
          "observedSameFramePct": 90.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 79,
          "modeRank": 38,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "https://github.com/bootsector/LLOAD",
          "buyUrl": "",
          "link": "https://github.com/bootsector/LLOAD",
          "amazon": "",
          "joystickId": "",
          "searchText": "bootsector - lload bootsector lload bootsector lload wired usb wired wired usb dinput wired dinput dinput controller adapter published published controller adapter - - - platinum 01-05ms (platinum) discontinued closed source https://github.com/bootsector/lload mister / pc bootsector lload [wired usb]"
        }
      ]
    },
    {
      "id": "published-aliexpress-jvs",
      "name": "AliExpress - JVS",
      "measurementName": "AliExpress - JVS [Xinput]",
      "deviceNorm": "aliexpress jvs",
      "make": "AliExpress",
      "model": "JVS",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Xinput",
      "outputMode": "XInput",
      "connectionTag": "Wired",
      "modeLabel": "XInput",
      "modeDisplay": "XInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 34,
      "modeRank": 8,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC",
        "Xbox One",
        "Xbox Series"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "Gold",
      "averageMs": 1.673,
      "sdMs": 0.389,
      "maxMs": 9.68,
      "minMs": 0.4,
      "p99Ms": 2.16,
      "sampleCount": 2452,
      "sameFramePct": 89.96,
      "observedSameFramePct": 90.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "aliexpress - jvs aliexpress jvs aliexpress jvs wired usb wired xinput xinput wired xinput xinput arcade stick encoder arcade stick encoder published published arcade stick encoder platinum gold 01-05ms (platinum) unknown closed source mister / pc xbox one xbox series raw capture aliexpress - jvs [xinput] aliexpress - jvs aliexpress - jvs [xinput] wired usb wired wired xinput xinput xinput xinput ['arcade stick encoder'] arcade stick encoder platinum gold arcade stick encoder published published unknown closed source aliexpress - jvs aliexpress jvs aliexpress jvs wired usb wired xinput xinput wired xinput xinput arcade stick encoder published published arcade stick encoder platinum gold 01-05ms (platinum) unknown closed source mister / pc xbox one xbox series raw capture aliexpress - jvs [xinput]",
      "controllerGroupKey": "published|aliexpress jvs",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-aliexpress-jvs",
          "name": "AliExpress - JVS",
          "measurementName": "AliExpress - JVS [Xinput]",
          "averageMs": 1.673,
          "averageTier": "Platinum",
          "p99Ms": 2.16,
          "p99Tier": "Gold",
          "sameFramePct": 89.96,
          "observedSameFramePct": 90.0,
          "sampleCount": 2452,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Xinput",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "XInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 80,
          "modeRank": 12,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "aliexpress - jvs aliexpress jvs aliexpress jvs wired usb wired xinput xinput wired xinput xinput arcade stick encoder published published arcade stick encoder platinum gold 01-05ms (platinum) unknown closed source mister / pc xbox one xbox series raw capture aliexpress - jvs [xinput]"
        }
      ]
    },
    {
      "id": "published-monoprice-dark-matter",
      "name": "Monoprice - Dark Matter",
      "measurementName": "Monoprice Dark Matter [Wired USB Xinput]",
      "deviceNorm": "monoprice dark matter",
      "make": "Monoprice",
      "model": "Dark Matter",
      "link": "https://www.monoprice.com/product?p_id=43710",
      "amazon": "",
      "buyUrl": "https://www.monoprice.com/product?p_id=43710",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Xinput",
      "outputMode": "DInput, XInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput, XInput",
      "modeDisplay": "DInput, XInput",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 35,
      "modeRank": 6,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "8",
      "weightOz": "",
      "dateAdded": "11/20/2022",
      "dateAddedSort": "2022-11-20",
      "platforms": [
        "MiSTer / PC",
        "Switch",
        "PS4",
        "Xbox One"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.674,
      "sdMs": 0.293,
      "maxMs": 2.22,
      "minMs": 1.15,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 89.96,
      "observedSameFramePct": 90.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "monoprice - dark matter monoprice dark matter monoprice dark matter wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired arcade stick wired arcade stick published published arcade stick 8 yes platinum 01-05ms (platinum) actively sold closed source mister / pc switch ps4 xbox one 045e:028e buy link monoprice dark matter [wired usb xinput] monoprice - dark matter monoprice dark matter [wired usb xinput] wired usb wired wired wired usb xinput dinput, xinput dinput, xinput dinput, xinput ['wired arcade stick'] wired arcade stick platinum arcade stick 8 yes published published actively sold closed source monoprice - dark matter monoprice dark matter monoprice dark matter wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired arcade stick published published arcade stick 8 yes platinum 01-05ms (platinum) actively sold closed source mister / pc switch ps4 xbox one 045e:028e buy link monoprice dark matter [wired usb xinput]",
      "controllerGroupKey": "published|monoprice dark matter",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-monoprice-dark-matter",
          "name": "Monoprice - Dark Matter",
          "measurementName": "Monoprice Dark Matter [Wired USB Xinput]",
          "averageMs": 1.674,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 89.96,
          "observedSameFramePct": 90.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Xinput",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 81,
          "modeRank": 11,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "11/20/2022",
          "dateAddedSort": "2022-11-20",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.monoprice.com/product?p_id=43710",
          "link": "https://www.monoprice.com/product?p_id=43710",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "monoprice - dark matter monoprice dark matter monoprice dark matter wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired arcade stick published published arcade stick 8 yes platinum 01-05ms (platinum) actively sold closed source mister / pc switch ps4 xbox one 045e:028e buy link monoprice dark matter [wired usb xinput]"
        }
      ]
    },
    {
      "id": "published-toodles-mc-cthlulhu",
      "name": "Toodles - MC Cthlulhu",
      "measurementName": "Toodles MC Cthlulhu [Wired USB]",
      "deviceNorm": "toodles mc cthlulhu",
      "make": "Toodles",
      "model": "MC Cthlulhu",
      "link": "https://paradisearcadeshop.com/home/electrical/pcbs-lighting/pcbs-for-controllers/godlike-controls-pcbs/1828_mc-cthulhu-multi-console-pcb-by-toodles",
      "amazon": "",
      "buyUrl": "https://paradisearcadeshop.com/home/electrical/pcbs-lighting/pcbs-for-controllers/godlike-controls-pcbs/1828_mc-cthulhu-multi-console-pcb-by-toodles",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 36,
      "modeRank": 9,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "6/16/2020",
      "dateAddedSort": "2020-06-16",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.696,
      "sdMs": 0.293,
      "maxMs": 3.748,
      "minMs": 1.18,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 89.82,
      "observedSameFramePct": 89.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "14d8:face",
      "searchText": "toodles - mc cthlulhu toodles mc cthlulhu toodles mc cthlulhu wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - - - platinum 01-05ms (platinum) actively sold closed source mister / pc 14d8:face buy link toodles mc cthlulhu [wired usb] toodles - mc cthlulhu toodles mc cthlulhu [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder platinum arcade stick encoder - - - published published actively sold closed source toodles - mc cthlulhu toodles mc cthlulhu toodles mc cthlulhu wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - platinum 01-05ms (platinum) actively sold closed source mister / pc 14d8:face buy link toodles mc cthlulhu [wired usb]",
      "controllerGroupKey": "published|toodles mc cthlulhu",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-toodles-mc-cthlulhu",
          "name": "Toodles - MC Cthlulhu",
          "measurementName": "Toodles MC Cthlulhu [Wired USB]",
          "averageMs": 1.696,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 89.82,
          "observedSameFramePct": 89.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 82,
          "modeRank": 13,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "6/16/2020",
          "dateAddedSort": "2020-06-16",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://paradisearcadeshop.com/home/electrical/pcbs-lighting/pcbs-for-controllers/godlike-controls-pcbs/1828_mc-cthulhu-multi-console-pcb-by-toodles",
          "link": "https://paradisearcadeshop.com/home/electrical/pcbs-lighting/pcbs-for-controllers/godlike-controls-pcbs/1828_mc-cthulhu-multi-console-pcb-by-toodles",
          "amazon": "",
          "joystickId": "14d8:face",
          "searchText": "toodles - mc cthlulhu toodles mc cthlulhu toodles mc cthlulhu wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - platinum 01-05ms (platinum) actively sold closed source mister / pc 14d8:face buy link toodles mc cthlulhu [wired usb]"
        }
      ]
    },
    {
      "id": "published-2600-daptor-d9",
      "name": "2600-daptor - D9",
      "measurementName": "2600-daptor D9 [Wired USB]",
      "deviceNorm": "2600 daptor d9",
      "make": "2600-daptor",
      "model": "D9",
      "link": "http://2600-daptor.com/2600-daptor%20D9.htm",
      "amazon": "",
      "buyUrl": "http://2600-daptor.com/2600-daptor%20D9.htm",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 37,
      "modeRank": 9,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "6/6/2020",
      "dateAddedSort": "2020-06-06",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.704,
      "sdMs": 0.29,
      "maxMs": 2.244,
      "minMs": 1.18,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 89.78,
      "observedSameFramePct": 89.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "04d8:f6eb",
      "searchText": "2600-daptor - d9 2600 daptor d9 2600-daptor d9 wired usb wired wired usb dinput wired dinput dinput controller adapter controller adapter published published controller adapter - - - platinum 01-05ms (platinum) actively sold closed source mister / pc 04d8:f6eb buy link 2600-daptor d9 [wired usb] 2600-daptor - d9 2600-daptor d9 [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter'] controller adapter platinum controller adapter - - - published published actively sold closed source 2600-daptor - d9 2600 daptor d9 2600-daptor d9 wired usb wired wired usb dinput wired dinput dinput controller adapter published published controller adapter - - - platinum 01-05ms (platinum) actively sold closed source mister / pc 04d8:f6eb buy link 2600-daptor d9 [wired usb]",
      "controllerGroupKey": "published|2600 daptor d9",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-2600-daptor-d9",
          "name": "2600-daptor - D9",
          "measurementName": "2600-daptor D9 [Wired USB]",
          "averageMs": 1.704,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 89.78,
          "observedSameFramePct": 89.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 83,
          "modeRank": 39,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "6/6/2020",
          "dateAddedSort": "2020-06-06",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "http://2600-daptor.com/2600-daptor%20D9.htm",
          "link": "http://2600-daptor.com/2600-daptor%20D9.htm",
          "amazon": "",
          "joystickId": "04d8:f6eb",
          "searchText": "2600-daptor - d9 2600 daptor d9 2600-daptor d9 wired usb wired wired usb dinput wired dinput dinput controller adapter published published controller adapter - - - platinum 01-05ms (platinum) actively sold closed source mister / pc 04d8:f6eb buy link 2600-daptor d9 [wired usb]"
        }
      ]
    },
    {
      "id": "published-sega-genesis-mini-3-button-usb-mk-16500",
      "name": "Sega - Genesis Mini 3 Button USB (MK-16500)",
      "measurementName": "Sega Genesis Mini 3 Button USB (MK-16500) [Wired USB]",
      "deviceNorm": "sega genesis mini 3 button usb mk 16500",
      "make": "Sega",
      "model": "Genesis Mini 3 Button USB (MK-16500)",
      "link": "https://amzn.to/3imovVI",
      "amazon": "",
      "buyUrl": "https://amzn.to/3imovVI",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 38,
      "modeRank": 13,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "3",
      "weightOz": "4.20",
      "dateAdded": "6/30/2020",
      "dateAddedSort": "2020-06-30",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.714,
      "sdMs": 0.29,
      "maxMs": 2.26,
      "minMs": 1.168,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 89.72,
      "observedSameFramePct": 89.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0ca3:0025",
      "searchText": "sega - genesis mini 3 button usb (mk-16500) sega genesis mini 3 button usb mk 16500 sega genesis mini 3 button usb (mk-16500) wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 3 no 4.20 platinum 01-05ms (platinum) actively sold closed source mister / pc 0ca3:0025 buy link sega genesis mini 3 button usb (mk-16500) [wired usb] sega - genesis mini 3 button usb (mk-16500) sega genesis mini 3 button usb (mk-16500) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller platinum controller 3 no 4.20 published published actively sold closed source sega - genesis mini 3 button usb (mk-16500) sega genesis mini 3 button usb mk 16500 sega genesis mini 3 button usb (mk-16500) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 3 no 4.20 platinum 01-05ms (platinum) actively sold closed source mister / pc 0ca3:0025 buy link sega genesis mini 3 button usb (mk-16500) [wired usb]",
      "controllerGroupKey": "published|sega genesis mini 3 button usb mk 16500",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-sega-genesis-mini-3-button-usb-mk-16500",
          "name": "Sega - Genesis Mini 3 Button USB (MK-16500)",
          "measurementName": "Sega Genesis Mini 3 Button USB (MK-16500) [Wired USB]",
          "averageMs": 1.714,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 89.72,
          "observedSameFramePct": 89.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 84,
          "modeRank": 15,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "3",
          "homeButton": "No",
          "weightOz": "4.20",
          "dateAdded": "6/30/2020",
          "dateAddedSort": "2020-06-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3imovVI",
          "link": "https://amzn.to/3imovVI",
          "amazon": "",
          "joystickId": "0ca3:0025",
          "searchText": "sega - genesis mini 3 button usb (mk-16500) sega genesis mini 3 button usb mk 16500 sega genesis mini 3 button usb (mk-16500) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 3 no 4.20 platinum 01-05ms (platinum) actively sold closed source mister / pc 0ca3:0025 buy link sega genesis mini 3 button usb (mk-16500) [wired usb]"
        }
      ]
    },
    {
      "id": "published-brook-zero-pi-fighting-board",
      "name": "Brook - Zero Pi Fighting Board",
      "measurementName": "Brook Zero Pi Fighting Board [Wired USB]",
      "deviceNorm": "brook zero pi fighting board",
      "make": "Brook",
      "model": "Zero Pi Fighting Board",
      "link": "https://amzn.to/3EsIRbH",
      "amazon": "",
      "buyUrl": "https://amzn.to/3EsIRbH",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 39,
      "modeRank": 10,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "6/9/2020",
      "dateAddedSort": "2020-06-09",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.736,
      "sdMs": 0.291,
      "maxMs": 3.688,
      "minMs": 1.224,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 89.58,
      "observedSameFramePct": 89.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0C12:0130",
      "searchText": "brook - zero pi fighting board brook zero pi fighting board brook zero pi fighting board wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - - platinum 01-05ms (platinum) actively sold closed source mister / pc 0c12:0130 buy link brook zero pi fighting board [wired usb] brook - zero pi fighting board brook zero pi fighting board [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder platinum arcade stick encoder - - published published actively sold closed source brook - zero pi fighting board brook zero pi fighting board brook zero pi fighting board wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - platinum 01-05ms (platinum) actively sold closed source mister / pc 0c12:0130 buy link brook zero pi fighting board [wired usb]",
      "controllerGroupKey": "published|brook zero pi fighting board",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-brook-zero-pi-fighting-board",
          "name": "Brook - Zero Pi Fighting Board",
          "measurementName": "Brook Zero Pi Fighting Board [Wired USB]",
          "averageMs": 1.736,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 89.58,
          "observedSameFramePct": 89.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 85,
          "modeRank": 14,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "",
          "dateAdded": "6/9/2020",
          "dateAddedSort": "2020-06-09",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3EsIRbH",
          "link": "https://amzn.to/3EsIRbH",
          "amazon": "",
          "joystickId": "0C12:0130",
          "searchText": "brook - zero pi fighting board brook zero pi fighting board brook zero pi fighting board wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - platinum 01-05ms (platinum) actively sold closed source mister / pc 0c12:0130 buy link brook zero pi fighting board [wired usb]"
        }
      ]
    },
    {
      "id": "published-retroflag-classic-snes-style",
      "name": "Retroflag - Classic (SNES Style)",
      "measurementName": "Retroflag Classic (SNES Style) [Wired USB]",
      "deviceNorm": "retroflag classic snes style",
      "make": "Retroflag",
      "model": "Classic (SNES Style)",
      "link": "https://amzn.to/2zQZmkq",
      "amazon": "",
      "buyUrl": "https://amzn.to/2zQZmkq",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 40,
      "modeRank": 14,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.738,
      "sdMs": 0.292,
      "maxMs": 2.3,
      "minMs": 1.164,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 89.57,
      "observedSameFramePct": 89.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0583:2060",
      "searchText": "retroflag - classic (snes style) retroflag classic snes style retroflag classic (snes style) wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no platinum 01-05ms (platinum) actively sold closed source mister / pc 0583:2060 buy link retroflag classic (snes style) [wired usb] retroflag - classic (snes style) retroflag classic (snes style) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller platinum controller 4 no published published actively sold closed source retroflag - classic (snes style) retroflag classic snes style retroflag classic (snes style) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no platinum 01-05ms (platinum) actively sold closed source mister / pc 0583:2060 buy link retroflag classic (snes style) [wired usb]",
      "controllerGroupKey": "published|retroflag classic snes style",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retroflag-classic-snes-style",
          "name": "Retroflag - Classic (SNES Style)",
          "measurementName": "Retroflag Classic (SNES Style) [Wired USB]",
          "averageMs": 1.738,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 89.57,
          "observedSameFramePct": 89.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 86,
          "modeRank": 16,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2zQZmkq",
          "link": "https://amzn.to/2zQZmkq",
          "amazon": "",
          "joystickId": "0583:2060",
          "searchText": "retroflag - classic (snes style) retroflag classic snes style retroflag classic (snes style) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no platinum 01-05ms (platinum) actively sold closed source mister / pc 0583:2060 buy link retroflag classic (snes style) [wired usb]"
        }
      ]
    },
    {
      "id": "published-xinmotek-xm-08-usb-adapter",
      "name": "XinMoTek - XM-08 USB Adapter",
      "measurementName": "XinMoTek XM-08 USB Adapter [Wired USB]",
      "deviceNorm": "xinmotek xm 08 usb adapter",
      "make": "XinMoTek",
      "model": "XM-08 USB Adapter",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 41,
      "modeRank": 11,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "6/13/2021",
      "dateAddedSort": "2021-06-13",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.75,
      "sdMs": 0.29,
      "maxMs": 2.328,
      "minMs": 1.192,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 89.5,
      "observedSameFramePct": 89.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Discontinued",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "16C0:05E1",
      "searchText": "xinmotek - xm-08 usb adapter xinmotek xm 08 usb adapter xinmotek xm-08 usb adapter wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - - platinum 01-05ms (platinum) discontinued closed source mister / pc 16c0:05e1 xinmotek xm-08 usb adapter [wired usb] xinmotek - xm-08 usb adapter xinmotek xm-08 usb adapter [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder platinum arcade stick encoder - - published published discontinued closed source xinmotek - xm-08 usb adapter xinmotek xm 08 usb adapter xinmotek xm-08 usb adapter wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - platinum 01-05ms (platinum) discontinued closed source mister / pc 16c0:05e1 xinmotek xm-08 usb adapter [wired usb]",
      "controllerGroupKey": "published|xinmotek xm 08 usb adapter",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-xinmotek-xm-08-usb-adapter",
          "name": "XinMoTek - XM-08 USB Adapter",
          "measurementName": "XinMoTek XM-08 USB Adapter [Wired USB]",
          "averageMs": 1.75,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 89.5,
          "observedSameFramePct": 89.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 87,
          "modeRank": 15,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "",
          "dateAdded": "6/13/2021",
          "dateAddedSort": "2021-06-13",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "16C0:05E1",
          "searchText": "xinmotek - xm-08 usb adapter xinmotek xm 08 usb adapter xinmotek xm-08 usb adapter wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - platinum 01-05ms (platinum) discontinued closed source mister / pc 16c0:05e1 xinmotek xm-08 usb adapter [wired usb]"
        }
      ]
    },
    {
      "id": "published-snk-neo-geo-mini",
      "name": "SNK - Neo-Geo Mini",
      "measurementName": "SNK Neo-Geo Mini [Wired USB]",
      "deviceNorm": "snk neo geo mini",
      "make": "SNK",
      "model": "Neo-Geo Mini",
      "link": "https://amzn.to/2ZD8y6C",
      "amazon": "",
      "buyUrl": "https://amzn.to/2ZD8y6C",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 42,
      "modeRank": 15,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "4.60",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.756,
      "sdMs": 0.293,
      "maxMs": 2.352,
      "minMs": 1.184,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 89.46,
      "observedSameFramePct": 89.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "2563:0575",
      "searchText": "snk - neo-geo mini snk neo geo mini snk neo-geo mini wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no 4.60 platinum 01-05ms (platinum) actively sold closed source mister / pc 2563:0575 buy link snk neo-geo mini [wired usb] snk - neo-geo mini snk neo-geo mini [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller platinum controller 4 no 4.60 published published actively sold closed source snk - neo-geo mini snk neo geo mini snk neo-geo mini wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 4.60 platinum 01-05ms (platinum) actively sold closed source mister / pc 2563:0575 buy link snk neo-geo mini [wired usb]",
      "controllerGroupKey": "published|snk neo geo mini",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-snk-neo-geo-mini",
          "name": "SNK - Neo-Geo Mini",
          "measurementName": "SNK Neo-Geo Mini [Wired USB]",
          "averageMs": 1.756,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 89.46,
          "observedSameFramePct": 89.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 88,
          "modeRank": 17,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "4.60",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2ZD8y6C",
          "link": "https://amzn.to/2ZD8y6C",
          "amazon": "",
          "joystickId": "2563:0575",
          "searchText": "snk - neo-geo mini snk neo geo mini snk neo-geo mini wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 4.60 platinum 01-05ms (platinum) actively sold closed source mister / pc 2563:0575 buy link snk neo-geo mini [wired usb]"
        }
      ]
    },
    {
      "id": "published-pdp-ps3-versus-controller-fight-pad",
      "name": "PDP - PS3 Versus Controller Fight Pad",
      "measurementName": "PDP - PS3 Versus Controller Fight Pad",
      "deviceNorm": "pdp ps3 versus controller fight pad",
      "make": "PDP",
      "model": "PS3 Versus Controller Fight Pad",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 43,
      "modeRank": 7,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "Gold",
      "averageMs": 1.777,
      "sdMs": 0.288,
      "maxMs": 2.36,
      "minMs": 1.19,
      "p99Ms": 2.288,
      "sampleCount": 2219,
      "sameFramePct": 89.34,
      "observedSameFramePct": 89.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "pdp - ps3 versus controller fight pad pdp ps3 versus controller fight pad pdp ps3 versus controller fight pad wired usb wired usb dinput wired dinput dinput wired arcade stick wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) unknown closed source mister / pc raw capture pdp - ps3 versus controller fight pad pdp - ps3 versus controller fight pad pdp - ps3 versus controller fight pad wired usb wired wired usb dinput dinput dinput ['wired arcade stick'] wired arcade stick platinum gold arcade stick published published unknown closed source pdp - ps3 versus controller fight pad pdp ps3 versus controller fight pad pdp ps3 versus controller fight pad wired usb wired usb dinput wired dinput dinput wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) unknown closed source mister / pc raw capture pdp - ps3 versus controller fight pad",
      "controllerGroupKey": "published|pdp ps3 versus controller fight pad",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-pdp-ps3-versus-controller-fight-pad",
          "name": "PDP - PS3 Versus Controller Fight Pad",
          "measurementName": "PDP - PS3 Versus Controller Fight Pad",
          "averageMs": 1.777,
          "averageTier": "Platinum",
          "p99Ms": 2.288,
          "p99Tier": "Gold",
          "sameFramePct": 89.34,
          "observedSameFramePct": 89.3,
          "sampleCount": 2219,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 89,
          "modeRank": 12,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "pdp - ps3 versus controller fight pad pdp ps3 versus controller fight pad pdp ps3 versus controller fight pad wired usb wired usb dinput wired dinput dinput wired arcade stick published published arcade stick platinum gold 01-05ms (platinum) unknown closed source mister / pc raw capture pdp - ps3 versus controller fight pad"
        }
      ]
    },
    {
      "id": "published-hori-fighting-stick-mini",
      "name": "Hori - Fighting Stick Mini",
      "measurementName": "Hori Fighting Stick Mini [Wired USB]",
      "deviceNorm": "hori fighting stick mini",
      "make": "Hori",
      "model": "Fighting Stick Mini",
      "link": "https://amzn.to/3dSXHJU",
      "amazon": "",
      "buyUrl": "https://amzn.to/3dSXHJU",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 44,
      "modeRank": 8,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "8",
      "weightOz": "",
      "dateAdded": "6/9/2020",
      "dateAddedSort": "2020-06-09",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.785,
      "sdMs": 0.3,
      "maxMs": 2.444,
      "minMs": 1.14,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 89.29,
      "observedSameFramePct": 89.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0f0d:0137",
      "searchText": "hori - fighting stick mini hori fighting stick mini hori fighting stick mini wired usb wired wired usb dinput wired dinput dinput wired arcade stick wired arcade stick published published arcade stick 8 yes platinum 01-05ms (platinum) actively sold closed source mister / pc switch 0f0d:0137 buy link hori fighting stick mini [wired usb] hori - fighting stick mini hori fighting stick mini [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired arcade stick'] wired arcade stick platinum arcade stick 8 yes published published actively sold closed source hori - fighting stick mini hori fighting stick mini hori fighting stick mini wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes platinum 01-05ms (platinum) actively sold closed source mister / pc switch 0f0d:0137 buy link hori fighting stick mini [wired usb] hori - fighting stick mini hori - fighting stick mini wired usb wired wired dinput dinput dinput ['wired arcade stick'] wired arcade stick platinum gold arcade stick 8 yes published published actively sold closed source hori - fighting stick mini hori fighting stick mini hori fighting stick mini wired usb wired dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes platinum gold 01-05ms (platinum) actively sold closed source mister / pc 0f0d:0137 raw capture buy link hori - fighting stick mini",
      "controllerGroupKey": "published|hori fighting stick mini",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-hori-fighting-stick-mini",
          "name": "Hori - Fighting Stick Mini",
          "measurementName": "Hori Fighting Stick Mini [Wired USB]",
          "averageMs": 1.785,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 89.29,
          "observedSameFramePct": 89.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 90,
          "modeRank": 13,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "6/9/2020",
          "dateAddedSort": "2020-06-09",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3dSXHJU",
          "link": "https://amzn.to/3dSXHJU",
          "amazon": "",
          "joystickId": "0f0d:0137",
          "searchText": "hori - fighting stick mini hori fighting stick mini hori fighting stick mini wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes platinum 01-05ms (platinum) actively sold closed source mister / pc switch 0f0d:0137 buy link hori fighting stick mini [wired usb]"
        },
        {
          "id": "published-hori-fighting-stick-mini-2",
          "name": "Hori - Fighting Stick Mini",
          "measurementName": "Hori - Fighting Stick Mini",
          "averageMs": 1.788,
          "averageTier": "Platinum",
          "p99Ms": 2.352,
          "p99Tier": "Gold",
          "sameFramePct": 89.27,
          "observedSameFramePct": 89.3,
          "sampleCount": 2077,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 91,
          "modeRank": 14,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3dSXHJU",
          "link": "https://amzn.to/3dSXHJU",
          "amazon": "",
          "joystickId": "0f0d:0137",
          "searchText": "hori - fighting stick mini hori fighting stick mini hori fighting stick mini wired usb wired dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes platinum gold 01-05ms (platinum) actively sold closed source mister / pc 0f0d:0137 raw capture buy link hori - fighting stick mini"
        }
      ]
    },
    {
      "id": "published-hori-turbografx-16-mini-usb-controller",
      "name": "Hori - TurboGrafx 16 Mini USB Controller",
      "measurementName": "Hori TurboGrafx 16 Mini USB Controller [Wired USB]",
      "deviceNorm": "hori turbografx 16 mini usb controller",
      "make": "Hori",
      "model": "TurboGrafx 16 Mini USB Controller",
      "link": "https://amzn.to/2TXWSYr",
      "amazon": "",
      "buyUrl": "https://amzn.to/2TXWSYr",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 45,
      "modeRank": 16,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "2",
      "weightOz": "2.95",
      "dateAdded": "6/1/2020",
      "dateAddedSort": "2020-06-01",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "",
      "averageMs": 1.788,
      "sdMs": 0.296,
      "maxMs": 2.372,
      "minMs": 1.168,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 89.27,
      "observedSameFramePct": 89.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0f0d:0138",
      "searchText": "hori - turbografx 16 mini usb controller hori turbografx 16 mini usb controller hori turbografx 16 mini usb controller wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 2 no 2.95 platinum 01-05ms (platinum) actively sold closed source mister / pc 0f0d:0138 buy link hori turbografx 16 mini usb controller [wired usb] hori - turbografx 16 mini usb controller hori turbografx 16 mini usb controller [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller platinum controller 2 no 2.95 published published actively sold closed source hori - turbografx 16 mini usb controller hori turbografx 16 mini usb controller hori turbografx 16 mini usb controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 2 no 2.95 platinum 01-05ms (platinum) actively sold closed source mister / pc 0f0d:0138 buy link hori turbografx 16 mini usb controller [wired usb]",
      "controllerGroupKey": "published|hori turbografx 16 mini usb controller",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-hori-turbografx-16-mini-usb-controller",
          "name": "Hori - TurboGrafx 16 Mini USB Controller",
          "measurementName": "Hori TurboGrafx 16 Mini USB Controller [Wired USB]",
          "averageMs": 1.788,
          "averageTier": "Platinum",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 89.27,
          "observedSameFramePct": 89.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 92,
          "modeRank": 18,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "2",
          "homeButton": "No",
          "weightOz": "2.95",
          "dateAdded": "6/1/2020",
          "dateAddedSort": "2020-06-01",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2TXWSYr",
          "link": "https://amzn.to/2TXWSYr",
          "amazon": "",
          "joystickId": "0f0d:0138",
          "searchText": "hori - turbografx 16 mini usb controller hori turbografx 16 mini usb controller hori turbografx 16 mini usb controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 2 no 2.95 platinum 01-05ms (platinum) actively sold closed source mister / pc 0f0d:0138 buy link hori turbografx 16 mini usb controller [wired usb]"
        }
      ]
    },
    {
      "id": "published-sony-dualsense-playstation-5",
      "name": "Sony - DualSense (PlayStation 5)",
      "measurementName": "Sony - Dual Sense Wired",
      "deviceNorm": "sony dualsense playstation 5",
      "make": "Sony",
      "model": "Dual Sense Wired",
      "link": "https://amzn.to/3wMBy8N",
      "amazon": "",
      "buyUrl": "https://amzn.to/3wMBy8N",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 46,
      "modeRank": 17,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "8/8/2021",
      "dateAddedSort": "2021-08-08",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Platinum",
      "p99Tier": "Gold",
      "averageMs": 1.809,
      "sdMs": 0.296,
      "maxMs": 2.48,
      "minMs": 1.18,
      "p99Ms": 2.369,
      "sampleCount": 2009,
      "sameFramePct": 89.15,
      "observedSameFramePct": 89.1,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "054c:0ce6",
      "searchText": "sony - dualsense (playstation 5) sony dualsense playstation 5 sony dual sense wired wired usb wired dinput wired dinput dinput wired controller wired controller published published controller platinum gold 01-05ms (platinum) actively sold closed source mister / pc 054c:0ce6 raw capture buy link sony - dual sense wired sony - dual sense wired sony - dual sense wired wired usb wired wired dinput dinput dinput ['wired controller'] wired controller platinum gold controller published published actively sold closed source sony - dual sense wired sony dual sense wired sony dual sense wired wired usb wired dinput wired dinput dinput wired controller published published controller platinum gold 01-05ms (platinum) unknown closed source mister / pc raw capture sony - dual sense wired sony - dual sense sony - dual sense [bt4.2] bluetooth wireless wireless bt bt4.2 bluetooth bluetooth ['wireless controller'] wireless controller gold silver controller published published unknown closed source sony - dual sense sony dual sense sony dual sense bluetooth wireless bt4.2 wireless bt bluetooth bluetooth wireless controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture sony - dual sense [bt4.2] sony - dualsense (playstation 5) sony dualsense (playstation 5) [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless controller'] wireless controller silver controller 4 yes 9.80 published published actively sold closed source sony - dualsense (playstation 5) sony dualsense playstation 5 sony dualsense (playstation 5) bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 9.80 silver 05-10ms (gold) actively sold closed source mister / pc ps5 054c:0ce6 buy link sony dualsense (playstation 5) [bt (csr8510)]",
      "controllerGroupKey": "published|sony dualsense playstation 5",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-sony-dual-sense-wired",
          "name": "Sony - Dual Sense Wired",
          "measurementName": "Sony - Dual Sense Wired",
          "averageMs": 1.809,
          "averageTier": "Platinum",
          "p99Ms": 2.369,
          "p99Tier": "Gold",
          "sameFramePct": 89.15,
          "observedSameFramePct": 89.1,
          "sampleCount": 2009,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 94,
          "modeRank": 19,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "8/8/2021",
          "dateAddedSort": "2021-08-08",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3wMBy8N",
          "link": "https://amzn.to/3wMBy8N",
          "amazon": "",
          "joystickId": "054c:0ce6",
          "searchText": "sony - dual sense wired sony dual sense wired sony dual sense wired wired usb wired dinput wired dinput dinput wired controller published published controller platinum gold 01-05ms (platinum) unknown closed source mister / pc raw capture sony - dual sense wired"
        },
        {
          "id": "published-sony-dual-sense",
          "name": "Sony - Dual Sense",
          "measurementName": "Sony - Dual Sense [BT4.2]",
          "averageMs": 4.786,
          "averageTier": "Gold",
          "p99Ms": 9.923,
          "p99Tier": "Silver",
          "sameFramePct": 71.28,
          "observedSameFramePct": 71.4,
          "sampleCount": 2068,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT4.2",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 151,
          "modeRank": 5,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "sony - dual sense sony dual sense sony dual sense bluetooth wireless bt4.2 wireless bt bluetooth bluetooth wireless controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture sony - dual sense [bt4.2]"
        },
        {
          "id": "published-sony-dualsense-playstation-5",
          "name": "Sony - DualSense (Playstation 5)",
          "measurementName": "Sony DualSense (Playstation 5) [BT (CSR8510)]",
          "averageMs": 6.322,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 62.07,
          "observedSameFramePct": 62.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 201,
          "modeRank": 13,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "9.80",
          "dateAdded": "8/8/2021",
          "dateAddedSort": "2021-08-08",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3wMBy8N",
          "link": "https://amzn.to/3wMBy8N",
          "amazon": "",
          "joystickId": "054c:0ce6",
          "searchText": "sony - dualsense (playstation 5) sony dualsense playstation 5 sony dualsense (playstation 5) bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 9.80 silver 05-10ms (gold) actively sold closed source mister / pc ps5 054c:0ce6 buy link sony dualsense (playstation 5) [bt (csr8510)]"
        }
      ]
    },
    {
      "id": "published-sony-playstation-classic",
      "name": "Sony - Playstation Classic",
      "measurementName": "Sony Playstation Classic [Wired USB]",
      "deviceNorm": "sony playstation classic",
      "make": "Sony",
      "model": "Playstation Classic",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 47,
      "modeRank": 18,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "3.65",
      "dateAdded": "5/27/2020",
      "dateAddedSort": "2020-05-27",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 2.044,
      "sdMs": 0.577,
      "maxMs": 3.092,
      "minMs": 1.032,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 87.74,
      "observedSameFramePct": 87.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "054c:0cda",
      "searchText": "sony - playstation classic sony playstation classic sony playstation classic wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no 3.65 gold 01-05ms (platinum) unknown closed source mister / pc 054c:0cda sony playstation classic [wired usb] sony - playstation classic sony playstation classic [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller gold controller 4 no 3.65 published published unknown closed source sony - playstation classic sony playstation classic sony playstation classic wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.65 gold 01-05ms (platinum) unknown closed source mister / pc 054c:0cda sony playstation classic [wired usb]",
      "controllerGroupKey": "published|sony playstation classic",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-sony-playstation-classic",
          "name": "Sony - Playstation Classic",
          "measurementName": "Sony Playstation Classic [Wired USB]",
          "averageMs": 2.044,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 87.74,
          "observedSameFramePct": 87.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 95,
          "modeRank": 20,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.65",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "054c:0cda",
          "searchText": "sony - playstation classic sony playstation classic sony playstation classic wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.65 gold 01-05ms (platinum) unknown closed source mister / pc 054c:0cda sony playstation classic [wired usb]"
        }
      ]
    },
    {
      "id": "published-retrousb-retrokit-snes",
      "name": "RetroUSB - RetroKit SNES",
      "measurementName": "RetroUSB RetroKit SNES [Wired USB]",
      "deviceNorm": "retrousb retrokit snes",
      "make": "RetroUSB",
      "model": "RetroKit SNES",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 48,
      "modeRank": 10,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "6/29/2020",
      "dateAddedSort": "2020-06-29",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "SNES Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 2.26,
      "sdMs": 0.422,
      "maxMs": 3.284,
      "minMs": 1.272,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 86.44,
      "observedSameFramePct": 86.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "f000:0003",
      "searchText": "retrousb - retrokit snes retrousb retrokit snes retrousb retrokit snes wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller controller adapter published published controller adapter - no gold 01-05ms (platinum) actively sold closed source mister / pc f000:0003 retrousb retrokit snes [wired usb] retrousb - retrokit snes retrousb retrokit snes [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter', 'snes controller'] controller adapter gold controller adapter - no published published actively sold closed source retrousb - retrokit snes retrousb retrokit snes retrousb retrokit snes wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller published published controller adapter - no gold 01-05ms (platinum) actively sold closed source mister / pc f000:0003 retrousb retrokit snes [wired usb]",
      "controllerGroupKey": "published|retrousb retrokit snes",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retrousb-retrokit-snes",
          "name": "RetroUSB - RetroKit SNES",
          "measurementName": "RetroUSB RetroKit SNES [Wired USB]",
          "averageMs": 2.26,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 86.44,
          "observedSameFramePct": 86.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "SNES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 99,
          "modeRank": 42,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "6/29/2020",
          "dateAddedSort": "2020-06-29",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "f000:0003",
          "searchText": "retrousb - retrokit snes retrousb retrokit snes retrousb retrokit snes wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller published published controller adapter - no gold 01-05ms (platinum) actively sold closed source mister / pc f000:0003 retrousb retrokit snes [wired usb]"
        }
      ]
    },
    {
      "id": "published-razer-panthera-evo",
      "name": "Razer - Panthera Evo",
      "measurementName": "Razer Panthera Evo [Wired USB]",
      "deviceNorm": "razer panthera evo",
      "make": "Razer",
      "model": "Panthera Evo",
      "link": "https://amzn.to/30fE0aS",
      "amazon": "",
      "buyUrl": "https://amzn.to/30fE0aS",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 49,
      "modeRank": 9,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "8",
      "weightOz": "73.85",
      "dateAdded": "6/13/2020",
      "dateAddedSort": "2020-06-13",
      "platforms": [
        "MiSTer / PC",
        "PS4",
        "PS5"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 2.296,
      "sdMs": 0.403,
      "maxMs": 3.296,
      "minMs": 1.32,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 86.22,
      "observedSameFramePct": 86.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "1532:1008",
      "searchText": "razer - panthera evo razer panthera evo razer panthera evo wired usb wired wired usb dinput wired dinput dinput wired arcade stick wired arcade stick published published arcade stick 8 yes 73.85 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 ps5 1532:1008 buy link razer panthera evo [wired usb] razer - panthera evo razer panthera evo [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired arcade stick'] wired arcade stick gold arcade stick 8 yes 73.85 published published actively sold closed source razer - panthera evo razer panthera evo razer panthera evo wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes 73.85 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 ps5 1532:1008 buy link razer panthera evo [wired usb]",
      "controllerGroupKey": "published|razer panthera evo",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-razer-panthera-evo",
          "name": "Razer - Panthera Evo",
          "measurementName": "Razer Panthera Evo [Wired USB]",
          "averageMs": 2.296,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 86.22,
          "observedSameFramePct": 86.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 100,
          "modeRank": 15,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "73.85",
          "dateAdded": "6/13/2020",
          "dateAddedSort": "2020-06-13",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/30fE0aS",
          "link": "https://amzn.to/30fE0aS",
          "amazon": "",
          "joystickId": "1532:1008",
          "searchText": "razer - panthera evo razer panthera evo razer panthera evo wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes 73.85 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 ps5 1532:1008 buy link razer panthera evo [wired usb]"
        }
      ]
    },
    {
      "id": "published-retrousb-retrokit-nes",
      "name": "RetroUSB - RetroKit NES",
      "measurementName": "RetroUSB RetroKit NES [Wired USB]",
      "deviceNorm": "retrousb retrokit nes",
      "make": "RetroUSB",
      "model": "RetroKit NES",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 50,
      "modeRank": 11,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "6/29/2020",
      "dateAddedSort": "2020-06-29",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "NES Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 2.298,
      "sdMs": 0.434,
      "maxMs": 3.324,
      "minMs": 1.292,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 86.21,
      "observedSameFramePct": 86.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "f000:0003",
      "searchText": "retrousb - retrokit nes retrousb retrokit nes retrousb retrokit nes wired usb wired wired usb dinput wired dinput dinput controller adapter nes controller controller adapter published published controller adapter - no gold 01-05ms (platinum) actively sold closed source mister / pc f000:0003 retrousb retrokit nes [wired usb] retrousb - retrokit nes retrousb retrokit nes [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter', 'nes controller'] controller adapter gold controller adapter - no published published actively sold closed source retrousb - retrokit nes retrousb retrokit nes retrousb retrokit nes wired usb wired wired usb dinput wired dinput dinput controller adapter nes controller published published controller adapter - no gold 01-05ms (platinum) actively sold closed source mister / pc f000:0003 retrousb retrokit nes [wired usb]",
      "controllerGroupKey": "published|retrousb retrokit nes",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retrousb-retrokit-nes",
          "name": "RetroUSB - RetroKit NES",
          "measurementName": "RetroUSB RetroKit NES [Wired USB]",
          "averageMs": 2.298,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 86.21,
          "observedSameFramePct": 86.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "NES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 101,
          "modeRank": 43,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "6/29/2020",
          "dateAddedSort": "2020-06-29",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "f000:0003",
          "searchText": "retrousb - retrokit nes retrousb retrokit nes retrousb retrokit nes wired usb wired wired usb dinput wired dinput dinput controller adapter nes controller published published controller adapter - no gold 01-05ms (platinum) actively sold closed source mister / pc f000:0003 retrousb retrokit nes [wired usb]"
        }
      ]
    },
    {
      "id": "published-jammix-jammix",
      "name": "JAMMIX - JAMMIX",
      "measurementName": "JAMMIX",
      "deviceNorm": "jammix jammix",
      "make": "",
      "model": "JAMMIX",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 51,
      "modeRank": 19,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "12/16/2021",
      "dateAddedSort": "2021-12-16",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "Gold",
      "averageMs": 2.381,
      "sdMs": 0.783,
      "maxMs": 12.06,
      "minMs": 1.19,
      "p99Ms": 4.118,
      "sampleCount": 2624,
      "sameFramePct": 85.71,
      "observedSameFramePct": 85.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "9036:0800",
      "searchText": "jammix - jammix jammix jammix jammix wired usb wired dinput wired dinput dinput wired controller wired controller published published controller gold gold 01-05ms (platinum) unknown closed source mister / pc 9036:0800 raw capture jammix jammix jammix wired usb wired wired dinput dinput dinput ['wired controller'] wired controller gold gold controller published published unknown closed source jammix jammix jammix wired usb wired dinput wired dinput dinput wired controller published published controller gold gold 01-05ms (platinum) unknown closed source mister / pc raw capture jammix",
      "controllerGroupKey": "published|jammix jammix",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-jammix",
          "name": "JAMMIX",
          "measurementName": "JAMMIX",
          "averageMs": 2.381,
          "averageTier": "Gold",
          "p99Ms": 4.118,
          "p99Tier": "Gold",
          "sameFramePct": 85.71,
          "observedSameFramePct": 85.7,
          "sampleCount": 2624,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 102,
          "modeRank": 23,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "12/16/2021",
          "dateAddedSort": "2021-12-16",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "9036:0800",
          "searchText": "jammix jammix jammix wired usb wired dinput wired dinput dinput wired controller published published controller gold gold 01-05ms (platinum) unknown closed source mister / pc raw capture jammix"
        }
      ]
    },
    {
      "id": "published-hori-fighting-commander-switch",
      "name": "Hori - Fighting Commander Switch",
      "measurementName": "Hori - Fighting Commander Switch",
      "deviceNorm": "hori fighting commander switch",
      "make": "Hori",
      "model": "Fighting Commander Switch",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 52,
      "modeRank": 20,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "Gold",
      "averageMs": 2.688,
      "sdMs": 1.172,
      "maxMs": 9.37,
      "minMs": 0.62,
      "p99Ms": 4.69,
      "sampleCount": 2608,
      "sameFramePct": 83.87,
      "observedSameFramePct": 83.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0f0d:00dc",
      "searchText": "hori - fighting commander switch hori fighting commander switch hori fighting commander switch wired usb wired dinput wired dinput dinput wired controller wired controller published published controller gold gold 01-05ms (platinum) unknown closed source mister / pc 0f0d:00dc raw capture hori - fighting commander switch hori - fighting commander switch hori - fighting commander switch wired usb wired wired dinput dinput dinput ['wired controller'] wired controller gold gold controller published published unknown closed source hori - fighting commander switch hori fighting commander switch hori fighting commander switch wired usb wired dinput wired dinput dinput wired controller published published controller gold gold 01-05ms (platinum) unknown closed source mister / pc 0f0d:00dc raw capture hori - fighting commander switch",
      "controllerGroupKey": "published|hori fighting commander switch",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-hori-fighting-commander-switch",
          "name": "Hori - Fighting Commander Switch",
          "measurementName": "Hori - Fighting Commander Switch",
          "averageMs": 2.688,
          "averageTier": "Gold",
          "p99Ms": 4.69,
          "p99Tier": "Gold",
          "sameFramePct": 83.87,
          "observedSameFramePct": 83.9,
          "sampleCount": 2608,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 103,
          "modeRank": 24,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "0f0d:00dc",
          "searchText": "hori - fighting commander switch hori fighting commander switch hori fighting commander switch wired usb wired dinput wired dinput dinput wired controller published published controller gold gold 01-05ms (platinum) unknown closed source mister / pc 0f0d:00dc raw capture hori - fighting commander switch"
        }
      ]
    },
    {
      "id": "published-pdp-xbox-360-versus-controller-ms-3660",
      "name": "PDP - Xbox 360 Versus Controller (MS-3660)",
      "measurementName": "PDP Xbox 360 Versus Controller (MS-3660) [Wired USB]",
      "deviceNorm": "pdp xbox 360 versus controller ms 3660",
      "make": "PDP",
      "model": "Xbox 360 Versus Controller (MS-3660)",
      "link": "https://amzn.to/2ZCrEti",
      "amazon": "",
      "buyUrl": "https://amzn.to/2ZCrEti",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 53,
      "modeRank": 21,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "4.00",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 2.806,
      "sdMs": 1.206,
      "maxMs": 5.688,
      "minMs": 0.28,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 83.16,
      "observedSameFramePct": 83.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "1bad:f904",
      "searchText": "pdp - xbox 360 versus controller (ms-3660) pdp xbox 360 versus controller ms 3660 pdp xbox 360 versus controller (ms-3660) wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 yes 4.00 gold 01-05ms (platinum) actively sold closed source mister / pc 1bad:f904 buy link pdp xbox 360 versus controller (ms-3660) [wired usb] pdp - xbox 360 versus controller (ms-3660) pdp xbox 360 versus controller (ms-3660) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller gold controller 6 yes 4.00 published published actively sold closed source pdp - xbox 360 versus controller (ms-3660) pdp xbox 360 versus controller ms 3660 pdp xbox 360 versus controller (ms-3660) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 4.00 gold 01-05ms (platinum) actively sold closed source mister / pc 1bad:f904 buy link pdp xbox 360 versus controller (ms-3660) [wired usb]",
      "controllerGroupKey": "published|pdp xbox 360 versus controller ms 3660",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-pdp-xbox-360-versus-controller-ms-3660",
          "name": "PDP - Xbox 360 Versus Controller (MS-3660)",
          "measurementName": "PDP Xbox 360 Versus Controller (MS-3660) [Wired USB]",
          "averageMs": 2.806,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 83.16,
          "observedSameFramePct": 83.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 105,
          "modeRank": 25,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.00",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2ZCrEti",
          "link": "https://amzn.to/2ZCrEti",
          "amazon": "",
          "joystickId": "1bad:f904",
          "searchText": "pdp - xbox 360 versus controller (ms-3660) pdp xbox 360 versus controller ms 3660 pdp xbox 360 versus controller (ms-3660) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 4.00 gold 01-05ms (platinum) actively sold closed source mister / pc 1bad:f904 buy link pdp xbox 360 versus controller (ms-3660) [wired usb]"
        }
      ]
    },
    {
      "id": "published-hori-fighting-commander-octa-ab03-001",
      "name": "Hori - Fighting Commander Octa (AB03-001)",
      "measurementName": "Hori Fighting Commander Octa (AB03-001) [Wired USB]",
      "deviceNorm": "hori fighting commander octa ab03 001",
      "make": "Hori",
      "model": "Fighting Commander Octa (AB03-001)",
      "link": "https://amzn.to/3rlpzOu",
      "amazon": "",
      "buyUrl": "https://amzn.to/3rlpzOu",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 54,
      "modeRank": 22,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "6.20",
      "dateAdded": "8/8/2021",
      "dateAddedSort": "2021-08-08",
      "platforms": [
        "MiSTer / PC",
        "Xbox Series"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "Silver",
      "averageMs": 2.904,
      "sdMs": 1.187,
      "maxMs": 5.35,
      "minMs": 0.45,
      "p99Ms": 5.118,
      "sampleCount": 2042,
      "sameFramePct": 82.58,
      "observedSameFramePct": 82.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0f0d:0150",
      "searchText": "hori - fighting commander octa (ab03-001) hori fighting commander octa ab03 001 hori fighting commander octa (ab03-001) wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 yes 6.20 gold silver 01-05ms (platinum) actively sold closed source mister / pc xbox series 0f0d:0150 raw capture buy link hori fighting commander octa (ab03-001) [wired usb] hori - fighting commander octa (ab03-001) hori fighting commander octa (ab03-001) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller gold silver controller 6 yes 6.20 published published actively sold closed source hori - fighting commander octa (ab03-001) hori fighting commander octa ab03 001 hori fighting commander octa (ab03-001) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 6.20 gold silver 01-05ms (platinum) actively sold closed source mister / pc xbox series 0f0d:0150 raw capture buy link hori fighting commander octa (ab03-001) [wired usb]",
      "controllerGroupKey": "published|hori fighting commander octa ab03 001",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-hori-fighting-commander-octa-ab03-001",
          "name": "Hori - Fighting Commander Octa (AB03-001)",
          "measurementName": "Hori Fighting Commander Octa (AB03-001) [Wired USB]",
          "averageMs": 2.904,
          "averageTier": "Gold",
          "p99Ms": 5.118,
          "p99Tier": "Silver",
          "sameFramePct": 82.58,
          "observedSameFramePct": 82.6,
          "sampleCount": 2042,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 106,
          "modeRank": 26,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "6.20",
          "dateAdded": "8/8/2021",
          "dateAddedSort": "2021-08-08",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3rlpzOu",
          "link": "https://amzn.to/3rlpzOu",
          "amazon": "",
          "joystickId": "0f0d:0150",
          "searchText": "hori - fighting commander octa (ab03-001) hori fighting commander octa ab03 001 hori fighting commander octa (ab03-001) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 6.20 gold silver 01-05ms (platinum) actively sold closed source mister / pc xbox series 0f0d:0150 raw capture buy link hori fighting commander octa (ab03-001) [wired usb]"
        }
      ]
    },
    {
      "id": "published-mayflash-2-port-snes-to-usb",
      "name": "Mayflash - 2 Port SNES to USB",
      "measurementName": "Mayflash 2 Port SNES to USB [Wired USB]",
      "deviceNorm": "mayflash 2 port snes to usb",
      "make": "Mayflash",
      "model": "2 Port SNES to USB",
      "link": "https://amzn.to/2LVVnoX",
      "amazon": "",
      "buyUrl": "https://amzn.to/2LVVnoX",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 55,
      "modeRank": 12,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "SNES Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 2.916,
      "sdMs": 0.58,
      "maxMs": 3.936,
      "minMs": 1.904,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 82.5,
      "observedSameFramePct": 82.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "oe8f:3013",
      "searchText": "mayflash - 2 port snes to usb mayflash 2 port snes to usb mayflash 2 port snes to usb wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller controller adapter published published controller adapter - - - gold 01-05ms (platinum) actively sold closed source mister / pc oe8f:3013 buy link mayflash 2 port snes to usb [wired usb] mayflash - 2 port snes to usb mayflash 2 port snes to usb [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter', 'snes controller'] controller adapter gold controller adapter - - - published published actively sold closed source mayflash - 2 port snes to usb mayflash 2 port snes to usb mayflash 2 port snes to usb wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller published published controller adapter - - - gold 01-05ms (platinum) actively sold closed source mister / pc oe8f:3013 buy link mayflash 2 port snes to usb [wired usb]",
      "controllerGroupKey": "published|mayflash 2 port snes to usb",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-mayflash-2-port-snes-to-usb",
          "name": "Mayflash - 2 Port SNES to USB",
          "measurementName": "Mayflash 2 Port SNES to USB [Wired USB]",
          "averageMs": 2.916,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 82.5,
          "observedSameFramePct": 82.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "SNES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 107,
          "modeRank": 45,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2LVVnoX",
          "link": "https://amzn.to/2LVVnoX",
          "amazon": "",
          "joystickId": "oe8f:3013",
          "searchText": "mayflash - 2 port snes to usb mayflash 2 port snes to usb mayflash 2 port snes to usb wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller published published controller adapter - - - gold 01-05ms (platinum) actively sold closed source mister / pc oe8f:3013 buy link mayflash 2 port snes to usb [wired usb]"
        }
      ]
    },
    {
      "id": "published-qanba-obsidian",
      "name": "Qanba - Obsidian",
      "measurementName": "Qanba Obsidian [Wired USB PS4]",
      "deviceNorm": "qanba obsidian",
      "make": "Qanba",
      "model": "Obsidian",
      "link": "https://amzn.to/31NtRBG",
      "amazon": "",
      "buyUrl": "https://amzn.to/31NtRBG",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB PS4",
      "outputMode": "DInput, PS4",
      "connectionTag": "Wired",
      "modeLabel": "DInput, PS4",
      "modeDisplay": "DInput, PS4",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 56,
      "modeRank": 10,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "8",
      "weightOz": "",
      "dateAdded": "8/14/2020",
      "dateAddedSort": "2020-08-14",
      "platforms": [
        "MiSTer / PC",
        "PS4"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.024,
      "sdMs": 1.163,
      "maxMs": 5.028,
      "minMs": 1.02,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 81.86,
      "observedSameFramePct": 81.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "2c22:2300",
      "searchText": "qanba - obsidian qanba obsidian qanba obsidian wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 wired arcade stick wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc ps4 2c22:2300 buy link qanba obsidian [wired usb ps4] qanba - obsidian qanba obsidian [wired usb ps4] wired usb wired wired wired usb ps4 dinput, ps4 dinput, ps4 dinput, ps4 ['wired arcade stick'] wired arcade stick gold arcade stick 8 yes published published actively sold closed source qanba - obsidian qanba obsidian qanba obsidian wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc ps4 2c22:2300 buy link qanba obsidian [wired usb ps4] qanba - obsidian qanba obsidian [wired usb pc] wired usb wired wired wired usb pc dinput dinput dinput ['wired arcade stick'] wired arcade stick gold arcade stick 8 yes published published actively sold closed source qanba - obsidian qanba obsidian qanba obsidian wired usb wired wired usb pc dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc 2c22:2303 buy link qanba obsidian [wired usb pc] qanba - obsidian qanba obsidian [wired usb ps3] wired usb wired wired wired usb ps3 dinput, ps3 dinput, ps3 dinput, ps3 ['wired arcade stick'] wired arcade stick gold arcade stick 8 yes published published actively sold closed source qanba - obsidian qanba obsidian qanba obsidian wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc 2c22:2302 buy link qanba obsidian [wired usb ps3]",
      "controllerGroupKey": "published|qanba obsidian",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-qanba-obsidian",
          "name": "Qanba - Obsidian",
          "measurementName": "Qanba Obsidian [Wired USB PS4]",
          "averageMs": 3.024,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 81.86,
          "observedSameFramePct": 81.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PS4",
          "outputMode": "DInput, PS4",
          "modeLabel": "DInput, PS4",
          "modeDisplay": "DInput, PS4",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 110,
          "modeRank": 16,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/31NtRBG",
          "link": "https://amzn.to/31NtRBG",
          "amazon": "",
          "joystickId": "2c22:2300",
          "searchText": "qanba - obsidian qanba obsidian qanba obsidian wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc ps4 2c22:2300 buy link qanba obsidian [wired usb ps4]"
        },
        {
          "id": "published-qanba-obsidian-2",
          "name": "Qanba - Obsidian",
          "measurementName": "Qanba Obsidian [Wired USB PC]",
          "averageMs": 3.273,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 80.36,
          "observedSameFramePct": 80.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PC",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 117,
          "modeRank": 19,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/31NtRBG",
          "link": "https://amzn.to/31NtRBG",
          "amazon": "",
          "joystickId": "2c22:2303",
          "searchText": "qanba - obsidian qanba obsidian qanba obsidian wired usb wired wired usb pc dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc 2c22:2303 buy link qanba obsidian [wired usb pc]"
        },
        {
          "id": "published-qanba-obsidian-3",
          "name": "Qanba - Obsidian",
          "measurementName": "Qanba Obsidian [Wired USB PS3]",
          "averageMs": 3.279,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 80.33,
          "observedSameFramePct": 80.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PS3",
          "outputMode": "DInput, PS3",
          "modeLabel": "DInput, PS3",
          "modeDisplay": "DInput, PS3",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 118,
          "modeRank": 20,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/31NtRBG",
          "link": "https://amzn.to/31NtRBG",
          "amazon": "",
          "joystickId": "2c22:2302",
          "searchText": "qanba - obsidian qanba obsidian qanba obsidian wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc 2c22:2302 buy link qanba obsidian [wired usb ps3]"
        }
      ]
    },
    {
      "id": "published-hori-fighting-commander-xbox-one",
      "name": "Hori - Fighting Commander Xbox One",
      "measurementName": "Hori Fighting Commander Xbox One [Wired USB Xbox One]",
      "deviceNorm": "hori fighting commander xbox one",
      "make": "Hori",
      "model": "Fighting Commander Xbox One",
      "link": "https://amzn.to/2TWJROv",
      "amazon": "",
      "buyUrl": "https://amzn.to/2TWJROv",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Xbox One",
      "outputMode": "DInput, Xbox One",
      "connectionTag": "Wired",
      "modeLabel": "DInput, Xbox One",
      "modeDisplay": "DInput, Xbox One",
      "rankMode": "Wired Controller",
      "overallRank": 57,
      "modeRank": 23,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "4.95",
      "dateAdded": "6/1/2020",
      "dateAddedSort": "2020-06-01",
      "platforms": [
        "MiSTer / PC",
        "Xbox One"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.153,
      "sdMs": 1.16,
      "maxMs": 5.176,
      "minMs": 1.12,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 81.08,
      "observedSameFramePct": 81.1,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0f05:00c5",
      "searchText": "hori - fighting commander xbox one hori fighting commander xbox one hori fighting commander xbox one wired usb wired wired usb xbox one dinput, xbox one wired dinput, xbox one dinput, xbox one wired controller wired controller published published controller 6 yes 4.95 gold 01-05ms (platinum) actively sold closed source mister / pc xbox one 0f05:00c5 buy link hori fighting commander xbox one [wired usb xbox one] hori - fighting commander xbox one hori fighting commander xbox one [wired usb xbox one] wired usb wired wired wired usb xbox one dinput, xbox one dinput, xbox one dinput, xbox one ['wired controller'] wired controller gold controller 6 yes 4.95 published published actively sold closed source hori - fighting commander xbox one hori fighting commander xbox one hori fighting commander xbox one wired usb wired wired usb xbox one dinput, xbox one wired dinput, xbox one dinput, xbox one wired controller published published controller 6 yes 4.95 gold 01-05ms (platinum) actively sold closed source mister / pc xbox one 0f05:00c5 buy link hori fighting commander xbox one [wired usb xbox one] hori - fighting commander xbox one hori fighting commander xbox one [wired usb non-llapi] wired usb wired wired wired usb non-llapi dinput dinput dinput ['wired controller'] wired controller gold controller 6 yes 4.95 published published actively sold closed source hori - fighting commander xbox one hori fighting commander xbox one hori fighting commander xbox one wired usb wired wired usb non-llapi dinput wired dinput dinput wired controller published published controller 6 yes 4.95 gold 01-05ms (platinum) actively sold closed source mister / pc 24c6:5510 buy link hori fighting commander xbox one [wired usb non-llapi] hori - fighting commander xbox one hori fighting commander xbox one [wired usb pc / xbox 360] wired usb wired wired wired usb pc / xbox 360 dinput, xbox 360 dinput, xbox 360 dinput, xbox 360 ['wired controller'] wired controller gold controller 6 yes 4.95 published published actively sold closed source hori - fighting commander xbox one hori fighting commander xbox one hori fighting commander xbox one wired usb wired wired usb pc / xbox 360 dinput, xbox 360 wired dinput, xbox 360 dinput, xbox 360 wired controller published published controller 6 yes 4.95 gold 01-05ms (platinum) actively sold closed source mister / pc 24c6:5510 buy link hori fighting commander xbox one [wired usb pc / xbox 360]",
      "controllerGroupKey": "published|hori fighting commander xbox one",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-hori-fighting-commander-xbox-one",
          "name": "Hori - Fighting Commander Xbox One",
          "measurementName": "Hori Fighting Commander Xbox One [Wired USB Xbox One]",
          "averageMs": 3.153,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 81.08,
          "observedSameFramePct": 81.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Xbox One",
          "outputMode": "DInput, Xbox One",
          "modeLabel": "DInput, Xbox One",
          "modeDisplay": "DInput, Xbox One",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 111,
          "modeRank": 27,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.95",
          "dateAdded": "6/2/2020",
          "dateAddedSort": "2020-06-02",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2TWJROv",
          "link": "https://amzn.to/2TWJROv",
          "amazon": "",
          "joystickId": "0f05:00c5",
          "searchText": "hori - fighting commander xbox one hori fighting commander xbox one hori fighting commander xbox one wired usb wired wired usb xbox one dinput, xbox one wired dinput, xbox one dinput, xbox one wired controller published published controller 6 yes 4.95 gold 01-05ms (platinum) actively sold closed source mister / pc xbox one 0f05:00c5 buy link hori fighting commander xbox one [wired usb xbox one]"
        },
        {
          "id": "published-hori-fighting-commander-xbox-one-2",
          "name": "Hori - Fighting Commander Xbox One",
          "measurementName": "Hori Fighting Commander Xbox One [Wired USB Non-LLAPI]",
          "averageMs": 3.158,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 81.05,
          "observedSameFramePct": 81.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Non-LLAPI",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 112,
          "modeRank": 28,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.95",
          "dateAdded": "6/1/2020",
          "dateAddedSort": "2020-06-01",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2TWJROv",
          "link": "https://amzn.to/2TWJROv",
          "amazon": "",
          "joystickId": "24c6:5510",
          "searchText": "hori - fighting commander xbox one hori fighting commander xbox one hori fighting commander xbox one wired usb wired wired usb non-llapi dinput wired dinput dinput wired controller published published controller 6 yes 4.95 gold 01-05ms (platinum) actively sold closed source mister / pc 24c6:5510 buy link hori fighting commander xbox one [wired usb non-llapi]"
        },
        {
          "id": "published-hori-fighting-commander-xbox-one-3",
          "name": "Hori - Fighting Commander Xbox One",
          "measurementName": "Hori Fighting Commander Xbox One [Wired USB PC / Xbox 360]",
          "averageMs": 3.163,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 81.02,
          "observedSameFramePct": 81.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PC / Xbox 360",
          "outputMode": "DInput, Xbox 360",
          "modeLabel": "DInput, Xbox 360",
          "modeDisplay": "DInput, Xbox 360",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 113,
          "modeRank": 29,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.95",
          "dateAdded": "6/9/2020",
          "dateAddedSort": "2020-06-09",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2TWJROv",
          "link": "https://amzn.to/2TWJROv",
          "amazon": "",
          "joystickId": "24c6:5510",
          "searchText": "hori - fighting commander xbox one hori fighting commander xbox one hori fighting commander xbox one wired usb wired wired usb pc / xbox 360 dinput, xbox 360 wired dinput, xbox 360 dinput, xbox 360 wired controller published published controller 6 yes 4.95 gold 01-05ms (platinum) actively sold closed source mister / pc 24c6:5510 buy link hori fighting commander xbox one [wired usb pc / xbox 360]"
        }
      ]
    },
    {
      "id": "published-8bitdo-sn30-pro-usb",
      "name": "8BitDo - SN30 Pro USB",
      "measurementName": "8BitDo SN30 Pro USB [Wired USB] FW V1.04",
      "deviceNorm": "8bitdo sn30 pro usb",
      "make": "8BitDo",
      "model": "SN30 Pro USB",
      "link": "https://amzn.to/30tlKuZ",
      "amazon": "",
      "buyUrl": "https://amzn.to/30tlKuZ",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 58,
      "modeRank": 24,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "3.80",
      "dateAdded": "6/7/2020",
      "dateAddedSort": "2020-06-07",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.245,
      "sdMs": 0.962,
      "maxMs": 5.112,
      "minMs": 1.688,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 80.53,
      "observedSameFramePct": 80.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "8bitdo - sn30 pro usb 8bitdo sn30 pro usb 8bitdo sn30 pro usb wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 yes 3.80 gold 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 pro usb [wired usb] fw v1.04 8bitdo - sn30 pro usb 8bitdo sn30 pro usb [wired usb] fw v1.04 wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller gold controller 4 yes 3.80 published published actively sold closed source 8bitdo - sn30 pro usb 8bitdo sn30 pro usb 8bitdo sn30 pro usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 3.80 gold 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 pro usb [wired usb] fw v1.04",
      "controllerGroupKey": "published|8bitdo sn30 pro usb",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-8bitdo-sn30-pro-usb",
          "name": "8BitDo - SN30 Pro USB",
          "measurementName": "8BitDo SN30 Pro USB [Wired USB] FW V1.04",
          "averageMs": 3.245,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 80.53,
          "observedSameFramePct": 80.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 114,
          "modeRank": 30,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "3.80",
          "dateAdded": "6/7/2020",
          "dateAddedSort": "2020-06-07",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/30tlKuZ",
          "link": "https://amzn.to/30tlKuZ",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - sn30 pro usb 8bitdo sn30 pro usb 8bitdo sn30 pro usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 3.80 gold 01-05ms (platinum) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 pro usb [wired usb] fw v1.04"
        }
      ]
    },
    {
      "id": "published-qanba-drone",
      "name": "Qanba - Drone",
      "measurementName": "Qanba Drone [Wired USB PS3]",
      "deviceNorm": "qanba drone",
      "make": "Qanba",
      "model": "Drone",
      "link": "https://amzn.to/2CpcG0A",
      "amazon": "",
      "buyUrl": "https://amzn.to/2CpcG0A",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB PS3",
      "outputMode": "DInput, PS3",
      "connectionTag": "Wired",
      "modeLabel": "DInput, PS3",
      "modeDisplay": "DInput, PS3",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 59,
      "modeRank": 11,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "8",
      "weightOz": "",
      "dateAdded": "8/14/2020",
      "dateAddedSort": "2020-08-14",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.25,
      "sdMs": 0.812,
      "maxMs": 5.24,
      "minMs": 1.296,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 80.5,
      "observedSameFramePct": 80.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "2c22:2003",
      "searchText": "qanba - drone qanba drone qanba drone wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc 2c22:2003 buy link qanba drone [wired usb ps3] qanba - drone qanba drone [wired usb ps3] wired usb wired wired wired usb ps3 dinput, ps3 dinput, ps3 dinput, ps3 ['wired arcade stick'] wired arcade stick gold arcade stick 8 yes published published actively sold closed source qanba - drone qanba drone qanba drone wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc 2c22:2003 buy link qanba drone [wired usb ps3] qanba - drone qanba drone [wired usb ps4] wired usb wired wired wired usb ps4 dinput, ps4 dinput, ps4 dinput, ps4 ['wired arcade stick'] wired arcade stick gold arcade stick 8 yes published published actively sold closed source qanba - drone qanba drone qanba drone wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc ps4 2c22:2000 buy link qanba drone [wired usb ps4]",
      "controllerGroupKey": "published|qanba drone",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-qanba-drone",
          "name": "Qanba - Drone",
          "measurementName": "Qanba Drone [Wired USB PS3]",
          "averageMs": 3.25,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 80.5,
          "observedSameFramePct": 80.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PS3",
          "outputMode": "DInput, PS3",
          "modeLabel": "DInput, PS3",
          "modeDisplay": "DInput, PS3",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 115,
          "modeRank": 17,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2CpcG0A",
          "link": "https://amzn.to/2CpcG0A",
          "amazon": "",
          "joystickId": "2c22:2003",
          "searchText": "qanba - drone qanba drone qanba drone wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc 2c22:2003 buy link qanba drone [wired usb ps3]"
        },
        {
          "id": "published-qanba-drone-3",
          "name": "Qanba - Drone",
          "measurementName": "Qanba Drone [Wired USB PS4]",
          "averageMs": 3.265,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 80.41,
          "observedSameFramePct": 80.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PS4",
          "outputMode": "DInput, PS4",
          "modeLabel": "DInput, PS4",
          "modeDisplay": "DInput, PS4",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 116,
          "modeRank": 18,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2CpcG0A",
          "link": "https://amzn.to/2CpcG0A",
          "amazon": "",
          "joystickId": "2c22:2000",
          "searchText": "qanba - drone qanba drone qanba drone wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc ps4 2c22:2000 buy link qanba drone [wired usb ps4]"
        }
      ]
    },
    {
      "id": "published-hori-fighting-commander-octa-playstation-ps4",
      "name": "Hori - Fighting Commander Octa Playstation PS4",
      "measurementName": "Hori - Fighting Commander Octa Playstation PS4",
      "deviceNorm": "hori fighting commander octa playstation ps4",
      "make": "Hori",
      "model": "Fighting Commander Octa Playstation PS4",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 60,
      "modeRank": 25,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "Silver",
      "averageMs": 3.332,
      "sdMs": 1.157,
      "maxMs": 8.87,
      "minMs": 1.28,
      "p99Ms": 5.28,
      "sampleCount": 2114,
      "sameFramePct": 80.01,
      "observedSameFramePct": 80.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "hori - fighting commander octa playstation ps4 hori fighting commander octa playstation ps4 hori fighting commander octa playstation ps4 wired usb wired dinput wired dinput dinput wired controller wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture hori - fighting commander octa playstation ps4 hori - fighting commander octa playstation ps4 hori - fighting commander octa playstation ps4 wired usb wired wired dinput dinput dinput ['wired controller'] wired controller gold silver controller published published unknown closed source hori - fighting commander octa playstation ps4 hori fighting commander octa playstation ps4 hori fighting commander octa playstation ps4 wired usb wired dinput wired dinput dinput wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture hori - fighting commander octa playstation ps4",
      "controllerGroupKey": "published|hori fighting commander octa playstation ps4",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-hori-fighting-commander-octa-playstation-ps4",
          "name": "Hori - Fighting Commander Octa Playstation PS4",
          "measurementName": "Hori - Fighting Commander Octa Playstation PS4",
          "averageMs": 3.332,
          "averageTier": "Gold",
          "p99Ms": 5.28,
          "p99Tier": "Silver",
          "sameFramePct": 80.01,
          "observedSameFramePct": 80.0,
          "sampleCount": 2114,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 119,
          "modeRank": 31,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "hori - fighting commander octa playstation ps4 hori fighting commander octa playstation ps4 hori fighting commander octa playstation ps4 wired usb wired dinput wired dinput dinput wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture hori - fighting commander octa playstation ps4"
        }
      ]
    },
    {
      "id": "published-retrousb-retrokit-genesis",
      "name": "RetroUSB - RetroKit Genesis",
      "measurementName": "RetroUSB RetroKit Genesis [Wired USB]",
      "deviceNorm": "retrousb retrokit genesis",
      "make": "RetroUSB",
      "model": "RetroKit Genesis",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 61,
      "modeRank": 13,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "6/29/2020",
      "dateAddedSort": "2020-06-29",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "Genesis Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.379,
      "sdMs": 1.489,
      "maxMs": 6.408,
      "minMs": 0.484,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 79.73,
      "observedSameFramePct": 79.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "f000:0008",
      "searchText": "retrousb - retrokit genesis retrousb retrokit genesis retrousb retrokit genesis wired usb wired wired usb dinput wired dinput dinput controller adapter genesis controller controller adapter published published controller adapter - no gold 01-05ms (platinum) actively sold closed source mister / pc f000:0008 retrousb retrokit genesis [wired usb] retrousb - retrokit genesis retrousb retrokit genesis [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter', 'genesis controller'] controller adapter gold controller adapter - no published published actively sold closed source retrousb - retrokit genesis retrousb retrokit genesis retrousb retrokit genesis wired usb wired wired usb dinput wired dinput dinput controller adapter genesis controller published published controller adapter - no gold 01-05ms (platinum) actively sold closed source mister / pc f000:0008 retrousb retrokit genesis [wired usb]",
      "controllerGroupKey": "published|retrousb retrokit genesis",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retrousb-retrokit-genesis",
          "name": "RetroUSB - RetroKit Genesis",
          "measurementName": "RetroUSB RetroKit Genesis [Wired USB]",
          "averageMs": 3.379,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 79.73,
          "observedSameFramePct": 79.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Genesis Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 120,
          "modeRank": 48,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "6/29/2020",
          "dateAddedSort": "2020-06-29",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "f000:0008",
          "searchText": "retrousb - retrokit genesis retrousb retrokit genesis retrousb retrokit genesis wired usb wired wired usb dinput wired dinput dinput controller adapter genesis controller published published controller adapter - no gold 01-05ms (platinum) actively sold closed source mister / pc f000:0008 retrousb retrokit genesis [wired usb]"
        }
      ]
    },
    {
      "id": "published-ultimarc-j-pac",
      "name": "Ultimarc - J-PAC",
      "measurementName": "Ultimarc J-PAC [Wired USB]",
      "deviceNorm": "ultimarc j pac",
      "make": "Ultimarc",
      "model": "J-PAC",
      "link": "https://www.ultimarc.com/control-interfaces/j-pac-en/j-pac-jamma-interface/",
      "amazon": "",
      "buyUrl": "https://www.ultimarc.com/control-interfaces/j-pac-en/j-pac-jamma-interface/",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 62,
      "modeRank": 12,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "5/30/2020",
      "dateAddedSort": "2020-05-30",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.401,
      "sdMs": 1.169,
      "maxMs": 5.628,
      "minMs": 1.172,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 79.59,
      "observedSameFramePct": 79.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "d209:0450",
      "searchText": "ultimarc - j-pac ultimarc j pac ultimarc j-pac wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - no - gold 01-05ms (platinum) actively sold closed source mister / pc d209:0450 buy link ultimarc j-pac [wired usb] ultimarc - j-pac ultimarc j-pac [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder gold arcade stick encoder - no - published published actively sold closed source ultimarc - j-pac ultimarc j pac ultimarc j-pac wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - no - gold 01-05ms (platinum) actively sold closed source mister / pc d209:0450 buy link ultimarc j-pac [wired usb]",
      "controllerGroupKey": "published|ultimarc j pac",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-ultimarc-j-pac",
          "name": "Ultimarc - J-PAC",
          "measurementName": "Ultimarc J-PAC [Wired USB]",
          "averageMs": 3.401,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 79.59,
          "observedSameFramePct": 79.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 121,
          "modeRank": 16,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "5/30/2020",
          "dateAddedSort": "2020-05-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.ultimarc.com/control-interfaces/j-pac-en/j-pac-jamma-interface/",
          "link": "https://www.ultimarc.com/control-interfaces/j-pac-en/j-pac-jamma-interface/",
          "amazon": "",
          "joystickId": "d209:0450",
          "searchText": "ultimarc - j-pac ultimarc j pac ultimarc j-pac wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - no - gold 01-05ms (platinum) actively sold closed source mister / pc d209:0450 buy link ultimarc j-pac [wired usb]"
        }
      ]
    },
    {
      "id": "published-8bitdo-ultimate-wired-black-82ca",
      "name": "8BitDo - Ultimate Wired Black (82CA)",
      "measurementName": "8BitDo - Ultimate Wired Black (82CA) [Wired]",
      "deviceNorm": "8bitdo ultimate wired black 82ca",
      "make": "8BitDo",
      "model": "Ultimate Wired Black (82CA)",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 63,
      "modeRank": 26,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "Gold",
      "averageMs": 3.465,
      "sdMs": 0.864,
      "maxMs": 4.96,
      "minMs": 1.93,
      "p99Ms": 4.92,
      "sampleCount": 2370,
      "sameFramePct": 79.21,
      "observedSameFramePct": 79.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "8bitdo - ultimate wired black (82ca) 8bitdo ultimate wired black 82ca 8bitdo ultimate wired black (82ca) wired usb wired wired dinput wired dinput dinput wired controller wired controller published published controller gold gold 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - ultimate wired black (82ca) [wired] 8bitdo - ultimate wired black (82ca) 8bitdo - ultimate wired black (82ca) [wired] wired usb wired wired wired dinput dinput dinput ['wired controller'] wired controller gold gold controller published published unknown closed source 8bitdo - ultimate wired black (82ca) 8bitdo ultimate wired black 82ca 8bitdo ultimate wired black (82ca) wired usb wired wired dinput wired dinput dinput wired controller published published controller gold gold 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - ultimate wired black (82ca) [wired]",
      "controllerGroupKey": "published|8bitdo ultimate wired black 82ca",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-8bitdo-ultimate-wired-black-82ca",
          "name": "8BitDo - Ultimate Wired Black (82CA)",
          "measurementName": "8BitDo - Ultimate Wired Black (82CA) [Wired]",
          "averageMs": 3.465,
          "averageTier": "Gold",
          "p99Ms": 4.92,
          "p99Tier": "Gold",
          "sameFramePct": 79.21,
          "observedSameFramePct": 79.2,
          "sampleCount": 2370,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 122,
          "modeRank": 32,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - ultimate wired black (82ca) 8bitdo ultimate wired black 82ca 8bitdo ultimate wired black (82ca) wired usb wired wired dinput wired dinput dinput wired controller published published controller gold gold 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - ultimate wired black (82ca) [wired]"
        }
      ]
    },
    {
      "id": "published-8bitdo-pro2",
      "name": "8BitDo - Pro2",
      "measurementName": "8BitDo - Pro2 [Wired Switch D Input 82BC]",
      "deviceNorm": "8bitdo pro2",
      "make": "8BitDo",
      "model": "Pro2",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired Switch D Input 82BC",
      "outputMode": "DInput, Switch",
      "connectionTag": "Wired",
      "modeLabel": "DInput, Switch",
      "modeDisplay": "DInput, Switch",
      "rankMode": "Wired Controller",
      "overallRank": 64,
      "modeRank": 27,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "Gold",
      "averageMs": 3.501,
      "sdMs": 0.866,
      "maxMs": 5.01,
      "minMs": 1.95,
      "p99Ms": 4.958,
      "sampleCount": 2319,
      "sameFramePct": 78.99,
      "observedSameFramePct": 79.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "8bitdo - pro2 8bitdo pro2 8bitdo pro2 wired usb wired wired switch d input 82bc dinput, switch wired dinput, switch dinput, switch wired controller wired controller published published controller gold gold 01-05ms (platinum) unknown closed source mister / pc switch raw capture 8bitdo - pro2 [wired switch d input 82bc] 8bitdo - pro2 8bitdo - pro2 [wired switch d input 82bc] wired usb wired wired wired switch d input 82bc dinput, switch dinput, switch dinput, switch ['wired controller'] wired controller gold gold controller published published unknown closed source 8bitdo - pro2 8bitdo pro2 8bitdo pro2 wired usb wired wired switch d input 82bc dinput, switch wired dinput, switch dinput, switch wired controller published published controller gold gold 01-05ms (platinum) unknown closed source mister / pc switch raw capture 8bitdo - pro2 [wired switch d input 82bc]",
      "controllerGroupKey": "published|8bitdo pro2",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-8bitdo-pro2",
          "name": "8BitDo - Pro2",
          "measurementName": "8BitDo - Pro2 [Wired Switch D Input 82BC]",
          "averageMs": 3.501,
          "averageTier": "Gold",
          "p99Ms": 4.958,
          "p99Tier": "Gold",
          "sameFramePct": 78.99,
          "observedSameFramePct": 79.0,
          "sampleCount": 2319,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired Switch D Input 82BC",
          "outputMode": "DInput, Switch",
          "modeLabel": "DInput, Switch",
          "modeDisplay": "DInput, Switch",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 123,
          "modeRank": 33,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - pro2 8bitdo pro2 8bitdo pro2 wired usb wired wired switch d input 82bc dinput, switch wired dinput, switch dinput, switch wired controller published published controller gold gold 01-05ms (platinum) unknown closed source mister / pc switch raw capture 8bitdo - pro2 [wired switch d input 82bc]"
        }
      ]
    },
    {
      "id": "published-ultimarc-i-pac-2004",
      "name": "Ultimarc - I-PAC (2004)",
      "measurementName": "Ultimarc I-PAC (2004) [Wired USB]",
      "deviceNorm": "ultimarc i pac 2004",
      "make": "Ultimarc",
      "model": "I-PAC (2004)",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 65,
      "modeRank": 13,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "6/16/2020",
      "dateAddedSort": "2020-06-16",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.514,
      "sdMs": 1.167,
      "maxMs": 5.708,
      "minMs": 1.208,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 78.92,
      "observedSameFramePct": 78.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Discontinued",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "d208:0310",
      "searchText": "ultimarc - i-pac (2004) ultimarc i pac 2004 ultimarc i-pac (2004) wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - - - gold 01-05ms (platinum) discontinued closed source mister / pc d208:0310 ultimarc i-pac (2004) [wired usb] ultimarc - i-pac (2004) ultimarc i-pac (2004) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder gold arcade stick encoder - - - published published discontinued closed source ultimarc - i-pac (2004) ultimarc i pac 2004 ultimarc i-pac (2004) wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - gold 01-05ms (platinum) discontinued closed source mister / pc d208:0310 ultimarc i-pac (2004) [wired usb]",
      "controllerGroupKey": "published|ultimarc i pac 2004",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-ultimarc-i-pac-2004",
          "name": "Ultimarc - I-PAC (2004)",
          "measurementName": "Ultimarc I-PAC (2004) [Wired USB]",
          "averageMs": 3.514,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 78.92,
          "observedSameFramePct": 78.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 124,
          "modeRank": 17,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "6/16/2020",
          "dateAddedSort": "2020-06-16",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "d208:0310",
          "searchText": "ultimarc - i-pac (2004) ultimarc i pac 2004 ultimarc i-pac (2004) wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - gold 01-05ms (platinum) discontinued closed source mister / pc d208:0310 ultimarc i-pac (2004) [wired usb]"
        }
      ]
    },
    {
      "id": "published-sony-dualshock-4-rev2",
      "name": "Sony - DualShock 4 (Rev2)",
      "measurementName": "Sony DualShock 4 (Rev2) [Wired USB]",
      "deviceNorm": "sony dualshock 4 rev2",
      "make": "Sony",
      "model": "DualShock 4 (Rev2)",
      "link": "https://amzn.to/3d5QANG",
      "amazon": "",
      "buyUrl": "https://amzn.to/3d5QANG",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 66,
      "modeRank": 28,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "7.45",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC",
        "PS4"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.56,
      "sdMs": 0.1,
      "maxMs": 4.08,
      "minMs": 3.03,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 78.64,
      "observedSameFramePct": 78.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "054c:09cc",
      "searchText": "sony - dualshock 4 (rev2) sony dualshock 4 rev2 sony dualshock 4 (rev2) wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 yes 7.45 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 054c:09cc buy link sony dualshock 4 (rev2) [wired usb] sony - dualshock 4 (rev2) sony dualshock 4 (rev2) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller gold controller 4 yes 7.45 published published actively sold closed source sony - dualshock 4 (rev2) sony dualshock 4 rev2 sony dualshock 4 (rev2) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 7.45 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 054c:09cc buy link sony dualshock 4 (rev2) [wired usb] sony - dualshock 4 (rev2) sony dualshock 4 (rev2) [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless controller'] wireless controller silver controller 4 yes 7.45 published published actively sold closed source sony - dualshock 4 (rev2) sony dualshock 4 rev2 sony dualshock 4 (rev2) bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 7.45 silver 05-10ms (gold) actively sold closed source mister / pc ps4 054c:09cc buy link sony dualshock 4 (rev2) [bt (csr8510)] sony - dualshock 4 (rev2) sony dualshock 4 (rev2) [sony ds4 wireless adapter] bluetooth wireless wireless bt sony ds4 wireless adapter bluetooth bluetooth ['wireless controller'] wireless controller copper controller 4 yes 7.45 published published actively sold closed source sony - dualshock 4 (rev2) sony dualshock 4 rev2 sony dualshock 4 (rev2) bluetooth wireless sony ds4 wireless adapter wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 7.45 copper 20ms+ (rust) actively sold closed source mister / pc ps4 054c:0ba0 buy link sony dualshock 4 (rev2) [sony ds4 wireless adapter]",
      "controllerGroupKey": "published|sony dualshock 4 rev2",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-sony-dualshock-4-rev2",
          "name": "Sony - DualShock 4 (Rev2)",
          "measurementName": "Sony DualShock 4 (Rev2) [Wired USB]",
          "averageMs": 3.56,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 78.64,
          "observedSameFramePct": 78.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 125,
          "modeRank": 34,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "7.45",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3d5QANG",
          "link": "https://amzn.to/3d5QANG",
          "amazon": "",
          "joystickId": "054c:09cc",
          "searchText": "sony - dualshock 4 (rev2) sony dualshock 4 rev2 sony dualshock 4 (rev2) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 7.45 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 054c:09cc buy link sony dualshock 4 (rev2) [wired usb]"
        },
        {
          "id": "published-sony-dualshock-4-rev2-2",
          "name": "Sony - DualShock 4 (Rev2)",
          "measurementName": "Sony DualShock 4 (Rev2) [BT (CSR8510)]",
          "averageMs": 6.495,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 61.03,
          "observedSameFramePct": 61.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 202,
          "modeRank": 14,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "7.45",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3d5QANG",
          "link": "https://amzn.to/3d5QANG",
          "amazon": "",
          "joystickId": "054c:09cc",
          "searchText": "sony - dualshock 4 (rev2) sony dualshock 4 rev2 sony dualshock 4 (rev2) bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 7.45 silver 05-10ms (gold) actively sold closed source mister / pc ps4 054c:09cc buy link sony dualshock 4 (rev2) [bt (csr8510)]"
        },
        {
          "id": "published-sony-dualshock-4-rev2-3",
          "name": "Sony - DualShock 4 (Rev2)",
          "measurementName": "Sony DualShock 4 (Rev2) [Sony DS4 Wireless Adapter]",
          "averageMs": 32.831,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 20.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "Sony DS4 Wireless Adapter",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 336,
          "modeRank": 96,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "7.45",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3d5QANG",
          "link": "https://amzn.to/3d5QANG",
          "amazon": "",
          "joystickId": "054c:0ba0",
          "searchText": "sony - dualshock 4 (rev2) sony dualshock 4 rev2 sony dualshock 4 (rev2) bluetooth wireless sony ds4 wireless adapter wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 7.45 copper 20ms+ (rust) actively sold closed source mister / pc ps4 054c:0ba0 buy link sony dualshock 4 (rev2) [sony ds4 wireless adapter]"
        }
      ]
    },
    {
      "id": "published-powera-fusion-wired-fightpad-for-ps4",
      "name": "PowerA - Fusion Wired Fightpad for PS4",
      "measurementName": "PowerA Fusion Wired Fightpad for PS4 [Wired USB]",
      "deviceNorm": "powera fusion wired fightpad for ps4",
      "make": "PowerA",
      "model": "Fusion Wired Fightpad for PS4",
      "link": "https://amzn.to/2M1Bopb",
      "amazon": "",
      "buyUrl": "https://amzn.to/2M1Bopb",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 67,
      "modeRank": 29,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "6.30",
      "dateAdded": "5/27/2020",
      "dateAddedSort": "2020-05-27",
      "platforms": [
        "MiSTer / PC",
        "PS4"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.566,
      "sdMs": 1.171,
      "maxMs": 6.068,
      "minMs": 1.104,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 78.6,
      "observedSameFramePct": 78.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "20d6:792a",
      "searchText": "powera - fusion wired fightpad for ps4 powera fusion wired fightpad for ps4 powera fusion wired fightpad for ps4 wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 yes 6.30 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 20d6:792a buy link powera fusion wired fightpad for ps4 [wired usb] powera - fusion wired fightpad for ps4 powera fusion wired fightpad for ps4 [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller gold controller 6 yes 6.30 published published actively sold closed source powera - fusion wired fightpad for ps4 powera fusion wired fightpad for ps4 powera fusion wired fightpad for ps4 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 6.30 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 20d6:792a buy link powera fusion wired fightpad for ps4 [wired usb]",
      "controllerGroupKey": "published|powera fusion wired fightpad for ps4",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-powera-fusion-wired-fightpad-for-ps4",
          "name": "PowerA - Fusion Wired Fightpad for PS4",
          "measurementName": "PowerA Fusion Wired Fightpad for PS4 [Wired USB]",
          "averageMs": 3.566,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 78.6,
          "observedSameFramePct": 78.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 126,
          "modeRank": 35,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "6.30",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2M1Bopb",
          "link": "https://amzn.to/2M1Bopb",
          "amazon": "",
          "joystickId": "20d6:792a",
          "searchText": "powera - fusion wired fightpad for ps4 powera fusion wired fightpad for ps4 powera fusion wired fightpad for ps4 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 6.30 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 20d6:792a buy link powera fusion wired fightpad for ps4 [wired usb]"
        }
      ]
    },
    {
      "id": "published-krikzz-joyzz",
      "name": "Krikzz - Joyzz",
      "measurementName": "Krikzz Joyzz [DaemonBite Genesis]",
      "deviceNorm": "krikzz joyzz",
      "make": "Krikzz",
      "model": "Joyzz",
      "link": "https://amzn.to/2A82yrA",
      "amazon": "",
      "buyUrl": "https://amzn.to/2A82yrA",
      "connection": "2.4 GHz Console",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "DaemonBite Genesis",
      "outputMode": "",
      "connectionTag": "Wireless 2.4GHz",
      "modeLabel": "2.4G",
      "modeDisplay": "2.4 GHz Console",
      "rankMode": "Wireless Controller",
      "overallRank": 68,
      "modeRank": 1,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "3.90",
      "dateAdded": "6/1/2020",
      "dateAddedSort": "2020-06-01",
      "platforms": [],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.642,
      "sdMs": 0.296,
      "maxMs": 4.332,
      "minMs": 3.06,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 78.15,
      "observedSameFramePct": 78.1,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "2341:8036",
      "searchText": "krikzz - joyzz krikzz joyzz krikzz joyzz 2.4 ghz console wireless daemonbite genesis wireless 2.4ghz 2.4g 2.4 ghz console wireless controller wireless controller published published controller 6 no 3.90 gold 01-05ms (platinum) actively sold closed source 2341:8036 buy link krikzz joyzz [daemonbite genesis] krikzz - joyzz krikzz joyzz [daemonbite genesis] 2.4 ghz console wireless wireless 2.4ghz daemonbite genesis 2.4g 2.4 ghz console ['wireless controller'] wireless controller gold controller 6 no 3.90 published published actively sold closed source krikzz - joyzz krikzz joyzz krikzz joyzz 2.4 ghz console wireless daemonbite genesis wireless 2.4ghz 2.4g 2.4 ghz console wireless controller published published controller 6 no 3.90 gold 01-05ms (platinum) actively sold closed source 2341:8036 buy link krikzz joyzz [daemonbite genesis]",
      "controllerGroupKey": "published|krikzz joyzz",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-krikzz-joyzz",
          "name": "Krikzz - Joyzz",
          "measurementName": "Krikzz Joyzz [DaemonBite Genesis]",
          "averageMs": 3.642,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 78.15,
          "observedSameFramePct": 78.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz Console",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "DaemonBite Genesis",
          "outputMode": "",
          "modeLabel": "2.4G",
          "modeDisplay": "2.4 GHz Console",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 127,
          "modeRank": 1,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "3.90",
          "dateAdded": "6/1/2020",
          "dateAddedSort": "2020-06-01",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2A82yrA",
          "link": "https://amzn.to/2A82yrA",
          "amazon": "",
          "joystickId": "2341:8036",
          "searchText": "krikzz - joyzz krikzz joyzz krikzz joyzz 2.4 ghz console wireless daemonbite genesis wireless 2.4ghz 2.4g 2.4 ghz console wireless controller published published controller 6 no 3.90 gold 01-05ms (platinum) actively sold closed source 2341:8036 buy link krikzz joyzz [daemonbite genesis]"
        }
      ]
    },
    {
      "id": "published-generic-1-port-snes-to-usb-aliexpress",
      "name": "Generic - 1 Port SNES to USB (AliExpress)",
      "measurementName": "Generic 1 Port SNES to USB (AliExpress) [Wired USB]",
      "deviceNorm": "generic 1 port snes to usb aliexpress",
      "make": "Generic",
      "model": "1 Port SNES to USB (AliExpress)",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 69,
      "modeRank": 14,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "SNES Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.699,
      "sdMs": 0.865,
      "maxMs": 5.212,
      "minMs": 2.188,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 77.81,
      "observedSameFramePct": 77.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Discontinued",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0925:8866",
      "searchText": "generic - 1 port snes to usb (aliexpress) generic 1 port snes to usb aliexpress generic 1 port snes to usb (aliexpress) wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller controller adapter published published controller adapter - - - gold 01-05ms (platinum) discontinued closed source mister / pc 0925:8866 generic 1 port snes to usb (aliexpress) [wired usb] generic - 1 port snes to usb (aliexpress) generic 1 port snes to usb (aliexpress) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter', 'snes controller'] controller adapter gold controller adapter - - - published published discontinued closed source generic - 1 port snes to usb (aliexpress) generic 1 port snes to usb aliexpress generic 1 port snes to usb (aliexpress) wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller published published controller adapter - - - gold 01-05ms (platinum) discontinued closed source mister / pc 0925:8866 generic 1 port snes to usb (aliexpress) [wired usb]",
      "controllerGroupKey": "published|generic 1 port snes to usb aliexpress",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-generic-1-port-snes-to-usb-aliexpress",
          "name": "Generic - 1 Port SNES to USB (AliExpress)",
          "measurementName": "Generic 1 Port SNES to USB (AliExpress) [Wired USB]",
          "averageMs": 3.699,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 77.81,
          "observedSameFramePct": 77.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "SNES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 128,
          "modeRank": 49,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "0925:8866",
          "searchText": "generic - 1 port snes to usb (aliexpress) generic 1 port snes to usb aliexpress generic 1 port snes to usb (aliexpress) wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller published published controller adapter - - - gold 01-05ms (platinum) discontinued closed source mister / pc 0925:8866 generic 1 port snes to usb (aliexpress) [wired usb]"
        }
      ]
    },
    {
      "id": "published-mayflash-megadrive-controller-adapter-pc-usb",
      "name": "Mayflash - Megadrive Controller Adapter PC USB",
      "measurementName": "Mayflash Megadrive Controller Adapter PC USB [Wired USB Xinput]",
      "deviceNorm": "mayflash megadrive controller adapter pc usb",
      "make": "Mayflash",
      "model": "Megadrive Controller Adapter PC USB",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Xinput",
      "outputMode": "DInput, XInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput, XInput",
      "modeDisplay": "DInput, XInput",
      "rankMode": "Controller Adapter",
      "overallRank": 70,
      "modeRank": 15,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "7/20/2020",
      "dateAddedSort": "2020-07-20",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "Genesis Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.782,
      "sdMs": 1.192,
      "maxMs": 6.228,
      "minMs": 1.336,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 77.31,
      "observedSameFramePct": 77.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Discontinued",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:18af",
      "searchText": "mayflash - megadrive controller adapter pc usb mayflash megadrive controller adapter pc usb mayflash megadrive controller adapter pc usb wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput controller adapter genesis controller controller adapter published published controller adapter - no gold 01-05ms (platinum) discontinued closed source mister / pc 0079:18af mayflash megadrive controller adapter pc usb [wired usb xinput] mayflash - megadrive controller adapter pc usb mayflash megadrive controller adapter pc usb [wired usb xinput] wired usb wired wired wired usb xinput dinput, xinput dinput, xinput dinput, xinput ['controller adapter', 'genesis controller'] controller adapter gold controller adapter - no published published discontinued closed source mayflash - megadrive controller adapter pc usb mayflash megadrive controller adapter pc usb mayflash megadrive controller adapter pc usb wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput controller adapter genesis controller published published controller adapter - no gold 01-05ms (platinum) discontinued closed source mister / pc 0079:18af mayflash megadrive controller adapter pc usb [wired usb xinput] mayflash - megadrive controller adapter pc usb mayflash megadrive controller adapter pc usb [wired usb dinput] wired usb wired wired wired usb dinput dinput dinput dinput ['controller adapter', 'genesis controller'] controller adapter silver controller adapter - no published published discontinued closed source mayflash - megadrive controller adapter pc usb mayflash megadrive controller adapter pc usb mayflash megadrive controller adapter pc usb wired usb wired wired usb dinput dinput wired dinput dinput controller adapter genesis controller published published controller adapter - no silver 05-10ms (gold) discontinued closed source mister / pc 0079:18ae mayflash megadrive controller adapter pc usb [wired usb dinput]",
      "controllerGroupKey": "published|mayflash megadrive controller adapter pc usb",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-mayflash-megadrive-controller-adapter-pc-usb",
          "name": "Mayflash - Megadrive Controller Adapter PC USB",
          "measurementName": "Mayflash Megadrive Controller Adapter PC USB [Wired USB Xinput]",
          "averageMs": 3.782,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 77.31,
          "observedSameFramePct": 77.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Xinput",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Controller Adapter",
            "Genesis Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 129,
          "modeRank": 50,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "7/20/2020",
          "dateAddedSort": "2020-07-20",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "0079:18af",
          "searchText": "mayflash - megadrive controller adapter pc usb mayflash megadrive controller adapter pc usb mayflash megadrive controller adapter pc usb wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput controller adapter genesis controller published published controller adapter - no gold 01-05ms (platinum) discontinued closed source mister / pc 0079:18af mayflash megadrive controller adapter pc usb [wired usb xinput]"
        },
        {
          "id": "published-mayflash-megadrive-controller-adapter-pc-usb-2",
          "name": "Mayflash - Megadrive Controller Adapter PC USB",
          "measurementName": "Mayflash Megadrive Controller Adapter PC USB [Wired USB Dinput]",
          "averageMs": 6.873,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 58.76,
          "observedSameFramePct": 58.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Genesis Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 207,
          "modeRank": 57,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "7/20/2020",
          "dateAddedSort": "2020-07-20",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "0079:18ae",
          "searchText": "mayflash - megadrive controller adapter pc usb mayflash megadrive controller adapter pc usb mayflash megadrive controller adapter pc usb wired usb wired wired usb dinput dinput wired dinput dinput controller adapter genesis controller published published controller adapter - no silver 05-10ms (gold) discontinued closed source mister / pc 0079:18ae mayflash megadrive controller adapter pc usb [wired usb dinput]"
        }
      ]
    },
    {
      "id": "published-madcatz-te2-ryu-sfv",
      "name": "MadCatz - TE2+ Ryu SFV",
      "measurementName": "MadCatz TE2+ Ryu SFV [Wired USB]",
      "deviceNorm": "madcatz te2 ryu sfv",
      "make": "MadCatz",
      "model": "TE2+ Ryu SFV",
      "link": "https://amzn.to/3fcCquZ",
      "amazon": "",
      "buyUrl": "https://amzn.to/3fcCquZ",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 71,
      "modeRank": 12,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "8",
      "weightOz": "",
      "dateAdded": "6/10/2020",
      "dateAddedSort": "2020-06-10",
      "platforms": [
        "MiSTer / PC",
        "PS4",
        "PS5"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 3.83,
      "sdMs": 1.202,
      "maxMs": 7.196,
      "minMs": 1.36,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 77.02,
      "observedSameFramePct": 77.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0738:8481",
      "searchText": "madcatz - te2+ ryu sfv madcatz te2 ryu sfv madcatz te2+ ryu sfv wired usb wired wired usb dinput wired dinput dinput wired arcade stick wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc ps4 ps5 0738:8481 buy link madcatz te2+ ryu sfv [wired usb] madcatz - te2+ ryu sfv madcatz te2+ ryu sfv [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired arcade stick'] wired arcade stick gold arcade stick 8 yes published published actively sold closed source madcatz - te2+ ryu sfv madcatz te2 ryu sfv madcatz te2+ ryu sfv wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc ps4 ps5 0738:8481 buy link madcatz te2+ ryu sfv [wired usb]",
      "controllerGroupKey": "published|madcatz te2 ryu sfv",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-madcatz-te2-ryu-sfv",
          "name": "MadCatz - TE2+ Ryu SFV",
          "measurementName": "MadCatz TE2+ Ryu SFV [Wired USB]",
          "averageMs": 3.83,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 77.02,
          "observedSameFramePct": 77.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 130,
          "modeRank": 21,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "6/10/2020",
          "dateAddedSort": "2020-06-10",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3fcCquZ",
          "link": "https://amzn.to/3fcCquZ",
          "amazon": "",
          "joystickId": "0738:8481",
          "searchText": "madcatz - te2+ ryu sfv madcatz te2 ryu sfv madcatz te2+ ryu sfv wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc ps4 ps5 0738:8481 buy link madcatz te2+ ryu sfv [wired usb]"
        }
      ]
    },
    {
      "id": "published-blissbox-blisster-v2",
      "name": "BlissBox - BlisSTer v2",
      "measurementName": "BlissBox BlisSTer v2 [Non-LLAPI Wired USB]",
      "deviceNorm": "blissbox blisster v2",
      "make": "BlissBox",
      "model": "BlisSTer v2",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Non-LLAPI Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "USB",
      "rankMode": "Controller Adapter",
      "overallRank": 72,
      "modeRank": 16,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "9/19/2020",
      "dateAddedSort": "2020-09-19",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 4.1,
      "sdMs": 0.577,
      "maxMs": 5.16,
      "minMs": 3.096,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 75.4,
      "observedSameFramePct": 75.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "16d0:0d04",
      "searchText": "blissbox - blisster v2 blissbox blisster v2 blissbox blisster v2 wired usb wired non-llapi wired usb dinput wired dinput usb controller adapter controller adapter published published controller adapter - - - gold 01-05ms (platinum) actively sold closed source mister / pc 16d0:0d04 blissbox blisster v2 [non-llapi wired usb] blissbox - blisster v2 blissbox blisster v2 [non-llapi wired usb] wired usb wired wired non-llapi wired usb dinput dinput usb ['controller adapter'] controller adapter gold controller adapter - - - published published actively sold closed source blissbox - blisster v2 blissbox blisster v2 blissbox blisster v2 wired usb wired non-llapi wired usb dinput wired dinput usb controller adapter published published controller adapter - - - gold 01-05ms (platinum) actively sold closed source mister / pc 16d0:0d04 blissbox blisster v2 [non-llapi wired usb]",
      "controllerGroupKey": "published|blissbox blisster v2",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-blissbox-blisster-v2",
          "name": "BlissBox - BlisSTer v2",
          "measurementName": "BlissBox BlisSTer v2 [Non-LLAPI Wired USB]",
          "averageMs": 4.1,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 75.4,
          "observedSameFramePct": 75.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Non-LLAPI Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "USB",
          "deviceTypes": [
            "Controller Adapter"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 131,
          "modeRank": 51,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "9/19/2020",
          "dateAddedSort": "2020-09-19",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "16d0:0d04",
          "searchText": "blissbox - blisster v2 blissbox blisster v2 blissbox blisster v2 wired usb wired non-llapi wired usb dinput wired dinput usb controller adapter published published controller adapter - - - gold 01-05ms (platinum) actively sold closed source mister / pc 16d0:0d04 blissbox blisster v2 [non-llapi wired usb]"
        }
      ]
    },
    {
      "id": "published-ultimarc-i-pac2",
      "name": "Ultimarc - I-PAC2",
      "measurementName": "Ultimarc I-PAC2 [Wired USB]",
      "deviceNorm": "ultimarc i pac2",
      "make": "Ultimarc",
      "model": "I-PAC2",
      "link": "https://www.ultimarc.com/control-interfaces/i-pacs/i-pac2/",
      "amazon": "",
      "buyUrl": "https://www.ultimarc.com/control-interfaces/i-pacs/i-pac2/",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 73,
      "modeRank": 14,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "6/12/2020",
      "dateAddedSort": "2020-06-12",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 4.21,
      "sdMs": 1.185,
      "maxMs": 6.64,
      "minMs": 1.9,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 74.74,
      "observedSameFramePct": 74.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "d209:0420",
      "searchText": "ultimarc - i-pac2 ultimarc i pac2 ultimarc i-pac2 wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - no gold 01-05ms (platinum) actively sold closed source mister / pc d209:0420 buy link ultimarc i-pac2 [wired usb] ultimarc - i-pac2 ultimarc i-pac2 [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder gold arcade stick encoder - no published published actively sold closed source ultimarc - i-pac2 ultimarc i pac2 ultimarc i-pac2 wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - no gold 01-05ms (platinum) actively sold closed source mister / pc d209:0420 buy link ultimarc i-pac2 [wired usb]",
      "controllerGroupKey": "published|ultimarc i pac2",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-ultimarc-i-pac2",
          "name": "Ultimarc - I-PAC2",
          "measurementName": "Ultimarc I-PAC2 [Wired USB]",
          "averageMs": 4.21,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 74.74,
          "observedSameFramePct": 74.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 132,
          "modeRank": 18,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "6/12/2020",
          "dateAddedSort": "2020-06-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.ultimarc.com/control-interfaces/i-pacs/i-pac2/",
          "link": "https://www.ultimarc.com/control-interfaces/i-pacs/i-pac2/",
          "amazon": "",
          "joystickId": "d209:0420",
          "searchText": "ultimarc - i-pac2 ultimarc i pac2 ultimarc i-pac2 wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - no gold 01-05ms (platinum) actively sold closed source mister / pc d209:0420 buy link ultimarc i-pac2 [wired usb]"
        }
      ]
    },
    {
      "id": "published-logitech-f310-usb-gamepad",
      "name": "Logitech - F310 USB Gamepad",
      "measurementName": "Logitech F310 USB Gamepad [Wired USB Xinput]",
      "deviceNorm": "logitech f310 usb gamepad",
      "make": "Logitech",
      "model": "F310 USB Gamepad",
      "link": "https://www.amazon.com/Logitech-940-000110-Gamepad-F310/dp/B003VAHYQY",
      "amazon": "",
      "buyUrl": "https://www.amazon.com/Logitech-940-000110-Gamepad-F310/dp/B003VAHYQY",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Xinput",
      "outputMode": "DInput, XInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput, XInput",
      "modeDisplay": "DInput, XInput",
      "rankMode": "Wired Controller",
      "overallRank": 74,
      "modeRank": 30,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "6.05",
      "dateAdded": "6/30/2020",
      "dateAddedSort": "2020-06-30",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 4.262,
      "sdMs": 0.756,
      "maxMs": 6.084,
      "minMs": 2.516,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 74.43,
      "observedSameFramePct": 74.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "046d:c21d",
      "searchText": "logitech - f310 usb gamepad logitech f310 usb gamepad logitech f310 usb gamepad wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired controller wired controller published published controller 4 yes 6.05 gold 01-05ms (platinum) actively sold closed source mister / pc 046d:c21d buy link logitech f310 usb gamepad [wired usb xinput] logitech - f310 usb gamepad logitech f310 usb gamepad [wired usb xinput] wired usb wired wired wired usb xinput dinput, xinput dinput, xinput dinput, xinput ['wired controller'] wired controller gold controller 4 yes 6.05 published published actively sold closed source logitech - f310 usb gamepad logitech f310 usb gamepad logitech f310 usb gamepad wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired controller published published controller 4 yes 6.05 gold 01-05ms (platinum) actively sold closed source mister / pc 046d:c21d buy link logitech f310 usb gamepad [wired usb xinput] logitech - f310 usb gamepad logitech f310 usb gamepad [wired usb dinput] wired usb wired wired wired usb dinput dinput dinput dinput ['wired controller'] wired controller gold controller 4 no 6.05 published published actively sold closed source logitech - f310 usb gamepad logitech f310 usb gamepad logitech f310 usb gamepad wired usb wired wired usb dinput dinput wired dinput dinput wired controller published published controller 4 no 6.05 gold 01-05ms (platinum) actively sold closed source mister / pc 046d:c21d buy link logitech f310 usb gamepad [wired usb dinput]",
      "controllerGroupKey": "published|logitech f310 usb gamepad",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-logitech-f310-usb-gamepad",
          "name": "Logitech - F310 USB Gamepad",
          "measurementName": "Logitech F310 USB Gamepad [Wired USB Xinput]",
          "averageMs": 4.262,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 74.43,
          "observedSameFramePct": 74.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Xinput",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 133,
          "modeRank": 36,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "6.05",
          "dateAdded": "6/30/2020",
          "dateAddedSort": "2020-06-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.amazon.com/Logitech-940-000110-Gamepad-F310/dp/B003VAHYQY",
          "link": "https://www.amazon.com/Logitech-940-000110-Gamepad-F310/dp/B003VAHYQY",
          "amazon": "",
          "joystickId": "046d:c21d",
          "searchText": "logitech - f310 usb gamepad logitech f310 usb gamepad logitech f310 usb gamepad wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired controller published published controller 4 yes 6.05 gold 01-05ms (platinum) actively sold closed source mister / pc 046d:c21d buy link logitech f310 usb gamepad [wired usb xinput]"
        },
        {
          "id": "published-logitech-f310-usb-gamepad-2",
          "name": "Logitech - F310 USB Gamepad",
          "measurementName": "Logitech F310 USB Gamepad [Wired USB Dinput]",
          "averageMs": 4.43,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 73.42,
          "observedSameFramePct": 73.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 138,
          "modeRank": 37,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "6.05",
          "dateAdded": "6/30/2020",
          "dateAddedSort": "2020-06-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.amazon.com/Logitech-940-000110-Gamepad-F310/dp/B003VAHYQY",
          "link": "https://www.amazon.com/Logitech-940-000110-Gamepad-F310/dp/B003VAHYQY",
          "amazon": "",
          "joystickId": "046d:c21d",
          "searchText": "logitech - f310 usb gamepad logitech f310 usb gamepad logitech f310 usb gamepad wired usb wired wired usb dinput dinput wired dinput dinput wired controller published published controller 4 no 6.05 gold 01-05ms (platinum) actively sold closed source mister / pc 046d:c21d buy link logitech f310 usb gamepad [wired usb dinput]"
        }
      ]
    },
    {
      "id": "published-hori-real-arcade-pro-4-kai",
      "name": "Hori - Real Arcade Pro 4 Kai",
      "measurementName": "Hori Real Arcade Pro 4 Kai [Wired USB PS3]",
      "deviceNorm": "hori real arcade pro 4 kai",
      "make": "Hori",
      "model": "Real Arcade Pro 4 Kai",
      "link": "https://amzn.to/2AgmzwJ",
      "amazon": "",
      "buyUrl": "https://amzn.to/2AgmzwJ",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB PS3",
      "outputMode": "DInput, PS3",
      "connectionTag": "Wired",
      "modeLabel": "DInput, PS3",
      "modeDisplay": "DInput, PS3",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 75,
      "modeRank": 13,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "8",
      "weightOz": "83.65",
      "dateAdded": "6/11/2020",
      "dateAddedSort": "2020-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 4.294,
      "sdMs": 1.286,
      "maxMs": 7.196,
      "minMs": 1.42,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 74.24,
      "observedSameFramePct": 74.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0f0d:008b",
      "searchText": "hori - real arcade pro 4 kai hori real arcade pro 4 kai hori real arcade pro 4 kai wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick wired arcade stick published published arcade stick 8 yes 83.65 gold 01-05ms (platinum) actively sold closed source mister / pc 0f0d:008b buy link hori real arcade pro 4 kai [wired usb ps3] hori - real arcade pro 4 kai hori real arcade pro 4 kai [wired usb ps3] wired usb wired wired wired usb ps3 dinput, ps3 dinput, ps3 dinput, ps3 ['wired arcade stick'] wired arcade stick gold arcade stick 8 yes 83.65 published published actively sold closed source hori - real arcade pro 4 kai hori real arcade pro 4 kai hori real arcade pro 4 kai wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick 8 yes 83.65 gold 01-05ms (platinum) actively sold closed source mister / pc 0f0d:008b buy link hori real arcade pro 4 kai [wired usb ps3] hori - real arcade pro 4 kai hori real arcade pro 4 kai [wired usb pc] wired usb wired wired wired usb pc dinput dinput dinput ['wired arcade stick'] wired arcade stick gold arcade stick 8 yes 83.65 published published actively sold closed source hori - real arcade pro 4 kai hori real arcade pro 4 kai hori real arcade pro 4 kai wired usb wired wired usb pc dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes 83.65 gold 01-05ms (platinum) actively sold closed source mister / pc 0f0d:008c buy link hori real arcade pro 4 kai [wired usb pc] hori - real arcade pro 4 kai hori real arcade pro 4 kai [wired usb ps4] wired usb wired wired wired usb ps4 dinput, ps4 dinput, ps4 dinput, ps4 ['wired arcade stick'] wired arcade stick gold arcade stick 8 yes 83.65 published published actively sold closed source hori - real arcade pro 4 kai hori real arcade pro 4 kai hori real arcade pro 4 kai wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 wired arcade stick published published arcade stick 8 yes 83.65 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 0f0d:008a buy link hori real arcade pro 4 kai [wired usb ps4]",
      "controllerGroupKey": "published|hori real arcade pro 4 kai",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-hori-real-arcade-pro-4-kai",
          "name": "Hori - Real Arcade Pro 4 Kai",
          "measurementName": "Hori Real Arcade Pro 4 Kai [Wired USB PS3]",
          "averageMs": 4.294,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 74.24,
          "observedSameFramePct": 74.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PS3",
          "outputMode": "DInput, PS3",
          "modeLabel": "DInput, PS3",
          "modeDisplay": "DInput, PS3",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 134,
          "modeRank": 22,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "83.65",
          "dateAdded": "6/11/2020",
          "dateAddedSort": "2020-06-11",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2AgmzwJ",
          "link": "https://amzn.to/2AgmzwJ",
          "amazon": "",
          "joystickId": "0f0d:008b",
          "searchText": "hori - real arcade pro 4 kai hori real arcade pro 4 kai hori real arcade pro 4 kai wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick 8 yes 83.65 gold 01-05ms (platinum) actively sold closed source mister / pc 0f0d:008b buy link hori real arcade pro 4 kai [wired usb ps3]"
        },
        {
          "id": "published-hori-real-arcade-pro-4-kai-2",
          "name": "Hori - Real Arcade Pro 4 Kai",
          "measurementName": "Hori Real Arcade Pro 4 Kai [Wired USB PC]",
          "averageMs": 4.318,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 74.09,
          "observedSameFramePct": 74.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PC",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 135,
          "modeRank": 23,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "83.65",
          "dateAdded": "6/11/2020",
          "dateAddedSort": "2020-06-11",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2AgmzwJ",
          "link": "https://amzn.to/2AgmzwJ",
          "amazon": "",
          "joystickId": "0f0d:008c",
          "searchText": "hori - real arcade pro 4 kai hori real arcade pro 4 kai hori real arcade pro 4 kai wired usb wired wired usb pc dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes 83.65 gold 01-05ms (platinum) actively sold closed source mister / pc 0f0d:008c buy link hori real arcade pro 4 kai [wired usb pc]"
        },
        {
          "id": "published-hori-real-arcade-pro-4-kai-3",
          "name": "Hori - Real Arcade Pro 4 Kai",
          "measurementName": "Hori Real Arcade Pro 4 Kai [Wired USB PS4]",
          "averageMs": 4.345,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 73.93,
          "observedSameFramePct": 73.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PS4",
          "outputMode": "DInput, PS4",
          "modeLabel": "DInput, PS4",
          "modeDisplay": "DInput, PS4",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 137,
          "modeRank": 24,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "83.65",
          "dateAdded": "6/11/2020",
          "dateAddedSort": "2020-06-11",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2AgmzwJ",
          "link": "https://amzn.to/2AgmzwJ",
          "amazon": "",
          "joystickId": "0f0d:008a",
          "searchText": "hori - real arcade pro 4 kai hori real arcade pro 4 kai hori real arcade pro 4 kai wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 wired arcade stick published published arcade stick 8 yes 83.65 gold 01-05ms (platinum) actively sold closed source mister / pc ps4 0f0d:008a buy link hori real arcade pro 4 kai [wired usb ps4]"
        }
      ]
    },
    {
      "id": "published-ultimarc-i-pac-ultimate",
      "name": "Ultimarc - I-PAC Ultimate",
      "measurementName": "Ultimarc I-PAC Ultimate [Wired USB]",
      "deviceNorm": "ultimarc i pac ultimate",
      "make": "Ultimarc",
      "model": "I-PAC Ultimate",
      "link": "https://www.ultimarc.com/control-interfaces/i-pacs/i-pac-ultimate-i-o/",
      "amazon": "",
      "buyUrl": "https://www.ultimarc.com/control-interfaces/i-pacs/i-pac-ultimate-i-o/",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 76,
      "modeRank": 15,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "6/12/2020",
      "dateAddedSort": "2020-06-12",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 4.34,
      "sdMs": 1.18,
      "maxMs": 6.684,
      "minMs": 1.976,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 73.96,
      "observedSameFramePct": 74.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "d209:0410",
      "searchText": "ultimarc - i-pac ultimate ultimarc i pac ultimate ultimarc i-pac ultimate wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - no gold 01-05ms (platinum) actively sold closed source mister / pc d209:0410 buy link ultimarc i-pac ultimate [wired usb] ultimarc - i-pac ultimate ultimarc i-pac ultimate [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder gold arcade stick encoder - no published published actively sold closed source ultimarc - i-pac ultimate ultimarc i pac ultimate ultimarc i-pac ultimate wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - no gold 01-05ms (platinum) actively sold closed source mister / pc d209:0410 buy link ultimarc i-pac ultimate [wired usb]",
      "controllerGroupKey": "published|ultimarc i pac ultimate",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-ultimarc-i-pac-ultimate",
          "name": "Ultimarc - I-PAC Ultimate",
          "measurementName": "Ultimarc I-PAC Ultimate [Wired USB]",
          "averageMs": 4.34,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 73.96,
          "observedSameFramePct": 74.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 136,
          "modeRank": 19,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "6/12/2020",
          "dateAddedSort": "2020-06-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.ultimarc.com/control-interfaces/i-pacs/i-pac-ultimate-i-o/",
          "link": "https://www.ultimarc.com/control-interfaces/i-pacs/i-pac-ultimate-i-o/",
          "amazon": "",
          "joystickId": "d209:0410",
          "searchText": "ultimarc - i-pac ultimate ultimarc i pac ultimate ultimarc i-pac ultimate wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - no gold 01-05ms (platinum) actively sold closed source mister / pc d209:0410 buy link ultimarc i-pac ultimate [wired usb]"
        }
      ]
    },
    {
      "id": "published-retro-fighters-brawler64",
      "name": "Retro Fighters - Brawler64",
      "measurementName": "RetroFighters - Brawler64 [Dinput]",
      "deviceNorm": "retro fighters brawler64",
      "make": "RetroFighters",
      "model": "Brawler64",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Dinput",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 77,
      "modeRank": 31,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "Silver",
      "averageMs": 4.508,
      "sdMs": 1.471,
      "maxMs": 7.53,
      "minMs": 1.59,
      "p99Ms": 7.22,
      "sampleCount": 6562,
      "sameFramePct": 72.95,
      "observedSameFramePct": 73.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "retro fighters - brawler64 retro fighters brawler64 retrofighters brawler64 wired usb wired dinput dinput wired dinput dinput wired controller wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture retrofighters - brawler64 [dinput] retrofighters - brawler64 retrofighters - brawler64 [dinput] wired usb wired wired dinput dinput dinput dinput ['wired controller'] wired controller gold silver controller published published unknown closed source retrofighters - brawler64 retrofighters brawler64 retrofighters brawler64 wired usb wired dinput dinput wired dinput dinput wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture retrofighters - brawler64 [dinput] retrofighters - brawler64 retrofighters - brawler64 [xinput] wired usb wired wired xinput xinput xinput xinput ['wired controller'] wired controller gold silver controller published published unknown closed source retrofighters - brawler64 retrofighters brawler64 retrofighters brawler64 wired usb wired xinput xinput wired xinput xinput wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture retrofighters - brawler64 [xinput]",
      "controllerGroupKey": "published|retro fighters brawler64",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-retrofighters-brawler64",
          "name": "RetroFighters - Brawler64",
          "measurementName": "RetroFighters - Brawler64 [Dinput]",
          "averageMs": 4.508,
          "averageTier": "Gold",
          "p99Ms": 7.22,
          "p99Tier": "Silver",
          "sameFramePct": 72.95,
          "observedSameFramePct": 73.0,
          "sampleCount": 6562,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 139,
          "modeRank": 38,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "retrofighters - brawler64 retrofighters brawler64 retrofighters brawler64 wired usb wired dinput dinput wired dinput dinput wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture retrofighters - brawler64 [dinput]"
        },
        {
          "id": "published-retrofighters-brawler64-2",
          "name": "RetroFighters - Brawler64",
          "measurementName": "RetroFighters - Brawler64 [Xinput]",
          "averageMs": 4.576,
          "averageTier": "Gold",
          "p99Ms": 7.3,
          "p99Tier": "Silver",
          "sameFramePct": 72.54,
          "observedSameFramePct": 72.5,
          "sampleCount": 2044,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Xinput",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "XInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 146,
          "modeRank": 41,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "retrofighters - brawler64 retrofighters brawler64 retrofighters brawler64 wired usb wired xinput xinput wired xinput xinput wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture retrofighters - brawler64 [xinput]"
        }
      ]
    },
    {
      "id": "published-retro-fighters-brawler-64-nso-edition",
      "name": "Retro Fighters - Brawler 64 NSO Edition",
      "measurementName": "Retro Fighters Brawler 64 NSO Edition [Wired USB Dinput]",
      "deviceNorm": "retro fighters brawler 64 nso edition",
      "make": "Retro Fighters",
      "model": "Brawler 64 NSO Edition",
      "link": "https://www.amazon.com/Fighters-Brawler64-Nintendo-Switch-Controller-Bluetooth/dp/B0BP9GH8VQ/ref=sr_1_6?crid=3S09IA6H9GJLF&keywords=nintendo%2Bswitch%2Bonline%2Bn64&qid=1693408295&sprefix=nintendo%2Bswitch%2Bonline%2Bn%2Caps%2C179&sr=8-6&th=1",
      "amazon": "",
      "buyUrl": "https://www.amazon.com/Fighters-Brawler64-Nintendo-Switch-Controller-Bluetooth/dp/B0BP9GH8VQ/ref=sr_1_6?crid=3S09IA6H9GJLF&keywords=nintendo%2Bswitch%2Bonline%2Bn64&qid=1693408295&sprefix=nintendo%2Bswitch%2Bonline%2Bn%2Caps%2C179&sr=8-6&th=1",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Dinput",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 78,
      "modeRank": 32,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "",
      "dateAdded": "3/19/2024",
      "dateAddedSort": "2024-03-19",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 4.51,
      "sdMs": 1.47,
      "maxMs": 7.53,
      "minMs": 1.59,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 72.94,
      "observedSameFramePct": 72.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "retro fighters - brawler 64 nso edition retro fighters brawler 64 nso edition retro fighters brawler 64 nso edition wired usb wired wired usb dinput dinput wired dinput dinput wired controller wired controller published published controller 6 gold 01-05ms (platinum) actively sold closed source mister / pc switch 045e:028e buy link retro fighters brawler 64 nso edition [wired usb dinput] retro fighters - brawler 64 nso edition retro fighters brawler 64 nso edition [wired usb dinput] wired usb wired wired wired usb dinput dinput dinput dinput ['wired controller'] wired controller gold controller 6 published published actively sold closed source retro fighters - brawler 64 nso edition retro fighters brawler 64 nso edition retro fighters brawler 64 nso edition wired usb wired wired usb dinput dinput wired dinput dinput wired controller published published controller 6 gold 01-05ms (platinum) actively sold closed source mister / pc switch 045e:028e buy link retro fighters brawler 64 nso edition [wired usb dinput] retro fighters - brawler 64 nso edition retro fighters brawler 64 nso edition [wired usbxinput] wired usb wired wired wired usbxinput dinput dinput dinput ['wired controller'] wired controller gold controller 6 published published actively sold closed source retro fighters - brawler 64 nso edition retro fighters brawler 64 nso edition retro fighters brawler 64 nso edition wired usb wired wired usbxinput dinput wired dinput dinput wired controller published published controller 6 gold 01-05ms (platinum) actively sold closed source mister / pc switch 0079:181c buy link retro fighters brawler 64 nso edition [wired usbxinput]",
      "controllerGroupKey": "published|retro fighters brawler 64 nso edition",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-retro-fighters-brawler-64-nso-edition",
          "name": "Retro Fighters - Brawler 64 NSO Edition",
          "measurementName": "Retro Fighters Brawler 64 NSO Edition [Wired USB Dinput]",
          "averageMs": 4.51,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 72.94,
          "observedSameFramePct": 72.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 140,
          "modeRank": 39,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "3/19/2024",
          "dateAddedSort": "2024-03-19",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.amazon.com/Fighters-Brawler64-Nintendo-Switch-Controller-Bluetooth/dp/B0BP9GH8VQ/ref=sr_1_6?crid=3S09IA6H9GJLF&keywords=nintendo%2Bswitch%2Bonline%2Bn64&qid=1693408295&sprefix=nintendo%2Bswitch%2Bonline%2Bn%2Caps%2C179&sr=8-6&th=1",
          "link": "https://www.amazon.com/Fighters-Brawler64-Nintendo-Switch-Controller-Bluetooth/dp/B0BP9GH8VQ/ref=sr_1_6?crid=3S09IA6H9GJLF&keywords=nintendo%2Bswitch%2Bonline%2Bn64&qid=1693408295&sprefix=nintendo%2Bswitch%2Bonline%2Bn%2Caps%2C179&sr=8-6&th=1",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "retro fighters - brawler 64 nso edition retro fighters brawler 64 nso edition retro fighters brawler 64 nso edition wired usb wired wired usb dinput dinput wired dinput dinput wired controller published published controller 6 gold 01-05ms (platinum) actively sold closed source mister / pc switch 045e:028e buy link retro fighters brawler 64 nso edition [wired usb dinput]"
        },
        {
          "id": "published-retro-fighters-brawler-64-nso-edition-2",
          "name": "Retro Fighters - Brawler 64 NSO Edition",
          "measurementName": "Retro Fighters Brawler 64 NSO Edition [Wired USBXinput]",
          "averageMs": 4.58,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 72.52,
          "observedSameFramePct": 72.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USBXinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 147,
          "modeRank": 42,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "3/19/2024",
          "dateAddedSort": "2024-03-19",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.amazon.com/Fighters-Brawler64-Nintendo-Switch-Controller-Bluetooth/dp/B0BP9GH8VQ/ref=sr_1_6?crid=3S09IA6H9GJLF&keywords=nintendo%2Bswitch%2Bonline%2Bn64&qid=1693408295&sprefix=nintendo%2Bswitch%2Bonline%2Bn%2Caps%2C179&sr=8-6&th=1",
          "link": "https://www.amazon.com/Fighters-Brawler64-Nintendo-Switch-Controller-Bluetooth/dp/B0BP9GH8VQ/ref=sr_1_6?crid=3S09IA6H9GJLF&keywords=nintendo%2Bswitch%2Bonline%2Bn64&qid=1693408295&sprefix=nintendo%2Bswitch%2Bonline%2Bn%2Caps%2C179&sr=8-6&th=1",
          "amazon": "",
          "joystickId": "0079:181c",
          "searchText": "retro fighters - brawler 64 nso edition retro fighters brawler 64 nso edition retro fighters brawler 64 nso edition wired usb wired wired usbxinput dinput wired dinput dinput wired controller published published controller 6 gold 01-05ms (platinum) actively sold closed source mister / pc switch 0079:181c buy link retro fighters brawler 64 nso edition [wired usbxinput]"
        }
      ]
    },
    {
      "id": "published-8bitdo-neogeo-wireless-controller",
      "name": "8BitDo - NEOGEO Wireless Controller",
      "measurementName": "8BitDo - NeoGeo 2.4G fw1.09",
      "deviceNorm": "8bitdo neogeo wireless controller",
      "make": "8BitDo",
      "model": "NeoGeo 2.4G fw1.09",
      "link": "https://amzn.to/45TAAtt",
      "amazon": "",
      "buyUrl": "https://amzn.to/45TAAtt",
      "connection": "2.4GHz Wireless",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "",
      "connectionTag": "Wireless 2.4GHz",
      "modeLabel": "2.4G",
      "modeDisplay": "2.4GHz Wireless",
      "rankMode": "Wireless Controller",
      "overallRank": 79,
      "modeRank": 2,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "8/20/2023",
      "dateAddedSort": "2023-08-20",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "Silver",
      "averageMs": 4.514,
      "sdMs": 2.02,
      "maxMs": 9.04,
      "minMs": 1.08,
      "p99Ms": 8.679,
      "sampleCount": 2109,
      "sameFramePct": 72.92,
      "observedSameFramePct": 72.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "2dca:3106",
      "searchText": "8bitdo - neogeo wireless controller 8bitdo neogeo wireless controller 8bitdo neogeo 2.4g fw1.09 2.4ghz wireless wireless wireless 2.4ghz 2.4g 2.4ghz wireless wireless controller wireless controller published published controller gold silver 01-05ms (platinum) actively sold closed source mister / pc 2dca:3106 raw capture buy link 8bitdo - neogeo 2.4g fw1.09 8bitdo - neogeo 2.4g fw1.09 8bitdo - neogeo 2.4g fw1.09 2.4ghz wireless wireless wireless 2.4ghz 2.4g 2.4ghz wireless ['wireless controller'] wireless controller gold silver controller published published actively sold closed source 8bitdo - neogeo 2.4g fw1.09 8bitdo neogeo 2 4g fw1 09 8bitdo neogeo 2.4g fw1.09 2.4ghz wireless wireless wireless 2.4ghz 2.4g 2.4ghz wireless wireless controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - neogeo 2.4g fw1.09 8bitdo - neogeo 2.4g fw1.00beta 8bitdo - neogeo 2.4g fw1.00beta 2.4ghz wireless wireless wireless 2.4ghz 2.4g 2.4ghz wireless ['wireless controller'] wireless controller gold silver controller published published actively sold closed source 8bitdo - neogeo 2.4g fw1.00beta 8bitdo neogeo 2 4g fw1 00beta 8bitdo neogeo 2.4g fw1.00beta 2.4ghz wireless wireless wireless 2.4ghz 2.4g 2.4ghz wireless wireless controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - neogeo 2.4g fw1.00beta 8bitdo - neogeo usb fw1.09 8bitdo - neogeo usb fw1.09 wired usb wired wired dinput dinput dinput ['wired controller'] wired controller silver bronze controller published published actively sold closed source 8bitdo - neogeo usb fw1.09 8bitdo neogeo usb fw1 09 8bitdo neogeo usb fw1.09 wired usb wired dinput wired dinput dinput wired controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - neogeo usb fw1.09 8bitdo - neogeo usb fw1.00beta 8bitdo - neogeo usb fw1.00beta wired usb wired wired dinput dinput dinput ['wired controller'] wired controller silver bronze controller published published actively sold closed source 8bitdo - neogeo usb fw1.00beta 8bitdo neogeo usb fw1 00beta 8bitdo neogeo usb fw1.00beta wired usb wired dinput wired dinput dinput wired controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - neogeo usb fw1.00beta 8bitdo - neogeo bt fw1.09 8bitdo - neogeo bt fw1.09 bluetooth wireless wireless bt bluetooth bluetooth ['wireless controller'] wireless controller silver bronze controller published published actively sold closed source 8bitdo - neogeo bt fw1.09 8bitdo neogeo bt fw1 09 8bitdo neogeo bt fw1.09 bluetooth wireless wireless bt bluetooth bluetooth wireless controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - neogeo bt fw1.09 8bitdo - neogeo bt fw1.00beta 8bitdo - neogeo bt fw1.00beta bluetooth wireless wireless bt bluetooth bluetooth ['wireless controller'] wireless controller silver copper controller published published actively sold closed source 8bitdo - neogeo bt fw1.00beta 8bitdo neogeo bt fw1 00beta 8bitdo neogeo bt fw1.00beta bluetooth wireless wireless bt bluetooth bluetooth wireless controller published published controller silver copper 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - neogeo bt fw1.00beta",
      "controllerGroupKey": "published|8bitdo neogeo wireless controller",
      "modeVariantCount": 6,
      "modeVariants": [
        {
          "id": "published-8bitdo-neogeo-2-4g-fw1-09",
          "name": "8BitDo - NeoGeo 2.4G fw1.09",
          "measurementName": "8BitDo - NeoGeo 2.4G fw1.09",
          "averageMs": 4.514,
          "averageTier": "Gold",
          "p99Ms": 8.679,
          "p99Tier": "Silver",
          "sameFramePct": 72.92,
          "observedSameFramePct": 72.9,
          "sampleCount": 2109,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4GHz Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "",
          "outputMode": "",
          "modeLabel": "2.4G",
          "modeDisplay": "2.4GHz Wireless",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 141,
          "modeRank": 2,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "8/20/2023",
          "dateAddedSort": "2023-08-20",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/45TAAtt",
          "link": "https://amzn.to/45TAAtt",
          "amazon": "",
          "joystickId": "2dca:3106",
          "searchText": "8bitdo - neogeo 2.4g fw1.09 8bitdo neogeo 2 4g fw1 09 8bitdo neogeo 2.4g fw1.09 2.4ghz wireless wireless wireless 2.4ghz 2.4g 2.4ghz wireless wireless controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - neogeo 2.4g fw1.09"
        },
        {
          "id": "published-8bitdo-neogeo-2-4g-fw1-00beta",
          "name": "8BitDo - NeoGeo 2.4G fw1.00beta",
          "measurementName": "8BitDo - NeoGeo 2.4G fw1.00beta",
          "averageMs": 4.519,
          "averageTier": "Gold",
          "p99Ms": 8.741,
          "p99Tier": "Silver",
          "sameFramePct": 72.89,
          "observedSameFramePct": 72.9,
          "sampleCount": 2123,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4GHz Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "",
          "outputMode": "",
          "modeLabel": "2.4G",
          "modeDisplay": "2.4GHz Wireless",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 142,
          "modeRank": 3,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "8/20/2023",
          "dateAddedSort": "2023-08-20",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/45TAAtt",
          "link": "https://amzn.to/45TAAtt",
          "amazon": "",
          "joystickId": "2dca:3106",
          "searchText": "8bitdo - neogeo 2.4g fw1.00beta 8bitdo neogeo 2 4g fw1 00beta 8bitdo neogeo 2.4g fw1.00beta 2.4ghz wireless wireless wireless 2.4ghz 2.4g 2.4ghz wireless wireless controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - neogeo 2.4g fw1.00beta"
        },
        {
          "id": "published-8bitdo-neogeo-usb-fw1-09",
          "name": "8BitDo - NeoGeo USB fw1.09",
          "measurementName": "8BitDo - NeoGeo USB fw1.09",
          "averageMs": 6.098,
          "averageTier": "Silver",
          "p99Ms": 11.12,
          "p99Tier": "Bronze",
          "sameFramePct": 63.41,
          "observedSameFramePct": 63.4,
          "sampleCount": 3096,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 188,
          "modeRank": 64,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "8/20/2023",
          "dateAddedSort": "2023-08-20",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/45TAAtt",
          "link": "https://amzn.to/45TAAtt",
          "amazon": "",
          "joystickId": "2dca:3106",
          "searchText": "8bitdo - neogeo usb fw1.09 8bitdo neogeo usb fw1 09 8bitdo neogeo usb fw1.09 wired usb wired dinput wired dinput dinput wired controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - neogeo usb fw1.09"
        },
        {
          "id": "published-8bitdo-neogeo-usb-fw1-00beta",
          "name": "8BitDo - NeoGeo USB fw1.00beta",
          "measurementName": "8BitDo - NeoGeo USB fw1.00beta",
          "averageMs": 6.15,
          "averageTier": "Silver",
          "p99Ms": 11.22,
          "p99Tier": "Bronze",
          "sameFramePct": 63.1,
          "observedSameFramePct": 63.1,
          "sampleCount": 2031,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 192,
          "modeRank": 68,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "8/20/2023",
          "dateAddedSort": "2023-08-20",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/45TAAtt",
          "link": "https://amzn.to/45TAAtt",
          "amazon": "",
          "joystickId": "2dca:3106",
          "searchText": "8bitdo - neogeo usb fw1.00beta 8bitdo neogeo usb fw1 00beta 8bitdo neogeo usb fw1.00beta wired usb wired dinput wired dinput dinput wired controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - neogeo usb fw1.00beta"
        },
        {
          "id": "published-8bitdo-neogeo-bt-fw1-09",
          "name": "8BitDo - NeoGeo BT fw1.09",
          "measurementName": "8BitDo - NeoGeo BT fw1.09",
          "averageMs": 9.75,
          "averageTier": "Silver",
          "p99Ms": 16.25,
          "p99Tier": "Bronze",
          "sameFramePct": 41.5,
          "observedSameFramePct": 41.6,
          "sampleCount": 3800,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 233,
          "modeRank": 25,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "8/20/2023",
          "dateAddedSort": "2023-08-20",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/45TAAtt",
          "link": "https://amzn.to/45TAAtt",
          "amazon": "",
          "joystickId": "2dc8:9025",
          "searchText": "8bitdo - neogeo bt fw1.09 8bitdo neogeo bt fw1 09 8bitdo neogeo bt fw1.09 bluetooth wireless wireless bt bluetooth bluetooth wireless controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - neogeo bt fw1.09"
        },
        {
          "id": "published-8bitdo-neogeo-bt-fw1-00beta",
          "name": "8BitDo - NeoGeo BT fw1.00beta",
          "measurementName": "8BitDo - NeoGeo BT fw1.00beta",
          "averageMs": 9.871,
          "averageTier": "Silver",
          "p99Ms": 16.696,
          "p99Tier": "Copper",
          "sameFramePct": 40.77,
          "observedSameFramePct": 40.9,
          "sampleCount": 2544,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 238,
          "modeRank": 29,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "8/20/2023",
          "dateAddedSort": "2023-08-20",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/45TAAtt",
          "link": "https://amzn.to/45TAAtt",
          "amazon": "",
          "joystickId": "2dc8:9025",
          "searchText": "8bitdo - neogeo bt fw1.00beta 8bitdo neogeo bt fw1 00beta 8bitdo neogeo bt fw1.00beta bluetooth wireless wireless bt bluetooth bluetooth wireless controller published published controller silver copper 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - neogeo bt fw1.00beta"
        }
      ]
    },
    {
      "id": "published-8bitdo-m30-for-xbox",
      "name": "8BitDo - M30 for Xbox",
      "measurementName": "8BitDo - M30 Wired Controller for Xbox",
      "deviceNorm": "8bitdo m30 for xbox",
      "make": "8BitDo",
      "model": "M30 Wired Controller for Xbox",
      "link": "https://amzn.to/3SsOfCq",
      "amazon": "",
      "buyUrl": "https://amzn.to/3SsOfCq",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 80,
      "modeRank": 33,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "2/2/2024",
      "dateAddedSort": "2024-02-02",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "Bronze",
      "averageMs": 4.535,
      "sdMs": 2.093,
      "maxMs": 23.14,
      "minMs": 0.32,
      "p99Ms": 12.623,
      "sampleCount": 7276,
      "sameFramePct": 72.79,
      "observedSameFramePct": 72.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "8bitdo - m30 for xbox 8bitdo m30 for xbox 8bitdo m30 wired controller for xbox wired usb wired dinput wired dinput dinput wired controller wired controller published published controller gold bronze 01-05ms (platinum) actively sold closed source mister / pc raw capture buy link 8bitdo - m30 wired controller for xbox 8bitdo - m30 wired controller for xbox 8bitdo - m30 wired controller for xbox wired usb wired wired dinput dinput dinput ['wired controller'] wired controller gold bronze controller published published actively sold closed source 8bitdo - m30 wired controller for xbox 8bitdo m30 wired controller for xbox 8bitdo m30 wired controller for xbox wired usb wired dinput wired dinput dinput wired controller published published controller gold bronze 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - m30 wired controller for xbox",
      "controllerGroupKey": "published|8bitdo m30 for xbox",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-8bitdo-m30-wired-controller-for-xbox",
          "name": "8BitDo - M30 Wired Controller for Xbox",
          "measurementName": "8BitDo - M30 Wired Controller for Xbox",
          "averageMs": 4.535,
          "averageTier": "Gold",
          "p99Ms": 12.623,
          "p99Tier": "Bronze",
          "sameFramePct": 72.79,
          "observedSameFramePct": 72.8,
          "sampleCount": 7276,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 143,
          "modeRank": 40,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "2/2/2024",
          "dateAddedSort": "2024-02-02",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3SsOfCq",
          "link": "https://amzn.to/3SsOfCq",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - m30 wired controller for xbox 8bitdo m30 wired controller for xbox 8bitdo m30 wired controller for xbox wired usb wired dinput wired dinput dinput wired controller published published controller gold bronze 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - m30 wired controller for xbox"
        }
      ]
    },
    {
      "id": "published-new-wave-toys-replicade-street-fighter-ii-mini-fight-stick",
      "name": "New Wave Toys (Replicade) - Street Fighter II Mini Fight Stick",
      "measurementName": "New Wave Toys (Replicade) Street Fighter II Mini Fight Stick [Wired USB]",
      "deviceNorm": "new wave toys replicade street fighter ii mini fight stick",
      "make": "New Wave Toys (Replicade)",
      "model": "Street Fighter II Mini Fight Stick",
      "link": "https://newwavetoys.com/products/street-fighter-ii-mini-fight-stick",
      "amazon": "",
      "buyUrl": "https://newwavetoys.com/products/street-fighter-ii-mini-fight-stick",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 81,
      "modeRank": 14,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "6",
      "weightOz": "",
      "dateAdded": "12/17/2021",
      "dateAddedSort": "2021-12-17",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 4.536,
      "sdMs": 2.013,
      "maxMs": 8.11,
      "minMs": 1.1,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 72.78,
      "observedSameFramePct": 72.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "1c5b:0025",
      "searchText": "new wave toys (replicade) - street fighter ii mini fight stick new wave toys replicade street fighter ii mini fight stick new wave toys (replicade) street fighter ii mini fight stick wired usb wired wired usb dinput wired dinput dinput wired arcade stick wired arcade stick published published arcade stick 6 no gold 01-05ms (platinum) actively sold closed source mister / pc 1c5b:0025 buy link new wave toys (replicade) street fighter ii mini fight stick [wired usb] new wave toys (replicade) - street fighter ii mini fight stick new wave toys (replicade) street fighter ii mini fight stick [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired arcade stick'] wired arcade stick gold arcade stick 6 no published published actively sold closed source new wave toys (replicade) - street fighter ii mini fight stick new wave toys replicade street fighter ii mini fight stick new wave toys (replicade) street fighter ii mini fight stick wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 6 no gold 01-05ms (platinum) actively sold closed source mister / pc 1c5b:0025 buy link new wave toys (replicade) street fighter ii mini fight stick [wired usb]",
      "controllerGroupKey": "published|new wave toys replicade street fighter ii mini fight stick",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-new-wave-toys-replicade-street-fighter-ii-mini-fight-stick",
          "name": "New Wave Toys (Replicade) - Street Fighter II Mini Fight Stick",
          "measurementName": "New Wave Toys (Replicade) Street Fighter II Mini Fight Stick [Wired USB]",
          "averageMs": 4.536,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 72.78,
          "observedSameFramePct": 72.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 144,
          "modeRank": 25,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "12/17/2021",
          "dateAddedSort": "2021-12-17",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://newwavetoys.com/products/street-fighter-ii-mini-fight-stick",
          "link": "https://newwavetoys.com/products/street-fighter-ii-mini-fight-stick",
          "amazon": "",
          "joystickId": "1c5b:0025",
          "searchText": "new wave toys (replicade) - street fighter ii mini fight stick new wave toys replicade street fighter ii mini fight stick new wave toys (replicade) street fighter ii mini fight stick wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 6 no gold 01-05ms (platinum) actively sold closed source mister / pc 1c5b:0025 buy link new wave toys (replicade) street fighter ii mini fight stick [wired usb]"
        }
      ]
    },
    {
      "id": "published-8bitdo-pro2-xbox",
      "name": "8BitDo - Pro2 Xbox",
      "measurementName": "8BitDo - Pro2 Xbox [Wired]",
      "deviceNorm": "8bitdo pro2 xbox",
      "make": "8BitDo",
      "model": "Pro2 Xbox",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 82,
      "modeRank": 34,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "Silver",
      "averageMs": 4.649,
      "sdMs": 1.645,
      "maxMs": 9.7,
      "minMs": 0.71,
      "p99Ms": 8.122,
      "sampleCount": 4481,
      "sameFramePct": 72.11,
      "observedSameFramePct": 72.1,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "8bitdo - pro2 xbox 8bitdo pro2 xbox 8bitdo pro2 xbox wired usb wired wired dinput wired dinput dinput wired controller wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - pro2 xbox [wired] 8bitdo - pro2 xbox 8bitdo - pro2 xbox [wired] wired usb wired wired wired dinput dinput dinput ['wired controller'] wired controller gold silver controller published published unknown closed source 8bitdo - pro2 xbox 8bitdo pro2 xbox 8bitdo pro2 xbox wired usb wired wired dinput wired dinput dinput wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - pro2 xbox [wired]",
      "controllerGroupKey": "published|8bitdo pro2 xbox",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-8bitdo-pro2-xbox",
          "name": "8BitDo - Pro2 Xbox",
          "measurementName": "8BitDo - Pro2 Xbox [Wired]",
          "averageMs": 4.649,
          "averageTier": "Gold",
          "p99Ms": 8.122,
          "p99Tier": "Silver",
          "sameFramePct": 72.11,
          "observedSameFramePct": 72.1,
          "sampleCount": 4481,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 148,
          "modeRank": 43,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - pro2 xbox 8bitdo pro2 xbox 8bitdo pro2 xbox wired usb wired wired dinput wired dinput dinput wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - pro2 xbox [wired]"
        }
      ]
    },
    {
      "id": "published-hori-nintendo-switch-horipad",
      "name": "Hori - Nintendo Switch HORIPAD",
      "measurementName": "Hori Nintendo Switch HORIPAD [Wired USB]",
      "deviceNorm": "hori nintendo switch horipad",
      "make": "Hori",
      "model": "Nintendo Switch HORIPAD",
      "link": "https://amzn.to/3igug76",
      "amazon": "",
      "buyUrl": "https://amzn.to/3igug76",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 83,
      "modeRank": 35,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "6.45",
      "dateAdded": "6/30/2020",
      "dateAddedSort": "2020-06-30",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 4.717,
      "sdMs": 1.471,
      "maxMs": 7.616,
      "minMs": 1.692,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 71.7,
      "observedSameFramePct": 71.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0f0d:00c1",
      "searchText": "hori - nintendo switch horipad hori nintendo switch horipad hori nintendo switch horipad wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 yes 6.45 gold 01-05ms (platinum) actively sold closed source mister / pc switch 0f0d:00c1 buy link hori nintendo switch horipad [wired usb] hori - nintendo switch horipad hori nintendo switch horipad [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller gold controller 4 yes 6.45 published published actively sold closed source hori - nintendo switch horipad hori nintendo switch horipad hori nintendo switch horipad wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 6.45 gold 01-05ms (platinum) actively sold closed source mister / pc switch 0f0d:00c1 buy link hori nintendo switch horipad [wired usb]",
      "controllerGroupKey": "published|hori nintendo switch horipad",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-hori-nintendo-switch-horipad",
          "name": "Hori - Nintendo Switch HORIPAD",
          "measurementName": "Hori Nintendo Switch HORIPAD [Wired USB]",
          "averageMs": 4.717,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 71.7,
          "observedSameFramePct": 71.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 149,
          "modeRank": 44,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "6.45",
          "dateAdded": "6/30/2020",
          "dateAddedSort": "2020-06-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3igug76",
          "link": "https://amzn.to/3igug76",
          "amazon": "",
          "joystickId": "0f0d:00c1",
          "searchText": "hori - nintendo switch horipad hori nintendo switch horipad hori nintendo switch horipad wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 6.45 gold 01-05ms (platinum) actively sold closed source mister / pc switch 0f0d:00c1 buy link hori nintendo switch horipad [wired usb]"
        }
      ]
    },
    {
      "id": "published-hori-real-arcade-pro-v-hayabusa-nintendo-switch",
      "name": "Hori - Real Arcade Pro V Hayabusa Nintendo Switch",
      "measurementName": "Hori Real Arcade Pro V Hayabusa Nintendo Switch [Wired USB Switch]",
      "deviceNorm": "hori real arcade pro v hayabusa nintendo switch",
      "make": "Hori",
      "model": "Real Arcade Pro V Hayabusa Nintendo Switch",
      "link": "https://amzn.to/2YhdATS",
      "amazon": "",
      "buyUrl": "https://amzn.to/2YhdATS",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Switch",
      "outputMode": "DInput, Switch",
      "connectionTag": "Wired",
      "modeLabel": "DInput, Switch",
      "modeDisplay": "DInput, Switch",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 84,
      "modeRank": 15,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "8",
      "weightOz": "",
      "dateAdded": "6/29/2020",
      "dateAddedSort": "2020-06-29",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 4.727,
      "sdMs": 1.47,
      "maxMs": 7.636,
      "minMs": 1.671,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 71.64,
      "observedSameFramePct": 71.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0f0d:00d8",
      "searchText": "hori - real arcade pro v hayabusa nintendo switch hori real arcade pro v hayabusa nintendo switch hori real arcade pro v hayabusa nintendo switch wired usb wired wired usb switch dinput, switch wired dinput, switch dinput, switch wired arcade stick wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc switch 0f0d:00d8 buy link hori real arcade pro v hayabusa nintendo switch [wired usb switch] hori - real arcade pro v hayabusa nintendo switch hori real arcade pro v hayabusa nintendo switch [wired usb switch] wired usb wired wired wired usb switch dinput, switch dinput, switch dinput, switch ['wired arcade stick'] wired arcade stick gold arcade stick 8 yes published published actively sold closed source hori - real arcade pro v hayabusa nintendo switch hori real arcade pro v hayabusa nintendo switch hori real arcade pro v hayabusa nintendo switch wired usb wired wired usb switch dinput, switch wired dinput, switch dinput, switch wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc switch 0f0d:00d8 buy link hori real arcade pro v hayabusa nintendo switch [wired usb switch]",
      "controllerGroupKey": "published|hori real arcade pro v hayabusa nintendo switch",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-hori-real-arcade-pro-v-hayabusa-nintendo-switch",
          "name": "Hori - Real Arcade Pro V Hayabusa Nintendo Switch",
          "measurementName": "Hori Real Arcade Pro V Hayabusa Nintendo Switch [Wired USB Switch]",
          "averageMs": 4.727,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 71.64,
          "observedSameFramePct": 71.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Switch",
          "outputMode": "DInput, Switch",
          "modeLabel": "DInput, Switch",
          "modeDisplay": "DInput, Switch",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 150,
          "modeRank": 26,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "6/29/2020",
          "dateAddedSort": "2020-06-29",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2YhdATS",
          "link": "https://amzn.to/2YhdATS",
          "amazon": "",
          "joystickId": "0f0d:00d8",
          "searchText": "hori - real arcade pro v hayabusa nintendo switch hori real arcade pro v hayabusa nintendo switch hori real arcade pro v hayabusa nintendo switch wired usb wired wired usb switch dinput, switch wired dinput, switch dinput, switch wired arcade stick published published arcade stick 8 yes gold 01-05ms (platinum) actively sold closed source mister / pc switch 0f0d:00d8 buy link hori real arcade pro v hayabusa nintendo switch [wired usb switch]"
        }
      ]
    },
    {
      "id": "published-8bitdo-ultimate-wired-xbox-82ce",
      "name": "8BitDo - Ultimate Wired Xbox (82CE)",
      "measurementName": "8BitDo - Ultimate Wired Xbox (82CE) [Wired]",
      "deviceNorm": "8bitdo ultimate wired xbox 82ce",
      "make": "8BitDo",
      "model": "Ultimate Wired Xbox (82CE)",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 85,
      "modeRank": 36,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "Silver",
      "averageMs": 4.848,
      "sdMs": 1.639,
      "maxMs": 8.89,
      "minMs": 1.02,
      "p99Ms": 8.4,
      "sampleCount": 3688,
      "sameFramePct": 70.91,
      "observedSameFramePct": 70.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "8bitdo - ultimate wired xbox (82ce) 8bitdo ultimate wired xbox 82ce 8bitdo ultimate wired xbox (82ce) wired usb wired wired dinput wired dinput dinput wired controller wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - ultimate wired xbox (82ce) [wired] 8bitdo - ultimate wired xbox (82ce) 8bitdo - ultimate wired xbox (82ce) [wired] wired usb wired wired wired dinput dinput dinput ['wired controller'] wired controller gold silver controller published published unknown closed source 8bitdo - ultimate wired xbox (82ce) 8bitdo ultimate wired xbox 82ce 8bitdo ultimate wired xbox (82ce) wired usb wired wired dinput wired dinput dinput wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - ultimate wired xbox (82ce) [wired]",
      "controllerGroupKey": "published|8bitdo ultimate wired xbox 82ce",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-8bitdo-ultimate-wired-xbox-82ce",
          "name": "8BitDo - Ultimate Wired Xbox (82CE)",
          "measurementName": "8BitDo - Ultimate Wired Xbox (82CE) [Wired]",
          "averageMs": 4.848,
          "averageTier": "Gold",
          "p99Ms": 8.4,
          "p99Tier": "Silver",
          "sameFramePct": 70.91,
          "observedSameFramePct": 70.9,
          "sampleCount": 3688,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 152,
          "modeRank": 45,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - ultimate wired xbox (82ce) 8bitdo ultimate wired xbox 82ce 8bitdo ultimate wired xbox (82ce) wired usb wired wired dinput wired dinput dinput wired controller published published controller gold silver 01-05ms (platinum) unknown closed source mister / pc raw capture 8bitdo - ultimate wired xbox (82ce) [wired]"
        }
      ]
    },
    {
      "id": "published-mayflash-wii-classic-controller-adapter-for-pc",
      "name": "Mayflash - Wii Classic Controller Adapter For PC",
      "measurementName": "Mayflash Wii Classic Controller Adapter For PC [Wired USB]",
      "deviceNorm": "mayflash wii classic controller adapter for pc",
      "make": "Mayflash",
      "model": "Wii Classic Controller Adapter For PC",
      "link": "https://amzn.to/2UpkV5V",
      "amazon": "",
      "buyUrl": "https://amzn.to/2UpkV5V",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 86,
      "modeRank": 17,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "4.00",
      "dateAdded": "8/8/2021",
      "dateAddedSort": "2021-08-08",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "Wii Classic Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 4.852,
      "sdMs": 2.293,
      "maxMs": 9.31,
      "minMs": 0.48,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 70.89,
      "observedSameFramePct": 70.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "1d79:0301",
      "searchText": "mayflash - wii classic controller adapter for pc mayflash wii classic controller adapter for pc mayflash wii classic controller adapter for pc wired usb wired wired usb dinput wired dinput dinput controller adapter wii classic controller controller adapter published published controller adapter - - 4.00 gold 01-05ms (platinum) actively sold closed source mister / pc 1d79:0301 buy link mayflash wii classic controller adapter for pc [wired usb] mayflash - wii classic controller adapter for pc mayflash wii classic controller adapter for pc [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter', 'wii classic controller'] controller adapter gold controller adapter - - 4.00 published published actively sold closed source mayflash - wii classic controller adapter for pc mayflash wii classic controller adapter for pc mayflash wii classic controller adapter for pc wired usb wired wired usb dinput wired dinput dinput controller adapter wii classic controller published published controller adapter - - 4.00 gold 01-05ms (platinum) actively sold closed source mister / pc 1d79:0301 buy link mayflash wii classic controller adapter for pc [wired usb]",
      "controllerGroupKey": "published|mayflash wii classic controller adapter for pc",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-mayflash-wii-classic-controller-adapter-for-pc",
          "name": "Mayflash - Wii Classic Controller Adapter For PC",
          "measurementName": "Mayflash Wii Classic Controller Adapter For PC [Wired USB]",
          "averageMs": 4.852,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 70.89,
          "observedSameFramePct": 70.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Wii Classic Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 153,
          "modeRank": 52,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "4.00",
          "dateAdded": "8/8/2021",
          "dateAddedSort": "2021-08-08",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2UpkV5V",
          "link": "https://amzn.to/2UpkV5V",
          "amazon": "",
          "joystickId": "1d79:0301",
          "searchText": "mayflash - wii classic controller adapter for pc mayflash wii classic controller adapter for pc mayflash wii classic controller adapter for pc wired usb wired wired usb dinput wired dinput dinput controller adapter wii classic controller published published controller adapter - - 4.00 gold 01-05ms (platinum) actively sold closed source mister / pc 1d79:0301 buy link mayflash wii classic controller adapter for pc [wired usb]"
        }
      ]
    },
    {
      "id": "published-powera-fusion-wired-fightpad-for-switch",
      "name": "PowerA - Fusion Wired Fightpad for Switch",
      "measurementName": "PowerA Fusion Wired Fightpad for Switch [Wired USB]",
      "deviceNorm": "powera fusion wired fightpad for switch",
      "make": "PowerA",
      "model": "Fusion Wired Fightpad for Switch",
      "link": "https://amzn.to/3iKEUCx",
      "amazon": "",
      "buyUrl": "https://amzn.to/3iKEUCx",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 87,
      "modeRank": 37,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "6.30",
      "dateAdded": "5/30/2020",
      "dateAddedSort": "2020-05-30",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "",
      "averageMs": 4.881,
      "sdMs": 2.323,
      "maxMs": 9.12,
      "minMs": 0.28,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 70.71,
      "observedSameFramePct": 70.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "20d6:a712",
      "searchText": "powera - fusion wired fightpad for switch powera fusion wired fightpad for switch powera fusion wired fightpad for switch wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 yes 6.30 gold 01-05ms (platinum) actively sold closed source mister / pc switch 20d6:a712 buy link powera fusion wired fightpad for switch [wired usb] powera - fusion wired fightpad for switch powera fusion wired fightpad for switch [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller gold controller 6 yes 6.30 published published actively sold closed source powera - fusion wired fightpad for switch powera fusion wired fightpad for switch powera fusion wired fightpad for switch wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 6.30 gold 01-05ms (platinum) actively sold closed source mister / pc switch 20d6:a712 buy link powera fusion wired fightpad for switch [wired usb]",
      "controllerGroupKey": "published|powera fusion wired fightpad for switch",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-powera-fusion-wired-fightpad-for-switch",
          "name": "PowerA - Fusion Wired Fightpad for Switch",
          "measurementName": "PowerA Fusion Wired Fightpad for Switch [Wired USB]",
          "averageMs": 4.881,
          "averageTier": "Gold",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 70.71,
          "observedSameFramePct": 70.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 154,
          "modeRank": 46,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "6.30",
          "dateAdded": "5/30/2020",
          "dateAddedSort": "2020-05-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3iKEUCx",
          "link": "https://amzn.to/3iKEUCx",
          "amazon": "",
          "joystickId": "20d6:a712",
          "searchText": "powera - fusion wired fightpad for switch powera fusion wired fightpad for switch powera fusion wired fightpad for switch wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 6.30 gold 01-05ms (platinum) actively sold closed source mister / pc switch 20d6:a712 buy link powera fusion wired fightpad for switch [wired usb]"
        }
      ]
    },
    {
      "id": "published-retro-bit-tribute64-wireless",
      "name": "Retro-Bit - Tribute64 Wireless",
      "measurementName": "Retro-Bit - Tribute64 Wireless [Xinput]",
      "deviceNorm": "retro bit tribute64 wireless",
      "make": "Retro-Bit",
      "model": "Tribute64 Wireless",
      "link": "https://amzn.to/4al62Tr",
      "amazon": "",
      "buyUrl": "https://amzn.to/4al62Tr",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Xinput",
      "outputMode": "XInput",
      "connectionTag": "Wired",
      "modeLabel": "XInput",
      "modeDisplay": "XInput",
      "rankMode": "Wired Controller",
      "overallRank": 88,
      "modeRank": 38,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "3/19/2024",
      "dateAddedSort": "2024-03-19",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "01-05ms (Platinum)",
      "averageTier": "Gold",
      "p99Tier": "Silver",
      "averageMs": 4.961,
      "sdMs": 0.958,
      "maxMs": 15.75,
      "minMs": 3.18,
      "p99Ms": 7.308,
      "sampleCount": 2076,
      "sameFramePct": 70.23,
      "observedSameFramePct": 70.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "retro-bit - tribute64 wireless retro bit tribute64 wireless retro-bit tribute64 wireless wired usb wired xinput xinput wired xinput xinput wired controller wired controller published published controller gold silver 01-05ms (platinum) actively sold closed source mister / pc 045e:028e raw capture buy link retro-bit - tribute64 wireless [xinput] retro-bit - tribute64 wireless retro-bit - tribute64 wireless [xinput] wired usb wired wired xinput xinput xinput xinput ['wired controller'] wired controller gold silver controller published published actively sold closed source retro-bit - tribute64 wireless retro bit tribute64 wireless retro-bit tribute64 wireless wired usb wired xinput xinput wired xinput xinput wired controller published published controller gold silver 01-05ms (platinum) actively sold closed source mister / pc 045e:028e raw capture buy link retro-bit - tribute64 wireless [xinput] retro-bit - tribute64 wireless retro-bit - tribute64 wireless [dinput] wired usb wired wired dinput dinput dinput dinput ['wired controller'] wired controller silver silver controller published published actively sold closed source retro-bit - tribute64 wireless retro bit tribute64 wireless retro-bit tribute64 wireless wired usb wired dinput dinput wired dinput dinput wired controller published published controller silver silver 05-10ms (gold) actively sold closed source mister / pc 2572:35:00 raw capture buy link retro-bit - tribute64 wireless [dinput] retro-bit tribute64 wireless wireless wireless wireless wireless n64 wireless wireless ['wireless controller'] wireless controller silver silver controller 6 published published actively sold closed source retro-bit tribute64 wireless retro bit tribute64 wireless retro-bit tribute64 wireless wireless wireless wireless n64 wireless wireless wireless wireless controller published published controller 6 silver silver 05-10ms (gold) actively sold closed source raw capture buy link",
      "controllerGroupKey": "published|retro bit tribute64 wireless",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-retro-bit-tribute64-wireless",
          "name": "Retro-Bit - Tribute64 Wireless",
          "measurementName": "Retro-Bit - Tribute64 Wireless [Xinput]",
          "averageMs": 4.961,
          "averageTier": "Gold",
          "p99Ms": 7.308,
          "p99Tier": "Silver",
          "sameFramePct": 70.23,
          "observedSameFramePct": 70.2,
          "sampleCount": 2076,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Xinput",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "XInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 155,
          "modeRank": 47,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "3/19/2024",
          "dateAddedSort": "2024-03-19",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/4al62Tr",
          "link": "https://amzn.to/4al62Tr",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "retro-bit - tribute64 wireless retro bit tribute64 wireless retro-bit tribute64 wireless wired usb wired xinput xinput wired xinput xinput wired controller published published controller gold silver 01-05ms (platinum) actively sold closed source mister / pc 045e:028e raw capture buy link retro-bit - tribute64 wireless [xinput]"
        },
        {
          "id": "published-retro-bit-tribute64-wireless-2",
          "name": "Retro-Bit - Tribute64 Wireless",
          "measurementName": "Retro-Bit - Tribute64 Wireless [Dinput]",
          "averageMs": 5.008,
          "averageTier": "Silver",
          "p99Ms": 7.271,
          "p99Tier": "Silver",
          "sameFramePct": 69.95,
          "observedSameFramePct": 70.0,
          "sampleCount": 2092,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 157,
          "modeRank": 49,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "3/19/2024",
          "dateAddedSort": "2024-03-19",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/4al62Tr",
          "link": "https://amzn.to/4al62Tr",
          "amazon": "",
          "joystickId": "2572:35:00",
          "searchText": "retro-bit - tribute64 wireless retro bit tribute64 wireless retro-bit tribute64 wireless wired usb wired dinput dinput wired dinput dinput wired controller published published controller silver silver 05-10ms (gold) actively sold closed source mister / pc 2572:35:00 raw capture buy link retro-bit - tribute64 wireless [dinput]"
        },
        {
          "id": "published-retro-bit-tribute64-wireless-3",
          "name": "Retro-Bit Tribute64 Wireless",
          "measurementName": "Retro-Bit Tribute64 Wireless [Wireless N64 Reflex Adapt]",
          "averageMs": 6.76,
          "averageTier": "Silver",
          "p99Ms": 8.24,
          "p99Tier": "Silver",
          "sameFramePct": 59.44,
          "observedSameFramePct": 59.5,
          "sampleCount": 2042,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless",
          "modeRaw": "Wireless N64",
          "outputMode": "",
          "modeLabel": "Wireless",
          "modeDisplay": "Wireless",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 204,
          "modeRank": 15,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "3/19/2024",
          "dateAddedSort": "2024-03-19",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/4al62Tr",
          "link": "https://amzn.to/4al62Tr",
          "amazon": "",
          "joystickId": "2474:56:00",
          "searchText": "retro-bit tribute64 wireless retro bit tribute64 wireless retro-bit tribute64 wireless wireless wireless wireless n64 wireless wireless wireless wireless controller published published controller 6 silver silver 05-10ms (gold) actively sold closed source raw capture buy link"
        }
      ]
    },
    {
      "id": "published-8bitdo-ultimate-2c-wireless-controller-model-81hd",
      "name": "8BitDo - Ultimate 2C Wireless Controller (Model 81HD)",
      "measurementName": "8BitDo - Ultimate 2C Wireless Controller 81HD [Wired USB]",
      "deviceNorm": "8bitdo ultimate 2c wireless controller model 81hd",
      "make": "8BitDo",
      "model": "Ultimate 2C Wireless Controller 81HD",
      "link": "https://amzn.to/468xvXJ",
      "amazon": "",
      "buyUrl": "https://amzn.to/468xvXJ",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 89,
      "modeRank": 39,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "7/18/2024",
      "dateAddedSort": "2024-07-18",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Silver",
      "averageMs": 5.006,
      "sdMs": 1.749,
      "maxMs": 8.56,
      "minMs": 1.57,
      "p99Ms": 8.249,
      "sampleCount": 2109,
      "sameFramePct": 69.96,
      "observedSameFramePct": 70.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "2dc8:310a",
      "searchText": "8bitdo - ultimate 2c wireless controller (model 81hd) 8bitdo ultimate 2c wireless controller model 81hd 8bitdo ultimate 2c wireless controller 81hd wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller silver silver 05-10ms (gold) actively sold closed source mister / pc 2dc8:310a raw capture buy link 8bitdo - ultimate 2c wireless controller 81hd [wired usb] 8bitdo - ultimate 2c wireless controller 81hd 8bitdo - ultimate 2c wireless controller 81hd [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver silver controller published published actively sold closed source 8bitdo - ultimate 2c wireless controller 81hd 8bitdo ultimate 2c wireless controller 81hd 8bitdo ultimate 2c wireless controller 81hd wired usb wired wired usb dinput wired dinput dinput wired controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc 2dc8:310a raw capture 8bitdo - ultimate 2c wireless controller 81hd [wired usb] 8bitdo - ultimate 2c wireless controller 81hd 8bitdo - ultimate 2c wireless controller 81hd [wireless 2.4g] 2.4ghz wireless wireless wireless 2.4ghz wireless 2.4g 2.4g 2.4ghz wireless ['wireless controller'] wireless controller silver silver controller published published actively sold closed source 8bitdo - ultimate 2c wireless controller 81hd 8bitdo ultimate 2c wireless controller 81hd 8bitdo ultimate 2c wireless controller 81hd 2.4ghz wireless wireless wireless 2.4g wireless 2.4ghz 2.4g 2.4ghz wireless wireless controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc 2dc8:310a raw capture 8bitdo - ultimate 2c wireless controller 81hd [wireless 2.4g] 8bitdo - ultimate 2c wireless controller 81hd 8bitdo - ultimate 2c wireless controller 81hd [wireless bt] bluetooth wireless wireless bt wireless bt bluetooth bluetooth ['wireless controller'] wireless controller bronze copper controller published published actively sold closed source 8bitdo - ultimate 2c wireless controller 81hd 8bitdo ultimate 2c wireless controller 81hd 8bitdo ultimate 2c wireless controller 81hd bluetooth wireless wireless bt wireless bt bluetooth bluetooth wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc 2dc8:310b raw capture 8bitdo - ultimate 2c wireless controller 81hd [wireless bt]",
      "controllerGroupKey": "published|8bitdo ultimate 2c wireless controller model 81hd",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-8bitdo-ultimate-2c-wireless-controller-81hd",
          "name": "8BitDo - Ultimate 2C Wireless Controller 81HD",
          "measurementName": "8BitDo - Ultimate 2C Wireless Controller 81HD [Wired USB]",
          "averageMs": 5.006,
          "averageTier": "Silver",
          "p99Ms": 8.249,
          "p99Tier": "Silver",
          "sameFramePct": 69.96,
          "observedSameFramePct": 70.0,
          "sampleCount": 2109,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 156,
          "modeRank": 48,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2024",
          "dateAddedSort": "2024-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/468xvXJ",
          "link": "https://amzn.to/468xvXJ",
          "amazon": "",
          "joystickId": "2dc8:310a",
          "searchText": "8bitdo - ultimate 2c wireless controller 81hd 8bitdo ultimate 2c wireless controller 81hd 8bitdo ultimate 2c wireless controller 81hd wired usb wired wired usb dinput wired dinput dinput wired controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc 2dc8:310a raw capture 8bitdo - ultimate 2c wireless controller 81hd [wired usb]"
        },
        {
          "id": "published-8bitdo-ultimate-2c-wireless-controller-81hd-2",
          "name": "8BitDo - Ultimate 2C Wireless Controller 81HD",
          "measurementName": "8BitDo - Ultimate 2C Wireless Controller 81HD [Wireless 2.4G]",
          "averageMs": 5.61,
          "averageTier": "Silver",
          "p99Ms": 8.844,
          "p99Tier": "Silver",
          "sameFramePct": 66.34,
          "observedSameFramePct": 66.3,
          "sampleCount": 2165,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4GHz Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Wireless 2.4G",
          "outputMode": "",
          "modeLabel": "2.4G",
          "modeDisplay": "2.4GHz Wireless",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 172,
          "modeRank": 6,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2024",
          "dateAddedSort": "2024-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/468xvXJ",
          "link": "https://amzn.to/468xvXJ",
          "amazon": "",
          "joystickId": "2dc8:310a",
          "searchText": "8bitdo - ultimate 2c wireless controller 81hd 8bitdo ultimate 2c wireless controller 81hd 8bitdo ultimate 2c wireless controller 81hd 2.4ghz wireless wireless wireless 2.4g wireless 2.4ghz 2.4g 2.4ghz wireless wireless controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc 2dc8:310a raw capture 8bitdo - ultimate 2c wireless controller 81hd [wireless 2.4g]"
        },
        {
          "id": "published-8bitdo-ultimate-2c-wireless-controller-81hd-3",
          "name": "8BitDo - Ultimate 2C Wireless Controller 81HD",
          "measurementName": "8BitDo - Ultimate 2C Wireless Controller 81HD [Wireless BT]",
          "averageMs": 13.394,
          "averageTier": "Bronze",
          "p99Ms": 19.0,
          "p99Tier": "Copper",
          "sameFramePct": 19.64,
          "observedSameFramePct": 20.4,
          "sampleCount": 2891,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "Wireless BT",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 269,
          "modeRank": 42,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "7/18/2024",
          "dateAddedSort": "2024-07-18",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/468xvXJ",
          "link": "https://amzn.to/468xvXJ",
          "amazon": "",
          "joystickId": "2dc8:310b",
          "searchText": "8bitdo - ultimate 2c wireless controller 81hd 8bitdo ultimate 2c wireless controller 81hd 8bitdo ultimate 2c wireless controller 81hd bluetooth wireless wireless bt wireless bt bluetooth bluetooth wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc 2dc8:310b raw capture 8bitdo - ultimate 2c wireless controller 81hd [wireless bt]"
        }
      ]
    },
    {
      "id": "published-sega-astro-city-mini-real-arcade-stick",
      "name": "Sega - Astro City Mini Real Arcade Stick",
      "measurementName": "Sega Astro City Mini Real Arcade Stick [Wired USB]",
      "deviceNorm": "sega astro city mini real arcade stick",
      "make": "Sega",
      "model": "Astro City Mini Real Arcade Stick",
      "link": "https://amzn.to/3gn7Qld",
      "amazon": "",
      "buyUrl": "https://amzn.to/3gn7Qld",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 90,
      "modeRank": 16,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "6",
      "weightOz": "-",
      "dateAdded": "8/21/2021",
      "dateAddedSort": "2021-08-21",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.013,
      "sdMs": 2.319,
      "maxMs": 9.07,
      "minMs": 0.96,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 69.92,
      "observedSameFramePct": 69.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0ca3:0028",
      "searchText": "sega - astro city mini real arcade stick sega astro city mini real arcade stick sega astro city mini real arcade stick wired usb wired wired usb dinput wired dinput dinput wired arcade stick wired arcade stick published published arcade stick 6 no - silver 05-10ms (gold) actively sold closed source mister / pc 0ca3:0028 buy link sega astro city mini real arcade stick [wired usb] sega - astro city mini real arcade stick sega astro city mini real arcade stick [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired arcade stick'] wired arcade stick silver arcade stick 6 no - published published actively sold closed source sega - astro city mini real arcade stick sega astro city mini real arcade stick sega astro city mini real arcade stick wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 6 no - silver 05-10ms (gold) actively sold closed source mister / pc 0ca3:0028 buy link sega astro city mini real arcade stick [wired usb]",
      "controllerGroupKey": "published|sega astro city mini real arcade stick",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-sega-astro-city-mini-real-arcade-stick",
          "name": "Sega - Astro City Mini Real Arcade Stick",
          "measurementName": "Sega Astro City Mini Real Arcade Stick [Wired USB]",
          "averageMs": 5.013,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 69.92,
          "observedSameFramePct": 69.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 158,
          "modeRank": 27,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "8/21/2021",
          "dateAddedSort": "2021-08-21",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3gn7Qld",
          "link": "https://amzn.to/3gn7Qld",
          "amazon": "",
          "joystickId": "0ca3:0028",
          "searchText": "sega - astro city mini real arcade stick sega astro city mini real arcade stick sega astro city mini real arcade stick wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 6 no - silver 05-10ms (gold) actively sold closed source mister / pc 0ca3:0028 buy link sega astro city mini real arcade stick [wired usb]"
        }
      ]
    },
    {
      "id": "published-sega-astro-city-mini-controller-acs-1002",
      "name": "Sega - Astro City Mini Controller (ACS-1002)",
      "measurementName": "Sega Astro City Mini Controller (ACS-1002) [Wired USB]",
      "deviceNorm": "sega astro city mini controller acs 1002",
      "make": "Sega",
      "model": "Astro City Mini Controller (ACS-1002)",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 91,
      "modeRank": 40,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "3.60",
      "dateAdded": "8/8/2021",
      "dateAddedSort": "2021-08-08",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.037,
      "sdMs": 2.305,
      "maxMs": 9.17,
      "minMs": 0.92,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 69.78,
      "observedSameFramePct": 69.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0ca3:0027",
      "searchText": "sega - astro city mini controller (acs-1002) sega astro city mini controller acs 1002 sega astro city mini controller (acs-1002) wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 no 3.60 silver 05-10ms (gold) unknown closed source mister / pc 0ca3:0027 sega astro city mini controller (acs-1002) [wired usb] sega - astro city mini controller (acs-1002) sega astro city mini controller (acs-1002) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 6 no 3.60 published published unknown closed source sega - astro city mini controller (acs-1002) sega astro city mini controller acs 1002 sega astro city mini controller (acs-1002) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 3.60 silver 05-10ms (gold) unknown closed source mister / pc 0ca3:0027 sega astro city mini controller (acs-1002) [wired usb]",
      "controllerGroupKey": "published|sega astro city mini controller acs 1002",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-sega-astro-city-mini-controller-acs-1002",
          "name": "Sega - Astro City Mini Controller (ACS-1002)",
          "measurementName": "Sega Astro City Mini Controller (ACS-1002) [Wired USB]",
          "averageMs": 5.037,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 69.78,
          "observedSameFramePct": 69.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 159,
          "modeRank": 50,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "3.60",
          "dateAdded": "8/8/2021",
          "dateAddedSort": "2021-08-08",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "0ca3:0027",
          "searchText": "sega - astro city mini controller (acs-1002) sega astro city mini controller acs 1002 sega astro city mini controller (acs-1002) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 3.60 silver 05-10ms (gold) unknown closed source mister / pc 0ca3:0027 sega astro city mini controller (acs-1002) [wired usb]"
        }
      ]
    },
    {
      "id": "published-8bitdo-ultimate-wireless-80na",
      "name": "8BitDo - Ultimate Wireless (80NA)",
      "measurementName": "8BitDo - Ultimate Wireless (80NA) [Wired]",
      "deviceNorm": "8bitdo ultimate wireless 80na",
      "make": "8BitDo",
      "model": "Ultimate Wireless (80NA)",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 92,
      "modeRank": 41,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Silver",
      "averageMs": 5.226,
      "sdMs": 1.444,
      "maxMs": 9.1,
      "minMs": 2.29,
      "p99Ms": 7.84,
      "sampleCount": 2105,
      "sameFramePct": 68.64,
      "observedSameFramePct": 68.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "8bitdo - ultimate wireless (80na) 8bitdo ultimate wireless 80na 8bitdo ultimate wireless (80na) wired usb wired wired dinput wired dinput dinput wired controller wired controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - ultimate wireless (80na) [wired] 8bitdo - ultimate wireless (80na) 8bitdo - ultimate wireless (80na) [wired] wired usb wired wired wired dinput dinput dinput ['wired controller'] wired controller silver silver controller published published unknown closed source 8bitdo - ultimate wireless (80na) 8bitdo ultimate wireless 80na 8bitdo ultimate wireless (80na) wired usb wired wired dinput wired dinput dinput wired controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - ultimate wireless (80na) [wired] 8bitdo - ultimate wireless (80na) 8bitdo - ultimate wireless (80na) [2.4ghz wireless] 2.4ghz wireless wireless wireless 2.4ghz 2.4ghz wireless 2.4g 2.4ghz wireless ['wireless controller'] wireless controller silver bronze controller published published unknown closed source 8bitdo - ultimate wireless (80na) 8bitdo ultimate wireless 80na 8bitdo ultimate wireless (80na) 2.4ghz wireless wireless 2.4ghz wireless wireless 2.4ghz 2.4g 2.4ghz wireless wireless controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - ultimate wireless (80na) [2.4ghz wireless] 8bitdo - ultimate wireless (80na) 8bitdo - ultimate wireless (80na) [bt] bluetooth wireless wireless bt bt bluetooth bluetooth ['wireless controller'] wireless controller copper copper controller published published unknown closed source 8bitdo - ultimate wireless (80na) 8bitdo ultimate wireless 80na 8bitdo ultimate wireless (80na) bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller published published controller copper copper 15-20ms (bronze) unknown closed source mister / pc raw capture 8bitdo - ultimate wireless (80na) [bt]",
      "controllerGroupKey": "published|8bitdo ultimate wireless 80na",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-8bitdo-ultimate-wireless-80na",
          "name": "8BitDo - Ultimate Wireless (80NA)",
          "measurementName": "8BitDo - Ultimate Wireless (80NA) [Wired]",
          "averageMs": 5.226,
          "averageTier": "Silver",
          "p99Ms": 7.84,
          "p99Tier": "Silver",
          "sameFramePct": 68.64,
          "observedSameFramePct": 68.6,
          "sampleCount": 2105,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 160,
          "modeRank": 51,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - ultimate wireless (80na) 8bitdo ultimate wireless 80na 8bitdo ultimate wireless (80na) wired usb wired wired dinput wired dinput dinput wired controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - ultimate wireless (80na) [wired]"
        },
        {
          "id": "published-8bitdo-ultimate-wireless-80na-2",
          "name": "8BitDo - Ultimate Wireless (80NA)",
          "measurementName": "8BitDo - Ultimate Wireless (80NA) [2.4GHz Wireless]",
          "averageMs": 7.573,
          "averageTier": "Silver",
          "p99Ms": 11.1,
          "p99Tier": "Bronze",
          "sameFramePct": 54.56,
          "observedSameFramePct": 54.6,
          "sampleCount": 2083,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4GHz Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "2.4GHz Wireless",
          "outputMode": "",
          "modeLabel": "2.4G",
          "modeDisplay": "2.4GHz Wireless",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 215,
          "modeRank": 19,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - ultimate wireless (80na) 8bitdo ultimate wireless 80na 8bitdo ultimate wireless (80na) 2.4ghz wireless wireless 2.4ghz wireless wireless 2.4ghz 2.4g 2.4ghz wireless wireless controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - ultimate wireless (80na) [2.4ghz wireless]"
        },
        {
          "id": "published-8bitdo-ultimate-wireless-80na-3",
          "name": "8BitDo - Ultimate Wireless (80NA)",
          "measurementName": "8BitDo - Ultimate Wireless (80NA) [BT]",
          "averageMs": 18.487,
          "averageTier": "Copper",
          "p99Ms": 32.255,
          "p99Tier": "Copper",
          "sameFramePct": 0,
          "observedSameFramePct": 15.7,
          "sampleCount": 2710,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 306,
          "modeRank": 75,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - ultimate wireless (80na) 8bitdo ultimate wireless 80na 8bitdo ultimate wireless (80na) bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller published published controller copper copper 15-20ms (bronze) unknown closed source mister / pc raw capture 8bitdo - ultimate wireless (80na) [bt]"
        }
      ]
    },
    {
      "id": "published-retro-bit-saturn-bluetooth",
      "name": "Retro-Bit - Saturn Bluetooth",
      "measurementName": "Retro-Bit Saturn Bluetooth [Wired USB Dinput] FW v1.02",
      "deviceNorm": "retro bit saturn bluetooth",
      "make": "Retro-Bit",
      "model": "Saturn Bluetooth",
      "link": "https://amzn.to/2S5AZVw",
      "amazon": "",
      "buyUrl": "https://amzn.to/2S5AZVw",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Dinput",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 93,
      "modeRank": 42,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "",
      "dateAdded": "9/27/2020",
      "dateAddedSort": "2020-09-27",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.228,
      "sdMs": 1.542,
      "maxMs": 8.652,
      "minMs": 1.596,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 68.63,
      "observedSameFramePct": 68.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:0122",
      "searchText": "retro-bit - saturn bluetooth retro bit saturn bluetooth retro-bit saturn bluetooth wired usb wired wired usb dinput dinput wired dinput dinput wired controller wired controller published published controller 6 yes silver 05-10ms (gold) actively sold closed source mister / pc 0079:0122 buy link retro-bit saturn bluetooth [wired usb dinput] fw v1.02 retro-bit - saturn bluetooth retro-bit saturn bluetooth [wired usb dinput] fw v1.02 wired usb wired wired wired usb dinput dinput dinput dinput ['wired controller'] wired controller silver controller 6 yes published published actively sold closed source retro-bit - saturn bluetooth retro bit saturn bluetooth retro-bit saturn bluetooth wired usb wired wired usb dinput dinput wired dinput dinput wired controller published published controller 6 yes silver 05-10ms (gold) actively sold closed source mister / pc 0079:0122 buy link retro-bit saturn bluetooth [wired usb dinput] fw v1.02 retro-bit - saturn bluetooth retro-bit saturn bluetooth [wired usb amazon] fw v1.02 wired usb wired wired wired usb amazon dinput dinput dinput ['wired controller'] wired controller silver controller 6 yes published published actively sold closed source retro-bit - saturn bluetooth retro bit saturn bluetooth retro-bit saturn bluetooth wired usb wired wired usb amazon dinput wired dinput dinput wired controller published published controller 6 yes silver 05-10ms (gold) actively sold closed source mister / pc 0079:181c buy link retro-bit saturn bluetooth [wired usb amazon] fw v1.02 retro-bit - saturn bluetooth retro-bit saturn bluetooth [bt (bcm20702a0) switch] fw v1.02 bluetooth wireless wireless bt bt (bcm20702a0) switch switch switch switch ['wireless controller'] wireless controller bronze controller 6 yes published published actively sold closed source retro-bit - saturn bluetooth retro bit saturn bluetooth retro-bit saturn bluetooth bluetooth wireless bt (bcm20702a0) switch switch wireless bt switch switch wireless controller published published controller 6 yes bronze 10-15ms (silver) actively sold closed source mister / pc switch 057e:2009 buy link retro-bit saturn bluetooth [bt (bcm20702a0) switch] fw v1.02 retro-bit - saturn bluetooth retro-bit saturn bluetooth [bt (bcm20702a0) android] fw v1.02 bluetooth wireless wireless bt bt (bcm20702a0) android android android android ['wireless controller'] wireless controller copper controller 6 yes published published actively sold closed source retro-bit - saturn bluetooth retro bit saturn bluetooth retro-bit saturn bluetooth bluetooth wireless bt (bcm20702a0) android android wireless bt android android wireless controller published published controller 6 yes copper 15-20ms (bronze) actively sold closed source mister / pc 1949:0402 buy link retro-bit saturn bluetooth [bt (bcm20702a0) android] fw v1.02 retro-bit - saturn bluetooth retro-bit saturn bluetooth [bt (bcm20702a0) macos] fw v1.02 bluetooth wireless wireless bt bt (bcm20702a0) macos macos macos macos ['wireless controller'] wireless controller copper controller 6 yes published published actively sold closed source retro-bit - saturn bluetooth retro bit saturn bluetooth retro-bit saturn bluetooth bluetooth wireless bt (bcm20702a0) macos macos wireless bt macos macos wireless controller published published controller 6 yes copper 15-20ms (bronze) actively sold closed source mister / pc 045e:02e0 buy link retro-bit saturn bluetooth [bt (bcm20702a0) macos] fw v1.02",
      "controllerGroupKey": "published|retro bit saturn bluetooth",
      "modeVariantCount": 5,
      "modeVariants": [
        {
          "id": "published-retro-bit-saturn-bluetooth",
          "name": "Retro-Bit - Saturn Bluetooth",
          "measurementName": "Retro-Bit Saturn Bluetooth [Wired USB Dinput] FW v1.02",
          "averageMs": 5.228,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 68.63,
          "observedSameFramePct": 68.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 161,
          "modeRank": 52,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "9/27/2020",
          "dateAddedSort": "2020-09-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2S5AZVw",
          "link": "https://amzn.to/2S5AZVw",
          "amazon": "",
          "joystickId": "0079:0122",
          "searchText": "retro-bit - saturn bluetooth retro bit saturn bluetooth retro-bit saturn bluetooth wired usb wired wired usb dinput dinput wired dinput dinput wired controller published published controller 6 yes silver 05-10ms (gold) actively sold closed source mister / pc 0079:0122 buy link retro-bit saturn bluetooth [wired usb dinput] fw v1.02"
        },
        {
          "id": "published-retro-bit-saturn-bluetooth-2",
          "name": "Retro-Bit - Saturn Bluetooth",
          "measurementName": "Retro-Bit Saturn Bluetooth [Wired USB Amazon] FW v1.02",
          "averageMs": 5.31,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 68.14,
          "observedSameFramePct": 68.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Amazon",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 165,
          "modeRank": 53,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "9/27/2020",
          "dateAddedSort": "2020-09-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2S5AZVw",
          "link": "https://amzn.to/2S5AZVw",
          "amazon": "",
          "joystickId": "0079:181c",
          "searchText": "retro-bit - saturn bluetooth retro bit saturn bluetooth retro-bit saturn bluetooth wired usb wired wired usb amazon dinput wired dinput dinput wired controller published published controller 6 yes silver 05-10ms (gold) actively sold closed source mister / pc 0079:181c buy link retro-bit saturn bluetooth [wired usb amazon] fw v1.02"
        },
        {
          "id": "published-retro-bit-saturn-bluetooth-3",
          "name": "Retro-Bit - Saturn Bluetooth",
          "measurementName": "Retro-Bit Saturn Bluetooth [BT (BCM20702A0) Switch] FW v1.02",
          "averageMs": 13.65,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 18.1,
          "observedSameFramePct": 20.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (BCM20702A0) Switch",
          "outputMode": "Switch",
          "modeLabel": "Switch",
          "modeDisplay": "Switch",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 270,
          "modeRank": 43,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "9/27/2020",
          "dateAddedSort": "2020-09-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2S5AZVw",
          "link": "https://amzn.to/2S5AZVw",
          "amazon": "",
          "joystickId": "057e:2009",
          "searchText": "retro-bit - saturn bluetooth retro bit saturn bluetooth retro-bit saturn bluetooth bluetooth wireless bt (bcm20702a0) switch switch wireless bt switch switch wireless controller published published controller 6 yes bronze 10-15ms (silver) actively sold closed source mister / pc switch 057e:2009 buy link retro-bit saturn bluetooth [bt (bcm20702a0) switch] fw v1.02"
        },
        {
          "id": "published-retro-bit-saturn-bluetooth-4",
          "name": "Retro-Bit - Saturn Bluetooth",
          "measurementName": "Retro-Bit Saturn Bluetooth [BT (BCM20702A0) Android] FW v1.02",
          "averageMs": 17.985,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 11.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (BCM20702A0) Android",
          "outputMode": "Android",
          "modeLabel": "Android",
          "modeDisplay": "Android",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 301,
          "modeRank": 71,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "9/27/2020",
          "dateAddedSort": "2020-09-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2S5AZVw",
          "link": "https://amzn.to/2S5AZVw",
          "amazon": "",
          "joystickId": "1949:0402",
          "searchText": "retro-bit - saturn bluetooth retro bit saturn bluetooth retro-bit saturn bluetooth bluetooth wireless bt (bcm20702a0) android android wireless bt android android wireless controller published published controller 6 yes copper 15-20ms (bronze) actively sold closed source mister / pc 1949:0402 buy link retro-bit saturn bluetooth [bt (bcm20702a0) android] fw v1.02"
        },
        {
          "id": "published-retro-bit-saturn-bluetooth-5",
          "name": "Retro-Bit - Saturn Bluetooth",
          "measurementName": "Retro-Bit Saturn Bluetooth [BT (BCM20702A0) MacOS] FW v1.02",
          "averageMs": 18.347,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 11.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (BCM20702A0) MacOS",
          "outputMode": "macOS",
          "modeLabel": "macOS",
          "modeDisplay": "macOS",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 303,
          "modeRank": 73,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "9/27/2020",
          "dateAddedSort": "2020-09-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2S5AZVw",
          "link": "https://amzn.to/2S5AZVw",
          "amazon": "",
          "joystickId": "045e:02e0",
          "searchText": "retro-bit - saturn bluetooth retro bit saturn bluetooth retro-bit saturn bluetooth bluetooth wireless bt (bcm20702a0) macos macos wireless bt macos macos wireless controller published published controller 6 yes copper 15-20ms (bronze) actively sold closed source mister / pc 045e:02e0 buy link retro-bit saturn bluetooth [bt (bcm20702a0) macos] fw v1.02"
        }
      ]
    },
    {
      "id": "published-mayflash-n64-mf103-wired-usb",
      "name": "Mayflash - N64 MF103 Wired USB",
      "measurementName": "Mayflash - N64 MF103 Wired USB",
      "deviceNorm": "mayflash n64 mf103 wired usb",
      "make": "Mayflash",
      "model": "N64 MF103 Wired USB",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 94,
      "modeRank": 18,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "N64 Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Silver",
      "averageMs": 5.239,
      "sdMs": 1.48,
      "maxMs": 10.34,
      "minMs": 2.32,
      "p99Ms": 7.998,
      "sampleCount": 2019,
      "sameFramePct": 68.57,
      "observedSameFramePct": 68.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "20d6:a710",
      "searchText": "mayflash - n64 mf103 wired usb mayflash n64 mf103 wired usb mayflash n64 mf103 wired usb wired usb wired dinput wired dinput dinput controller adapter n64 controller controller adapter published published controller adapter silver silver 05-10ms (gold) unknown closed source mister / pc 20d6:a710 raw capture mayflash - n64 mf103 wired usb mayflash - n64 mf103 wired usb mayflash - n64 mf103 wired usb wired usb wired wired dinput dinput dinput ['controller adapter', 'n64 controller'] controller adapter silver silver controller adapter published published unknown closed source mayflash - n64 mf103 wired usb mayflash n64 mf103 wired usb mayflash n64 mf103 wired usb wired usb wired dinput wired dinput dinput controller adapter n64 controller published published controller adapter silver silver 05-10ms (gold) unknown closed source mister / pc 20d6:a710 raw capture mayflash - n64 mf103 wired usb",
      "controllerGroupKey": "published|mayflash n64 mf103 wired usb",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-mayflash-n64-mf103-wired-usb",
          "name": "Mayflash - N64 MF103 Wired USB",
          "measurementName": "Mayflash - N64 MF103 Wired USB",
          "averageMs": 5.239,
          "averageTier": "Silver",
          "p99Ms": 7.998,
          "p99Tier": "Silver",
          "sameFramePct": 68.57,
          "observedSameFramePct": 68.6,
          "sampleCount": 2019,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "N64 Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 162,
          "modeRank": 53,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "20d6:a710",
          "searchText": "mayflash - n64 mf103 wired usb mayflash n64 mf103 wired usb mayflash n64 mf103 wired usb wired usb wired dinput wired dinput dinput controller adapter n64 controller published published controller adapter silver silver 05-10ms (gold) unknown closed source mister / pc 20d6:a710 raw capture mayflash - n64 mf103 wired usb"
        }
      ]
    },
    {
      "id": "published-hori-real-arcade-pro-n-hayabusa",
      "name": "Hori - Real Arcade Pro N Hayabusa",
      "measurementName": "Hori Real Arcade Pro N Hayabusa [Wired USB PS3]",
      "deviceNorm": "hori real arcade pro n hayabusa",
      "make": "Hori",
      "model": "Real Arcade Pro N Hayabusa",
      "link": "https://amzn.to/37octWN",
      "amazon": "",
      "buyUrl": "https://amzn.to/37octWN",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB PS3",
      "outputMode": "DInput, PS3",
      "connectionTag": "Wired",
      "modeLabel": "DInput, PS3",
      "modeDisplay": "DInput, PS3",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 95,
      "modeRank": 17,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "8",
      "weightOz": "112.50",
      "dateAdded": "6/7/2020",
      "dateAddedSort": "2020-06-07",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.269,
      "sdMs": 1.647,
      "maxMs": 9.196,
      "minMs": 1.284,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 68.39,
      "observedSameFramePct": 68.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0f0d:00ae",
      "searchText": "hori - real arcade pro n hayabusa hori real arcade pro n hayabusa hori real arcade pro n hayabusa wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick wired arcade stick published published arcade stick 8 yes 112.50 silver 05-10ms (gold) actively sold closed source mister / pc 0f0d:00ae buy link hori real arcade pro n hayabusa [wired usb ps3] hori - real arcade pro n hayabusa hori real arcade pro n hayabusa [wired usb ps3] wired usb wired wired wired usb ps3 dinput, ps3 dinput, ps3 dinput, ps3 ['wired arcade stick'] wired arcade stick silver arcade stick 8 yes 112.50 published published actively sold closed source hori - real arcade pro n hayabusa hori real arcade pro n hayabusa hori real arcade pro n hayabusa wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick 8 yes 112.50 silver 05-10ms (gold) actively sold closed source mister / pc 0f0d:00ae buy link hori real arcade pro n hayabusa [wired usb ps3] hori - real arcade pro n hayabusa hori real arcade pro n hayabusa [wired usb ps4] wired usb wired wired wired usb ps4 dinput, ps4 dinput, ps4 dinput, ps4 ['wired arcade stick'] wired arcade stick silver arcade stick 8 yes 112.50 published published actively sold closed source hori - real arcade pro n hayabusa hori real arcade pro n hayabusa hori real arcade pro n hayabusa wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 wired arcade stick published published arcade stick 8 yes 112.50 silver 05-10ms (gold) actively sold closed source mister / pc ps4 0f0d:00ae buy link hori real arcade pro n hayabusa [wired usb ps4]",
      "controllerGroupKey": "published|hori real arcade pro n hayabusa",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-hori-real-arcade-pro-n-hayabusa",
          "name": "Hori - Real Arcade Pro N Hayabusa",
          "measurementName": "Hori Real Arcade Pro N Hayabusa [Wired USB PS3]",
          "averageMs": 5.269,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 68.39,
          "observedSameFramePct": 68.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PS3",
          "outputMode": "DInput, PS3",
          "modeLabel": "DInput, PS3",
          "modeDisplay": "DInput, PS3",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 163,
          "modeRank": 28,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "112.50",
          "dateAdded": "6/7/2020",
          "dateAddedSort": "2020-06-07",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/37octWN",
          "link": "https://amzn.to/37octWN",
          "amazon": "",
          "joystickId": "0f0d:00ae",
          "searchText": "hori - real arcade pro n hayabusa hori real arcade pro n hayabusa hori real arcade pro n hayabusa wired usb wired wired usb ps3 dinput, ps3 wired dinput, ps3 dinput, ps3 wired arcade stick published published arcade stick 8 yes 112.50 silver 05-10ms (gold) actively sold closed source mister / pc 0f0d:00ae buy link hori real arcade pro n hayabusa [wired usb ps3]"
        },
        {
          "id": "published-hori-real-arcade-pro-n-hayabusa-2",
          "name": "Hori - Real Arcade Pro N Hayabusa",
          "measurementName": "Hori Real Arcade Pro N Hayabusa [Wired USB PS4]",
          "averageMs": 5.289,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 68.27,
          "observedSameFramePct": 68.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB PS4",
          "outputMode": "DInput, PS4",
          "modeLabel": "DInput, PS4",
          "modeDisplay": "DInput, PS4",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 164,
          "modeRank": 29,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "112.50",
          "dateAdded": "6/7/2020",
          "dateAddedSort": "2020-06-07",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/37octWN",
          "link": "https://amzn.to/37octWN",
          "amazon": "",
          "joystickId": "0f0d:00ae",
          "searchText": "hori - real arcade pro n hayabusa hori real arcade pro n hayabusa hori real arcade pro n hayabusa wired usb wired wired usb ps4 dinput, ps4 wired dinput, ps4 dinput, ps4 wired arcade stick published published arcade stick 8 yes 112.50 silver 05-10ms (gold) actively sold closed source mister / pc ps4 0f0d:00ae buy link hori real arcade pro n hayabusa [wired usb ps4]"
        }
      ]
    },
    {
      "id": "published-cyboris-switch-pro-controller",
      "name": "Cyboris - Switch Pro Controller",
      "measurementName": "Cyboris Switch Pro Controller [Wired USB]",
      "deviceNorm": "cyboris switch pro controller",
      "make": "Cyboris",
      "model": "Switch Pro Controller",
      "link": "https://www.amazon.ca/CYBORIS-Controller-Nintendo-Bluetooth-Compatible/dp/B07S9JBR11",
      "amazon": "",
      "buyUrl": "https://www.amazon.ca/CYBORIS-Controller-Nintendo-Bluetooth-Compatible/dp/B07S9JBR11",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 96,
      "modeRank": 43,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "3.20",
      "dateAdded": "8/14/2020",
      "dateAddedSort": "2020-08-14",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.356,
      "sdMs": 1.532,
      "maxMs": 8.244,
      "minMs": 2.272,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 67.86,
      "observedSameFramePct": 67.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "cyboris - switch pro controller cyboris switch pro controller cyboris switch pro controller wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 yes 3.20 silver 05-10ms (gold) actively sold closed source mister / pc switch 045e:028e buy link cyboris switch pro controller [wired usb] cyboris - switch pro controller cyboris switch pro controller [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 4 yes 3.20 published published actively sold closed source cyboris - switch pro controller cyboris switch pro controller cyboris switch pro controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 3.20 silver 05-10ms (gold) actively sold closed source mister / pc switch 045e:028e buy link cyboris switch pro controller [wired usb]",
      "controllerGroupKey": "published|cyboris switch pro controller",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-cyboris-switch-pro-controller",
          "name": "Cyboris - Switch Pro Controller",
          "measurementName": "Cyboris Switch Pro Controller [Wired USB]",
          "averageMs": 5.356,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 67.86,
          "observedSameFramePct": 67.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 166,
          "modeRank": 54,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "3.20",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.amazon.ca/CYBORIS-Controller-Nintendo-Bluetooth-Compatible/dp/B07S9JBR11",
          "link": "https://www.amazon.ca/CYBORIS-Controller-Nintendo-Bluetooth-Compatible/dp/B07S9JBR11",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "cyboris - switch pro controller cyboris switch pro controller cyboris switch pro controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 3.20 silver 05-10ms (gold) actively sold closed source mister / pc switch 045e:028e buy link cyboris switch pro controller [wired usb]"
        }
      ]
    },
    {
      "id": "published-8bitdo-arcade-stick-for-switch-windows",
      "name": "8BitDo - Arcade Stick for Switch Windows",
      "measurementName": "8BitDo - Arcade Stick for Switch Windows [BT Xinput]",
      "deviceNorm": "8bitdo arcade stick for switch windows",
      "make": "8BitDo",
      "model": "Arcade Stick for Switch Windows",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT Xinput",
      "outputMode": "XInput",
      "connectionTag": "Wireless BT",
      "modeLabel": "XInput",
      "modeDisplay": "XInput",
      "rankMode": "Wireless Arcade Stick",
      "overallRank": 97,
      "modeRank": 1,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC",
        "Xbox One",
        "Xbox Series"
      ],
      "deviceTypes": [
        "Wireless Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Silver",
      "averageMs": 5.383,
      "sdMs": 1.516,
      "maxMs": 8.97,
      "minMs": 1.82,
      "p99Ms": 8.346,
      "sampleCount": 2145,
      "sameFramePct": 67.7,
      "observedSameFramePct": 67.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "8bitdo - arcade stick for switch windows 8bitdo arcade stick for switch windows 8bitdo arcade stick for switch windows bluetooth wireless bt xinput xinput wireless bt xinput xinput wireless arcade stick wireless arcade stick published published arcade stick silver silver 05-10ms (gold) unknown closed source mister / pc xbox one xbox series raw capture 8bitdo - arcade stick for switch windows [bt xinput] 8bitdo - arcade stick for switch windows 8bitdo - arcade stick for switch windows [bt xinput] bluetooth wireless wireless bt bt xinput xinput xinput xinput ['wireless arcade stick'] wireless arcade stick silver silver arcade stick published published unknown closed source 8bitdo - arcade stick for switch windows 8bitdo arcade stick for switch windows 8bitdo arcade stick for switch windows bluetooth wireless bt xinput xinput wireless bt xinput xinput wireless arcade stick published published arcade stick silver silver 05-10ms (gold) unknown closed source mister / pc xbox one xbox series raw capture 8bitdo - arcade stick for switch windows [bt xinput] 8bitdo - arcade stick for switch windows 8bitdo - arcade stick for switch windows [wired xinput] wired usb wired wired wired xinput xinput xinput xinput ['wired arcade stick'] wired arcade stick bronze copper arcade stick published published unknown closed source 8bitdo - arcade stick for switch windows 8bitdo arcade stick for switch windows 8bitdo arcade stick for switch windows wired usb wired wired xinput xinput wired xinput xinput wired arcade stick published published arcade stick bronze copper 10-15ms (silver) unknown closed source mister / pc xbox one xbox series raw capture 8bitdo - arcade stick for switch windows [wired xinput] 8bitdo - arcade stick for switch windows 8bitdo - arcade stick for switch windows [2.4g xinput] 2.4ghz wireless wireless wireless 2.4ghz 2.4g xinput xinput xinput xinput ['wireless arcade stick'] wireless arcade stick bronze bronze arcade stick published published unknown closed source 8bitdo - arcade stick for switch windows 8bitdo arcade stick for switch windows 8bitdo arcade stick for switch windows 2.4ghz wireless wireless 2.4g xinput xinput wireless 2.4ghz xinput xinput wireless arcade stick published published arcade stick bronze bronze 10-15ms (silver) unknown closed source mister / pc xbox one xbox series raw capture 8bitdo - arcade stick for switch windows [2.4g xinput]",
      "controllerGroupKey": "published|8bitdo arcade stick for switch windows",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-8bitdo-arcade-stick-for-switch-windows",
          "name": "8BitDo - Arcade Stick for Switch Windows",
          "measurementName": "8BitDo - Arcade Stick for Switch Windows [BT Xinput]",
          "averageMs": 5.383,
          "averageTier": "Silver",
          "p99Ms": 8.346,
          "p99Tier": "Silver",
          "sameFramePct": 67.7,
          "observedSameFramePct": 67.7,
          "sampleCount": 2145,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT Xinput",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "XInput",
          "deviceTypes": [
            "Wireless Arcade Stick"
          ],
          "rankMode": "Wireless Arcade Stick",
          "overallRank": 167,
          "modeRank": 1,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - arcade stick for switch windows 8bitdo arcade stick for switch windows 8bitdo arcade stick for switch windows bluetooth wireless bt xinput xinput wireless bt xinput xinput wireless arcade stick published published arcade stick silver silver 05-10ms (gold) unknown closed source mister / pc xbox one xbox series raw capture 8bitdo - arcade stick for switch windows [bt xinput]"
        },
        {
          "id": "published-8bitdo-arcade-stick-for-switch-windows-2",
          "name": "8BitDo - Arcade Stick for Switch Windows",
          "measurementName": "8BitDo - Arcade Stick for Switch Windows [Wired Xinput]",
          "averageMs": 10.518,
          "averageTier": "Bronze",
          "p99Ms": 18.82,
          "p99Tier": "Copper",
          "sameFramePct": 36.89,
          "observedSameFramePct": 37.3,
          "sampleCount": 3906,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired Xinput",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "XInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 243,
          "modeRank": 35,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - arcade stick for switch windows 8bitdo arcade stick for switch windows 8bitdo arcade stick for switch windows wired usb wired wired xinput xinput wired xinput xinput wired arcade stick published published arcade stick bronze copper 10-15ms (silver) unknown closed source mister / pc xbox one xbox series raw capture 8bitdo - arcade stick for switch windows [wired xinput]"
        },
        {
          "id": "published-8bitdo-arcade-stick-for-switch-windows-3",
          "name": "8BitDo - Arcade Stick for Switch Windows",
          "measurementName": "8BitDo - Arcade Stick for Switch Windows [2.4G Xinput]",
          "averageMs": 11.074,
          "averageTier": "Bronze",
          "p99Ms": 16.05,
          "p99Tier": "Bronze",
          "sameFramePct": 33.56,
          "observedSameFramePct": 33.6,
          "sampleCount": 3897,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4GHz Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "2.4G Xinput",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "XInput",
          "deviceTypes": [
            "Wireless Arcade Stick"
          ],
          "rankMode": "Wireless Arcade Stick",
          "overallRank": 252,
          "modeRank": 4,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - arcade stick for switch windows 8bitdo arcade stick for switch windows 8bitdo arcade stick for switch windows 2.4ghz wireless wireless 2.4g xinput xinput wireless 2.4ghz xinput xinput wireless arcade stick published published arcade stick bronze bronze 10-15ms (silver) unknown closed source mister / pc xbox one xbox series raw capture 8bitdo - arcade stick for switch windows [2.4g xinput]"
        }
      ]
    },
    {
      "id": "published-hori-pro-pad-wired-controller-pokken-tournament-dx-edition",
      "name": "Hori - Pro Pad Wired Controller - Pokken Tournament DX Edition",
      "measurementName": "Hori Pro Pad Wired Controller - Pokken Tournament DX Edition [Wired USB]",
      "deviceNorm": "hori pro pad wired controller pokken tournament dx edition",
      "make": "Hori",
      "model": "Pro Pad Wired Controller - Pokken Tournament DX Edition",
      "link": "https://amzn.to/3d6HWyE",
      "amazon": "",
      "buyUrl": "https://amzn.to/3d6HWyE",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 98,
      "modeRank": 44,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "",
      "dateAdded": "5/26/2020",
      "dateAddedSort": "2020-05-26",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.404,
      "sdMs": 0.407,
      "maxMs": 6.444,
      "minMs": 4.36,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 67.58,
      "observedSameFramePct": 67.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "hori - pro pad wired controller - pokken tournament dx edition hori pro pad wired controller pokken tournament dx edition hori pro pad wired controller - pokken tournament dx edition wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no silver 05-10ms (gold) actively sold closed source mister / pc switch buy link hori pro pad wired controller - pokken tournament dx edition [wired usb] hori - pro pad wired controller - pokken tournament dx edition hori pro pad wired controller - pokken tournament dx edition [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 4 no published published actively sold closed source hori - pro pad wired controller - pokken tournament dx edition hori pro pad wired controller pokken tournament dx edition hori pro pad wired controller - pokken tournament dx edition wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no silver 05-10ms (gold) actively sold closed source mister / pc switch buy link hori pro pad wired controller - pokken tournament dx edition [wired usb]",
      "controllerGroupKey": "published|hori pro pad wired controller pokken tournament dx edition",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-hori-pro-pad-wired-controller-pokken-tournament-dx-edition",
          "name": "Hori - Pro Pad Wired Controller - Pokken Tournament DX Edition",
          "measurementName": "Hori Pro Pad Wired Controller - Pokken Tournament DX Edition [Wired USB]",
          "averageMs": 5.404,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 67.58,
          "observedSameFramePct": 67.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 168,
          "modeRank": 55,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "5/26/2020",
          "dateAddedSort": "2020-05-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3d6HWyE",
          "link": "https://amzn.to/3d6HWyE",
          "amazon": "",
          "joystickId": "",
          "searchText": "hori - pro pad wired controller - pokken tournament dx edition hori pro pad wired controller pokken tournament dx edition hori pro pad wired controller - pokken tournament dx edition wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no silver 05-10ms (gold) actively sold closed source mister / pc switch buy link hori pro pad wired controller - pokken tournament dx edition [wired usb]"
        }
      ]
    },
    {
      "id": "published-brook-wireless-fighting-board",
      "name": "Brook - Wireless Fighting Board",
      "measurementName": "Brook Wireless Fighting Board [BT (CSR8510)]",
      "deviceNorm": "brook wireless fighting board",
      "make": "Brook",
      "model": "Wireless Fighting Board",
      "link": "https://amzn.to/3TWXREa",
      "amazon": "",
      "buyUrl": "https://amzn.to/3TWXREa",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT (CSR8510)",
      "outputMode": "",
      "connectionTag": "Wireless BT",
      "modeLabel": "Bluetooth",
      "modeDisplay": "Bluetooth",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 99,
      "modeRank": 16,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "5/26/2020",
      "dateAddedSort": "2020-05-26",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.561,
      "sdMs": 1.527,
      "maxMs": 16.272,
      "minMs": 2.3,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 66.63,
      "observedSameFramePct": 66.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "brook - wireless fighting board brook wireless fighting board brook wireless fighting board bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth arcade stick encoder arcade stick encoder published published arcade stick encoder - - - silver 05-10ms (gold) actively sold closed source mister / pc buy link brook wireless fighting board [bt (csr8510)] brook - wireless fighting board brook wireless fighting board [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['arcade stick encoder'] arcade stick encoder silver arcade stick encoder - - - published published actively sold closed source brook - wireless fighting board brook wireless fighting board brook wireless fighting board bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth arcade stick encoder published published arcade stick encoder - - - silver 05-10ms (gold) actively sold closed source mister / pc buy link brook wireless fighting board [bt (csr8510)]",
      "controllerGroupKey": "published|brook wireless fighting board",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-brook-wireless-fighting-board",
          "name": "Brook - Wireless Fighting Board",
          "measurementName": "Brook Wireless Fighting Board [BT (CSR8510)]",
          "averageMs": 5.561,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 66.63,
          "observedSameFramePct": 66.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 169,
          "modeRank": 20,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "5/26/2020",
          "dateAddedSort": "2020-05-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3TWXREa",
          "link": "https://amzn.to/3TWXREa",
          "amazon": "",
          "joystickId": "",
          "searchText": "brook - wireless fighting board brook wireless fighting board brook wireless fighting board bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth arcade stick encoder published published arcade stick encoder - - - silver 05-10ms (gold) actively sold closed source mister / pc buy link brook wireless fighting board [bt (csr8510)]"
        }
      ]
    },
    {
      "id": "published-microsoft-wireless-controller-wired",
      "name": "Microsoft - Wireless Controller Wired",
      "measurementName": "Microsoft - Wireless Controller Wired",
      "deviceNorm": "microsoft wireless controller wired",
      "make": "Microsoft",
      "model": "Wireless Controller Wired",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 100,
      "modeRank": 45,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Silver",
      "averageMs": 5.591,
      "sdMs": 2.318,
      "maxMs": 9.94,
      "minMs": 1.55,
      "p99Ms": 9.497,
      "sampleCount": 2017,
      "sameFramePct": 66.45,
      "observedSameFramePct": 66.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "microsoft - wireless controller wired microsoft wireless controller wired microsoft wireless controller wired wired usb wired dinput wired dinput dinput wired controller wired controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc raw capture microsoft - wireless controller wired microsoft - wireless controller wired microsoft - wireless controller wired wired usb wired wired dinput dinput dinput ['wired controller'] wired controller silver silver controller published published unknown closed source microsoft - wireless controller wired microsoft wireless controller wired microsoft wireless controller wired wired usb wired dinput wired dinput dinput wired controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc raw capture microsoft - wireless controller wired",
      "controllerGroupKey": "published|microsoft wireless controller wired",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-microsoft-wireless-controller-wired",
          "name": "Microsoft - Wireless Controller Wired",
          "measurementName": "Microsoft - Wireless Controller Wired",
          "averageMs": 5.591,
          "averageTier": "Silver",
          "p99Ms": 9.497,
          "p99Tier": "Silver",
          "sameFramePct": 66.45,
          "observedSameFramePct": 66.5,
          "sampleCount": 2017,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 170,
          "modeRank": 56,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "microsoft - wireless controller wired microsoft wireless controller wired microsoft wireless controller wired wired usb wired dinput wired dinput dinput wired controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc raw capture microsoft - wireless controller wired"
        }
      ]
    },
    {
      "id": "published-microsoft-xbox-wireless-controller",
      "name": "Microsoft - Xbox Wireless Controller",
      "measurementName": "Microsoft Xbox Wireless Controller [Wired USB]",
      "deviceNorm": "microsoft xbox wireless controller",
      "make": "Microsoft",
      "model": "Xbox Wireless Controller",
      "link": "https://amzn.to/3hL61j6",
      "amazon": "",
      "buyUrl": "https://amzn.to/3hL61j6",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 101,
      "modeRank": 46,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "10.20",
      "dateAdded": "8/8/2021",
      "dateAddedSort": "2021-08-08",
      "platforms": [
        "MiSTer / PC",
        "Xbox Series"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.591,
      "sdMs": 2.318,
      "maxMs": 9.94,
      "minMs": 1.55,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 66.45,
      "observedSameFramePct": 66.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:0b12",
      "searchText": "microsoft - xbox wireless controller microsoft xbox wireless controller microsoft xbox wireless controller wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 yes 10.20 silver 05-10ms (gold) actively sold closed source mister / pc xbox series 045e:0b12 buy link microsoft xbox wireless controller [wired usb] microsoft - xbox wireless controller microsoft xbox wireless controller [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 4 yes 10.20 published published actively sold closed source microsoft - xbox wireless controller microsoft xbox wireless controller microsoft xbox wireless controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 10.20 silver 05-10ms (gold) actively sold closed source mister / pc xbox series 045e:0b12 buy link microsoft xbox wireless controller [wired usb] microsoft - xbox wireless controller microsoft xbox wireless controller [microsoft xbox usb adapter] 2.4 ghz usb wireless wireless 2.4ghz microsoft xbox usb adapter dinput dinput dinput ['wireless controller'] wireless controller silver controller 4 yes 10.20 published published actively sold closed source microsoft - xbox wireless controller microsoft xbox wireless controller microsoft xbox wireless controller 2.4 ghz usb wireless microsoft xbox usb adapter dinput wireless 2.4ghz dinput dinput wireless controller published published controller 4 yes 10.20 silver 05-10ms (gold) actively sold closed source mister / pc xbox series 045e:0b12 buy link microsoft xbox wireless controller [microsoft xbox usb adapter]",
      "controllerGroupKey": "published|microsoft xbox wireless controller",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-microsoft-xbox-wireless-controller",
          "name": "Microsoft - Xbox Wireless Controller",
          "measurementName": "Microsoft Xbox Wireless Controller [Wired USB]",
          "averageMs": 5.591,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 66.45,
          "observedSameFramePct": 66.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 171,
          "modeRank": 57,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "10.20",
          "dateAdded": "8/8/2021",
          "dateAddedSort": "2021-08-08",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3hL61j6",
          "link": "https://amzn.to/3hL61j6",
          "amazon": "",
          "joystickId": "045e:0b12",
          "searchText": "microsoft - xbox wireless controller microsoft xbox wireless controller microsoft xbox wireless controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 10.20 silver 05-10ms (gold) actively sold closed source mister / pc xbox series 045e:0b12 buy link microsoft xbox wireless controller [wired usb]"
        },
        {
          "id": "published-microsoft-xbox-wireless-controller-2",
          "name": "Microsoft - Xbox Wireless Controller",
          "measurementName": "Microsoft Xbox Wireless Controller [Microsoft Xbox USB Adapter]",
          "averageMs": 6.093,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 63.44,
          "observedSameFramePct": 63.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Microsoft Xbox USB Adapter",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 187,
          "modeRank": 12,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "10.20",
          "dateAdded": "8/8/2021",
          "dateAddedSort": "2021-08-08",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3hL61j6",
          "link": "https://amzn.to/3hL61j6",
          "amazon": "",
          "joystickId": "045e:0b12",
          "searchText": "microsoft - xbox wireless controller microsoft xbox wireless controller microsoft xbox wireless controller 2.4 ghz usb wireless microsoft xbox usb adapter dinput wireless 2.4ghz dinput dinput wireless controller published published controller 4 yes 10.20 silver 05-10ms (gold) actively sold closed source mister / pc xbox series 045e:0b12 buy link microsoft xbox wireless controller [microsoft xbox usb adapter]"
        }
      ]
    },
    {
      "id": "published-nintendo-gamecube-usb-4-player-adapter",
      "name": "Nintendo - GameCube USB 4 Player Adapter",
      "measurementName": "Nintendo - GameCube USB 4 Player Adapter [Wired USB]",
      "deviceNorm": "nintendo gamecube usb 4 player adapter",
      "make": "Nintendo",
      "model": "GameCube USB 4 Player Adapter",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 102,
      "modeRank": 19,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "GameCube Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Silver",
      "averageMs": 5.62,
      "sdMs": 2.335,
      "maxMs": 10.13,
      "minMs": 0.98,
      "p99Ms": 9.752,
      "sampleCount": 2081,
      "sameFramePct": 66.28,
      "observedSameFramePct": 66.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "nintendo - gamecube usb 4 player adapter nintendo gamecube usb 4 player adapter nintendo gamecube usb 4 player adapter wired usb wired wired usb dinput wired dinput dinput controller adapter gamecube controller controller adapter published published controller adapter silver silver 05-10ms (gold) unknown closed source mister / pc raw capture nintendo - gamecube usb 4 player adapter [wired usb] nintendo - gamecube usb 4 player adapter nintendo - gamecube usb 4 player adapter [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter', 'gamecube controller'] controller adapter silver silver controller adapter published published unknown closed source nintendo - gamecube usb 4 player adapter nintendo gamecube usb 4 player adapter nintendo gamecube usb 4 player adapter wired usb wired wired usb dinput wired dinput dinput controller adapter gamecube controller published published controller adapter silver silver 05-10ms (gold) unknown closed source mister / pc raw capture nintendo - gamecube usb 4 player adapter [wired usb]",
      "controllerGroupKey": "published|nintendo gamecube usb 4 player adapter",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-nintendo-gamecube-usb-4-player-adapter",
          "name": "Nintendo - GameCube USB 4 Player Adapter",
          "measurementName": "Nintendo - GameCube USB 4 Player Adapter [Wired USB]",
          "averageMs": 5.62,
          "averageTier": "Silver",
          "p99Ms": 9.752,
          "p99Tier": "Silver",
          "sameFramePct": 66.28,
          "observedSameFramePct": 66.3,
          "sampleCount": 2081,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "GameCube Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 173,
          "modeRank": 54,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "nintendo - gamecube usb 4 player adapter nintendo gamecube usb 4 player adapter nintendo gamecube usb 4 player adapter wired usb wired wired usb dinput wired dinput dinput controller adapter gamecube controller published published controller adapter silver silver 05-10ms (gold) unknown closed source mister / pc raw capture nintendo - gamecube usb 4 player adapter [wired usb]"
        }
      ]
    },
    {
      "id": "published-8bitdo-m30-bluetooth",
      "name": "8BitDo - M30 (Bluetooth)",
      "measurementName": "8BitDo M30 (Bluetooth) [Wired USB]",
      "deviceNorm": "8bitdo m30 bluetooth",
      "make": "8BitDo",
      "model": "M30 (Bluetooth)",
      "link": "https://amzn.to/2XsQZDs",
      "amazon": "",
      "buyUrl": "https://amzn.to/2XsQZDs",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 103,
      "modeRank": 47,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "4.00",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.74,
      "sdMs": 2.84,
      "maxMs": 11.1,
      "minMs": 0.32,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 65.56,
      "observedSameFramePct": 65.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "054c:05c4",
      "searchText": "8bitdo - m30 (bluetooth) 8bitdo m30 bluetooth 8bitdo m30 (bluetooth) wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 yes 4.00 silver 05-10ms (gold) actively sold closed source mister / pc switch 054c:05c4 buy link 8bitdo m30 (bluetooth) [wired usb] 8bitdo - m30 (bluetooth) 8bitdo m30 (bluetooth) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 6 yes 4.00 published published actively sold closed source 8bitdo - m30 (bluetooth) 8bitdo m30 bluetooth 8bitdo m30 (bluetooth) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 4.00 silver 05-10ms (gold) actively sold closed source mister / pc switch 054c:05c4 buy link 8bitdo m30 (bluetooth) [wired usb] 8bitdo - m30 (bluetooth) 8bitdo m30 (bluetooth) [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless controller'] wireless controller bronze controller 6 yes 4.00 published published actively sold closed source 8bitdo - m30 (bluetooth) 8bitdo m30 bluetooth 8bitdo m30 (bluetooth) bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 6 yes 4.00 bronze 10-15ms (silver) actively sold closed source mister / pc switch buy link 8bitdo m30 (bluetooth) [bt (csr8510)]",
      "controllerGroupKey": "published|8bitdo m30 bluetooth",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-8bitdo-m30-bluetooth",
          "name": "8BitDo - M30 (Bluetooth)",
          "measurementName": "8BitDo M30 (Bluetooth) [Wired USB]",
          "averageMs": 5.74,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 65.56,
          "observedSameFramePct": 65.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 176,
          "modeRank": 58,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.00",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2XsQZDs",
          "link": "https://amzn.to/2XsQZDs",
          "amazon": "",
          "joystickId": "054c:05c4",
          "searchText": "8bitdo - m30 (bluetooth) 8bitdo m30 bluetooth 8bitdo m30 (bluetooth) wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 4.00 silver 05-10ms (gold) actively sold closed source mister / pc switch 054c:05c4 buy link 8bitdo m30 (bluetooth) [wired usb]"
        },
        {
          "id": "published-8bitdo-m30-bluetooth-2",
          "name": "8BitDo - M30 (Bluetooth)",
          "measurementName": "8BitDo M30 (Bluetooth) [BT (CSR8510)]",
          "averageMs": 11.02,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 33.88,
          "observedSameFramePct": 34.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 251,
          "modeRank": 39,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.00",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2XsQZDs",
          "link": "https://amzn.to/2XsQZDs",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - m30 (bluetooth) 8bitdo m30 bluetooth 8bitdo m30 (bluetooth) bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 6 yes 4.00 bronze 10-15ms (silver) actively sold closed source mister / pc switch buy link 8bitdo m30 (bluetooth) [bt (csr8510)]"
        }
      ]
    },
    {
      "id": "published-freejoy-freejoy",
      "name": "FreeJoy - FreeJoy",
      "measurementName": "FreeJoy FreeJoy [Wired USB]",
      "deviceNorm": "freejoy freejoy",
      "make": "FreeJoy",
      "model": "FreeJoy",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 104,
      "modeRank": 17,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "8/27/2020",
      "dateAddedSort": "2020-08-27",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.798,
      "sdMs": 1.511,
      "maxMs": 9.716,
      "minMs": 2.02,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 65.21,
      "observedSameFramePct": 65.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Discontinued",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0483:5750",
      "searchText": "freejoy - freejoy freejoy freejoy freejoy freejoy wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - - silver 05-10ms (gold) discontinued closed source mister / pc 0483:5750 freejoy freejoy [wired usb] freejoy - freejoy freejoy freejoy [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder silver arcade stick encoder - - published published discontinued closed source freejoy - freejoy freejoy freejoy freejoy freejoy wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - silver 05-10ms (gold) discontinued closed source mister / pc 0483:5750 freejoy freejoy [wired usb]",
      "controllerGroupKey": "published|freejoy freejoy",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-freejoy-freejoy",
          "name": "FreeJoy - FreeJoy",
          "measurementName": "FreeJoy FreeJoy [Wired USB]",
          "averageMs": 5.798,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 65.21,
          "observedSameFramePct": 65.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 178,
          "modeRank": 21,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "",
          "dateAdded": "8/27/2020",
          "dateAddedSort": "2020-08-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "0483:5750",
          "searchText": "freejoy - freejoy freejoy freejoy freejoy freejoy wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - silver 05-10ms (gold) discontinued closed source mister / pc 0483:5750 freejoy freejoy [wired usb]"
        }
      ]
    },
    {
      "id": "published-snk-neo-geo-x",
      "name": "SNK - Neo-Geo X",
      "measurementName": "SNK Neo-Geo X [Wired USB]",
      "deviceNorm": "snk neo geo x",
      "make": "SNK",
      "model": "Neo-Geo X",
      "link": "https://amzn.to/30uw98e",
      "amazon": "",
      "buyUrl": "https://amzn.to/30uw98e",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 105,
      "modeRank": 18,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "4",
      "weightOz": "",
      "dateAdded": "7/20/2020",
      "dateAddedSort": "2020-07-20",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.911,
      "sdMs": 2.866,
      "maxMs": 11.136,
      "minMs": 0.308,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 64.53,
      "observedSameFramePct": 64.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "1292:4e47",
      "searchText": "snk - neo-geo x snk neo geo x snk neo-geo x wired usb wired wired usb dinput wired dinput dinput wired arcade stick wired arcade stick published published arcade stick 4 no silver 05-10ms (gold) actively sold closed source mister / pc 1292:4e47 buy link snk neo-geo x [wired usb] snk - neo-geo x snk neo-geo x [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired arcade stick'] wired arcade stick silver arcade stick 4 no published published actively sold closed source snk - neo-geo x snk neo geo x snk neo-geo x wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 4 no silver 05-10ms (gold) actively sold closed source mister / pc 1292:4e47 buy link snk neo-geo x [wired usb]",
      "controllerGroupKey": "published|snk neo geo x",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-snk-neo-geo-x",
          "name": "SNK - Neo-Geo X",
          "measurementName": "SNK Neo-Geo X [Wired USB]",
          "averageMs": 5.911,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 64.53,
          "observedSameFramePct": 64.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 179,
          "modeRank": 30,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "7/20/2020",
          "dateAddedSort": "2020-07-20",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/30uw98e",
          "link": "https://amzn.to/30uw98e",
          "amazon": "",
          "joystickId": "1292:4e47",
          "searchText": "snk - neo-geo x snk neo geo x snk neo-geo x wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 4 no silver 05-10ms (gold) actively sold closed source mister / pc 1292:4e47 buy link snk neo-geo x [wired usb]"
        }
      ]
    },
    {
      "id": "published-powera-fusion-wired-fightpad-for-xbox-one",
      "name": "PowerA - Fusion Wired Fightpad for Xbox One",
      "measurementName": "PowerA Fusion Wired Fightpad for Xbox One [Wired USB]",
      "deviceNorm": "powera fusion wired fightpad for xbox one",
      "make": "PowerA",
      "model": "Fusion Wired Fightpad for Xbox One",
      "link": "https://amzn.to/3g4BFE5",
      "amazon": "",
      "buyUrl": "https://amzn.to/3g4BFE5",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 106,
      "modeRank": 48,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "6.30",
      "dateAdded": "5/30/2020",
      "dateAddedSort": "2020-05-30",
      "platforms": [
        "MiSTer / PC",
        "Xbox One"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.927,
      "sdMs": 2.87,
      "maxMs": 11.196,
      "minMs": 0.396,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 64.44,
      "observedSameFramePct": 64.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "24c6:791a",
      "searchText": "powera - fusion wired fightpad for xbox one powera fusion wired fightpad for xbox one powera fusion wired fightpad for xbox one wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 yes 6.30 silver 05-10ms (gold) actively sold closed source mister / pc xbox one 24c6:791a buy link powera fusion wired fightpad for xbox one [wired usb] powera - fusion wired fightpad for xbox one powera fusion wired fightpad for xbox one [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 6 yes 6.30 published published actively sold closed source powera - fusion wired fightpad for xbox one powera fusion wired fightpad for xbox one powera fusion wired fightpad for xbox one wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 6.30 silver 05-10ms (gold) actively sold closed source mister / pc xbox one 24c6:791a buy link powera fusion wired fightpad for xbox one [wired usb]",
      "controllerGroupKey": "published|powera fusion wired fightpad for xbox one",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-powera-fusion-wired-fightpad-for-xbox-one",
          "name": "PowerA - Fusion Wired Fightpad for Xbox One",
          "measurementName": "PowerA Fusion Wired Fightpad for Xbox One [Wired USB]",
          "averageMs": 5.927,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 64.44,
          "observedSameFramePct": 64.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 180,
          "modeRank": 59,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "6.30",
          "dateAdded": "5/30/2020",
          "dateAddedSort": "2020-05-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3g4BFE5",
          "link": "https://amzn.to/3g4BFE5",
          "amazon": "",
          "joystickId": "24c6:791a",
          "searchText": "powera - fusion wired fightpad for xbox one powera fusion wired fightpad for xbox one powera fusion wired fightpad for xbox one wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 yes 6.30 silver 05-10ms (gold) actively sold closed source mister / pc xbox one 24c6:791a buy link powera fusion wired fightpad for xbox one [wired usb]"
        }
      ]
    },
    {
      "id": "published-microsoft-xbox-one-model-1708",
      "name": "Microsoft - Xbox One Model 1708",
      "measurementName": "Microsoft Xbox One Model 1708 [Wired USB]",
      "deviceNorm": "microsoft xbox one model 1708",
      "make": "Microsoft",
      "model": "Xbox One Model 1708",
      "link": "https://amzn.to/3d4iHga",
      "amazon": "",
      "buyUrl": "https://amzn.to/3d4iHga",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 107,
      "modeRank": 49,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "9.75",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC",
        "Xbox One"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 5.929,
      "sdMs": 2.321,
      "maxMs": 10.332,
      "minMs": 1.348,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 64.43,
      "observedSameFramePct": 64.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:02ea",
      "searchText": "microsoft - xbox one model 1708 microsoft xbox one model 1708 microsoft xbox one model 1708 wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 yes 9.75 silver 05-10ms (gold) actively sold closed source mister / pc xbox one 045e:02ea buy link microsoft xbox one model 1708 [wired usb] microsoft - xbox one model 1708 microsoft xbox one model 1708 [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 4 yes 9.75 published published actively sold closed source microsoft - xbox one model 1708 microsoft xbox one model 1708 microsoft xbox one model 1708 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 9.75 silver 05-10ms (gold) actively sold closed source mister / pc xbox one 045e:02ea buy link microsoft xbox one model 1708 [wired usb] microsoft - xbox one model 1708 microsoft xbox one model 1708 [microsoft xbox one wireless adapter] bluetooth wireless wireless bt microsoft xbox one wireless adapter xbox one xbox one xbox one ['wireless controller'] wireless controller silver controller 4 yes 9.75 published published actively sold closed source microsoft - xbox one model 1708 microsoft xbox one model 1708 microsoft xbox one model 1708 bluetooth wireless microsoft xbox one wireless adapter xbox one wireless bt xbox one xbox one wireless controller published published controller 4 yes 9.75 silver 05-10ms (gold) actively sold closed source mister / pc xbox one buy link microsoft xbox one model 1708 [microsoft xbox one wireless adapter] microsoft - xbox one model 1708 microsoft xbox one model 1708 [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless controller'] wireless controller bronze controller 4 yes 9.75 published published actively sold closed source microsoft - xbox one model 1708 microsoft xbox one model 1708 microsoft xbox one model 1708 bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 9.75 bronze 15-20ms (bronze) actively sold closed source mister / pc xbox one 045e:02e0 buy link microsoft xbox one model 1708 [bt (csr8510)]",
      "controllerGroupKey": "published|microsoft xbox one model 1708",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-microsoft-xbox-one-model-1708",
          "name": "Microsoft - Xbox One Model 1708",
          "measurementName": "Microsoft Xbox One Model 1708 [Wired USB]",
          "averageMs": 5.929,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 64.43,
          "observedSameFramePct": 64.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 181,
          "modeRank": 60,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "9.75",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3d4iHga",
          "link": "https://amzn.to/3d4iHga",
          "amazon": "",
          "joystickId": "045e:02ea",
          "searchText": "microsoft - xbox one model 1708 microsoft xbox one model 1708 microsoft xbox one model 1708 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 9.75 silver 05-10ms (gold) actively sold closed source mister / pc xbox one 045e:02ea buy link microsoft xbox one model 1708 [wired usb]"
        },
        {
          "id": "published-microsoft-xbox-one-model-1708-2",
          "name": "Microsoft - Xbox One Model 1708",
          "measurementName": "Microsoft Xbox One Model 1708 [Microsoft Xbox One Wireless Adapter]",
          "averageMs": 6.051,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 63.69,
          "observedSameFramePct": 63.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "Microsoft Xbox One Wireless Adapter",
          "outputMode": "Xbox One",
          "modeLabel": "Xbox One",
          "modeDisplay": "Xbox One",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 183,
          "modeRank": 10,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "9.75",
          "dateAdded": "10/13/2020",
          "dateAddedSort": "2020-10-13",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3d4iHga",
          "link": "https://amzn.to/3d4iHga",
          "amazon": "",
          "joystickId": "",
          "searchText": "microsoft - xbox one model 1708 microsoft xbox one model 1708 microsoft xbox one model 1708 bluetooth wireless microsoft xbox one wireless adapter xbox one wireless bt xbox one xbox one wireless controller published published controller 4 yes 9.75 silver 05-10ms (gold) actively sold closed source mister / pc xbox one buy link microsoft xbox one model 1708 [microsoft xbox one wireless adapter]"
        },
        {
          "id": "published-microsoft-xbox-one-model-1708-3",
          "name": "Microsoft - Xbox One Model 1708",
          "measurementName": "Microsoft Xbox One Model 1708 [BT (CSR8510)]",
          "averageMs": 15.686,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 5.88,
          "observedSameFramePct": 9.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 288,
          "modeRank": 60,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "9.75",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3d4iHga",
          "link": "https://amzn.to/3d4iHga",
          "amazon": "",
          "joystickId": "045e:02e0",
          "searchText": "microsoft - xbox one model 1708 microsoft xbox one model 1708 microsoft xbox one model 1708 bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 9.75 bronze 15-20ms (bronze) actively sold closed source mister / pc xbox one 045e:02e0 buy link microsoft xbox one model 1708 [bt (csr8510)]"
        }
      ]
    },
    {
      "id": "published-8bitdo-pro-2-82bc",
      "name": "8BitDo - Pro 2 82BC",
      "measurementName": "8BitDo Pro 2 82BC [Wired USB Xinput]",
      "deviceNorm": "8bitdo pro 2 82bc",
      "make": "8BitDo",
      "model": "Pro 2 82BC",
      "link": "https://amzn.to/3av4hXp",
      "amazon": "",
      "buyUrl": "https://amzn.to/3av4hXp",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Xinput",
      "outputMode": "DInput, XInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput, XInput",
      "modeDisplay": "DInput, XInput",
      "rankMode": "Wired Controller",
      "overallRank": 108,
      "modeRank": 50,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "",
      "dateAdded": "4/23/2021",
      "dateAddedSort": "2021-04-23",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 6.039,
      "sdMs": 2.901,
      "maxMs": 11.552,
      "minMs": 0.612,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 63.77,
      "observedSameFramePct": 63.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "2dc8:2000",
      "searchText": "8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired controller wired controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source mister / pc 2dc8:2000 buy link 8bitdo pro 2 82bc [wired usb xinput] 8bitdo - pro 2 82bc 8bitdo pro 2 82bc [wired usb xinput] wired usb wired wired wired usb xinput dinput, xinput dinput, xinput dinput, xinput ['wired controller'] wired controller silver controller 4 yes published published actively sold closed source 8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source mister / pc 2dc8:2000 buy link 8bitdo pro 2 82bc [wired usb xinput] 8bitdo - pro 2 82bc 8bitdo pro 2 82bc [wired usb android] wired usb wired wired wired usb android dinput, android dinput, android dinput, android ['wired controller'] wired controller silver controller 4 yes published published actively sold closed source 8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc wired usb wired wired usb android dinput, android wired dinput, android dinput, android wired controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source mister / pc buy link 8bitdo pro 2 82bc [wired usb android] 8bitdo - pro 2 82bc 8bitdo pro 2 82bc [wired usb dinput] wired usb wired wired wired usb dinput dinput dinput dinput ['wired controller'] wired controller silver controller 4 yes published published actively sold closed source 8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc wired usb wired wired usb dinput dinput wired dinput dinput wired controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source mister / pc buy link 8bitdo pro 2 82bc [wired usb dinput] 8bitdo - pro 2 82bc 8bitdo pro 2 82bc [bt (csr8510) xinput] bluetooth wireless wireless bt bt (csr8510) xinput xinput xinput xinput ['wireless controller'] wireless controller copper controller 4 yes published published actively sold closed source 8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc bluetooth wireless bt (csr8510) xinput xinput wireless bt xinput xinput wireless controller published published controller 4 yes copper 15-20ms (bronze) actively sold closed source mister / pc buy link 8bitdo pro 2 82bc [bt (csr8510) xinput] 8bitdo - pro 2 82bc 8bitdo pro 2 82bc [bt (csr8510) dinput] bluetooth wireless wireless bt bt (csr8510) dinput dinput dinput dinput ['wireless controller'] wireless controller copper controller 4 yes published published actively sold closed source 8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc bluetooth wireless bt (csr8510) dinput dinput wireless bt dinput dinput wireless controller published published controller 4 yes copper 15-20ms (bronze) actively sold closed source mister / pc buy link 8bitdo pro 2 82bc [bt (csr8510) dinput] 8bitdo - pro 2 82bc 8bitdo pro 2 82bc [bt (csr8510) android] bluetooth wireless wireless bt bt (csr8510) android android android android ['wireless controller'] wireless controller copper controller 4 yes published published actively sold closed source 8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc bluetooth wireless bt (csr8510) android android wireless bt android android wireless controller published published controller 4 yes copper 15-20ms (bronze) actively sold closed source mister / pc buy link 8bitdo pro 2 82bc [bt (csr8510) android] 8bitdo - pro 2 82bc 8bitdo pro 2 82bc [8bitdo usb adapter switch] bluetooth wireless wireless bt 8bitdo usb adapter switch dinput, switch dinput, switch dinput, switch ['wireless controller'] wireless controller copper controller 4 yes published published actively sold closed source 8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc bluetooth wireless 8bitdo usb adapter switch dinput, switch wireless bt dinput, switch dinput, switch wireless controller published published controller 4 yes copper 20ms+ (rust) actively sold closed source mister / pc switch 2dc8:3010 buy link 8bitdo pro 2 82bc [8bitdo usb adapter switch] 8bitdo - pro 2 82bc 8bitdo pro 2 82bc [8bitdo usb adapter android] bluetooth wireless wireless bt 8bitdo usb adapter android dinput, android dinput, android dinput, android ['wireless controller'] wireless controller copper controller 4 yes published published actively sold closed source 8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc bluetooth wireless 8bitdo usb adapter android dinput, android wireless bt dinput, android dinput, android wireless controller published published controller 4 yes copper 20ms+ (rust) actively sold closed source mister / pc buy link 8bitdo pro 2 82bc [8bitdo usb adapter android]",
      "controllerGroupKey": "published|8bitdo pro 2 82bc",
      "modeVariantCount": 8,
      "modeVariants": [
        {
          "id": "published-8bitdo-pro-2-82bc",
          "name": "8BitDo - Pro 2 82BC",
          "measurementName": "8BitDo Pro 2 82BC [Wired USB Xinput]",
          "averageMs": 6.039,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 63.77,
          "observedSameFramePct": 63.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Xinput",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 182,
          "modeRank": 61,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "4/23/2021",
          "dateAddedSort": "2021-04-23",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3av4hXp",
          "link": "https://amzn.to/3av4hXp",
          "amazon": "",
          "joystickId": "2dc8:2000",
          "searchText": "8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source mister / pc 2dc8:2000 buy link 8bitdo pro 2 82bc [wired usb xinput]"
        },
        {
          "id": "published-8bitdo-pro-2-82bc-2",
          "name": "8BitDo - Pro 2 82BC",
          "measurementName": "8BitDo Pro 2 82BC [Wired USB Android]",
          "averageMs": 6.103,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 63.38,
          "observedSameFramePct": 63.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Android",
          "outputMode": "DInput, Android",
          "modeLabel": "DInput, Android",
          "modeDisplay": "DInput, Android",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 189,
          "modeRank": 65,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "4/23/2021",
          "dateAddedSort": "2021-04-23",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3av4hXp",
          "link": "https://amzn.to/3av4hXp",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc wired usb wired wired usb android dinput, android wired dinput, android dinput, android wired controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source mister / pc buy link 8bitdo pro 2 82bc [wired usb android]"
        },
        {
          "id": "published-8bitdo-pro-2-82bc-3",
          "name": "8BitDo - Pro 2 82BC",
          "measurementName": "8BitDo Pro 2 82BC [Wired USB Dinput]",
          "averageMs": 6.152,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 63.09,
          "observedSameFramePct": 63.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 193,
          "modeRank": 69,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "4/23/2021",
          "dateAddedSort": "2021-04-23",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3av4hXp",
          "link": "https://amzn.to/3av4hXp",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc wired usb wired wired usb dinput dinput wired dinput dinput wired controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source mister / pc buy link 8bitdo pro 2 82bc [wired usb dinput]"
        },
        {
          "id": "published-8bitdo-pro-2-82bc-4",
          "name": "8BitDo - Pro 2 82BC",
          "measurementName": "8BitDo Pro 2 82BC [BT (CSR8510) XInput]",
          "averageMs": 18.119,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 11.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) XInput",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "XInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 302,
          "modeRank": 72,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "4/23/2021",
          "dateAddedSort": "2021-04-23",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3av4hXp",
          "link": "https://amzn.to/3av4hXp",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc bluetooth wireless bt (csr8510) xinput xinput wireless bt xinput xinput wireless controller published published controller 4 yes copper 15-20ms (bronze) actively sold closed source mister / pc buy link 8bitdo pro 2 82bc [bt (csr8510) xinput]"
        },
        {
          "id": "published-8bitdo-pro-2-82bc-5",
          "name": "8BitDo - Pro 2 82BC",
          "measurementName": "8BitDo Pro 2 82BC [BT (CSR8510) DInput]",
          "averageMs": 18.389,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 10.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) DInput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 305,
          "modeRank": 74,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "4/23/2021",
          "dateAddedSort": "2021-04-23",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3av4hXp",
          "link": "https://amzn.to/3av4hXp",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc bluetooth wireless bt (csr8510) dinput dinput wireless bt dinput dinput wireless controller published published controller 4 yes copper 15-20ms (bronze) actively sold closed source mister / pc buy link 8bitdo pro 2 82bc [bt (csr8510) dinput]"
        },
        {
          "id": "published-8bitdo-pro-2-82bc-6",
          "name": "8BitDo - Pro 2 82BC",
          "measurementName": "8BitDo Pro 2 82BC [BT (CSR8510) Android]",
          "averageMs": 19.824,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 8.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Android",
          "outputMode": "Android",
          "modeLabel": "Android",
          "modeDisplay": "Android",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 313,
          "modeRank": 80,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "4/23/2021",
          "dateAddedSort": "2021-04-23",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3av4hXp",
          "link": "https://amzn.to/3av4hXp",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc bluetooth wireless bt (csr8510) android android wireless bt android android wireless controller published published controller 4 yes copper 15-20ms (bronze) actively sold closed source mister / pc buy link 8bitdo pro 2 82bc [bt (csr8510) android]"
        },
        {
          "id": "published-8bitdo-pro-2-82bc-7",
          "name": "8BitDo - Pro 2 82BC",
          "measurementName": "8BitDo Pro 2 82BC [8BitDo USB Adapter Switch]",
          "averageMs": 21.485,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 10.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter Switch",
          "outputMode": "DInput, Switch",
          "modeLabel": "DInput, Switch",
          "modeDisplay": "DInput, Switch",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 325,
          "modeRank": 89,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "4/23/2021",
          "dateAddedSort": "2021-04-23",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3av4hXp",
          "link": "https://amzn.to/3av4hXp",
          "amazon": "",
          "joystickId": "2dc8:3010",
          "searchText": "8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc bluetooth wireless 8bitdo usb adapter switch dinput, switch wireless bt dinput, switch dinput, switch wireless controller published published controller 4 yes copper 20ms+ (rust) actively sold closed source mister / pc switch 2dc8:3010 buy link 8bitdo pro 2 82bc [8bitdo usb adapter switch]"
        },
        {
          "id": "published-8bitdo-pro-2-82bc-8",
          "name": "8BitDo - Pro 2 82BC",
          "measurementName": "8BitDo Pro 2 82BC [8BitDo USB Adapter Android]",
          "averageMs": 22.422,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 4.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter Android",
          "outputMode": "DInput, Android",
          "modeLabel": "DInput, Android",
          "modeDisplay": "DInput, Android",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 327,
          "modeRank": 91,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "4/23/2021",
          "dateAddedSort": "2021-04-23",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3av4hXp",
          "link": "https://amzn.to/3av4hXp",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - pro 2 82bc 8bitdo pro 2 82bc 8bitdo pro 2 82bc bluetooth wireless 8bitdo usb adapter android dinput, android wireless bt dinput, android dinput, android wireless controller published published controller 4 yes copper 20ms+ (rust) actively sold closed source mister / pc buy link 8bitdo pro 2 82bc [8bitdo usb adapter android]"
        }
      ]
    },
    {
      "id": "published-hori-fighting-commander-octa-playstation-pc",
      "name": "Hori - Fighting Commander Octa Playstation PC",
      "measurementName": "Hori - Fighting Commander Octa Playstation PC",
      "deviceNorm": "hori fighting commander octa playstation pc",
      "make": "Hori",
      "model": "Fighting Commander Octa Playstation PC",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 109,
      "modeRank": 51,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Silver",
      "averageMs": 6.052,
      "sdMs": 0.867,
      "maxMs": 7.57,
      "minMs": 4.47,
      "p99Ms": 7.51,
      "sampleCount": 4593,
      "sameFramePct": 63.69,
      "observedSameFramePct": 63.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "hori - fighting commander octa playstation pc hori fighting commander octa playstation pc hori fighting commander octa playstation pc wired usb wired dinput wired dinput dinput wired controller wired controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc raw capture hori - fighting commander octa playstation pc hori - fighting commander octa playstation pc hori - fighting commander octa playstation pc wired usb wired wired dinput dinput dinput ['wired controller'] wired controller silver silver controller published published unknown closed source hori - fighting commander octa playstation pc hori fighting commander octa playstation pc hori fighting commander octa playstation pc wired usb wired dinput wired dinput dinput wired controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc raw capture hori - fighting commander octa playstation pc",
      "controllerGroupKey": "published|hori fighting commander octa playstation pc",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-hori-fighting-commander-octa-playstation-pc",
          "name": "Hori - Fighting Commander Octa Playstation PC",
          "measurementName": "Hori - Fighting Commander Octa Playstation PC",
          "averageMs": 6.052,
          "averageTier": "Silver",
          "p99Ms": 7.51,
          "p99Tier": "Silver",
          "sameFramePct": 63.69,
          "observedSameFramePct": 63.7,
          "sampleCount": 4593,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 184,
          "modeRank": 62,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "hori - fighting commander octa playstation pc hori fighting commander octa playstation pc hori fighting commander octa playstation pc wired usb wired dinput wired dinput dinput wired controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc raw capture hori - fighting commander octa playstation pc"
        }
      ]
    },
    {
      "id": "published-8bitdo-sn30-pro",
      "name": "8BitDo - SN30 Pro+",
      "measurementName": "8BitDo SN30 Pro+ [Wired USB] FW 4.01",
      "deviceNorm": "8bitdo sn30 pro",
      "make": "8BitDo",
      "model": "SN30 Pro+",
      "link": "https://amzn.to/3hiyU4b",
      "amazon": "",
      "buyUrl": "https://amzn.to/3hiyU4b",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 110,
      "modeRank": 52,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "3.40",
      "dateAdded": "5/26/2020",
      "dateAddedSort": "2020-05-26",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 6.056,
      "sdMs": 2.883,
      "maxMs": 13.056,
      "minMs": 0.608,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 63.66,
      "observedSameFramePct": 63.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no 3.40 silver 05-10ms (gold) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 pro+ [wired usb] fw 4.01 8bitdo - sn30 pro+ 8bitdo sn30 pro+ [wired usb] fw 4.01 wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 4 no 3.40 published published actively sold closed source 8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.40 silver 05-10ms (gold) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 pro+ [wired usb] fw 4.01 8bitdo - sn30 pro+ 8bitdo sn30 pro+ [bt (csr8510) macos] fw 3.02 bluetooth wireless wireless bt bt (csr8510) macos macos macos macos ['wireless controller'] wireless controller bronze controller 4 yes 3.40 published published actively sold closed source 8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless bt (csr8510) macos macos wireless bt macos macos wireless controller published published controller 4 yes 3.40 bronze 10-15ms (silver) actively sold closed source mister / pc 054c:05c4 buy link 8bitdo sn30 pro+ [bt (csr8510) macos] fw 3.02 8bitdo - sn30 pro+ 8bitdo sn30 pro+ [bt (csr8510) switch] fw 3.02 bluetooth wireless wireless bt bt (csr8510) switch switch switch switch ['wireless controller'] wireless controller bronze controller 4 yes 3.40 published published actively sold closed source 8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless bt (csr8510) switch switch wireless bt switch switch wireless controller published published controller 4 yes 3.40 bronze 15-20ms (bronze) actively sold closed source mister / pc switch 057e:2009 buy link 8bitdo sn30 pro+ [bt (csr8510) switch] fw 3.02 8bitdo - sn30 pro+ 8bitdo sn30 pro+ [bt (csr8510) dinput] fw 3.02 bluetooth wireless wireless bt bt (csr8510) dinput dinput dinput dinput ['wireless controller'] wireless controller copper controller 4 yes 3.40 published published actively sold closed source 8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless bt (csr8510) dinput dinput wireless bt dinput dinput wireless controller published published controller 4 yes 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 2dc8:6102 buy link 8bitdo sn30 pro+ [bt (csr8510) dinput] fw 3.02 8bitdo - sn30 pro+ 8bitdo sn30 pro+ [bt (csr8510) x-input] fw 3.02 bluetooth wireless wireless bt bt (csr8510) x-input xinput xinput xinput ['wireless controller'] wireless controller copper controller 4 yes 3.40 published published actively sold closed source 8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless bt (csr8510) x-input xinput wireless bt xinput xinput wireless controller published published controller 4 yes 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 045e:02e0 buy link 8bitdo sn30 pro+ [bt (csr8510) x-input] fw 3.02 8bitdo - sn30 pro+ 8bitdo sn30 pro+ [8bitdo usb adapter x-input] fw 4.01 bluetooth wireless wireless bt 8bitdo usb adapter x-input dinput, xinput dinput, xinput dinput, xinput ['wireless controller'] wireless controller copper controller 4 yes published published actively sold closed source 8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless 8bitdo usb adapter x-input dinput, xinput wireless bt dinput, xinput dinput, xinput wireless controller published published controller 4 yes copper 20ms+ (rust) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 pro+ [8bitdo usb adapter x-input] fw 4.01 8bitdo - sn30 pro+ 8bitdo sn30 pro+ [8bitdo usb adapter dinput] fw 3.02 bluetooth wireless wireless bt 8bitdo usb adapter dinput dinput dinput dinput ['wireless controller'] wireless controller copper controller 4 yes 3.40 published published actively sold closed source 8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 yes 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 2dc8:3100 buy link 8bitdo sn30 pro+ [8bitdo usb adapter dinput] fw 3.02 8bitdo - sn30 pro+ 8bitdo sn30 pro+ [8bitdo usb adapter x-input] fw 3.02 bluetooth wireless wireless bt 8bitdo usb adapter x-input dinput, xinput dinput, xinput dinput, xinput ['wireless controller'] wireless controller copper controller 4 yes 3.40 published published actively sold closed source 8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless 8bitdo usb adapter x-input dinput, xinput wireless bt dinput, xinput dinput, xinput wireless controller published published controller 4 yes 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 pro+ [8bitdo usb adapter x-input] fw 3.02",
      "controllerGroupKey": "published|8bitdo sn30 pro",
      "modeVariantCount": 8,
      "modeVariants": [
        {
          "id": "published-8bitdo-sn30-pro",
          "name": "8BitDo - SN30 Pro+",
          "measurementName": "8BitDo SN30 Pro+ [Wired USB] FW 4.01",
          "averageMs": 6.056,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 63.66,
          "observedSameFramePct": 63.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 185,
          "modeRank": 63,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "5/26/2020",
          "dateAddedSort": "2020-05-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3hiyU4b",
          "link": "https://amzn.to/3hiyU4b",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.40 silver 05-10ms (gold) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 pro+ [wired usb] fw 4.01"
        },
        {
          "id": "published-8bitdo-sn30-pro-2",
          "name": "8BitDo - SN30 Pro+",
          "measurementName": "8BitDo SN30 Pro+ [BT (CSR8510) MacOS] FW 3.02",
          "averageMs": 14.365,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 13.81,
          "observedSameFramePct": 23.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) MacOS",
          "outputMode": "macOS",
          "modeLabel": "macOS",
          "modeDisplay": "macOS",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 277,
          "modeRank": 50,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "3.40",
          "dateAdded": "6/10/2020",
          "dateAddedSort": "2020-06-10",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3hiyU4b",
          "link": "https://amzn.to/3hiyU4b",
          "amazon": "",
          "joystickId": "054c:05c4",
          "searchText": "8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless bt (csr8510) macos macos wireless bt macos macos wireless controller published published controller 4 yes 3.40 bronze 10-15ms (silver) actively sold closed source mister / pc 054c:05c4 buy link 8bitdo sn30 pro+ [bt (csr8510) macos] fw 3.02"
        },
        {
          "id": "published-8bitdo-sn30-pro-3",
          "name": "8BitDo - SN30 Pro+",
          "measurementName": "8BitDo SN30 Pro+ [BT (CSR8510) Switch] FW 3.02",
          "averageMs": 15.918,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 4.49,
          "observedSameFramePct": 19.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Switch",
          "outputMode": "Switch",
          "modeLabel": "Switch",
          "modeDisplay": "Switch",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 292,
          "modeRank": 63,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "3.40",
          "dateAdded": "6/10/2020",
          "dateAddedSort": "2020-06-10",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3hiyU4b",
          "link": "https://amzn.to/3hiyU4b",
          "amazon": "",
          "joystickId": "057e:2009",
          "searchText": "8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless bt (csr8510) switch switch wireless bt switch switch wireless controller published published controller 4 yes 3.40 bronze 15-20ms (bronze) actively sold closed source mister / pc switch 057e:2009 buy link 8bitdo sn30 pro+ [bt (csr8510) switch] fw 3.02"
        },
        {
          "id": "published-8bitdo-sn30-pro-4",
          "name": "8BitDo - SN30 Pro+",
          "measurementName": "8BitDo SN30 Pro+ [BT (CSR8510) Dinput] FW 3.02",
          "averageMs": 20.081,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 10.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 316,
          "modeRank": 83,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "3.40",
          "dateAdded": "6/10/2020",
          "dateAddedSort": "2020-06-10",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3hiyU4b",
          "link": "https://amzn.to/3hiyU4b",
          "amazon": "",
          "joystickId": "2dc8:6102",
          "searchText": "8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless bt (csr8510) dinput dinput wireless bt dinput dinput wireless controller published published controller 4 yes 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 2dc8:6102 buy link 8bitdo sn30 pro+ [bt (csr8510) dinput] fw 3.02"
        },
        {
          "id": "published-8bitdo-sn30-pro-5",
          "name": "8BitDo - SN30 Pro+",
          "measurementName": "8BitDo SN30 Pro+ [BT (CSR8510) X-Input] FW 3.02",
          "averageMs": 20.145,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 10.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) X-Input",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "XInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 317,
          "modeRank": 84,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "3.40",
          "dateAdded": "6/10/2020",
          "dateAddedSort": "2020-06-10",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3hiyU4b",
          "link": "https://amzn.to/3hiyU4b",
          "amazon": "",
          "joystickId": "045e:02e0",
          "searchText": "8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless bt (csr8510) x-input xinput wireless bt xinput xinput wireless controller published published controller 4 yes 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 045e:02e0 buy link 8bitdo sn30 pro+ [bt (csr8510) x-input] fw 3.02"
        },
        {
          "id": "published-8bitdo-sn30-pro-6",
          "name": "8BitDo - SN30 Pro+",
          "measurementName": "8BitDo SN30 Pro+ [8BitDo USB Adapter X-Input] FW 4.01",
          "averageMs": 26.13,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 3.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter X-Input",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 330,
          "modeRank": 92,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "5/26/2020",
          "dateAddedSort": "2020-05-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3hiyU4b",
          "link": "https://amzn.to/3hiyU4b",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless 8bitdo usb adapter x-input dinput, xinput wireless bt dinput, xinput dinput, xinput wireless controller published published controller 4 yes copper 20ms+ (rust) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 pro+ [8bitdo usb adapter x-input] fw 4.01"
        },
        {
          "id": "published-8bitdo-sn30-pro-7",
          "name": "8BitDo - SN30 Pro+",
          "measurementName": "8BitDo SN30 Pro+ [8BitDo USB Adapter Dinput] FW 3.02",
          "averageMs": 30.327,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 16.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 333,
          "modeRank": 94,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "3.40",
          "dateAdded": "5/26/2020",
          "dateAddedSort": "2020-05-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3hiyU4b",
          "link": "https://amzn.to/3hiyU4b",
          "amazon": "",
          "joystickId": "2dc8:3100",
          "searchText": "8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 yes 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 2dc8:3100 buy link 8bitdo sn30 pro+ [8bitdo usb adapter dinput] fw 3.02"
        },
        {
          "id": "published-8bitdo-sn30-pro-8",
          "name": "8BitDo - SN30 Pro+",
          "measurementName": "8BitDo SN30 Pro+ [8BitDo USB Adapter X-Input] FW 3.02",
          "averageMs": 30.771,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 15.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter X-Input",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 334,
          "modeRank": 95,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "3.40",
          "dateAdded": "5/26/2020",
          "dateAddedSort": "2020-05-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3hiyU4b",
          "link": "https://amzn.to/3hiyU4b",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - sn30 pro+ 8bitdo sn30 pro 8bitdo sn30 pro+ bluetooth wireless 8bitdo usb adapter x-input dinput, xinput wireless bt dinput, xinput dinput, xinput wireless controller published published controller 4 yes 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 045e:028e buy link 8bitdo sn30 pro+ [8bitdo usb adapter x-input] fw 3.02"
        }
      ]
    },
    {
      "id": "published-microsoft-wireless-controller-wireless",
      "name": "Microsoft - Wireless Controller Wireless",
      "measurementName": "Microsoft - Wireless Controller Wireless",
      "deviceNorm": "microsoft wireless controller wireless",
      "make": "Microsoft",
      "model": "Wireless Controller Wireless",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wireless",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "",
      "connectionTag": "Wireless",
      "modeLabel": "Wireless",
      "modeDisplay": "Wireless",
      "rankMode": "Wireless Controller",
      "overallRank": 111,
      "modeRank": 3,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Silver",
      "averageMs": 6.093,
      "sdMs": 2.346,
      "maxMs": 23.49,
      "minMs": 1.96,
      "p99Ms": 10.0,
      "sampleCount": 6459,
      "sameFramePct": 63.44,
      "observedSameFramePct": 63.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "microsoft - wireless controller wireless microsoft wireless controller wireless microsoft wireless controller wireless wireless wireless wireless wireless wireless wireless controller wireless controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc raw capture microsoft - wireless controller wireless microsoft - wireless controller wireless microsoft - wireless controller wireless wireless wireless wireless wireless wireless ['wireless controller'] wireless controller silver silver controller published published unknown closed source microsoft - wireless controller wireless microsoft wireless controller wireless microsoft wireless controller wireless wireless wireless wireless wireless wireless wireless controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc raw capture microsoft - wireless controller wireless",
      "controllerGroupKey": "published|microsoft wireless controller wireless",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-microsoft-wireless-controller-wireless",
          "name": "Microsoft - Wireless Controller Wireless",
          "measurementName": "Microsoft - Wireless Controller Wireless",
          "averageMs": 6.093,
          "averageTier": "Silver",
          "p99Ms": 10.0,
          "p99Tier": "Silver",
          "sameFramePct": 63.44,
          "observedSameFramePct": 63.5,
          "sampleCount": 6459,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless",
          "modeRaw": "",
          "outputMode": "",
          "modeLabel": "Wireless",
          "modeDisplay": "Wireless",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 186,
          "modeRank": 11,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "microsoft - wireless controller wireless microsoft wireless controller wireless microsoft wireless controller wireless wireless wireless wireless wireless wireless wireless controller published published controller silver silver 05-10ms (gold) unknown closed source mister / pc raw capture microsoft - wireless controller wireless"
        }
      ]
    },
    {
      "id": "published-retro-bit-6-button-usb",
      "name": "Retro-Bit - 6 Button USB",
      "measurementName": "Retro-Bit 6 Button USB [Wired USB]",
      "deviceNorm": "retro bit 6 button usb",
      "make": "Retro-Bit",
      "model": "6 Button USB",
      "link": "https://amzn.to/2XVAVLq",
      "amazon": "",
      "buyUrl": "https://amzn.to/2XVAVLq",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 112,
      "modeRank": 53,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "3.55",
      "dateAdded": "8/14/2020",
      "dateAddedSort": "2020-08-14",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 6.114,
      "sdMs": 2.867,
      "maxMs": 11.676,
      "minMs": 0.828,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 63.32,
      "observedSameFramePct": 63.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:0011",
      "searchText": "retro-bit - 6 button usb retro bit 6 button usb retro-bit 6 button usb wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 no 3.55 silver 05-10ms (gold) actively sold closed source mister / pc switch 0079:0011 buy link retro-bit 6 button usb [wired usb] retro-bit - 6 button usb retro-bit 6 button usb [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 6 no 3.55 published published actively sold closed source retro-bit - 6 button usb retro bit 6 button usb retro-bit 6 button usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 3.55 silver 05-10ms (gold) actively sold closed source mister / pc switch 0079:0011 buy link retro-bit 6 button usb [wired usb]",
      "controllerGroupKey": "published|retro bit 6 button usb",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retro-bit-6-button-usb",
          "name": "Retro-Bit - 6 Button USB",
          "measurementName": "Retro-Bit 6 Button USB [Wired USB]",
          "averageMs": 6.114,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 63.32,
          "observedSameFramePct": 63.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 190,
          "modeRank": 66,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "3.55",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2XVAVLq",
          "link": "https://amzn.to/2XVAVLq",
          "amazon": "",
          "joystickId": "0079:0011",
          "searchText": "retro-bit - 6 button usb retro bit 6 button usb retro-bit 6 button usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 3.55 silver 05-10ms (gold) actively sold closed source mister / pc switch 0079:0011 buy link retro-bit 6 button usb [wired usb]"
        }
      ]
    },
    {
      "id": "published-microsoft-xbox-elite-series-2",
      "name": "Microsoft - Xbox Elite Series 2",
      "measurementName": "Microsoft Xbox Elite Series 2 [Wired USB]",
      "deviceNorm": "microsoft xbox elite series 2",
      "make": "Microsoft",
      "model": "Xbox Elite Series 2",
      "link": "https://amzn.to/30UKrQP",
      "amazon": "",
      "buyUrl": "https://amzn.to/30UKrQP",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 113,
      "modeRank": 54,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "12.05",
      "dateAdded": "8/14/2020",
      "dateAddedSort": "2020-08-14",
      "platforms": [
        "MiSTer / PC",
        "Xbox Series"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 6.147,
      "sdMs": 2.336,
      "maxMs": 10.452,
      "minMs": 1.532,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 63.12,
      "observedSameFramePct": 63.1,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:0b00",
      "searchText": "microsoft - xbox elite series 2 microsoft xbox elite series 2 microsoft xbox elite series 2 wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 yes 12.05 silver 05-10ms (gold) actively sold closed source mister / pc xbox series 045e:0b00 buy link microsoft xbox elite series 2 [wired usb] microsoft - xbox elite series 2 microsoft xbox elite series 2 [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 4 yes 12.05 published published actively sold closed source microsoft - xbox elite series 2 microsoft xbox elite series 2 microsoft xbox elite series 2 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 12.05 silver 05-10ms (gold) actively sold closed source mister / pc xbox series 045e:0b00 buy link microsoft xbox elite series 2 [wired usb] microsoft - xbox elite series 2 microsoft xbox elite series 2 [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless controller'] wireless controller bronze controller 4 yes 12.05 published published actively sold closed source microsoft - xbox elite series 2 microsoft xbox elite series 2 microsoft xbox elite series 2 bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 12.05 bronze 10-15ms (silver) actively sold closed source mister / pc xbox series 045e:0b05 buy link microsoft xbox elite series 2 [bt (csr8510)]",
      "controllerGroupKey": "published|microsoft xbox elite series 2",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-microsoft-xbox-elite-series-2",
          "name": "Microsoft - Xbox Elite Series 2",
          "measurementName": "Microsoft Xbox Elite Series 2 [Wired USB]",
          "averageMs": 6.147,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 63.12,
          "observedSameFramePct": 63.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 191,
          "modeRank": 67,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "12.05",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/30UKrQP",
          "link": "https://amzn.to/30UKrQP",
          "amazon": "",
          "joystickId": "045e:0b00",
          "searchText": "microsoft - xbox elite series 2 microsoft xbox elite series 2 microsoft xbox elite series 2 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 12.05 silver 05-10ms (gold) actively sold closed source mister / pc xbox series 045e:0b00 buy link microsoft xbox elite series 2 [wired usb]"
        },
        {
          "id": "published-microsoft-xbox-elite-series-2-2",
          "name": "Microsoft - Xbox Elite Series 2",
          "measurementName": "Microsoft Xbox Elite Series 2 [BT (CSR8510)]",
          "averageMs": 10.249,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 38.51,
          "observedSameFramePct": 38.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 240,
          "modeRank": 31,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "12.05",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/30UKrQP",
          "link": "https://amzn.to/30UKrQP",
          "amazon": "",
          "joystickId": "045e:0b05",
          "searchText": "microsoft - xbox elite series 2 microsoft xbox elite series 2 microsoft xbox elite series 2 bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 12.05 bronze 10-15ms (silver) actively sold closed source mister / pc xbox series 045e:0b05 buy link microsoft xbox elite series 2 [bt (csr8510)]"
        }
      ]
    },
    {
      "id": "published-retro-bit-big-6",
      "name": "Retro-Bit - Big 6",
      "measurementName": "Retro-Bit Big 6 [Wired USB]",
      "deviceNorm": "retro bit big 6",
      "make": "Retro-Bit",
      "model": "Big 6",
      "link": "https://amzn.to/3NfEmHs",
      "amazon": "",
      "buyUrl": "https://amzn.to/3NfEmHs",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 114,
      "modeRank": 55,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "",
      "dateAdded": "4/26/2023",
      "dateAddedSort": "2023-04-26",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 6.154,
      "sdMs": 2.914,
      "maxMs": 13.06,
      "minMs": 0.82,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 63.08,
      "observedSameFramePct": 63.1,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "retro-bit - big 6 retro bit big 6 retro-bit big 6 wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 no silver 05-10ms (gold) actively sold closed source mister / pc switch buy link retro-bit big 6 [wired usb] retro-bit - big 6 retro-bit big 6 [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 6 no published published actively sold closed source retro-bit - big 6 retro bit big 6 retro-bit big 6 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no silver 05-10ms (gold) actively sold closed source mister / pc switch buy link retro-bit big 6 [wired usb]",
      "controllerGroupKey": "published|retro bit big 6",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retro-bit-big-6",
          "name": "Retro-Bit - Big 6",
          "measurementName": "Retro-Bit Big 6 [Wired USB]",
          "averageMs": 6.154,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 63.08,
          "observedSameFramePct": 63.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 194,
          "modeRank": 70,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "4/26/2023",
          "dateAddedSort": "2023-04-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3NfEmHs",
          "link": "https://amzn.to/3NfEmHs",
          "amazon": "",
          "joystickId": "",
          "searchText": "retro-bit - big 6 retro bit big 6 retro-bit big 6 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no silver 05-10ms (gold) actively sold closed source mister / pc switch buy link retro-bit big 6 [wired usb]"
        }
      ]
    },
    {
      "id": "published-retro-bit-legacy-16-wired-usb-controller",
      "name": "Retro-Bit - Legacy 16 Wired USB Controller",
      "measurementName": "Retro-Bit Legacy 16 Wired USB Controller [Wired USB Xinput]",
      "deviceNorm": "retro bit legacy 16 wired usb controller",
      "make": "Retro-Bit",
      "model": "Legacy 16 Wired USB Controller",
      "link": "https://amzn.to/3qo3puJ",
      "amazon": "",
      "buyUrl": "https://amzn.to/3qo3puJ",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Xinput",
      "outputMode": "DInput, XInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput, XInput",
      "modeDisplay": "DInput, XInput",
      "rankMode": "Wired Controller",
      "overallRank": 115,
      "modeRank": 56,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "",
      "dateAdded": "12/17/2021",
      "dateAddedSort": "2021-12-17",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 6.259,
      "sdMs": 2.902,
      "maxMs": 11.68,
      "minMs": 0.76,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 62.45,
      "observedSameFramePct": 62.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "retro-bit - legacy 16 wired usb controller retro bit legacy 16 wired usb controller retro-bit legacy 16 wired usb controller wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired controller wired controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source mister / pc 045e:028e buy link retro-bit legacy 16 wired usb controller [wired usb xinput] retro-bit - legacy 16 wired usb controller retro-bit legacy 16 wired usb controller [wired usb xinput] wired usb wired wired wired usb xinput dinput, xinput dinput, xinput dinput, xinput ['wired controller'] wired controller silver controller 4 yes published published actively sold closed source retro-bit - legacy 16 wired usb controller retro bit legacy 16 wired usb controller retro-bit legacy 16 wired usb controller wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source mister / pc 045e:028e buy link retro-bit legacy 16 wired usb controller [wired usb xinput] retro-bit - legacy 16 wired usb controller retro-bit legacy 16 wired usb controller [wired usb dinput] wired usb wired wired wired usb dinput dinput dinput dinput ['wired controller'] wired controller silver controller 4 yes published published actively sold closed source retro-bit - legacy 16 wired usb controller retro bit legacy 16 wired usb controller retro-bit legacy 16 wired usb controller wired usb wired wired usb dinput dinput wired dinput dinput wired controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source mister / pc switch 0079:0011 buy link retro-bit legacy 16 wired usb controller [wired usb dinput]",
      "controllerGroupKey": "published|retro bit legacy 16 wired usb controller",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-retro-bit-legacy-16-wired-usb-controller",
          "name": "Retro-Bit - Legacy 16 Wired USB Controller",
          "measurementName": "Retro-Bit Legacy 16 Wired USB Controller [Wired USB Xinput]",
          "averageMs": 6.259,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 62.45,
          "observedSameFramePct": 62.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Xinput",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 195,
          "modeRank": 71,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "12/17/2021",
          "dateAddedSort": "2021-12-17",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3qo3puJ",
          "link": "https://amzn.to/3qo3puJ",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "retro-bit - legacy 16 wired usb controller retro bit legacy 16 wired usb controller retro-bit legacy 16 wired usb controller wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput wired controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source mister / pc 045e:028e buy link retro-bit legacy 16 wired usb controller [wired usb xinput]"
        },
        {
          "id": "published-retro-bit-legacy-16-wired-usb-controller-2",
          "name": "Retro-Bit - Legacy 16 Wired USB Controller",
          "measurementName": "Retro-Bit Legacy 16 Wired USB Controller [Wired USB Dinput]",
          "averageMs": 6.262,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 62.43,
          "observedSameFramePct": 62.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 196,
          "modeRank": 72,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "12/17/2021",
          "dateAddedSort": "2021-12-17",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3qo3puJ",
          "link": "https://amzn.to/3qo3puJ",
          "amazon": "",
          "joystickId": "0079:0011",
          "searchText": "retro-bit - legacy 16 wired usb controller retro bit legacy 16 wired usb controller retro-bit legacy 16 wired usb controller wired usb wired wired usb dinput dinput wired dinput dinput wired controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source mister / pc switch 0079:0011 buy link retro-bit legacy 16 wired usb controller [wired usb dinput]"
        }
      ]
    },
    {
      "id": "published-8bitdo-gbros",
      "name": "8BitDo - GBros",
      "measurementName": "8BitDo - GBros",
      "deviceNorm": "8bitdo gbros",
      "make": "8BitDo",
      "model": "GBros",
      "link": "https://amzn.to/3Aw5KKa",
      "amazon": "",
      "buyUrl": "https://amzn.to/3Aw5KKa",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 116,
      "modeRank": 20,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "8/8/2021",
      "dateAddedSort": "2021-08-08",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Bronze",
      "averageMs": 6.268,
      "sdMs": 2.915,
      "maxMs": 11.7,
      "minMs": 0.86,
      "p99Ms": 11.36,
      "sampleCount": 3190,
      "sameFramePct": 62.39,
      "observedSameFramePct": 62.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "8bitdo - gbros 8bitdo gbros 8bitdo gbros wired usb wired dinput wired dinput dinput controller adapter controller adapter published published controller adapter silver bronze 05-10ms (gold) actively sold closed source mister / pc raw capture buy link 8bitdo - gbros 8bitdo - gbros 8bitdo - gbros wired usb wired wired dinput dinput dinput ['controller adapter'] controller adapter silver bronze controller adapter published published actively sold closed source 8bitdo - gbros 8bitdo gbros 8bitdo gbros wired usb wired dinput wired dinput dinput controller adapter published published controller adapter silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - gbros",
      "controllerGroupKey": "published|8bitdo gbros",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-8bitdo-gbros",
          "name": "8BitDo - GBros",
          "measurementName": "8BitDo - GBros",
          "averageMs": 6.268,
          "averageTier": "Silver",
          "p99Ms": 11.36,
          "p99Tier": "Bronze",
          "sameFramePct": 62.39,
          "observedSameFramePct": 62.4,
          "sampleCount": 3190,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 197,
          "modeRank": 55,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "8/8/2021",
          "dateAddedSort": "2021-08-08",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Aw5KKa",
          "link": "https://amzn.to/3Aw5KKa",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - gbros 8bitdo gbros 8bitdo gbros wired usb wired dinput wired dinput dinput controller adapter published published controller adapter silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - gbros"
        }
      ]
    },
    {
      "id": "published-elecom-wii-classic-gamepad-converter",
      "name": "Elecom - Wii Classic Gamepad Converter",
      "measurementName": "Elecom Wii Classic Gamepad Converter [Wii Classic]",
      "deviceNorm": "elecom wii classic gamepad converter",
      "make": "Elecom",
      "model": "Wii Classic Gamepad Converter",
      "link": "https://amzn.to/2OGtzpY",
      "amazon": "",
      "buyUrl": "https://amzn.to/2OGtzpY",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wii Classic",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 117,
      "modeRank": 21,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "7/20/2020",
      "dateAddedSort": "2020-07-20",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "Wii Classic Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 6.307,
      "sdMs": 3.015,
      "maxMs": 11.78,
      "minMs": 0.732,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 62.16,
      "observedSameFramePct": 62.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "056e:2007",
      "searchText": "elecom - wii classic gamepad converter elecom wii classic gamepad converter elecom wii classic gamepad converter wired usb wired wii classic dinput wired dinput dinput controller adapter wii classic controller controller adapter published published controller adapter - no - silver 05-10ms (gold) actively sold closed source mister / pc 056e:2007 buy link elecom wii classic gamepad converter [wii classic] elecom - wii classic gamepad converter elecom wii classic gamepad converter [wii classic] wired usb wired wired wii classic dinput dinput dinput ['controller adapter', 'wii classic controller'] controller adapter silver controller adapter - no - published published actively sold closed source elecom - wii classic gamepad converter elecom wii classic gamepad converter elecom wii classic gamepad converter wired usb wired wii classic dinput wired dinput dinput controller adapter wii classic controller published published controller adapter - no - silver 05-10ms (gold) actively sold closed source mister / pc 056e:2007 buy link elecom wii classic gamepad converter [wii classic]",
      "controllerGroupKey": "published|elecom wii classic gamepad converter",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-elecom-wii-classic-gamepad-converter",
          "name": "Elecom - Wii Classic Gamepad Converter",
          "measurementName": "Elecom Wii Classic Gamepad Converter [Wii Classic]",
          "averageMs": 6.307,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 62.16,
          "observedSameFramePct": 62.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wii Classic",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Wii Classic Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 199,
          "modeRank": 56,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "7/20/2020",
          "dateAddedSort": "2020-07-20",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2OGtzpY",
          "link": "https://amzn.to/2OGtzpY",
          "amazon": "",
          "joystickId": "056e:2007",
          "searchText": "elecom - wii classic gamepad converter elecom wii classic gamepad converter elecom wii classic gamepad converter wired usb wired wii classic dinput wired dinput dinput controller adapter wii classic controller published published controller adapter - no - silver 05-10ms (gold) actively sold closed source mister / pc 056e:2007 buy link elecom wii classic gamepad converter [wii classic]"
        }
      ]
    },
    {
      "id": "published-retro-fighters-brawlergen-usb",
      "name": "Retro Fighters - brawlerGEN USB",
      "measurementName": "Retro Fighters brawlerGEN USB [Wired USB]",
      "deviceNorm": "retro fighters brawlergen usb",
      "make": "Retro Fighters",
      "model": "brawlerGEN USB",
      "link": "https://amzn.to/2TAxabZ",
      "amazon": "",
      "buyUrl": "https://amzn.to/2TAxabZ",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 118,
      "modeRank": 57,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "5.75",
      "dateAdded": "6/12/2020",
      "dateAddedSort": "2020-06-12",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 6.315,
      "sdMs": 2.893,
      "maxMs": 11.688,
      "minMs": 0.776,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 62.11,
      "observedSameFramePct": 62.1,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:0011",
      "searchText": "retro fighters - brawlergen usb retro fighters brawlergen usb retro fighters brawlergen usb wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 no 5.75 silver 05-10ms (gold) actively sold closed source mister / pc 0079:0011 buy link retro fighters brawlergen usb [wired usb] retro fighters - brawlergen usb retro fighters brawlergen usb [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 6 no 5.75 published published actively sold closed source retro fighters - brawlergen usb retro fighters brawlergen usb retro fighters brawlergen usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 5.75 silver 05-10ms (gold) actively sold closed source mister / pc 0079:0011 buy link retro fighters brawlergen usb [wired usb]",
      "controllerGroupKey": "published|retro fighters brawlergen usb",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retro-fighters-brawlergen-usb",
          "name": "Retro Fighters - brawlerGEN USB",
          "measurementName": "Retro Fighters brawlerGEN USB [Wired USB]",
          "averageMs": 6.315,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 62.11,
          "observedSameFramePct": 62.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 200,
          "modeRank": 73,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "5.75",
          "dateAdded": "6/12/2020",
          "dateAddedSort": "2020-06-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2TAxabZ",
          "link": "https://amzn.to/2TAxabZ",
          "amazon": "",
          "joystickId": "0079:0011",
          "searchText": "retro fighters - brawlergen usb retro fighters brawlergen usb retro fighters brawlergen usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 5.75 silver 05-10ms (gold) actively sold closed source mister / pc 0079:0011 buy link retro fighters brawlergen usb [wired usb]"
        }
      ]
    },
    {
      "id": "published-snk-neo-geo-arcade-stick-pro",
      "name": "SNK - Neo-Geo Arcade Stick Pro",
      "measurementName": "SNK Neo-Geo Arcade Stick Pro [Wired USB Dinput (PC2)]",
      "deviceNorm": "snk neo geo arcade stick pro",
      "make": "SNK",
      "model": "Neo-Geo Arcade Stick Pro",
      "link": "https://amzn.to/32pqPrI",
      "amazon": "",
      "buyUrl": "https://amzn.to/32pqPrI",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Dinput (PC2)",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 119,
      "modeRank": 19,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "8",
      "weightOz": "",
      "dateAdded": "12/17/2021",
      "dateAddedSort": "2021-12-17",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 6.736,
      "sdMs": 1.187,
      "maxMs": 9.16,
      "minMs": 4.32,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 59.58,
      "observedSameFramePct": 59.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "20bc:5501",
      "searchText": "snk - neo-geo arcade stick pro snk neo geo arcade stick pro snk neo-geo arcade stick pro wired usb wired wired usb dinput (pc2) dinput wired dinput dinput wired arcade stick wired arcade stick published published arcade stick 8 no silver 05-10ms (gold) actively sold closed source mister / pc 20bc:5501 buy link snk neo-geo arcade stick pro [wired usb dinput (pc2)] snk - neo-geo arcade stick pro snk neo-geo arcade stick pro [wired usb dinput (pc2)] wired usb wired wired wired usb dinput (pc2) dinput dinput dinput ['wired arcade stick'] wired arcade stick silver arcade stick 8 no published published actively sold closed source snk - neo-geo arcade stick pro snk neo geo arcade stick pro snk neo-geo arcade stick pro wired usb wired wired usb dinput (pc2) dinput wired dinput dinput wired arcade stick published published arcade stick 8 no silver 05-10ms (gold) actively sold closed source mister / pc 20bc:5501 buy link snk neo-geo arcade stick pro [wired usb dinput (pc2)] snk - neo-geo arcade stick pro snk neo-geo arcade stick pro [wired usb neo-geo mini] wired usb wired wired wired usb neo-geo mini dinput dinput dinput ['wired arcade stick'] wired arcade stick silver arcade stick 8 no published published actively sold closed source snk - neo-geo arcade stick pro snk neo geo arcade stick pro snk neo-geo arcade stick pro wired usb wired wired usb neo-geo mini dinput wired dinput dinput wired arcade stick published published arcade stick 8 no silver 05-10ms (gold) actively sold closed source mister / pc 20bc:5501 buy link snk neo-geo arcade stick pro [wired usb neo-geo mini]",
      "controllerGroupKey": "published|snk neo geo arcade stick pro",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-snk-neo-geo-arcade-stick-pro",
          "name": "SNK - Neo-Geo Arcade Stick Pro",
          "measurementName": "SNK Neo-Geo Arcade Stick Pro [Wired USB Dinput (PC2)]",
          "averageMs": 6.736,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 59.58,
          "observedSameFramePct": 59.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Dinput (PC2)",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 203,
          "modeRank": 31,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "12/17/2021",
          "dateAddedSort": "2021-12-17",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/32pqPrI",
          "link": "https://amzn.to/32pqPrI",
          "amazon": "",
          "joystickId": "20bc:5501",
          "searchText": "snk - neo-geo arcade stick pro snk neo geo arcade stick pro snk neo-geo arcade stick pro wired usb wired wired usb dinput (pc2) dinput wired dinput dinput wired arcade stick published published arcade stick 8 no silver 05-10ms (gold) actively sold closed source mister / pc 20bc:5501 buy link snk neo-geo arcade stick pro [wired usb dinput (pc2)]"
        },
        {
          "id": "published-snk-neo-geo-arcade-stick-pro-2",
          "name": "SNK - Neo-Geo Arcade Stick Pro",
          "measurementName": "SNK Neo-Geo Arcade Stick Pro [Wired USB Neo-Geo Mini]",
          "averageMs": 6.761,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 59.43,
          "observedSameFramePct": 59.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Neo-Geo Mini",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 205,
          "modeRank": 32,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "12/17/2021",
          "dateAddedSort": "2021-12-17",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/32pqPrI",
          "link": "https://amzn.to/32pqPrI",
          "amazon": "",
          "joystickId": "20bc:5501",
          "searchText": "snk - neo-geo arcade stick pro snk neo geo arcade stick pro snk neo-geo arcade stick pro wired usb wired wired usb neo-geo mini dinput wired dinput dinput wired arcade stick published published arcade stick 8 no silver 05-10ms (gold) actively sold closed source mister / pc 20bc:5501 buy link snk neo-geo arcade stick pro [wired usb neo-geo mini]"
        }
      ]
    },
    {
      "id": "published-powera-wired-controller-for-ps3",
      "name": "PowerA - Wired Controller for PS3",
      "measurementName": "PowerA Wired Controller for PS3 [Wired USB]",
      "deviceNorm": "powera wired controller for ps3",
      "make": "PowerA",
      "model": "Wired Controller for PS3",
      "link": "https://amzn.to/3ifnezq",
      "amazon": "",
      "buyUrl": "https://amzn.to/3ifnezq",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 120,
      "modeRank": 58,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "5.95",
      "dateAdded": "6/29/2020",
      "dateAddedSort": "2020-06-29",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 6.784,
      "sdMs": 2.32,
      "maxMs": 11.18,
      "minMs": 2.36,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 59.3,
      "observedSameFramePct": 59.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "20d6:ca6d",
      "searchText": "powera - wired controller for ps3 powera wired controller for ps3 powera wired controller for ps3 wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 yes 5.95 silver 05-10ms (gold) actively sold closed source mister / pc 20d6:ca6d buy link powera wired controller for ps3 [wired usb] powera - wired controller for ps3 powera wired controller for ps3 [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 4 yes 5.95 published published actively sold closed source powera - wired controller for ps3 powera wired controller for ps3 powera wired controller for ps3 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 5.95 silver 05-10ms (gold) actively sold closed source mister / pc 20d6:ca6d buy link powera wired controller for ps3 [wired usb]",
      "controllerGroupKey": "published|powera wired controller for ps3",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-powera-wired-controller-for-ps3",
          "name": "PowerA - Wired Controller for PS3",
          "measurementName": "PowerA Wired Controller for PS3 [Wired USB]",
          "averageMs": 6.784,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 59.3,
          "observedSameFramePct": 59.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 206,
          "modeRank": 74,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "5.95",
          "dateAdded": "6/29/2020",
          "dateAddedSort": "2020-06-29",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3ifnezq",
          "link": "https://amzn.to/3ifnezq",
          "amazon": "",
          "joystickId": "20d6:ca6d",
          "searchText": "powera - wired controller for ps3 powera wired controller for ps3 powera wired controller for ps3 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 5.95 silver 05-10ms (gold) actively sold closed source mister / pc 20d6:ca6d buy link powera wired controller for ps3 [wired usb]"
        }
      ]
    },
    {
      "id": "published-powera-wired-controller-for-switch",
      "name": "PowerA - Wired Controller for Switch",
      "measurementName": "PowerA Wired Controller for Switch [Wired USB]",
      "deviceNorm": "powera wired controller for switch",
      "make": "PowerA",
      "model": "Wired Controller for Switch",
      "link": "https://amzn.to/2YMKYDp",
      "amazon": "",
      "buyUrl": "https://amzn.to/2YMKYDp",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 121,
      "modeRank": 59,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "7.25",
      "dateAdded": "6/30/2020",
      "dateAddedSort": "2020-06-30",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 6.881,
      "sdMs": 2.324,
      "maxMs": 11.272,
      "minMs": 2.408,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 58.71,
      "observedSameFramePct": 58.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "20d6:a711",
      "searchText": "powera - wired controller for switch powera wired controller for switch powera wired controller for switch wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 yes 7.25 silver 05-10ms (gold) actively sold closed source mister / pc switch 20d6:a711 buy link powera wired controller for switch [wired usb] powera - wired controller for switch powera wired controller for switch [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 4 yes 7.25 published published actively sold closed source powera - wired controller for switch powera wired controller for switch powera wired controller for switch wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 7.25 silver 05-10ms (gold) actively sold closed source mister / pc switch 20d6:a711 buy link powera wired controller for switch [wired usb]",
      "controllerGroupKey": "published|powera wired controller for switch",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-powera-wired-controller-for-switch",
          "name": "PowerA - Wired Controller for Switch",
          "measurementName": "PowerA Wired Controller for Switch [Wired USB]",
          "averageMs": 6.881,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 58.71,
          "observedSameFramePct": 58.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 208,
          "modeRank": 75,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "7.25",
          "dateAdded": "6/30/2020",
          "dateAddedSort": "2020-06-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2YMKYDp",
          "link": "https://amzn.to/2YMKYDp",
          "amazon": "",
          "joystickId": "20d6:a711",
          "searchText": "powera - wired controller for switch powera wired controller for switch powera wired controller for switch wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 7.25 silver 05-10ms (gold) actively sold closed source mister / pc switch 20d6:a711 buy link powera wired controller for switch [wired usb]"
        }
      ]
    },
    {
      "id": "published-8bitdo-n64-mod-kit",
      "name": "8BitDo - N64 Mod Kit",
      "measurementName": "8BitDo N64 Mod Kit [Wired USB Dinput]",
      "deviceNorm": "8bitdo n64 mod kit",
      "make": "8BitDo",
      "model": "N64 Mod Kit",
      "link": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-n64-controller",
      "amazon": "",
      "buyUrl": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-n64-controller",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Dinput",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "USB",
      "rankMode": "Controller Conversion",
      "overallRank": 122,
      "modeRank": 2,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Conversion",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "3/19/2024",
      "dateAddedSort": "2024-03-19",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Conversion"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Bronze",
      "averageMs": 7.31,
      "sdMs": 3.127,
      "maxMs": 19.46,
      "minMs": 0.41,
      "p99Ms": 13.47,
      "sampleCount": 2198,
      "sameFramePct": 56.14,
      "observedSameFramePct": 56.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "2dc8:2869",
      "searchText": "8bitdo - n64 mod kit 8bitdo n64 mod kit 8bitdo n64 mod kit wired usb wired wired usb dinput dinput wired dinput usb controller conversion controller conversion published published controller conversion - no silver bronze 05-10ms (gold) actively sold closed source mister / pc 2dc8:2869 raw capture buy link 8bitdo n64 mod kit [wired usb dinput] 8bitdo - n64 mod kit 8bitdo n64 mod kit [wired usb dinput] wired usb wired wired wired usb dinput dinput dinput usb ['controller conversion'] controller conversion silver bronze controller conversion - no published published actively sold closed source 8bitdo - n64 mod kit 8bitdo n64 mod kit 8bitdo n64 mod kit wired usb wired wired usb dinput dinput wired dinput usb controller conversion published published controller conversion - no silver bronze 05-10ms (gold) actively sold closed source mister / pc 2dc8:2869 raw capture buy link 8bitdo n64 mod kit [wired usb dinput] 8bitdo - n64 mod kit 8bitdo n64 mod kit [bt (csr8510) direct input] bluetooth wireless wireless bt bt (csr8510) direct input dinput dinput usb ['controller conversion'] controller conversion silver controller conversion - no published published actively sold closed source 8bitdo - n64 mod kit 8bitdo n64 mod kit 8bitdo n64 mod kit bluetooth wireless bt (csr8510) direct input dinput wireless bt dinput usb controller conversion published published controller conversion - no silver 05-10ms (gold) actively sold closed source mister / pc 2dc8:2869 buy link 8bitdo n64 mod kit [bt (csr8510) direct input] 8bitdo - n64 mod kit 8bitdo - n64 mod kit [wireless dinput] wireless wireless wireless wireless dinput dinput dinput dinput ['wireless controller'] wireless controller silver copper controller published published actively sold closed source 8bitdo - n64 mod kit 8bitdo n64 mod kit 8bitdo n64 mod kit wireless wireless wireless dinput dinput wireless dinput dinput wireless controller published published controller silver copper 05-10ms (gold) actively sold closed source mister / pc raw capture buy link 8bitdo - n64 mod kit [wireless dinput] 8bitdo - n64 mod kit 8bitdo n64 mod kit [bt (csr8510) switch] bluetooth wireless wireless bt bt (csr8510) switch switch switch switch ['controller conversion'] controller conversion bronze controller conversion - no published published actively sold closed source 8bitdo - n64 mod kit 8bitdo n64 mod kit 8bitdo n64 mod kit bluetooth wireless bt (csr8510) switch switch wireless bt switch switch controller conversion published published controller conversion - no bronze 10-15ms (silver) actively sold closed source mister / pc switch 057e:2019 buy link 8bitdo n64 mod kit [bt (csr8510) switch] 8bitdo - n64 mod kit 8bitdo - n64 mod kit [wireless switch] wireless wireless wireless wireless switch switch switch switch ['wireless controller'] wireless controller bronze copper controller published published actively sold closed source 8bitdo - n64 mod kit 8bitdo n64 mod kit 8bitdo n64 mod kit wireless wireless wireless switch switch wireless switch switch wireless controller published published controller bronze copper 10-15ms (silver) actively sold closed source mister / pc raw capture buy link 8bitdo - n64 mod kit [wireless switch]",
      "controllerGroupKey": "published|8bitdo n64 mod kit",
      "modeVariantCount": 5,
      "modeVariants": [
        {
          "id": "published-8bitdo-n64-mod-kit",
          "name": "8BitDo - N64 Mod Kit",
          "measurementName": "8BitDo N64 Mod Kit [Wired USB Dinput]",
          "averageMs": 7.31,
          "averageTier": "Silver",
          "p99Ms": 13.47,
          "p99Tier": "Bronze",
          "sameFramePct": 56.14,
          "observedSameFramePct": 56.2,
          "sampleCount": 2198,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "USB",
          "deviceTypes": [
            "Controller Conversion"
          ],
          "rankMode": "Controller Conversion",
          "overallRank": 210,
          "modeRank": 7,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Conversion",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "3/19/2024",
          "dateAddedSort": "2024-03-19",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-n64-controller",
          "link": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-n64-controller",
          "amazon": "",
          "joystickId": "2dc8:2869",
          "searchText": "8bitdo - n64 mod kit 8bitdo n64 mod kit 8bitdo n64 mod kit wired usb wired wired usb dinput dinput wired dinput usb controller conversion published published controller conversion - no silver bronze 05-10ms (gold) actively sold closed source mister / pc 2dc8:2869 raw capture buy link 8bitdo n64 mod kit [wired usb dinput]"
        },
        {
          "id": "published-8bitdo-n64-mod-kit-2",
          "name": "8BitDo - N64 Mod Kit",
          "measurementName": "8BitDo N64 Mod Kit [BT (CSR8510) Direct Input]",
          "averageMs": 9.03,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 45.82,
          "observedSameFramePct": 46.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Direct Input",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "USB",
          "deviceTypes": [
            "Controller Conversion"
          ],
          "rankMode": "Controller Conversion",
          "overallRank": 224,
          "modeRank": 8,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Conversion",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "3/19/2024",
          "dateAddedSort": "2024-03-19",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-n64-controller",
          "link": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-n64-controller",
          "amazon": "",
          "joystickId": "2dc8:2869",
          "searchText": "8bitdo - n64 mod kit 8bitdo n64 mod kit 8bitdo n64 mod kit bluetooth wireless bt (csr8510) direct input dinput wireless bt dinput usb controller conversion published published controller conversion - no silver 05-10ms (gold) actively sold closed source mister / pc 2dc8:2869 buy link 8bitdo n64 mod kit [bt (csr8510) direct input]"
        },
        {
          "id": "published-8bitdo-n64-mod-kit-3",
          "name": "8BitDo - N64 Mod Kit",
          "measurementName": "8BitDo - N64 Mod Kit [Wireless Dinput]",
          "averageMs": 9.034,
          "averageTier": "Silver",
          "p99Ms": 21.114,
          "p99Tier": "Copper",
          "sameFramePct": 45.8,
          "observedSameFramePct": 46.9,
          "sampleCount": 2711,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless",
          "modeRaw": "Wireless Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 225,
          "modeRank": 22,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-n64-controller",
          "link": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-n64-controller",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - n64 mod kit 8bitdo n64 mod kit 8bitdo n64 mod kit wireless wireless wireless dinput dinput wireless dinput dinput wireless controller published published controller silver copper 05-10ms (gold) actively sold closed source mister / pc raw capture buy link 8bitdo - n64 mod kit [wireless dinput]"
        },
        {
          "id": "published-8bitdo-n64-mod-kit-4",
          "name": "8BitDo - N64 Mod Kit",
          "measurementName": "8BitDo N64 Mod Kit [BT (CSR8510) Switch]",
          "averageMs": 11.6,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 30.4,
          "observedSameFramePct": 33.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Switch",
          "outputMode": "Switch",
          "modeLabel": "Switch",
          "modeDisplay": "Switch",
          "deviceTypes": [
            "Controller Conversion"
          ],
          "rankMode": "Controller Conversion",
          "overallRank": 261,
          "modeRank": 9,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Conversion",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "3/19/2024",
          "dateAddedSort": "2024-03-19",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-n64-controller",
          "link": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-n64-controller",
          "amazon": "",
          "joystickId": "057e:2019",
          "searchText": "8bitdo - n64 mod kit 8bitdo n64 mod kit 8bitdo n64 mod kit bluetooth wireless bt (csr8510) switch switch wireless bt switch switch controller conversion published published controller conversion - no bronze 10-15ms (silver) actively sold closed source mister / pc switch 057e:2019 buy link 8bitdo n64 mod kit [bt (csr8510) switch]"
        },
        {
          "id": "published-8bitdo-n64-mod-kit-5",
          "name": "8BitDo - N64 Mod Kit",
          "measurementName": "8BitDo - N64 Mod Kit [Wireless Switch]",
          "averageMs": 11.6,
          "averageTier": "Bronze",
          "p99Ms": 25.929,
          "p99Tier": "Copper",
          "sameFramePct": 30.4,
          "observedSameFramePct": 33.1,
          "sampleCount": 2769,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless",
          "modeRaw": "Wireless Switch",
          "outputMode": "Switch",
          "modeLabel": "Switch",
          "modeDisplay": "Switch",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 262,
          "modeRank": 40,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-n64-controller",
          "link": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-n64-controller",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - n64 mod kit 8bitdo n64 mod kit 8bitdo n64 mod kit wireless wireless wireless switch switch wireless switch switch wireless controller published published controller bronze copper 10-15ms (silver) actively sold closed source mister / pc raw capture buy link 8bitdo - n64 mod kit [wireless switch]"
        }
      ]
    },
    {
      "id": "published-8bitdo-arcade-stick-for-switch-and-windows",
      "name": "8BitDo - Arcade Stick for Switch and Windows",
      "measurementName": "8BitDo Arcade Stick for Switch and Windows [BT (CSR8510)]",
      "deviceNorm": "8bitdo arcade stick for switch and windows",
      "make": "8BitDo",
      "model": "Arcade Stick for Switch and Windows",
      "link": "https://amzn.to/3o5oCHd",
      "amazon": "",
      "buyUrl": "https://amzn.to/3o5oCHd",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT (CSR8510)",
      "outputMode": "",
      "connectionTag": "Wireless BT",
      "modeLabel": "Bluetooth",
      "modeDisplay": "Bluetooth",
      "rankMode": "Wireless Arcade Stick",
      "overallRank": 123,
      "modeRank": 2,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "8",
      "weightOz": "",
      "dateAdded": "11/27/2020",
      "dateAddedSort": "2020-11-27",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wireless Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 7.363,
      "sdMs": 2.017,
      "maxMs": 18.8,
      "minMs": 2.284,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 55.82,
      "observedSameFramePct": 55.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "8bitdo - arcade stick for switch and windows 8bitdo arcade stick for switch and windows 8bitdo arcade stick for switch and windows bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless arcade stick wireless arcade stick published published arcade stick 8 yes silver 05-10ms (gold) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo arcade stick for switch and windows [bt (csr8510)] 8bitdo - arcade stick for switch and windows 8bitdo arcade stick for switch and windows [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless arcade stick'] wireless arcade stick silver arcade stick 8 yes published published actively sold closed source 8bitdo - arcade stick for switch and windows 8bitdo arcade stick for switch and windows 8bitdo arcade stick for switch and windows bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless arcade stick published published arcade stick 8 yes silver 05-10ms (gold) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo arcade stick for switch and windows [bt (csr8510)] 8bitdo - arcade stick for switch and windows 8bitdo arcade stick for switch and windows [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired arcade stick'] wired arcade stick bronze arcade stick 8 yes published published actively sold closed source 8bitdo - arcade stick for switch and windows 8bitdo arcade stick for switch and windows 8bitdo arcade stick for switch and windows wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes bronze 10-15ms (silver) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo arcade stick for switch and windows [wired usb] 8bitdo - arcade stick for switch and windows 8bitdo arcade stick for switch and windows [2.4ghz usb] 2.4 ghz usb wireless wireless 2.4ghz 2.4ghz usb dinput dinput dinput ['wireless arcade stick'] wireless arcade stick bronze arcade stick 8 yes published published actively sold closed source 8bitdo - arcade stick for switch and windows 8bitdo arcade stick for switch and windows 8bitdo arcade stick for switch and windows 2.4 ghz usb wireless 2.4ghz usb dinput wireless 2.4ghz dinput dinput wireless arcade stick published published arcade stick 8 yes bronze 10-15ms (silver) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo arcade stick for switch and windows [2.4ghz usb]",
      "controllerGroupKey": "published|8bitdo arcade stick for switch and windows",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-8bitdo-arcade-stick-for-switch-and-windows",
          "name": "8BitDo - Arcade Stick for Switch and Windows",
          "measurementName": "8BitDo Arcade Stick for Switch and Windows [BT (CSR8510)]",
          "averageMs": 7.363,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 55.82,
          "observedSameFramePct": 55.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Arcade Stick"
          ],
          "rankMode": "Wireless Arcade Stick",
          "overallRank": 211,
          "modeRank": 3,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "11/27/2020",
          "dateAddedSort": "2020-11-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3o5oCHd",
          "link": "https://amzn.to/3o5oCHd",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - arcade stick for switch and windows 8bitdo arcade stick for switch and windows 8bitdo arcade stick for switch and windows bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless arcade stick published published arcade stick 8 yes silver 05-10ms (gold) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo arcade stick for switch and windows [bt (csr8510)]"
        },
        {
          "id": "published-8bitdo-arcade-stick-for-switch-and-windows-2",
          "name": "8BitDo - Arcade Stick for Switch and Windows",
          "measurementName": "8BitDo Arcade Stick for Switch and Windows [Wired USB]",
          "averageMs": 10.863,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 34.82,
          "observedSameFramePct": 35.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 249,
          "modeRank": 36,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "11/27/2020",
          "dateAddedSort": "2020-11-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3o5oCHd",
          "link": "https://amzn.to/3o5oCHd",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - arcade stick for switch and windows 8bitdo arcade stick for switch and windows 8bitdo arcade stick for switch and windows wired usb wired wired usb dinput wired dinput dinput wired arcade stick published published arcade stick 8 yes bronze 10-15ms (silver) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo arcade stick for switch and windows [wired usb]"
        },
        {
          "id": "published-8bitdo-arcade-stick-for-switch-and-windows-3",
          "name": "8BitDo - Arcade Stick for Switch and Windows",
          "measurementName": "8BitDo Arcade Stick for Switch and Windows [2.4GHz USB]",
          "averageMs": 11.102,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 33.39,
          "observedSameFramePct": 33.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "2.4GHz USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Arcade Stick"
          ],
          "rankMode": "Wireless Arcade Stick",
          "overallRank": 253,
          "modeRank": 5,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "8",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "11/27/2020",
          "dateAddedSort": "2020-11-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3o5oCHd",
          "link": "https://amzn.to/3o5oCHd",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "8bitdo - arcade stick for switch and windows 8bitdo arcade stick for switch and windows 8bitdo arcade stick for switch and windows 2.4 ghz usb wireless 2.4ghz usb dinput wireless 2.4ghz dinput dinput wireless arcade stick published published arcade stick 8 yes bronze 10-15ms (silver) actively sold closed source mister / pc switch 045e:028e buy link 8bitdo arcade stick for switch and windows [2.4ghz usb]"
        }
      ]
    },
    {
      "id": "published-yok-playstation-classic-wireless-controller",
      "name": "YoK - Playstation Classic Wireless Controller",
      "measurementName": "YoK Playstation Classic Wireless Controller [Wireless USB Dongle]",
      "deviceNorm": "yok playstation classic wireless controller",
      "make": "YoK",
      "model": "Playstation Classic Wireless Controller",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "2.4 GHz USB",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "Wireless USB Dongle",
      "outputMode": "DInput",
      "connectionTag": "Wireless 2.4GHz",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wireless Controller",
      "overallRank": 124,
      "modeRank": 4,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "5.35",
      "dateAdded": "8/14/2020",
      "dateAddedSort": "2020-08-14",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 7.42,
      "sdMs": 2.374,
      "maxMs": 18.684,
      "minMs": 2.988,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 55.48,
      "observedSameFramePct": 55.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "054c:0cda",
      "searchText": "yok - playstation classic wireless controller yok playstation classic wireless controller yok playstation classic wireless controller 2.4 ghz usb wireless wireless usb dongle dinput wireless 2.4ghz dinput dinput wireless controller wireless controller published published controller 4 yes 5.35 silver 05-10ms (gold) unknown closed source mister / pc 054c:0cda yok playstation classic wireless controller [wireless usb dongle] yok - playstation classic wireless controller yok playstation classic wireless controller [wireless usb dongle] 2.4 ghz usb wireless wireless 2.4ghz wireless usb dongle dinput dinput dinput ['wireless controller'] wireless controller silver controller 4 yes 5.35 published published unknown closed source yok - playstation classic wireless controller yok playstation classic wireless controller yok playstation classic wireless controller 2.4 ghz usb wireless wireless usb dongle dinput wireless 2.4ghz dinput dinput wireless controller published published controller 4 yes 5.35 silver 05-10ms (gold) unknown closed source mister / pc 054c:0cda yok playstation classic wireless controller [wireless usb dongle]",
      "controllerGroupKey": "published|yok playstation classic wireless controller",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-yok-playstation-classic-wireless-controller",
          "name": "YoK - Playstation Classic Wireless Controller",
          "measurementName": "YoK Playstation Classic Wireless Controller [Wireless USB Dongle]",
          "averageMs": 7.42,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 55.48,
          "observedSameFramePct": 55.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Wireless USB Dongle",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 212,
          "modeRank": 16,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "5.35",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "054c:0cda",
          "searchText": "yok - playstation classic wireless controller yok playstation classic wireless controller yok playstation classic wireless controller 2.4 ghz usb wireless wireless usb dongle dinput wireless 2.4ghz dinput dinput wireless controller published published controller 4 yes 5.35 silver 05-10ms (gold) unknown closed source mister / pc 054c:0cda yok playstation classic wireless controller [wireless usb dongle]"
        }
      ]
    },
    {
      "id": "published-razer-raion",
      "name": "Razer - Raion",
      "measurementName": "Razer - Raion [PC]",
      "deviceNorm": "razer raion",
      "make": "Razer",
      "model": "Raion",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "PC",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 125,
      "modeRank": 20,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Bronze",
      "averageMs": 7.627,
      "sdMs": 3.529,
      "maxMs": 14.1,
      "minMs": 1.28,
      "p99Ms": 13.774,
      "sampleCount": 2266,
      "sameFramePct": 54.24,
      "observedSameFramePct": 54.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "razer - raion razer raion razer raion wired usb wired pc dinput wired dinput dinput wired arcade stick wired arcade stick published published arcade stick silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture razer - raion [pc] razer - raion razer - raion [pc] wired usb wired wired pc dinput dinput dinput ['wired arcade stick'] wired arcade stick silver bronze arcade stick published published unknown closed source razer - raion razer raion razer raion wired usb wired pc dinput wired dinput dinput wired arcade stick published published arcade stick silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture razer - raion [pc] razer - raion razer - raion [ps4] wired usb wired wired ps4 ps4 ps4 ps4 ['wired arcade stick'] wired arcade stick silver bronze arcade stick published published unknown closed source razer - raion razer raion razer raion wired usb wired ps4 ps4 wired ps4 ps4 wired arcade stick published published arcade stick silver bronze 05-10ms (gold) unknown closed source mister / pc ps4 raw capture razer - raion [ps4]",
      "controllerGroupKey": "published|razer raion",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-razer-raion",
          "name": "Razer - Raion",
          "measurementName": "Razer - Raion [PC]",
          "averageMs": 7.627,
          "averageTier": "Silver",
          "p99Ms": 13.774,
          "p99Tier": "Bronze",
          "sameFramePct": 54.24,
          "observedSameFramePct": 54.2,
          "sampleCount": 2266,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "PC",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 216,
          "modeRank": 33,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "razer - raion razer raion razer raion wired usb wired pc dinput wired dinput dinput wired arcade stick published published arcade stick silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture razer - raion [pc]"
        },
        {
          "id": "published-razer-raion-2",
          "name": "Razer - Raion",
          "measurementName": "Razer - Raion [PS4]",
          "averageMs": 7.656,
          "averageTier": "Silver",
          "p99Ms": 13.72,
          "p99Tier": "Bronze",
          "sameFramePct": 54.06,
          "observedSameFramePct": 54.1,
          "sampleCount": 2139,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "PS4",
          "outputMode": "PS4",
          "modeLabel": "PS4",
          "modeDisplay": "PS4",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 217,
          "modeRank": 34,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "razer - raion razer raion razer raion wired usb wired ps4 ps4 wired ps4 ps4 wired arcade stick published published arcade stick silver bronze 05-10ms (gold) unknown closed source mister / pc ps4 raw capture razer - raion [ps4]"
        }
      ]
    },
    {
      "id": "published-google-stadia",
      "name": "Google - Stadia",
      "measurementName": "Google - Stadia [Wired USB]",
      "deviceNorm": "google stadia",
      "make": "Google",
      "model": "Stadia",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 126,
      "modeRank": 60,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Bronze",
      "averageMs": 7.83,
      "sdMs": 4.639,
      "maxMs": 16.23,
      "minMs": 0.14,
      "p99Ms": 16.06,
      "sampleCount": 2275,
      "sameFramePct": 53.02,
      "observedSameFramePct": 53.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "04f2:0833",
      "searchText": "google - stadia google stadia google stadia wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc 04f2:0833 raw capture google - stadia [wired usb] google - stadia google - stadia [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver bronze controller published published unknown closed source google - stadia google stadia google stadia wired usb wired wired usb dinput wired dinput dinput wired controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc 04f2:0833 raw capture google - stadia [wired usb] google - stadia google - stadia [bt] bluetooth wireless wireless bt bt bluetooth bluetooth ['wireless controller'] wireless controller bronze copper controller published published unknown closed source google - stadia google stadia google stadia bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc 18d1:9400 raw capture google - stadia [bt]",
      "controllerGroupKey": "published|google stadia",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-google-stadia",
          "name": "Google - Stadia",
          "measurementName": "Google - Stadia [Wired USB]",
          "averageMs": 7.83,
          "averageTier": "Silver",
          "p99Ms": 16.06,
          "p99Tier": "Bronze",
          "sameFramePct": 53.02,
          "observedSameFramePct": 53.0,
          "sampleCount": 2275,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 218,
          "modeRank": 76,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "04f2:0833",
          "searchText": "google - stadia google stadia google stadia wired usb wired wired usb dinput wired dinput dinput wired controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc 04f2:0833 raw capture google - stadia [wired usb]"
        },
        {
          "id": "published-google-stadia-2",
          "name": "Google - Stadia",
          "measurementName": "Google - Stadia [BT]",
          "averageMs": 14.805,
          "averageTier": "Bronze",
          "p99Ms": 32.421,
          "p99Tier": "Copper",
          "sameFramePct": 11.17,
          "observedSameFramePct": 39.5,
          "sampleCount": 2665,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 279,
          "modeRank": 52,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "18d1:9400",
          "searchText": "google - stadia google stadia google stadia bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc 18d1:9400 raw capture google - stadia [bt]"
        }
      ]
    },
    {
      "id": "published-mayflash-ss-controller-adapter",
      "name": "Mayflash - SS Controller Adapter",
      "measurementName": "Mayflash SS Controller Adapter [Wired USB Dinput]",
      "deviceNorm": "mayflash ss controller adapter",
      "make": "Mayflash",
      "model": "SS Controller Adapter",
      "link": "https://amzn.to/2LXQyeW",
      "amazon": "",
      "buyUrl": "https://amzn.to/2LXQyeW",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Dinput",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 127,
      "modeRank": 22,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "5/26/2020",
      "dateAddedSort": "2020-05-26",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 7.998,
      "sdMs": 1.247,
      "maxMs": 10.576,
      "minMs": 5.52,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 52.01,
      "observedSameFramePct": 52.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:187a",
      "searchText": "mayflash - ss controller adapter mayflash ss controller adapter mayflash ss controller adapter wired usb wired wired usb dinput dinput wired dinput dinput controller adapter controller adapter published published controller adapter - no - silver 05-10ms (gold) actively sold closed source mister / pc 0079:187a buy link mayflash ss controller adapter [wired usb dinput] mayflash - ss controller adapter mayflash ss controller adapter [wired usb dinput] wired usb wired wired wired usb dinput dinput dinput dinput ['controller adapter'] controller adapter silver controller adapter - no - published published actively sold closed source mayflash - ss controller adapter mayflash ss controller adapter mayflash ss controller adapter wired usb wired wired usb dinput dinput wired dinput dinput controller adapter published published controller adapter - no - silver 05-10ms (gold) actively sold closed source mister / pc 0079:187a buy link mayflash ss controller adapter [wired usb dinput] mayflash - ss controller adapter mayflash ss controller adapter [wired usb xinput] wired usb wired wired wired usb xinput dinput, xinput dinput, xinput dinput, xinput ['controller adapter'] controller adapter silver controller adapter - no - published published actively sold closed source mayflash - ss controller adapter mayflash ss controller adapter mayflash ss controller adapter wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput controller adapter published published controller adapter - no - silver 05-10ms (gold) actively sold closed source mister / pc 0079:187b buy link mayflash ss controller adapter [wired usb xinput]",
      "controllerGroupKey": "published|mayflash ss controller adapter",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-mayflash-ss-controller-adapter",
          "name": "Mayflash - SS Controller Adapter",
          "measurementName": "Mayflash SS Controller Adapter [Wired USB Dinput]",
          "averageMs": 7.998,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 52.01,
          "observedSameFramePct": 52.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 219,
          "modeRank": 59,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "5/26/2020",
          "dateAddedSort": "2020-05-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2LXQyeW",
          "link": "https://amzn.to/2LXQyeW",
          "amazon": "",
          "joystickId": "0079:187a",
          "searchText": "mayflash - ss controller adapter mayflash ss controller adapter mayflash ss controller adapter wired usb wired wired usb dinput dinput wired dinput dinput controller adapter published published controller adapter - no - silver 05-10ms (gold) actively sold closed source mister / pc 0079:187a buy link mayflash ss controller adapter [wired usb dinput]"
        },
        {
          "id": "published-mayflash-ss-controller-adapter-2",
          "name": "Mayflash - SS Controller Adapter",
          "measurementName": "Mayflash SS Controller Adapter [Wired USB Xinput]",
          "averageMs": 8.001,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 51.99,
          "observedSameFramePct": 52.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB Xinput",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Controller Adapter"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 220,
          "modeRank": 60,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "5/26/2020",
          "dateAddedSort": "2020-05-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2LXQyeW",
          "link": "https://amzn.to/2LXQyeW",
          "amazon": "",
          "joystickId": "0079:187b",
          "searchText": "mayflash - ss controller adapter mayflash ss controller adapter mayflash ss controller adapter wired usb wired wired usb xinput dinput, xinput wired dinput, xinput dinput, xinput controller adapter published published controller adapter - no - silver 05-10ms (gold) actively sold closed source mister / pc 0079:187b buy link mayflash ss controller adapter [wired usb xinput]"
        }
      ]
    },
    {
      "id": "published-retro-bit-tribute-64-wired-usb-controller",
      "name": "Retro-Bit - Tribute 64 Wired USB Controller",
      "measurementName": "Retro-Bit Tribute 64 Wired USB Controller [Wired USB]",
      "deviceNorm": "retro bit tribute 64 wired usb controller",
      "make": "Retro-Bit",
      "model": "Tribute 64 Wired USB Controller",
      "link": "https://amzn.to/31wuiSh",
      "amazon": "",
      "buyUrl": "https://amzn.to/31wuiSh",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 128,
      "modeRank": 61,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "5.00",
      "dateAdded": "6/30/2020",
      "dateAddedSort": "2020-06-30",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 8.593,
      "sdMs": 2.855,
      "maxMs": 13.956,
      "minMs": 3.132,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 48.44,
      "observedSameFramePct": 48.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "2563:0575",
      "searchText": "retro-bit - tribute 64 wired usb controller retro bit tribute 64 wired usb controller retro-bit tribute 64 wired usb controller wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 no 5.00 silver 05-10ms (gold) actively sold closed source mister / pc 2563:0575 buy link retro-bit tribute 64 wired usb controller [wired usb] retro-bit - tribute 64 wired usb controller retro-bit tribute 64 wired usb controller [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 6 no 5.00 published published actively sold closed source retro-bit - tribute 64 wired usb controller retro bit tribute 64 wired usb controller retro-bit tribute 64 wired usb controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 5.00 silver 05-10ms (gold) actively sold closed source mister / pc 2563:0575 buy link retro-bit tribute 64 wired usb controller [wired usb]",
      "controllerGroupKey": "published|retro bit tribute 64 wired usb controller",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retro-bit-tribute-64-wired-usb-controller",
          "name": "Retro-Bit - Tribute 64 Wired USB Controller",
          "measurementName": "Retro-Bit Tribute 64 Wired USB Controller [Wired USB]",
          "averageMs": 8.593,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 48.44,
          "observedSameFramePct": 48.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 221,
          "modeRank": 77,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "5.00",
          "dateAdded": "6/30/2020",
          "dateAddedSort": "2020-06-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/31wuiSh",
          "link": "https://amzn.to/31wuiSh",
          "amazon": "",
          "joystickId": "2563:0575",
          "searchText": "retro-bit - tribute 64 wired usb controller retro bit tribute 64 wired usb controller retro-bit tribute 64 wired usb controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 5.00 silver 05-10ms (gold) actively sold closed source mister / pc 2563:0575 buy link retro-bit tribute 64 wired usb controller [wired usb]"
        }
      ]
    },
    {
      "id": "published-8bitdo-sn30-2-4g-snes-classic-model-81aa",
      "name": "8BitDo - SN30 2.4G SNES Classic (Model 81AA)",
      "measurementName": "8BitDo SN30 2.4G SNES Classic (Model 81AA) [Raphnet Wii Classic]",
      "deviceNorm": "8bitdo sn30 2 4g snes classic model 81aa",
      "make": "8BitDo",
      "model": "SN30 2.4G SNES Classic (Model 81AA)",
      "link": "https://amzn.to/2CMLQPO",
      "amazon": "",
      "buyUrl": "https://amzn.to/2CMLQPO",
      "connection": "2.4 GHz Console",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "Raphnet Wii Classic",
      "outputMode": "",
      "connectionTag": "Wireless 2.4GHz",
      "modeLabel": "2.4G",
      "modeDisplay": "2.4 GHz Console",
      "rankMode": "Wireless Controller",
      "overallRank": 129,
      "modeRank": 5,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "",
      "dateAdded": "6/29/2020",
      "dateAddedSort": "2020-06-29",
      "platforms": [],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 8.599,
      "sdMs": 3.035,
      "maxMs": 31.272,
      "minMs": 2.676,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 48.41,
      "observedSameFramePct": 48.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "289b:0080",
      "searchText": "8bitdo - sn30 2.4g snes classic (model 81aa) 8bitdo sn30 2 4g snes classic model 81aa 8bitdo sn30 2.4g snes classic (model 81aa) 2.4 ghz console wireless raphnet wii classic wireless 2.4ghz 2.4g 2.4 ghz console wireless controller wireless controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source 289b:0080 buy link 8bitdo sn30 2.4g snes classic (model 81aa) [raphnet wii classic] 8bitdo - sn30 2.4g snes classic (model 81aa) 8bitdo sn30 2.4g snes classic (model 81aa) [raphnet wii classic] 2.4 ghz console wireless wireless 2.4ghz raphnet wii classic 2.4g 2.4 ghz console ['wireless controller'] wireless controller silver controller 4 yes published published actively sold closed source 8bitdo - sn30 2.4g snes classic (model 81aa) 8bitdo sn30 2 4g snes classic model 81aa 8bitdo sn30 2.4g snes classic (model 81aa) 2.4 ghz console wireless raphnet wii classic wireless 2.4ghz 2.4g 2.4 ghz console wireless controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source 289b:0080 buy link 8bitdo sn30 2.4g snes classic (model 81aa) [raphnet wii classic]",
      "controllerGroupKey": "published|8bitdo sn30 2 4g snes classic model 81aa",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-8bitdo-sn30-2-4g-snes-classic-model-81aa",
          "name": "8BitDo - SN30 2.4G SNES Classic (Model 81AA)",
          "measurementName": "8BitDo SN30 2.4G SNES Classic (Model 81AA) [Raphnet Wii Classic]",
          "averageMs": 8.599,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 48.41,
          "observedSameFramePct": 48.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz Console",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Raphnet Wii Classic",
          "outputMode": "",
          "modeLabel": "2.4G",
          "modeDisplay": "2.4 GHz Console",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 222,
          "modeRank": 20,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "6/29/2020",
          "dateAddedSort": "2020-06-29",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2CMLQPO",
          "link": "https://amzn.to/2CMLQPO",
          "amazon": "",
          "joystickId": "289b:0080",
          "searchText": "8bitdo - sn30 2.4g snes classic (model 81aa) 8bitdo sn30 2 4g snes classic model 81aa 8bitdo sn30 2.4g snes classic (model 81aa) 2.4 ghz console wireless raphnet wii classic wireless 2.4ghz 2.4g 2.4 ghz console wireless controller published published controller 4 yes silver 05-10ms (gold) actively sold closed source 289b:0080 buy link 8bitdo sn30 2.4g snes classic (model 81aa) [raphnet wii classic]"
        }
      ]
    },
    {
      "id": "published-retro-bit-sega-saturn-2-4ghz-wireless-pro-controller",
      "name": "Retro-Bit - Sega Saturn 2.4GHz Wireless Pro Controller",
      "measurementName": "Retro-Bit - Sega Saturn 2.4GHz Wireless Pro Controller [Xinput]",
      "deviceNorm": "retro bit sega saturn 2 4ghz wireless pro controller",
      "make": "Retro-Bit",
      "model": "Sega Saturn 2.4GHz Wireless Pro Controller",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "2.4GHz Wireless",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "Xinput",
      "outputMode": "XInput",
      "connectionTag": "Wireless 2.4GHz",
      "modeLabel": "XInput",
      "modeDisplay": "XInput",
      "rankMode": "Wireless Controller",
      "overallRank": 130,
      "modeRank": 6,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC",
        "Xbox One",
        "Xbox Series"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Bronze",
      "averageMs": 8.774,
      "sdMs": 1.44,
      "maxMs": 12.64,
      "minMs": 5.11,
      "p99Ms": 11.86,
      "sampleCount": 2394,
      "sameFramePct": 47.36,
      "observedSameFramePct": 47.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:028e",
      "searchText": "retro-bit - sega saturn 2.4ghz wireless pro controller retro bit sega saturn 2 4ghz wireless pro controller retro-bit sega saturn 2.4ghz wireless pro controller 2.4ghz wireless wireless xinput xinput wireless 2.4ghz xinput xinput wireless controller wireless controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc xbox one xbox series 045e:028e raw capture retro-bit - sega saturn 2.4ghz wireless pro controller [xinput] retro-bit - sega saturn 2.4ghz wireless pro controller retro-bit - sega saturn 2.4ghz wireless pro controller [xinput] 2.4ghz wireless wireless wireless 2.4ghz xinput xinput xinput xinput ['wireless controller'] wireless controller silver bronze controller published published unknown closed source retro-bit - sega saturn 2.4ghz wireless pro controller retro bit sega saturn 2 4ghz wireless pro controller retro-bit sega saturn 2.4ghz wireless pro controller 2.4ghz wireless wireless xinput xinput wireless 2.4ghz xinput xinput wireless controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc xbox one xbox series 045e:028e raw capture retro-bit - sega saturn 2.4ghz wireless pro controller [xinput] retro-bit - sega saturn 2.4ghz wireless pro controller retro-bit - sega saturn 2.4ghz wireless pro controller [dinput] 2.4ghz wireless wireless wireless 2.4ghz dinput dinput dinput dinput ['wireless controller'] wireless controller bronze copper controller published published unknown closed source retro-bit - sega saturn 2.4ghz wireless pro controller retro bit sega saturn 2 4ghz wireless pro controller retro-bit sega saturn 2.4ghz wireless pro controller 2.4ghz wireless wireless dinput dinput wireless 2.4ghz dinput dinput wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc 2563:0575 raw capture retro-bit - sega saturn 2.4ghz wireless pro controller [dinput]",
      "controllerGroupKey": "published|retro bit sega saturn 2 4ghz wireless pro controller",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-retro-bit-sega-saturn-2-4ghz-wireless-pro-controller",
          "name": "Retro-Bit - Sega Saturn 2.4GHz Wireless Pro Controller",
          "measurementName": "Retro-Bit - Sega Saturn 2.4GHz Wireless Pro Controller [Xinput]",
          "averageMs": 8.774,
          "averageTier": "Silver",
          "p99Ms": 11.86,
          "p99Tier": "Bronze",
          "sameFramePct": 47.36,
          "observedSameFramePct": 47.4,
          "sampleCount": 2394,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4GHz Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Xinput",
          "outputMode": "XInput",
          "modeLabel": "XInput",
          "modeDisplay": "XInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 223,
          "modeRank": 21,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "retro-bit - sega saturn 2.4ghz wireless pro controller retro bit sega saturn 2 4ghz wireless pro controller retro-bit sega saturn 2.4ghz wireless pro controller 2.4ghz wireless wireless xinput xinput wireless 2.4ghz xinput xinput wireless controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc xbox one xbox series 045e:028e raw capture retro-bit - sega saturn 2.4ghz wireless pro controller [xinput]"
        },
        {
          "id": "published-retro-bit-sega-saturn-2-4ghz-wireless-pro-controller-2",
          "name": "Retro-Bit - Sega Saturn 2.4GHz Wireless Pro Controller",
          "measurementName": "Retro-Bit - Sega Saturn 2.4GHz Wireless Pro Controller [Dinput]",
          "averageMs": 14.672,
          "averageTier": "Bronze",
          "p99Ms": 19.45,
          "p99Tier": "Copper",
          "sameFramePct": 11.97,
          "observedSameFramePct": 13.8,
          "sampleCount": 2076,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4GHz Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 278,
          "modeRank": 51,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "2563:0575",
          "searchText": "retro-bit - sega saturn 2.4ghz wireless pro controller retro bit sega saturn 2 4ghz wireless pro controller retro-bit sega saturn 2.4ghz wireless pro controller 2.4ghz wireless wireless dinput dinput wireless 2.4ghz dinput dinput wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc 2563:0575 raw capture retro-bit - sega saturn 2.4ghz wireless pro controller [dinput]"
        }
      ]
    },
    {
      "id": "published-retro-bit-nes-to-usb",
      "name": "Retro-Bit - NES to USB",
      "measurementName": "Retro-Bit NES to USB [Wired USB]",
      "deviceNorm": "retro bit nes to usb",
      "make": "Retro-Bit",
      "model": "NES to USB",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 131,
      "modeRank": 23,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "NES Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 9.052,
      "sdMs": 4.732,
      "maxMs": 17.564,
      "minMs": 0.264,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 45.69,
      "observedSameFramePct": 46.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Discontinued",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "1292:4643",
      "searchText": "retro-bit - nes to usb retro bit nes to usb retro-bit nes to usb wired usb wired wired usb dinput wired dinput dinput controller adapter nes controller controller adapter published published controller adapter - - - silver 05-10ms (gold) discontinued closed source mister / pc 1292:4643 retro-bit nes to usb [wired usb] retro-bit - nes to usb retro-bit nes to usb [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter', 'nes controller'] controller adapter silver controller adapter - - - published published discontinued closed source retro-bit - nes to usb retro bit nes to usb retro-bit nes to usb wired usb wired wired usb dinput wired dinput dinput controller adapter nes controller published published controller adapter - - - silver 05-10ms (gold) discontinued closed source mister / pc 1292:4643 retro-bit nes to usb [wired usb]",
      "controllerGroupKey": "published|retro bit nes to usb",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retro-bit-nes-to-usb",
          "name": "Retro-Bit - NES to USB",
          "measurementName": "Retro-Bit NES to USB [Wired USB]",
          "averageMs": 9.052,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 45.69,
          "observedSameFramePct": 46.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "NES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 226,
          "modeRank": 61,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "1292:4643",
          "searchText": "retro-bit - nes to usb retro bit nes to usb retro-bit nes to usb wired usb wired wired usb dinput wired dinput dinput controller adapter nes controller published published controller adapter - - - silver 05-10ms (gold) discontinued closed source mister / pc 1292:4643 retro-bit nes to usb [wired usb]"
        }
      ]
    },
    {
      "id": "published-generic-usb-port-game-controller-converter-p2-to-p3-adapter-cable-without-driver",
      "name": "Generic - USB Port Game Controller Converter P2 to P3 Adapter Cable Without Driver",
      "measurementName": "Generic USB Port Game Controller Converter P2 to P3 Adapter Cable Without Driver [Wired USB]",
      "deviceNorm": "generic usb port game controller converter p2 to p3 adapter cable without driver",
      "make": "Generic",
      "model": "USB Port Game Controller Converter P2 to P3 Adapter Cable Without Driver",
      "link": "https://amzn.to/3BNqiNi",
      "amazon": "",
      "buyUrl": "https://amzn.to/3BNqiNi",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 132,
      "modeRank": 24,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "2/23/2022",
      "dateAddedSort": "2022-02-23",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 9.088,
      "sdMs": 4.475,
      "maxMs": 17.77,
      "minMs": 1.21,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 45.47,
      "observedSameFramePct": 46.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "generic - usb port game controller converter p2 to p3 adapter cable without driver generic usb port game controller converter p2 to p3 adapter cable without driver generic usb port game controller converter p2 to p3 adapter cable without driver wired usb wired wired usb dinput wired dinput dinput controller adapter controller adapter published published controller adapter - - - silver 05-10ms (gold) actively sold closed source mister / pc buy link generic usb port game controller converter p2 to p3 adapter cable without driver [wired usb] generic - usb port game controller converter p2 to p3 adapter cable without driver generic usb port game controller converter p2 to p3 adapter cable without driver [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter'] controller adapter silver controller adapter - - - published published actively sold closed source generic - usb port game controller converter p2 to p3 adapter cable without driver generic usb port game controller converter p2 to p3 adapter cable without driver generic usb port game controller converter p2 to p3 adapter cable without driver wired usb wired wired usb dinput wired dinput dinput controller adapter published published controller adapter - - - silver 05-10ms (gold) actively sold closed source mister / pc buy link generic usb port game controller converter p2 to p3 adapter cable without driver [wired usb]",
      "controllerGroupKey": "published|generic usb port game controller converter p2 to p3 adapter cable without driver",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-generic-usb-port-game-controller-converter-p2-to-p3-adapter-cable-without-driver",
          "name": "Generic - USB Port Game Controller Converter P2 to P3 Adapter Cable Without Driver",
          "measurementName": "Generic USB Port Game Controller Converter P2 to P3 Adapter Cable Without Driver [Wired USB]",
          "averageMs": 9.088,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 45.47,
          "observedSameFramePct": 46.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 227,
          "modeRank": 62,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "2/23/2022",
          "dateAddedSort": "2022-02-23",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3BNqiNi",
          "link": "https://amzn.to/3BNqiNi",
          "amazon": "",
          "joystickId": "",
          "searchText": "generic - usb port game controller converter p2 to p3 adapter cable without driver generic usb port game controller converter p2 to p3 adapter cable without driver generic usb port game controller converter p2 to p3 adapter cable without driver wired usb wired wired usb dinput wired dinput dinput controller adapter published published controller adapter - - - silver 05-10ms (gold) actively sold closed source mister / pc buy link generic usb port game controller converter p2 to p3 adapter cable without driver [wired usb]"
        }
      ]
    },
    {
      "id": "published-generic-2-port-genesis-to-usb-adapter",
      "name": "Generic - 2-Port Genesis to USB Adapter",
      "measurementName": "Generic 2 Port Genesis to USB (Cable Style with 2 Blue Ports) [Wired USB]",
      "deviceNorm": "generic 2 port genesis to usb adapter",
      "make": "Generic",
      "model": "2 Port Genesis to USB (Cable Style with 2 Blue Ports)",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 133,
      "modeRank": 25,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "5/30/2020",
      "dateAddedSort": "2020-05-30",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "Genesis Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 9.091,
      "sdMs": 4.802,
      "maxMs": 17.62,
      "minMs": 0.616,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 45.45,
      "observedSameFramePct": 46.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Discontinued",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "1292:4745",
      "searchText": "generic - 2-port genesis to usb adapter generic 2 port genesis to usb adapter generic 2 port genesis to usb (cable style with 2 blue ports) wired usb wired wired usb dinput wired dinput dinput controller adapter genesis controller controller adapter published published controller adapter - - - silver 05-10ms (gold) discontinued closed source mister / pc 1292:4745 generic 2 port genesis to usb (cable style with 2 blue ports) [wired usb] generic - 2 port genesis to usb (cable style with 2 blue ports) generic 2 port genesis to usb (cable style with 2 blue ports) [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter', 'genesis controller'] controller adapter silver controller adapter - - - published published discontinued closed source generic - 2 port genesis to usb (cable style with 2 blue ports) generic 2 port genesis to usb cable style with 2 blue ports generic 2 port genesis to usb (cable style with 2 blue ports) wired usb wired wired usb dinput wired dinput dinput controller adapter genesis controller published published controller adapter - - - silver 05-10ms (gold) discontinued closed source mister / pc 1292:4745 generic 2 port genesis to usb (cable style with 2 blue ports) [wired usb]",
      "controllerGroupKey": "published|generic 2 port genesis to usb cable style with 2 blue ports",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-generic-2-port-genesis-to-usb-cable-style-with-2-blue-ports",
          "name": "Generic - 2 Port Genesis to USB (Cable Style with 2 Blue Ports)",
          "measurementName": "Generic 2 Port Genesis to USB (Cable Style with 2 Blue Ports) [Wired USB]",
          "averageMs": 9.091,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 45.45,
          "observedSameFramePct": 46.2,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "Genesis Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 228,
          "modeRank": 63,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "5/30/2020",
          "dateAddedSort": "2020-05-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Discontinued",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "1292:4745",
          "searchText": "generic - 2 port genesis to usb (cable style with 2 blue ports) generic 2 port genesis to usb cable style with 2 blue ports generic 2 port genesis to usb (cable style with 2 blue ports) wired usb wired wired usb dinput wired dinput dinput controller adapter genesis controller published published controller adapter - - - silver 05-10ms (gold) discontinued closed source mister / pc 1292:4745 generic 2 port genesis to usb (cable style with 2 blue ports) [wired usb]"
        }
      ]
    },
    {
      "id": "published-finera-usb-2-0-games-controller-adapter-converter-cable",
      "name": "Finera - USB 2.0 Games Controller Adapter Converter Cable",
      "measurementName": "Finera - USB 2.0 Games Controller Adapter Converter Cable",
      "deviceNorm": "finera usb 2 0 games controller adapter converter cable",
      "make": "Finera",
      "model": "USB 2.0 Games Controller Adapter Converter Cable",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 134,
      "modeRank": 26,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Copper",
      "averageMs": 9.107,
      "sdMs": 4.397,
      "maxMs": 19.22,
      "minMs": 0.82,
      "p99Ms": 17.211,
      "sampleCount": 4130,
      "sameFramePct": 45.36,
      "observedSameFramePct": 45.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "finera - usb 2.0 games controller adapter converter cable finera usb 2 0 games controller adapter converter cable finera usb 2.0 games controller adapter converter cable wired usb wired dinput wired dinput dinput controller adapter controller adapter published published controller adapter silver copper 05-10ms (gold) unknown closed source mister / pc raw capture finera - usb 2.0 games controller adapter converter cable finera - usb 2.0 games controller adapter converter cable finera - usb 2.0 games controller adapter converter cable wired usb wired wired dinput dinput dinput ['controller adapter'] controller adapter silver copper controller adapter published published unknown closed source finera - usb 2.0 games controller adapter converter cable finera usb 2 0 games controller adapter converter cable finera usb 2.0 games controller adapter converter cable wired usb wired dinput wired dinput dinput controller adapter published published controller adapter silver copper 05-10ms (gold) unknown closed source mister / pc raw capture finera - usb 2.0 games controller adapter converter cable",
      "controllerGroupKey": "published|finera usb 2 0 games controller adapter converter cable",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-finera-usb-2-0-games-controller-adapter-converter-cable",
          "name": "Finera - USB 2.0 Games Controller Adapter Converter Cable",
          "measurementName": "Finera - USB 2.0 Games Controller Adapter Converter Cable",
          "averageMs": 9.107,
          "averageTier": "Silver",
          "p99Ms": 17.211,
          "p99Tier": "Copper",
          "sameFramePct": 45.36,
          "observedSameFramePct": 45.4,
          "sampleCount": 4130,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 229,
          "modeRank": 64,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "finera - usb 2.0 games controller adapter converter cable finera usb 2 0 games controller adapter converter cable finera usb 2.0 games controller adapter converter cable wired usb wired dinput wired dinput dinput controller adapter published published controller adapter silver copper 05-10ms (gold) unknown closed source mister / pc raw capture finera - usb 2.0 games controller adapter converter cable"
        }
      ]
    },
    {
      "id": "published-sony-dualshock-3",
      "name": "Sony - DualShock 3",
      "measurementName": "Sony DualShock 3 [Wired USB]",
      "deviceNorm": "sony dualshock 3",
      "make": "Sony",
      "model": "DualShock 3",
      "link": "https://amzn.to/2WZrydI",
      "amazon": "",
      "buyUrl": "https://amzn.to/2WZrydI",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 135,
      "modeRank": 62,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "4.85",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 9.266,
      "sdMs": 2.866,
      "maxMs": 14.688,
      "minMs": 3.764,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 44.4,
      "observedSameFramePct": 44.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "054c:0268",
      "searchText": "sony - dualshock 3 sony dualshock 3 sony dualshock 3 wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 yes 4.85 silver 05-10ms (gold) actively sold closed source mister / pc 054c:0268 buy link sony dualshock 3 [wired usb] sony - dualshock 3 sony dualshock 3 [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller silver controller 4 yes 4.85 published published actively sold closed source sony - dualshock 3 sony dualshock 3 sony dualshock 3 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 4.85 silver 05-10ms (gold) actively sold closed source mister / pc 054c:0268 buy link sony dualshock 3 [wired usb] sony - dualshock 3 sony dualshock 3 [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless controller'] wireless controller bronze controller 4 yes 4.85 published published actively sold closed source sony - dualshock 3 sony dualshock 3 sony dualshock 3 bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 4.85 bronze 10-15ms (silver) actively sold closed source mister / pc 054c:0268 buy link sony dualshock 3 [bt (csr8510)]",
      "controllerGroupKey": "published|sony dualshock 3",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-sony-dualshock-3",
          "name": "Sony - DualShock 3",
          "measurementName": "Sony DualShock 3 [Wired USB]",
          "averageMs": 9.266,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 44.4,
          "observedSameFramePct": 44.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 230,
          "modeRank": 78,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "4.85",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2WZrydI",
          "link": "https://amzn.to/2WZrydI",
          "amazon": "",
          "joystickId": "054c:0268",
          "searchText": "sony - dualshock 3 sony dualshock 3 sony dualshock 3 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes 4.85 silver 05-10ms (gold) actively sold closed source mister / pc 054c:0268 buy link sony dualshock 3 [wired usb]"
        },
        {
          "id": "published-sony-dualshock-3-2",
          "name": "Sony - DualShock 3",
          "measurementName": "Sony DualShock 3 [BT (CSR8510)]",
          "averageMs": 11.646,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 30.12,
          "observedSameFramePct": 30.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 264,
          "modeRank": 41,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "4.85",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2WZrydI",
          "link": "https://amzn.to/2WZrydI",
          "amazon": "",
          "joystickId": "054c:0268",
          "searchText": "sony - dualshock 3 sony dualshock 3 sony dualshock 3 bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 4.85 bronze 10-15ms (silver) actively sold closed source mister / pc 054c:0268 buy link sony dualshock 3 [bt (csr8510)]"
        }
      ]
    },
    {
      "id": "published-logitech-f710-wireless-gamepad",
      "name": "Logitech - F710 Wireless Gamepad",
      "measurementName": "Logitech F710 Wireless Gamepad [Wired USB Dinput]",
      "deviceNorm": "logitech f710 wireless gamepad",
      "make": "Logitech",
      "model": "F710 Wireless Gamepad",
      "link": "https://amzn.to/2DMklqG",
      "amazon": "",
      "buyUrl": "https://amzn.to/2DMklqG",
      "connection": "2.4 GHz USB",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Dinput",
      "outputMode": "DInput",
      "connectionTag": "Wireless 2.4GHz",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wireless Controller",
      "overallRank": 136,
      "modeRank": 7,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "9.70",
      "dateAdded": "8/14/2020",
      "dateAddedSort": "2020-08-14",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 9.546,
      "sdMs": 1.184,
      "maxMs": 14.788,
      "minMs": 7.084,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 42.72,
      "observedSameFramePct": 42.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "046d:c219",
      "searchText": "logitech - f710 wireless gamepad logitech f710 wireless gamepad logitech f710 wireless gamepad 2.4 ghz usb wireless wired usb dinput dinput wireless 2.4ghz dinput dinput wireless controller wireless controller published published controller 4 yes 9.70 silver 05-10ms (gold) actively sold closed source mister / pc 046d:c219 buy link logitech f710 wireless gamepad [wired usb dinput] logitech - f710 wireless gamepad logitech f710 wireless gamepad [wired usb dinput] 2.4 ghz usb wireless wireless 2.4ghz wired usb dinput dinput dinput dinput ['wireless controller'] wireless controller silver controller 4 yes 9.70 published published actively sold closed source logitech - f710 wireless gamepad logitech f710 wireless gamepad logitech f710 wireless gamepad 2.4 ghz usb wireless wired usb dinput dinput wireless 2.4ghz dinput dinput wireless controller published published controller 4 yes 9.70 silver 05-10ms (gold) actively sold closed source mister / pc 046d:c219 buy link logitech f710 wireless gamepad [wired usb dinput] logitech - f710 wireless gamepad logitech f710 wireless gamepad [wired usb xinput] 2.4 ghz usb wireless wireless 2.4ghz wired usb xinput dinput, xinput dinput, xinput dinput, xinput ['wireless controller'] wireless controller silver controller 4 yes 9.70 published published actively sold closed source logitech - f710 wireless gamepad logitech f710 wireless gamepad logitech f710 wireless gamepad 2.4 ghz usb wireless wired usb xinput dinput, xinput wireless 2.4ghz dinput, xinput dinput, xinput wireless controller published published controller 4 yes 9.70 silver 05-10ms (gold) actively sold closed source mister / pc 046d:c21f buy link logitech f710 wireless gamepad [wired usb xinput]",
      "controllerGroupKey": "published|logitech f710 wireless gamepad",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-logitech-f710-wireless-gamepad",
          "name": "Logitech - F710 Wireless Gamepad",
          "measurementName": "Logitech F710 Wireless Gamepad [Wired USB Dinput]",
          "averageMs": 9.546,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 42.72,
          "observedSameFramePct": 42.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 231,
          "modeRank": 23,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "9.70",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2DMklqG",
          "link": "https://amzn.to/2DMklqG",
          "amazon": "",
          "joystickId": "046d:c219",
          "searchText": "logitech - f710 wireless gamepad logitech f710 wireless gamepad logitech f710 wireless gamepad 2.4 ghz usb wireless wired usb dinput dinput wireless 2.4ghz dinput dinput wireless controller published published controller 4 yes 9.70 silver 05-10ms (gold) actively sold closed source mister / pc 046d:c219 buy link logitech f710 wireless gamepad [wired usb dinput]"
        },
        {
          "id": "published-logitech-f710-wireless-gamepad-2",
          "name": "Logitech - F710 Wireless Gamepad",
          "measurementName": "Logitech F710 Wireless Gamepad [Wired USB Xinput]",
          "averageMs": 9.761,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 41.43,
          "observedSameFramePct": 41.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Wired USB Xinput",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 236,
          "modeRank": 27,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "9.70",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2DMklqG",
          "link": "https://amzn.to/2DMklqG",
          "amazon": "",
          "joystickId": "046d:c21f",
          "searchText": "logitech - f710 wireless gamepad logitech f710 wireless gamepad logitech f710 wireless gamepad 2.4 ghz usb wireless wired usb xinput dinput, xinput wireless 2.4ghz dinput, xinput dinput, xinput wireless controller published published controller 4 yes 9.70 silver 05-10ms (gold) actively sold closed source mister / pc 046d:c21f buy link logitech f710 wireless gamepad [wired usb xinput]"
        }
      ]
    },
    {
      "id": "published-8bitdo-n30-2-4g-nes-classic-model-81ba",
      "name": "8BitDo - N30 2.4G NES Classic (Model 81BA)",
      "measurementName": "8BitDo N30 2.4G NES Classic (Model 81BA) [Raphnet Wii Classic]",
      "deviceNorm": "8bitdo n30 2 4g nes classic model 81ba",
      "make": "8BitDo",
      "model": "N30 2.4G NES Classic (Model 81BA)",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "2.4 GHz Console",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "Raphnet Wii Classic",
      "outputMode": "",
      "connectionTag": "Wireless 2.4GHz",
      "modeLabel": "2.4G",
      "modeDisplay": "2.4 GHz Console",
      "rankMode": "Wireless Controller",
      "overallRank": 137,
      "modeRank": 8,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "2",
      "weightOz": "",
      "dateAdded": "6/29/2020",
      "dateAddedSort": "2020-06-29",
      "platforms": [],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "",
      "averageMs": 9.731,
      "sdMs": 4.74,
      "maxMs": 42.052,
      "minMs": 3.048,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 41.61,
      "observedSameFramePct": 42.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "289b:0080",
      "searchText": "8bitdo - n30 2.4g nes classic (model 81ba) 8bitdo n30 2 4g nes classic model 81ba 8bitdo n30 2.4g nes classic (model 81ba) 2.4 ghz console wireless raphnet wii classic wireless 2.4ghz 2.4g 2.4 ghz console wireless controller wireless controller published published controller 2 yes silver 05-10ms (gold) unknown closed source 289b:0080 8bitdo n30 2.4g nes classic (model 81ba) [raphnet wii classic] 8bitdo - n30 2.4g nes classic (model 81ba) 8bitdo n30 2.4g nes classic (model 81ba) [raphnet wii classic] 2.4 ghz console wireless wireless 2.4ghz raphnet wii classic 2.4g 2.4 ghz console ['wireless controller'] wireless controller silver controller 2 yes published published unknown closed source 8bitdo - n30 2.4g nes classic (model 81ba) 8bitdo n30 2 4g nes classic model 81ba 8bitdo n30 2.4g nes classic (model 81ba) 2.4 ghz console wireless raphnet wii classic wireless 2.4ghz 2.4g 2.4 ghz console wireless controller published published controller 2 yes silver 05-10ms (gold) unknown closed source 289b:0080 8bitdo n30 2.4g nes classic (model 81ba) [raphnet wii classic]",
      "controllerGroupKey": "published|8bitdo n30 2 4g nes classic model 81ba",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-8bitdo-n30-2-4g-nes-classic-model-81ba",
          "name": "8BitDo - N30 2.4G NES Classic (Model 81BA)",
          "measurementName": "8BitDo N30 2.4G NES Classic (Model 81BA) [Raphnet Wii Classic]",
          "averageMs": 9.731,
          "averageTier": "Silver",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 41.61,
          "observedSameFramePct": 42.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz Console",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Raphnet Wii Classic",
          "outputMode": "",
          "modeLabel": "2.4G",
          "modeDisplay": "2.4 GHz Console",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 232,
          "modeRank": 24,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "2",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "6/29/2020",
          "dateAddedSort": "2020-06-29",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "289b:0080",
          "searchText": "8bitdo - n30 2.4g nes classic (model 81ba) 8bitdo n30 2 4g nes classic model 81ba 8bitdo n30 2.4g nes classic (model 81ba) 2.4 ghz console wireless raphnet wii classic wireless 2.4ghz 2.4g 2.4 ghz console wireless controller published published controller 2 yes silver 05-10ms (gold) unknown closed source 289b:0080 8bitdo n30 2.4g nes classic (model 81ba) [raphnet wii classic]"
        }
      ]
    },
    {
      "id": "published-8bitdo-ultimate-2-4g-wireless-81ha",
      "name": "8BitDo - Ultimate 2.4G Wireless (81HA)",
      "measurementName": "8BitDo - Ultimate 2.4G Wireless (81HA) [Wired Direct Input]",
      "deviceNorm": "8bitdo ultimate 2 4g wireless 81ha",
      "make": "8BitDo",
      "model": "Ultimate 2.4G Wireless (81HA)",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired Direct Input",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 138,
      "modeRank": 63,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "05-10ms (Gold)",
      "averageTier": "Silver",
      "p99Tier": "Bronze",
      "averageMs": 9.75,
      "sdMs": 1.752,
      "maxMs": 13.22,
      "minMs": 6.29,
      "p99Ms": 12.87,
      "sampleCount": 5386,
      "sameFramePct": 41.5,
      "observedSameFramePct": 41.5,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "8bitdo - ultimate 2.4g wireless (81ha) 8bitdo ultimate 2 4g wireless 81ha 8bitdo ultimate 2.4g wireless (81ha) wired usb wired wired direct input dinput wired dinput dinput wired controller wired controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - ultimate 2.4g wireless (81ha) [wired direct input] 8bitdo - ultimate 2.4g wireless (81ha) 8bitdo - ultimate 2.4g wireless (81ha) [wired direct input] wired usb wired wired wired direct input dinput dinput dinput ['wired controller'] wired controller silver bronze controller published published unknown closed source 8bitdo - ultimate 2.4g wireless (81ha) 8bitdo ultimate 2 4g wireless 81ha 8bitdo ultimate 2.4g wireless (81ha) wired usb wired wired direct input dinput wired dinput dinput wired controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - ultimate 2.4g wireless (81ha) [wired direct input] 8bitdo - ultimate 2.4g wireless (81ha) 8bitdo - ultimate 2.4g wireless (81ha) [wireless direct input] wireless wireless wireless wireless direct input dinput dinput dinput ['wireless controller'] wireless controller bronze copper controller published published unknown closed source 8bitdo - ultimate 2.4g wireless (81ha) 8bitdo ultimate 2 4g wireless 81ha 8bitdo ultimate 2.4g wireless (81ha) wireless wireless wireless direct input dinput wireless dinput dinput wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture 8bitdo - ultimate 2.4g wireless (81ha) [wireless direct input]",
      "controllerGroupKey": "published|8bitdo ultimate 2 4g wireless 81ha",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-8bitdo-ultimate-2-4g-wireless-81ha",
          "name": "8BitDo - Ultimate 2.4G Wireless (81HA)",
          "measurementName": "8BitDo - Ultimate 2.4G Wireless (81HA) [Wired Direct Input]",
          "averageMs": 9.75,
          "averageTier": "Silver",
          "p99Ms": 12.87,
          "p99Tier": "Bronze",
          "sameFramePct": 41.5,
          "observedSameFramePct": 41.5,
          "sampleCount": 5386,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired Direct Input",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 234,
          "modeRank": 79,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - ultimate 2.4g wireless (81ha) 8bitdo ultimate 2 4g wireless 81ha 8bitdo ultimate 2.4g wireless (81ha) wired usb wired wired direct input dinput wired dinput dinput wired controller published published controller silver bronze 05-10ms (gold) unknown closed source mister / pc raw capture 8bitdo - ultimate 2.4g wireless (81ha) [wired direct input]"
        },
        {
          "id": "published-8bitdo-ultimate-2-4g-wireless-81ha-2",
          "name": "8BitDo - Ultimate 2.4G Wireless (81HA)",
          "measurementName": "8BitDo - Ultimate 2.4G Wireless (81HA) [Wireless Direct Input]",
          "averageMs": 13.893,
          "averageTier": "Bronze",
          "p99Ms": 20.395,
          "p99Tier": "Copper",
          "sameFramePct": 16.64,
          "observedSameFramePct": 18.4,
          "sampleCount": 2154,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless",
          "modeRaw": "Wireless Direct Input",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 274,
          "modeRank": 47,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - ultimate 2.4g wireless (81ha) 8bitdo ultimate 2 4g wireless 81ha 8bitdo ultimate 2.4g wireless (81ha) wireless wireless wireless direct input dinput wireless dinput dinput wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture 8bitdo - ultimate 2.4g wireless (81ha) [wireless direct input]"
        }
      ]
    },
    {
      "id": "published-microsoft-xbox-360",
      "name": "Microsoft - Xbox 360",
      "measurementName": "Microsoft Xbox 360 [Generic 360 Receiver \"HDE\"]",
      "deviceNorm": "microsoft xbox 360",
      "make": "Microsoft",
      "model": "Xbox 360",
      "link": "https://amzn.to/2ywxwcu",
      "amazon": "",
      "buyUrl": "https://amzn.to/2ywxwcu",
      "connection": "2.4 GHz USB",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "Generic 360 Receiver \"HDE\"",
      "outputMode": "DInput",
      "connectionTag": "Wireless 2.4GHz",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wireless Controller",
      "overallRank": 139,
      "modeRank": 9,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 10.174,
      "sdMs": 1.927,
      "maxMs": 22.352,
      "minMs": 6.124,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 38.96,
      "observedSameFramePct": 39.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:02a1",
      "searchText": "microsoft - xbox 360 microsoft xbox 360 microsoft xbox 360 2.4 ghz usb wireless generic 360 receiver \"hde\" dinput wireless 2.4ghz dinput dinput wireless controller wireless controller published published controller 4 yes bronze 10-15ms (silver) actively sold closed source mister / pc 045e:02a1 buy link microsoft xbox 360 [generic 360 receiver \"hde\"] microsoft - xbox 360 microsoft xbox 360 [generic 360 receiver \"hde\"] 2.4 ghz usb wireless wireless 2.4ghz generic 360 receiver \"hde\" dinput dinput dinput ['wireless controller'] wireless controller bronze controller 4 yes published published actively sold closed source microsoft - xbox 360 microsoft xbox 360 microsoft xbox 360 2.4 ghz usb wireless generic 360 receiver \"hde\" dinput wireless 2.4ghz dinput dinput wireless controller published published controller 4 yes bronze 10-15ms (silver) actively sold closed source mister / pc 045e:02a1 buy link microsoft xbox 360 [generic 360 receiver \"hde\"]",
      "controllerGroupKey": "published|microsoft xbox 360",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-microsoft-xbox-360",
          "name": "Microsoft - Xbox 360",
          "measurementName": "Microsoft Xbox 360 [Generic 360 Receiver \"HDE\"]",
          "averageMs": 10.174,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 38.96,
          "observedSameFramePct": 39.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Generic 360 Receiver \"HDE\"",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 239,
          "modeRank": 30,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2ywxwcu",
          "link": "https://amzn.to/2ywxwcu",
          "amazon": "",
          "joystickId": "045e:02a1",
          "searchText": "microsoft - xbox 360 microsoft xbox 360 microsoft xbox 360 2.4 ghz usb wireless generic 360 receiver \"hde\" dinput wireless 2.4ghz dinput dinput wireless controller published published controller 4 yes bronze 10-15ms (silver) actively sold closed source mister / pc 045e:02a1 buy link microsoft xbox 360 [generic 360 receiver \"hde\"]"
        }
      ]
    },
    {
      "id": "published-nintendo-wii-remote",
      "name": "Nintendo - Wii Remote",
      "measurementName": "Nintendo Wii Remote [BT (CSR8510)]",
      "deviceNorm": "nintendo wii remote",
      "make": "Nintendo",
      "model": "Wii Remote",
      "link": "https://amzn.to/2yy8xFR",
      "amazon": "",
      "buyUrl": "https://amzn.to/2yy8xFR",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT (CSR8510)",
      "outputMode": "",
      "connectionTag": "Wireless BT",
      "modeLabel": "Bluetooth",
      "modeDisplay": "Bluetooth",
      "rankMode": "Wireless Controller",
      "overallRank": 140,
      "modeRank": 10,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "2",
      "weightOz": "",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 10.287,
      "sdMs": 3.549,
      "maxMs": 21.952,
      "minMs": 1.952,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 38.28,
      "observedSameFramePct": 38.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "057e:2017",
      "searchText": "nintendo - wii remote nintendo wii remote nintendo wii remote bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller wireless controller published published controller 2 yes bronze 10-15ms (silver) actively sold closed source mister / pc 057e:2017 buy link nintendo wii remote [bt (csr8510)] nintendo - wii remote nintendo wii remote [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless controller'] wireless controller bronze controller 2 yes published published actively sold closed source nintendo - wii remote nintendo wii remote nintendo wii remote bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 2 yes bronze 10-15ms (silver) actively sold closed source mister / pc 057e:2017 buy link nintendo wii remote [bt (csr8510)]",
      "controllerGroupKey": "published|nintendo wii remote",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-nintendo-wii-remote",
          "name": "Nintendo - Wii Remote",
          "measurementName": "Nintendo Wii Remote [BT (CSR8510)]",
          "averageMs": 10.287,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 38.28,
          "observedSameFramePct": 38.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 241,
          "modeRank": 32,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "2",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2yy8xFR",
          "link": "https://amzn.to/2yy8xFR",
          "amazon": "",
          "joystickId": "057e:2017",
          "searchText": "nintendo - wii remote nintendo wii remote nintendo wii remote bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 2 yes bronze 10-15ms (silver) actively sold closed source mister / pc 057e:2017 buy link nintendo wii remote [bt (csr8510)]"
        }
      ]
    },
    {
      "id": "published-8bitdo-snes-conversion-pcb",
      "name": "8BitDo - SNES Conversion PCB",
      "measurementName": "8BitDo SNES Conversion PCB [BT (CSR8510) MacOS]",
      "deviceNorm": "8bitdo snes conversion pcb",
      "make": "8BitDo",
      "model": "SNES Conversion PCB",
      "link": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-snes-sfc-controller-old-edition",
      "amazon": "",
      "buyUrl": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-snes-sfc-controller-old-edition",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT (CSR8510) MacOS",
      "outputMode": "macOS",
      "connectionTag": "Wireless BT",
      "modeLabel": "macOS",
      "modeDisplay": "macOS",
      "rankMode": "Wireless Controller",
      "overallRank": 141,
      "modeRank": 11,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "3.40",
      "dateAdded": "5/26/2020",
      "dateAddedSort": "2020-05-26",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 10.481,
      "sdMs": 3.045,
      "maxMs": 23.508,
      "minMs": 3.616,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 37.11,
      "observedSameFramePct": 37.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "05cc:05c4",
      "searchText": "8bitdo - snes conversion pcb 8bitdo snes conversion pcb 8bitdo snes conversion pcb bluetooth wireless bt (csr8510) macos macos wireless bt macos macos wireless controller wireless controller published published controller 4 no 3.40 bronze 10-15ms (silver) actively sold closed source mister / pc 05cc:05c4 buy link 8bitdo snes conversion pcb [bt (csr8510) macos] 8bitdo - snes conversion pcb 8bitdo snes conversion pcb [bt (csr8510) macos] bluetooth wireless wireless bt bt (csr8510) macos macos macos macos ['wireless controller'] wireless controller bronze controller 4 no 3.40 published published actively sold closed source 8bitdo - snes conversion pcb 8bitdo snes conversion pcb 8bitdo snes conversion pcb bluetooth wireless bt (csr8510) macos macos wireless bt macos macos wireless controller published published controller 4 no 3.40 bronze 10-15ms (silver) actively sold closed source mister / pc 05cc:05c4 buy link 8bitdo snes conversion pcb [bt (csr8510) macos] 8bitdo - snes conversion pcb 8bitdo snes conversion pcb [bt (csr8510) switch] bluetooth wireless wireless bt bt (csr8510) switch switch switch switch ['wireless controller'] wireless controller copper controller 4 no 3.40 published published actively sold closed source 8bitdo - snes conversion pcb 8bitdo snes conversion pcb 8bitdo snes conversion pcb bluetooth wireless bt (csr8510) switch switch wireless bt switch switch wireless controller published published controller 4 no 3.40 copper 15-20ms (bronze) actively sold closed source mister / pc switch 054c:05c4 buy link 8bitdo snes conversion pcb [bt (csr8510) switch] 8bitdo - snes conversion pcb 8bitdo snes conversion pcb [bt (csr8510) windows] bluetooth wireless wireless bt bt (csr8510) windows dinput dinput dinput ['wireless controller'] wireless controller copper controller 4 no 3.40 published published actively sold closed source 8bitdo - snes conversion pcb 8bitdo snes conversion pcb 8bitdo snes conversion pcb bluetooth wireless bt (csr8510) windows dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 045e:02e0 buy link 8bitdo snes conversion pcb [bt (csr8510) windows] 8bitdo - snes conversion pcb 8bitdo snes conversion pcb [bt (csr8510) android] bluetooth wireless wireless bt bt (csr8510) android android android android ['wireless controller'] wireless controller copper controller 4 no 3.40 published published actively sold closed source 8bitdo - snes conversion pcb 8bitdo snes conversion pcb 8bitdo snes conversion pcb bluetooth wireless bt (csr8510) android android wireless bt android android wireless controller published published controller 4 no 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 2dc8:5103 buy link 8bitdo snes conversion pcb [bt (csr8510) android]",
      "controllerGroupKey": "published|8bitdo snes conversion pcb",
      "modeVariantCount": 4,
      "modeVariants": [
        {
          "id": "published-8bitdo-snes-conversion-pcb",
          "name": "8BitDo - SNES Conversion PCB",
          "measurementName": "8BitDo SNES Conversion PCB [BT (CSR8510) MacOS]",
          "averageMs": 10.481,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 37.11,
          "observedSameFramePct": 37.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) MacOS",
          "outputMode": "macOS",
          "modeLabel": "macOS",
          "modeDisplay": "macOS",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 242,
          "modeRank": 33,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "5/26/2020",
          "dateAddedSort": "2020-05-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-snes-sfc-controller-old-edition",
          "link": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-snes-sfc-controller-old-edition",
          "amazon": "",
          "joystickId": "05cc:05c4",
          "searchText": "8bitdo - snes conversion pcb 8bitdo snes conversion pcb 8bitdo snes conversion pcb bluetooth wireless bt (csr8510) macos macos wireless bt macos macos wireless controller published published controller 4 no 3.40 bronze 10-15ms (silver) actively sold closed source mister / pc 05cc:05c4 buy link 8bitdo snes conversion pcb [bt (csr8510) macos]"
        },
        {
          "id": "published-8bitdo-snes-conversion-pcb-2",
          "name": "8BitDo - SNES Conversion PCB",
          "measurementName": "8BitDo SNES Conversion PCB [BT (CSR8510) Switch]",
          "averageMs": 19.902,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 8.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Switch",
          "outputMode": "Switch",
          "modeLabel": "Switch",
          "modeDisplay": "Switch",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 315,
          "modeRank": 82,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "5/26/2020",
          "dateAddedSort": "2020-05-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-snes-sfc-controller-old-edition",
          "link": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-snes-sfc-controller-old-edition",
          "amazon": "",
          "joystickId": "054c:05c4",
          "searchText": "8bitdo - snes conversion pcb 8bitdo snes conversion pcb 8bitdo snes conversion pcb bluetooth wireless bt (csr8510) switch switch wireless bt switch switch wireless controller published published controller 4 no 3.40 copper 15-20ms (bronze) actively sold closed source mister / pc switch 054c:05c4 buy link 8bitdo snes conversion pcb [bt (csr8510) switch]"
        },
        {
          "id": "published-8bitdo-snes-conversion-pcb-3",
          "name": "8BitDo - SNES Conversion PCB",
          "measurementName": "8BitDo SNES Conversion PCB [BT (CSR8510) Windows]",
          "averageMs": 20.176,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 7.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Windows",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 318,
          "modeRank": 85,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "5/26/2020",
          "dateAddedSort": "2020-05-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-snes-sfc-controller-old-edition",
          "link": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-snes-sfc-controller-old-edition",
          "amazon": "",
          "joystickId": "045e:02e0",
          "searchText": "8bitdo - snes conversion pcb 8bitdo snes conversion pcb 8bitdo snes conversion pcb bluetooth wireless bt (csr8510) windows dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 045e:02e0 buy link 8bitdo snes conversion pcb [bt (csr8510) windows]"
        },
        {
          "id": "published-8bitdo-snes-conversion-pcb-4",
          "name": "8BitDo - SNES Conversion PCB",
          "measurementName": "8BitDo SNES Conversion PCB [BT (CSR8510) Android]",
          "averageMs": 21.139,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 7.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510) Android",
          "outputMode": "Android",
          "modeLabel": "Android",
          "modeDisplay": "Android",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 321,
          "modeRank": 88,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "5/26/2020",
          "dateAddedSort": "2020-05-26",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-snes-sfc-controller-old-edition",
          "link": "https://shop.8bitdo.com/products/8bitdo-mod-kit-for-original-snes-sfc-controller-old-edition",
          "amazon": "",
          "joystickId": "2dc8:5103",
          "searchText": "8bitdo - snes conversion pcb 8bitdo snes conversion pcb 8bitdo snes conversion pcb bluetooth wireless bt (csr8510) android android wireless bt android android wireless controller published published controller 4 no 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 2dc8:5103 buy link 8bitdo snes conversion pcb [bt (csr8510) android]"
        }
      ]
    },
    {
      "id": "published-generic-ps2-controller-to-usb-adapter-converter-cable",
      "name": "Generic - PS2 Controller to USB Adapter Converter Cable",
      "measurementName": "PS2 - Controller to USB Adapter Converter Cable",
      "deviceNorm": "generic ps2 controller to usb adapter converter cable",
      "make": "PS2",
      "model": "Controller to USB Adapter Converter Cable",
      "link": "https://amzn.to/3Iw8IAl",
      "amazon": "",
      "buyUrl": "https://amzn.to/3Iw8IAl",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 142,
      "modeRank": 27,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "2/23/2022",
      "dateAddedSort": "2022-02-23",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "Copper",
      "averageMs": 10.589,
      "sdMs": 4.001,
      "maxMs": 17.81,
      "minMs": 2.95,
      "p99Ms": 17.417,
      "sampleCount": 2930,
      "sameFramePct": 36.47,
      "observedSameFramePct": 36.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "generic - ps2 controller to usb adapter converter cable generic ps2 controller to usb adapter converter cable ps2 controller to usb adapter converter cable wired usb wired dinput wired dinput dinput controller adapter controller adapter published published controller adapter bronze copper 10-15ms (silver) actively sold closed source mister / pc raw capture buy link ps2 - controller to usb adapter converter cable ps2 - controller to usb adapter converter cable ps2 - controller to usb adapter converter cable wired usb wired wired dinput dinput dinput ['controller adapter'] controller adapter bronze copper controller adapter published published actively sold closed source ps2 - controller to usb adapter converter cable ps2 controller to usb adapter converter cable ps2 controller to usb adapter converter cable wired usb wired dinput wired dinput dinput controller adapter published published controller adapter bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture ps2 - controller to usb adapter converter cable",
      "controllerGroupKey": "published|generic ps2 controller to usb adapter converter cable",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-ps2-controller-to-usb-adapter-converter-cable",
          "name": "PS2 - Controller to USB Adapter Converter Cable",
          "measurementName": "PS2 - Controller to USB Adapter Converter Cable",
          "averageMs": 10.589,
          "averageTier": "Bronze",
          "p99Ms": 17.417,
          "p99Tier": "Copper",
          "sameFramePct": 36.47,
          "observedSameFramePct": 36.6,
          "sampleCount": 2930,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 245,
          "modeRank": 65,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "2/23/2022",
          "dateAddedSort": "2022-02-23",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3Iw8IAl",
          "link": "https://amzn.to/3Iw8IAl",
          "amazon": "",
          "joystickId": "",
          "searchText": "ps2 - controller to usb adapter converter cable ps2 controller to usb adapter converter cable ps2 controller to usb adapter converter cable wired usb wired dinput wired dinput dinput controller adapter published published controller adapter bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture ps2 - controller to usb adapter converter cable"
        }
      ]
    },
    {
      "id": "published-mcbazel-playstation-2-controller-to-usb-adapter-for-pc",
      "name": "Mcbazel - PlayStation 2 Controller to USB Adapter for PC",
      "measurementName": "Mcbazel - PlayStation 2 Controller to USB Adapter for PC or Playstation 3 Converter Cable for Sony DualShock PS2 PS3 Controllers (NOT compatible with Dancing Mat Guitar Hero)",
      "deviceNorm": "mcbazel playstation 2 controller to usb adapter for pc",
      "make": "Mcbazel",
      "model": "PlayStation 2 Controller to USB Adapter for PC or Playstation 3 Converter Cable for Sony DualShock PS2 PS3 Controllers (NOT compatible with Dancing Mat Guitar Hero)",
      "link": "https://amzn.to/3t5Xvjc",
      "amazon": "",
      "buyUrl": "https://amzn.to/3t5Xvjc",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 143,
      "modeRank": 28,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "2/23/2022",
      "dateAddedSort": "2022-02-23",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "PSX Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "Copper",
      "averageMs": 11.265,
      "sdMs": 4.643,
      "maxMs": 23.21,
      "minMs": 1.46,
      "p99Ms": 19.937,
      "sampleCount": 2609,
      "sameFramePct": 32.41,
      "observedSameFramePct": 33.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "mcbazel - playstation 2 controller to usb adapter for pc mcbazel playstation 2 controller to usb adapter for pc mcbazel playstation 2 controller to usb adapter for pc or playstation 3 converter cable for sony dualshock ps2 ps3 controllers (not compatible with dancing mat guitar hero) wired usb wired dinput wired dinput dinput controller adapter psx controller controller adapter published published controller adapter bronze copper 10-15ms (silver) actively sold closed source mister / pc raw capture buy link mcbazel - playstation 2 controller to usb adapter for pc or playstation 3 converter cable for sony dualshock ps2 ps3 controllers (not compatible with dancing mat guitar hero) mcbazel - playstation 2 controller to usb adapter for pc or playstation 3 converter cable for sony dualshock ps2 ps3 controllers (not compatible with dancing mat guitar hero) mcbazel - playstation 2 controller to usb adapter for pc or playstation 3 converter cable for sony dualshock ps2 ps3 controllers (not compatible with dancing mat guitar hero) wired usb wired wired dinput dinput dinput ['controller adapter', 'psx controller'] controller adapter bronze copper controller adapter published published actively sold closed source mcbazel - playstation 2 controller to usb adapter for pc or playstation 3 converter cable for sony dualshock ps2 ps3 controllers (not compatible with dancing mat guitar hero) mcbazel playstation 2 controller to usb adapter for pc or playstation 3 converter cable for sony dualshock ps2 ps3 controllers not compatible with dancing mat guitar hero mcbazel playstation 2 controller to usb adapter for pc or playstation 3 converter cable for sony dualshock ps2 ps3 controllers (not compatible with dancing mat guitar hero) wired usb wired dinput wired dinput dinput controller adapter psx controller published published controller adapter bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture mcbazel - playstation 2 controller to usb adapter for pc or playstation 3 converter cable for sony dualshock ps2 ps3 controllers (not compatible with dancing mat guitar hero)",
      "controllerGroupKey": "published|mcbazel playstation 2 controller to usb adapter for pc",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-mcbazel-playstation-2-controller-to-usb-adapter-for-pc-or-playstation-3-converter-cable-for-sony-dualshock-ps2-ps3-controllers-not-compatible-with-dancing-mat-guitar-hero",
          "name": "Mcbazel - PlayStation 2 Controller to USB Adapter for PC or Playstation 3 Converter Cable for Sony DualShock PS2 PS3 Controllers (NOT compatible with Dancing Mat Guitar Hero)",
          "measurementName": "Mcbazel - PlayStation 2 Controller to USB Adapter for PC or Playstation 3 Converter Cable for Sony DualShock PS2 PS3 Controllers (NOT compatible with Dancing Mat Guitar Hero)",
          "averageMs": 11.265,
          "averageTier": "Bronze",
          "p99Ms": 19.937,
          "p99Tier": "Copper",
          "sameFramePct": 32.41,
          "observedSameFramePct": 33.8,
          "sampleCount": 2609,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "PSX Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 254,
          "modeRank": 66,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "2/23/2022",
          "dateAddedSort": "2022-02-23",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3t5Xvjc",
          "link": "https://amzn.to/3t5Xvjc",
          "amazon": "",
          "joystickId": "",
          "searchText": "mcbazel - playstation 2 controller to usb adapter for pc or playstation 3 converter cable for sony dualshock ps2 ps3 controllers (not compatible with dancing mat guitar hero) mcbazel playstation 2 controller to usb adapter for pc or playstation 3 converter cable for sony dualshock ps2 ps3 controllers not compatible with dancing mat guitar hero mcbazel playstation 2 controller to usb adapter for pc or playstation 3 converter cable for sony dualshock ps2 ps3 controllers (not compatible with dancing mat guitar hero) wired usb wired dinput wired dinput dinput controller adapter psx controller published published controller adapter bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture mcbazel - playstation 2 controller to usb adapter for pc or playstation 3 converter cable for sony dualshock ps2 ps3 controllers (not compatible with dancing mat guitar hero)"
        }
      ]
    },
    {
      "id": "published-innext-snes-retro-usb",
      "name": "iNNEXT - SNES Retro USB",
      "measurementName": "iNNEXT SNES Retro USB [Wired USB]",
      "deviceNorm": "innext snes retro usb",
      "make": "iNNEXT",
      "model": "SNES Retro USB",
      "link": "https://amzn.to/2X2UCRi",
      "amazon": "",
      "buyUrl": "https://amzn.to/2X2UCRi",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 144,
      "modeRank": 64,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "2.35",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 11.45,
      "sdMs": 6.274,
      "maxMs": 22.71,
      "minMs": 0.24,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 31.3,
      "observedSameFramePct": 35.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "innext - snes retro usb innext snes retro usb innext snes retro usb wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no 2.35 bronze 10-15ms (silver) actively sold closed source mister / pc buy link innext snes retro usb [wired usb] innext - snes retro usb innext snes retro usb [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller bronze controller 4 no 2.35 published published actively sold closed source innext - snes retro usb innext snes retro usb innext snes retro usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 2.35 bronze 10-15ms (silver) actively sold closed source mister / pc buy link innext snes retro usb [wired usb]",
      "controllerGroupKey": "published|innext snes retro usb",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-innext-snes-retro-usb",
          "name": "iNNEXT - SNES Retro USB",
          "measurementName": "iNNEXT SNES Retro USB [Wired USB]",
          "averageMs": 11.45,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 31.3,
          "observedSameFramePct": 35.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 255,
          "modeRank": 80,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "2.35",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2X2UCRi",
          "link": "https://amzn.to/2X2UCRi",
          "amazon": "",
          "joystickId": "",
          "searchText": "innext - snes retro usb innext snes retro usb innext snes retro usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 2.35 bronze 10-15ms (silver) actively sold closed source mister / pc buy link innext snes retro usb [wired usb]"
        }
      ]
    },
    {
      "id": "published-unbranded-nes-usb",
      "name": "Unbranded - NES USB",
      "measurementName": "Unbranded NES USB [Wired USB]",
      "deviceNorm": "unbranded nes usb",
      "make": "Unbranded",
      "model": "NES USB",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 145,
      "modeRank": 65,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "2",
      "weightOz": "",
      "dateAdded": "6/12/2020",
      "dateAddedSort": "2020-06-12",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 11.491,
      "sdMs": 6.262,
      "maxMs": 22.916,
      "minMs": 0.312,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 31.05,
      "observedSameFramePct": 35.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:0011",
      "searchText": "unbranded - nes usb unbranded nes usb unbranded nes usb wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 2 no bronze 10-15ms (silver) unknown closed source mister / pc 0079:0011 unbranded nes usb [wired usb] unbranded - nes usb unbranded nes usb [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller bronze controller 2 no published published unknown closed source unbranded - nes usb unbranded nes usb unbranded nes usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 2 no bronze 10-15ms (silver) unknown closed source mister / pc 0079:0011 unbranded nes usb [wired usb]",
      "controllerGroupKey": "published|unbranded nes usb",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-unbranded-nes-usb",
          "name": "Unbranded - NES USB",
          "measurementName": "Unbranded NES USB [Wired USB]",
          "averageMs": 11.491,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 31.05,
          "observedSameFramePct": 35.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 256,
          "modeRank": 81,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "2",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "6/12/2020",
          "dateAddedSort": "2020-06-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "0079:0011",
          "searchText": "unbranded - nes usb unbranded nes usb unbranded nes usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 2 no bronze 10-15ms (silver) unknown closed source mister / pc 0079:0011 unbranded nes usb [wired usb]"
        }
      ]
    },
    {
      "id": "published-retro-bit-retro-link-nes-dogbone",
      "name": "Retro-Bit - Retro-Link NES Dogbone",
      "measurementName": "Retro-Bit Retro-Link NES Dogbone [Wired USB]",
      "deviceNorm": "retro bit retro link nes dogbone",
      "make": "Retro-Bit",
      "model": "Retro-Link NES Dogbone",
      "link": "-",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 146,
      "modeRank": 66,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "2",
      "weightOz": "1.95",
      "dateAdded": "8/14/2020",
      "dateAddedSort": "2020-08-14",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 11.5,
      "sdMs": 6.268,
      "maxMs": 22.784,
      "minMs": 0.36,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 31.0,
      "observedSameFramePct": 35.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:0011",
      "searchText": "retro-bit - retro-link nes dogbone retro bit retro link nes dogbone retro-bit retro-link nes dogbone wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 2 no 1.95 bronze 10-15ms (silver) unknown closed source mister / pc 0079:0011 retro-bit retro-link nes dogbone [wired usb] retro-bit - retro-link nes dogbone retro-bit retro-link nes dogbone [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller bronze controller 2 no 1.95 published published unknown closed source retro-bit - retro-link nes dogbone retro bit retro link nes dogbone retro-bit retro-link nes dogbone wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 2 no 1.95 bronze 10-15ms (silver) unknown closed source mister / pc 0079:0011 retro-bit retro-link nes dogbone [wired usb]",
      "controllerGroupKey": "published|retro bit retro link nes dogbone",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retro-bit-retro-link-nes-dogbone",
          "name": "Retro-Bit - Retro-Link NES Dogbone",
          "measurementName": "Retro-Bit Retro-Link NES Dogbone [Wired USB]",
          "averageMs": 11.5,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 31.0,
          "observedSameFramePct": 35.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 257,
          "modeRank": 82,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "2",
          "homeButton": "No",
          "weightOz": "1.95",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "-",
          "amazon": "",
          "joystickId": "0079:0011",
          "searchText": "retro-bit - retro-link nes dogbone retro bit retro link nes dogbone retro-bit retro-link nes dogbone wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 2 no 1.95 bronze 10-15ms (silver) unknown closed source mister / pc 0079:0011 retro-bit retro-link nes dogbone [wired usb]"
        }
      ]
    },
    {
      "id": "published-vilrose-retro-gaming-genesis-controller",
      "name": "Vilrose - Retro Gaming Genesis Controller",
      "measurementName": "Vilrose Retro Gaming Genesis Controller [Wired USB]",
      "deviceNorm": "vilrose retro gaming genesis controller",
      "make": "Vilrose",
      "model": "Retro Gaming Genesis Controller",
      "link": "https://amzn.to/2VXxDq3",
      "amazon": "",
      "buyUrl": "https://amzn.to/2VXxDq3",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 147,
      "modeRank": 67,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "3.05",
      "dateAdded": "7/7/2020",
      "dateAddedSort": "2020-07-07",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 11.548,
      "sdMs": 6.273,
      "maxMs": 22.848,
      "minMs": 0.292,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 30.71,
      "observedSameFramePct": 35.1,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:0011",
      "searchText": "vilrose - retro gaming genesis controller vilrose retro gaming genesis controller vilrose retro gaming genesis controller wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 no 3.05 bronze 10-15ms (silver) actively sold closed source mister / pc 0079:0011 buy link vilrose retro gaming genesis controller [wired usb] vilrose - retro gaming genesis controller vilrose retro gaming genesis controller [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller bronze controller 6 no 3.05 published published actively sold closed source vilrose - retro gaming genesis controller vilrose retro gaming genesis controller vilrose retro gaming genesis controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 3.05 bronze 10-15ms (silver) actively sold closed source mister / pc 0079:0011 buy link vilrose retro gaming genesis controller [wired usb]",
      "controllerGroupKey": "published|vilrose retro gaming genesis controller",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-vilrose-retro-gaming-genesis-controller",
          "name": "Vilrose - Retro Gaming Genesis Controller",
          "measurementName": "Vilrose Retro Gaming Genesis Controller [Wired USB]",
          "averageMs": 11.548,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 30.71,
          "observedSameFramePct": 35.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 258,
          "modeRank": 83,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "3.05",
          "dateAdded": "7/7/2020",
          "dateAddedSort": "2020-07-07",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2VXxDq3",
          "link": "https://amzn.to/2VXxDq3",
          "amazon": "",
          "joystickId": "0079:0011",
          "searchText": "vilrose - retro gaming genesis controller vilrose retro gaming genesis controller vilrose retro gaming genesis controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 3.05 bronze 10-15ms (silver) actively sold closed source mister / pc 0079:0011 buy link vilrose retro gaming genesis controller [wired usb]"
        }
      ]
    },
    {
      "id": "published-retro-bit-retro-link-saturn-classic",
      "name": "Retro-Bit - Retro-Link Saturn Classic",
      "measurementName": "Retro-Bit Retro-Link Saturn Classic [Wired USB]",
      "deviceNorm": "retro bit retro link saturn classic",
      "make": "Retro-Bit",
      "model": "Retro-Link Saturn Classic",
      "link": "https://amzn.to/2TAxabZ",
      "amazon": "",
      "buyUrl": "https://amzn.to/2TAxabZ",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 148,
      "modeRank": 68,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 11.59,
      "sdMs": 5.986,
      "maxMs": 22.68,
      "minMs": 0.52,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 30.46,
      "observedSameFramePct": 34.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "retro-bit - retro-link saturn classic retro bit retro link saturn classic retro-bit retro-link saturn classic wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 no bronze 10-15ms (silver) actively sold closed source mister / pc buy link retro-bit retro-link saturn classic [wired usb] retro-bit - retro-link saturn classic retro-bit retro-link saturn classic [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller bronze controller 6 no published published actively sold closed source retro-bit - retro-link saturn classic retro bit retro link saturn classic retro-bit retro-link saturn classic wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no bronze 10-15ms (silver) actively sold closed source mister / pc buy link retro-bit retro-link saturn classic [wired usb]",
      "controllerGroupKey": "published|retro bit retro link saturn classic",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retro-bit-retro-link-saturn-classic",
          "name": "Retro-Bit - Retro-Link Saturn Classic",
          "measurementName": "Retro-Bit Retro-Link Saturn Classic [Wired USB]",
          "averageMs": 11.59,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 30.46,
          "observedSameFramePct": 34.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 259,
          "modeRank": 84,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2TAxabZ",
          "link": "https://amzn.to/2TAxabZ",
          "amazon": "",
          "joystickId": "",
          "searchText": "retro-bit - retro-link saturn classic retro bit retro link saturn classic retro-bit retro-link saturn classic wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no bronze 10-15ms (silver) actively sold closed source mister / pc buy link retro-bit retro-link saturn classic [wired usb]"
        }
      ]
    },
    {
      "id": "published-vilrose-retro-gaming-weighted-snes-controller",
      "name": "Vilrose - Retro Gaming Weighted SNES Controller",
      "measurementName": "Vilrose Retro Gaming Weighted SNES Controller [Wired USB]",
      "deviceNorm": "vilrose retro gaming weighted snes controller",
      "make": "Vilrose",
      "model": "Retro Gaming Weighted SNES Controller",
      "link": "https://amzn.to/3ffHwXW",
      "amazon": "",
      "buyUrl": "https://amzn.to/3ffHwXW",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 149,
      "modeRank": 69,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "3.30",
      "dateAdded": "7/7/2020",
      "dateAddedSort": "2020-07-07",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 11.597,
      "sdMs": 6.268,
      "maxMs": 22.876,
      "minMs": 0.268,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 30.42,
      "observedSameFramePct": 34.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:0011",
      "searchText": "vilrose - retro gaming weighted snes controller vilrose retro gaming weighted snes controller vilrose retro gaming weighted snes controller wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no 3.30 bronze 10-15ms (silver) actively sold closed source mister / pc 0079:0011 buy link vilrose retro gaming weighted snes controller [wired usb] vilrose - retro gaming weighted snes controller vilrose retro gaming weighted snes controller [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller bronze controller 4 no 3.30 published published actively sold closed source vilrose - retro gaming weighted snes controller vilrose retro gaming weighted snes controller vilrose retro gaming weighted snes controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.30 bronze 10-15ms (silver) actively sold closed source mister / pc 0079:0011 buy link vilrose retro gaming weighted snes controller [wired usb]",
      "controllerGroupKey": "published|vilrose retro gaming weighted snes controller",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-vilrose-retro-gaming-weighted-snes-controller",
          "name": "Vilrose - Retro Gaming Weighted SNES Controller",
          "measurementName": "Vilrose Retro Gaming Weighted SNES Controller [Wired USB]",
          "averageMs": 11.597,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 30.42,
          "observedSameFramePct": 34.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 260,
          "modeRank": 85,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.30",
          "dateAdded": "7/7/2020",
          "dateAddedSort": "2020-07-07",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3ffHwXW",
          "link": "https://amzn.to/3ffHwXW",
          "amazon": "",
          "joystickId": "0079:0011",
          "searchText": "vilrose - retro gaming weighted snes controller vilrose retro gaming weighted snes controller vilrose retro gaming weighted snes controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.30 bronze 10-15ms (silver) actively sold closed source mister / pc 0079:0011 buy link vilrose retro gaming weighted snes controller [wired usb]"
        }
      ]
    },
    {
      "id": "published-qanba-drone-2",
      "name": "Qanba - Drone 2",
      "measurementName": "Qanba - Drone 2 [PS4]",
      "deviceNorm": "qanba drone 2",
      "make": "Qanba",
      "model": "Drone 2",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "PS4",
      "outputMode": "PS4",
      "connectionTag": "Wired",
      "modeLabel": "PS4",
      "modeDisplay": "PS4",
      "rankMode": "Wired Arcade Stick",
      "overallRank": 150,
      "modeRank": 21,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC",
        "PS4"
      ],
      "deviceTypes": [
        "Wired Arcade Stick"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "Bronze",
      "averageMs": 11.632,
      "sdMs": 1.159,
      "maxMs": 13.76,
      "minMs": 9.48,
      "p99Ms": 13.62,
      "sampleCount": 2072,
      "sameFramePct": 30.21,
      "observedSameFramePct": 30.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "qanba - drone 2 qanba drone 2 qanba drone 2 wired usb wired ps4 ps4 wired ps4 ps4 wired arcade stick wired arcade stick published published arcade stick bronze bronze 10-15ms (silver) unknown closed source mister / pc ps4 raw capture qanba - drone 2 [ps4] qanba - drone 2 qanba - drone 2 [ps4] wired usb wired wired ps4 ps4 ps4 ps4 ['wired arcade stick'] wired arcade stick bronze bronze arcade stick published published unknown closed source qanba - drone 2 qanba drone 2 qanba drone 2 wired usb wired ps4 ps4 wired ps4 ps4 wired arcade stick published published arcade stick bronze bronze 10-15ms (silver) unknown closed source mister / pc ps4 raw capture qanba - drone 2 [ps4] qanba - drone 2 qanba - drone 2 [ps5] wired usb wired wired ps5 ps5 ps5 ps5 ['wired arcade stick'] wired arcade stick bronze bronze arcade stick published published unknown closed source qanba - drone 2 qanba drone 2 qanba drone 2 wired usb wired ps5 ps5 wired ps5 ps5 wired arcade stick published published arcade stick bronze bronze 10-15ms (silver) unknown closed source mister / pc ps5 raw capture qanba - drone 2 [ps5] qanba - drone 2 qanba - drone 2 [pc] wired usb wired wired pc dinput dinput dinput ['wired arcade stick'] wired arcade stick bronze bronze arcade stick published published unknown closed source qanba - drone 2 qanba drone 2 qanba drone 2 wired usb wired pc dinput wired dinput dinput wired arcade stick published published arcade stick bronze bronze 10-15ms (silver) unknown closed source mister / pc raw capture qanba - drone 2 [pc]",
      "controllerGroupKey": "published|qanba drone 2",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-qanba-drone-2",
          "name": "Qanba - Drone 2",
          "measurementName": "Qanba - Drone 2 [PS4]",
          "averageMs": 11.632,
          "averageTier": "Bronze",
          "p99Ms": 13.62,
          "p99Tier": "Bronze",
          "sameFramePct": 30.21,
          "observedSameFramePct": 30.2,
          "sampleCount": 2072,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "PS4",
          "outputMode": "PS4",
          "modeLabel": "PS4",
          "modeDisplay": "PS4",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 263,
          "modeRank": 37,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "qanba - drone 2 qanba drone 2 qanba drone 2 wired usb wired ps4 ps4 wired ps4 ps4 wired arcade stick published published arcade stick bronze bronze 10-15ms (silver) unknown closed source mister / pc ps4 raw capture qanba - drone 2 [ps4]"
        },
        {
          "id": "published-qanba-drone-2-2",
          "name": "Qanba - Drone 2",
          "measurementName": "Qanba - Drone 2 [PS5]",
          "averageMs": 11.698,
          "averageTier": "Bronze",
          "p99Ms": 13.78,
          "p99Tier": "Bronze",
          "sameFramePct": 29.81,
          "observedSameFramePct": 29.8,
          "sampleCount": 2341,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "PS5",
          "outputMode": "PS5",
          "modeLabel": "PS5",
          "modeDisplay": "PS5",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 265,
          "modeRank": 38,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "qanba - drone 2 qanba drone 2 qanba drone 2 wired usb wired ps5 ps5 wired ps5 ps5 wired arcade stick published published arcade stick bronze bronze 10-15ms (silver) unknown closed source mister / pc ps5 raw capture qanba - drone 2 [ps5]"
        },
        {
          "id": "published-qanba-drone-2-3",
          "name": "Qanba - Drone 2",
          "measurementName": "Qanba - Drone 2 [PC]",
          "averageMs": 11.961,
          "averageTier": "Bronze",
          "p99Ms": 13.98,
          "p99Tier": "Bronze",
          "sameFramePct": 28.23,
          "observedSameFramePct": 28.2,
          "sampleCount": 2079,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "PC",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Arcade Stick"
          ],
          "rankMode": "Wired Arcade Stick",
          "overallRank": 268,
          "modeRank": 39,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "qanba - drone 2 qanba drone 2 qanba drone 2 wired usb wired pc dinput wired dinput dinput wired arcade stick published published arcade stick bronze bronze 10-15ms (silver) unknown closed source mister / pc raw capture qanba - drone 2 [pc]"
        }
      ]
    },
    {
      "id": "published-gravis-gamepad-pro",
      "name": "Gravis - GamePad Pro",
      "measurementName": "Gravis GamePad Pro [Wired USB]",
      "deviceNorm": "gravis gamepad pro",
      "make": "Gravis",
      "model": "GamePad Pro",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 151,
      "modeRank": 70,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "4.00",
      "dateAdded": "8/8/2021",
      "dateAddedSort": "2021-08-08",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 11.813,
      "sdMs": 5.854,
      "maxMs": 22.44,
      "minMs": 1.28,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 29.12,
      "observedSameFramePct": 33.1,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0428:4001",
      "searchText": "gravis - gamepad pro gravis gamepad pro gravis gamepad pro wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no 4.00 bronze 10-15ms (silver) unknown closed source mister / pc 0428:4001 gravis gamepad pro [wired usb] gravis - gamepad pro gravis gamepad pro [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller bronze controller 4 no 4.00 published published unknown closed source gravis - gamepad pro gravis gamepad pro gravis gamepad pro wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 4.00 bronze 10-15ms (silver) unknown closed source mister / pc 0428:4001 gravis gamepad pro [wired usb]",
      "controllerGroupKey": "published|gravis gamepad pro",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-gravis-gamepad-pro",
          "name": "Gravis - GamePad Pro",
          "measurementName": "Gravis GamePad Pro [Wired USB]",
          "averageMs": 11.813,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 29.12,
          "observedSameFramePct": 33.1,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 266,
          "modeRank": 86,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "4.00",
          "dateAdded": "8/8/2021",
          "dateAddedSort": "2021-08-08",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "0428:4001",
          "searchText": "gravis - gamepad pro gravis gamepad pro gravis gamepad pro wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 4.00 bronze 10-15ms (silver) unknown closed source mister / pc 0428:4001 gravis gamepad pro [wired usb]"
        }
      ]
    },
    {
      "id": "published-mayflash-gamecube-controler-adapter",
      "name": "Mayflash - Gamecube Controler Adapter",
      "measurementName": "Mayflash - Gamecube Controler Adapter [PC USB]",
      "deviceNorm": "mayflash gamecube controler adapter",
      "make": "Mayflash",
      "model": "Gamecube Controler Adapter",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "PC USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 152,
      "modeRank": 29,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "GameCube Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "Bronze",
      "averageMs": 11.944,
      "sdMs": 2.266,
      "maxMs": 17.98,
      "minMs": 8.06,
      "p99Ms": 15.98,
      "sampleCount": 4231,
      "sameFramePct": 28.34,
      "observedSameFramePct": 28.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "mayflash - gamecube controler adapter mayflash gamecube controler adapter mayflash gamecube controler adapter wired usb wired pc usb dinput wired dinput dinput controller adapter gamecube controller controller adapter published published controller adapter bronze bronze 10-15ms (silver) unknown closed source mister / pc raw capture mayflash - gamecube controler adapter [pc usb] mayflash - gamecube controler adapter mayflash - gamecube controler adapter [pc usb] wired usb wired wired pc usb dinput dinput dinput ['controller adapter', 'gamecube controller'] controller adapter bronze bronze controller adapter published published unknown closed source mayflash - gamecube controler adapter mayflash gamecube controler adapter mayflash gamecube controler adapter wired usb wired pc usb dinput wired dinput dinput controller adapter gamecube controller published published controller adapter bronze bronze 10-15ms (silver) unknown closed source mister / pc raw capture mayflash - gamecube controler adapter [pc usb]",
      "controllerGroupKey": "published|mayflash gamecube controler adapter",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-mayflash-gamecube-controler-adapter",
          "name": "Mayflash - Gamecube Controler Adapter",
          "measurementName": "Mayflash - Gamecube Controler Adapter [PC USB]",
          "averageMs": 11.944,
          "averageTier": "Bronze",
          "p99Ms": 15.98,
          "p99Tier": "Bronze",
          "sameFramePct": 28.34,
          "observedSameFramePct": 28.3,
          "sampleCount": 4231,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "PC USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "GameCube Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 267,
          "modeRank": 67,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "mayflash - gamecube controler adapter mayflash gamecube controler adapter mayflash gamecube controler adapter wired usb wired pc usb dinput wired dinput dinput controller adapter gamecube controller published published controller adapter bronze bronze 10-15ms (silver) unknown closed source mister / pc raw capture mayflash - gamecube controler adapter [pc usb]"
        }
      ]
    },
    {
      "id": "published-retro-fighters-defender-wireless",
      "name": "Retro Fighters - Defender Wireless",
      "measurementName": "RetroFighters - Defender Wireless",
      "deviceNorm": "retro fighters defender wireless",
      "make": "RetroFighters",
      "model": "Defender Wireless",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wireless",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "",
      "connectionTag": "Wireless",
      "modeLabel": "Wireless",
      "modeDisplay": "Wireless",
      "rankMode": "Wireless Controller",
      "overallRank": 153,
      "modeRank": 12,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "Copper",
      "averageMs": 13.729,
      "sdMs": 2.42,
      "maxMs": 25.0,
      "minMs": 8.02,
      "p99Ms": 18.182,
      "sampleCount": 2161,
      "sameFramePct": 17.63,
      "observedSameFramePct": 18.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "retro fighters - defender wireless retro fighters defender wireless retrofighters defender wireless wireless wireless wireless wireless wireless wireless controller wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture retrofighters - defender wireless retrofighters - defender wireless retrofighters - defender wireless wireless wireless wireless wireless wireless ['wireless controller'] wireless controller bronze copper controller published published unknown closed source retrofighters - defender wireless retrofighters defender wireless retrofighters defender wireless wireless wireless wireless wireless wireless wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture retrofighters - defender wireless",
      "controllerGroupKey": "published|retro fighters defender wireless",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-retrofighters-defender-wireless",
          "name": "RetroFighters - Defender Wireless",
          "measurementName": "RetroFighters - Defender Wireless",
          "averageMs": 13.729,
          "averageTier": "Bronze",
          "p99Ms": 18.182,
          "p99Tier": "Copper",
          "sameFramePct": 17.63,
          "observedSameFramePct": 18.3,
          "sampleCount": 2161,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless",
          "modeRaw": "",
          "outputMode": "",
          "modeLabel": "Wireless",
          "modeDisplay": "Wireless",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 271,
          "modeRank": 44,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "retrofighters - defender wireless retrofighters defender wireless retrofighters defender wireless wireless wireless wireless wireless wireless wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture retrofighters - defender wireless"
        }
      ]
    },
    {
      "id": "published-nintendo-switch-online-n64",
      "name": "Nintendo Switch Online - N64",
      "measurementName": "Nintendo Switch Online - N64 [BT]",
      "deviceNorm": "nintendo switch online n64",
      "make": "Nintendo Switch Online",
      "model": "N64",
      "link": "https://www.amazon.com/Nintendo-Controller-Switch-Online-N64-Official/dp/B09KT1B7N3",
      "amazon": "",
      "buyUrl": "https://www.amazon.com/Nintendo-Controller-Switch-Online-N64-Official/dp/B09KT1B7N3",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT",
      "outputMode": "",
      "connectionTag": "Wireless BT",
      "modeLabel": "Bluetooth",
      "modeDisplay": "Bluetooth",
      "rankMode": "Wireless Controller",
      "overallRank": 154,
      "modeRank": 13,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "9/2/2023",
      "dateAddedSort": "2023-09-02",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "Copper",
      "averageMs": 13.786,
      "sdMs": 4.378,
      "maxMs": 31.49,
      "minMs": 3.29,
      "p99Ms": 21.16,
      "sampleCount": 2073,
      "sameFramePct": 17.28,
      "observedSameFramePct": 21.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "nintendo switch online - n64 nintendo switch online n64 nintendo switch online n64 bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller wireless controller published published controller bronze copper 10-15ms (silver) actively sold closed source mister / pc raw capture buy link nintendo switch online - n64 [bt] nintendo switch online - n64 nintendo switch online - n64 [bt] bluetooth wireless wireless bt bt bluetooth bluetooth ['wireless controller'] wireless controller bronze copper controller published published actively sold closed source nintendo switch online - n64 nintendo switch online n64 nintendo switch online n64 bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller published published controller bronze copper 10-15ms (silver) actively sold closed source mister / pc raw capture buy link nintendo switch online - n64 [bt] nintendo - switch online n64 nintendo switch online n64 [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless controller'] wireless controller bronze controller 6 published published actively sold closed source nintendo - switch online n64 nintendo switch online n64 nintendo switch online n64 bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 6 bronze 10-15ms (silver) actively sold closed source mister / pc switch buy link nintendo switch online n64 [bt (csr8510)] nintendo switch online - n64 nintendo switch online - n64 [usb] wired usb wired wired usb dinput dinput dinput ['wired controller'] wired controller copper copper controller published published actively sold closed source nintendo switch online - n64 nintendo switch online n64 nintendo switch online n64 wired usb wired usb dinput wired dinput dinput wired controller published published controller copper copper 15-20ms (bronze) actively sold closed source mister / pc raw capture buy link nintendo switch online - n64 [usb] nintendo - switch online n64 nintendo switch online n64 [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller copper controller 6 published published actively sold closed source nintendo - switch online n64 nintendo switch online n64 nintendo switch online n64 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 copper 15-20ms (bronze) actively sold closed source mister / pc 057e:2019 buy link nintendo switch online n64 [wired usb]",
      "controllerGroupKey": "published|nintendo switch online n64",
      "modeVariantCount": 4,
      "modeVariants": [
        {
          "id": "published-nintendo-switch-online-n64",
          "name": "Nintendo Switch Online - N64",
          "measurementName": "Nintendo Switch Online - N64 [BT]",
          "averageMs": 13.786,
          "averageTier": "Bronze",
          "p99Ms": 21.16,
          "p99Tier": "Copper",
          "sameFramePct": 17.28,
          "observedSameFramePct": 21.6,
          "sampleCount": 2073,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 272,
          "modeRank": 45,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.amazon.com/Nintendo-Controller-Switch-Online-N64-Official/dp/B09KT1B7N3",
          "link": "https://www.amazon.com/Nintendo-Controller-Switch-Online-N64-Official/dp/B09KT1B7N3",
          "amazon": "",
          "joystickId": "",
          "searchText": "nintendo switch online - n64 nintendo switch online n64 nintendo switch online n64 bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller published published controller bronze copper 10-15ms (silver) actively sold closed source mister / pc raw capture buy link nintendo switch online - n64 [bt]"
        },
        {
          "id": "published-nintendo-switch-online-n64-2",
          "name": "Nintendo - Switch Online N64",
          "measurementName": "Nintendo Switch Online N64 [BT (CSR8510)]",
          "averageMs": 13.79,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 17.26,
          "observedSameFramePct": 21.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 273,
          "modeRank": 46,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "9/2/2023",
          "dateAddedSort": "2023-09-02",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.amazon.com/Nintendo-Controller-Switch-Online-N64-Official/dp/B09KT1B7N3",
          "link": "https://www.amazon.com/Nintendo-Controller-Switch-Online-N64-Official/dp/B09KT1B7N3",
          "amazon": "",
          "joystickId": "",
          "searchText": "nintendo - switch online n64 nintendo switch online n64 nintendo switch online n64 bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 6 bronze 10-15ms (silver) actively sold closed source mister / pc switch buy link nintendo switch online n64 [bt (csr8510)]"
        },
        {
          "id": "published-nintendo-switch-online-n64-3",
          "name": "Nintendo Switch Online - N64",
          "measurementName": "Nintendo Switch Online - N64 [USB]",
          "averageMs": 19.657,
          "averageTier": "Copper",
          "p99Ms": 31.44,
          "p99Tier": "Copper",
          "sameFramePct": 0,
          "observedSameFramePct": 7.0,
          "sampleCount": 2377,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 311,
          "modeRank": 88,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.amazon.com/Nintendo-Controller-Switch-Online-N64-Official/dp/B09KT1B7N3",
          "link": "https://www.amazon.com/Nintendo-Controller-Switch-Online-N64-Official/dp/B09KT1B7N3",
          "amazon": "",
          "joystickId": "",
          "searchText": "nintendo switch online - n64 nintendo switch online n64 nintendo switch online n64 wired usb wired usb dinput wired dinput dinput wired controller published published controller copper copper 15-20ms (bronze) actively sold closed source mister / pc raw capture buy link nintendo switch online - n64 [usb]"
        },
        {
          "id": "published-nintendo-switch-online-n64-4",
          "name": "Nintendo - Switch Online N64",
          "measurementName": "Nintendo Switch Online N64 [Wired USB]",
          "averageMs": 19.66,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 6.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 312,
          "modeRank": 89,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "9/2/2023",
          "dateAddedSort": "2023-09-02",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.amazon.com/Nintendo-Controller-Switch-Online-N64-Official/dp/B09KT1B7N3",
          "link": "https://www.amazon.com/Nintendo-Controller-Switch-Online-N64-Official/dp/B09KT1B7N3",
          "amazon": "",
          "joystickId": "057e:2019",
          "searchText": "nintendo - switch online n64 nintendo switch online n64 nintendo switch online n64 wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 copper 15-20ms (bronze) actively sold closed source mister / pc 057e:2019 buy link nintendo switch online n64 [wired usb]"
        }
      ]
    },
    {
      "id": "published-nintendo-switch-pro",
      "name": "Nintendo - Switch Pro",
      "measurementName": "Nintendo Switch Pro [BT (CSR8510)]",
      "deviceNorm": "nintendo switch pro",
      "make": "Nintendo",
      "model": "Switch Pro",
      "link": "https://amzn.to/2zlcONl",
      "amazon": "",
      "buyUrl": "https://amzn.to/2zlcONl",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT (CSR8510)",
      "outputMode": "",
      "connectionTag": "Wireless BT",
      "modeLabel": "Bluetooth",
      "modeDisplay": "Bluetooth",
      "rankMode": "Wireless Controller",
      "overallRank": 155,
      "modeRank": 14,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "8.70",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC",
        "Switch"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 13.939,
      "sdMs": 4.543,
      "maxMs": 36.676,
      "minMs": 5.168,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 16.37,
      "observedSameFramePct": 21.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "057e:2009",
      "searchText": "nintendo - switch pro nintendo switch pro nintendo switch pro bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller wireless controller published published controller 4 yes 8.70 bronze 10-15ms (silver) actively sold closed source mister / pc switch 057e:2009 buy link nintendo switch pro [bt (csr8510)] nintendo - switch pro nintendo switch pro [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless controller'] wireless controller bronze controller 4 yes 8.70 published published actively sold closed source nintendo - switch pro nintendo switch pro nintendo switch pro bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 8.70 bronze 10-15ms (silver) actively sold closed source mister / pc switch 057e:2009 buy link nintendo switch pro [bt (csr8510)] nintendo - switch pro nintendo switch pro [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller copper controller 4 yes published published actively sold closed source nintendo - switch pro nintendo switch pro nintendo switch pro wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes copper 15-20ms (bronze) actively sold closed source mister / pc switch 057e:2009 buy link nintendo switch pro [wired usb] nintendo - switch pro nintendo switch pro [8bitdo usb adapter dinput] bluetooth wireless wireless bt 8bitdo usb adapter dinput dinput dinput dinput ['wireless controller'] wireless controller copper controller 4 yes 8.70 published published actively sold closed source nintendo - switch pro nintendo switch pro nintendo switch pro bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 yes 8.70 copper 15-20ms (bronze) actively sold closed source mister / pc switch 2dc8:3100 buy link nintendo switch pro [8bitdo usb adapter dinput] nintendo - switch pro nintendo switch pro [8bitdo usb adapter macos] bluetooth wireless wireless bt 8bitdo usb adapter macos dinput, macos dinput, macos dinput, macos ['wireless controller'] wireless controller copper controller 4 yes 8.70 published published actively sold closed source nintendo - switch pro nintendo switch pro nintendo switch pro bluetooth wireless 8bitdo usb adapter macos dinput, macos wireless bt dinput, macos dinput, macos wireless controller published published controller 4 yes 8.70 copper 20ms+ (rust) actively sold closed source mister / pc 054c:05c4 buy link nintendo switch pro [8bitdo usb adapter macos]",
      "controllerGroupKey": "published|nintendo switch pro",
      "modeVariantCount": 4,
      "modeVariants": [
        {
          "id": "published-nintendo-switch-pro",
          "name": "Nintendo - Switch Pro",
          "measurementName": "Nintendo Switch Pro [BT (CSR8510)]",
          "averageMs": 13.939,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 16.37,
          "observedSameFramePct": 21.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 275,
          "modeRank": 48,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "8.70",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2zlcONl",
          "link": "https://amzn.to/2zlcONl",
          "amazon": "",
          "joystickId": "057e:2009",
          "searchText": "nintendo - switch pro nintendo switch pro nintendo switch pro bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 8.70 bronze 10-15ms (silver) actively sold closed source mister / pc switch 057e:2009 buy link nintendo switch pro [bt (csr8510)]"
        },
        {
          "id": "published-nintendo-switch-pro-2",
          "name": "Nintendo - Switch Pro",
          "measurementName": "Nintendo Switch Pro [Wired USB]",
          "averageMs": 18.355,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 7.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 304,
          "modeRank": 87,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "9/12/2020",
          "dateAddedSort": "2020-09-12",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2zlcONl",
          "link": "https://amzn.to/2zlcONl",
          "amazon": "",
          "joystickId": "057e:2009",
          "searchText": "nintendo - switch pro nintendo switch pro nintendo switch pro wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 yes copper 15-20ms (bronze) actively sold closed source mister / pc switch 057e:2009 buy link nintendo switch pro [wired usb]"
        },
        {
          "id": "published-nintendo-switch-pro-3",
          "name": "Nintendo - Switch Pro",
          "measurementName": "Nintendo Switch Pro [8BitDo USB Adapter Dinput]",
          "averageMs": 19.881,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 8.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 314,
          "modeRank": 81,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "8.70",
          "dateAdded": "6/6/2020",
          "dateAddedSort": "2020-06-06",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2zlcONl",
          "link": "https://amzn.to/2zlcONl",
          "amazon": "",
          "joystickId": "2dc8:3100",
          "searchText": "nintendo - switch pro nintendo switch pro nintendo switch pro bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 yes 8.70 copper 15-20ms (bronze) actively sold closed source mister / pc switch 2dc8:3100 buy link nintendo switch pro [8bitdo usb adapter dinput]"
        },
        {
          "id": "published-nintendo-switch-pro-4",
          "name": "Nintendo - Switch Pro",
          "measurementName": "Nintendo Switch Pro [8BitDo USB Adapter MacOS]",
          "averageMs": 20.729,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 5.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter MacOS",
          "outputMode": "DInput, macOS",
          "modeLabel": "DInput, macOS",
          "modeDisplay": "DInput, macOS",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 319,
          "modeRank": 86,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "8.70",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2zlcONl",
          "link": "https://amzn.to/2zlcONl",
          "amazon": "",
          "joystickId": "054c:05c4",
          "searchText": "nintendo - switch pro nintendo switch pro nintendo switch pro bluetooth wireless 8bitdo usb adapter macos dinput, macos wireless bt dinput, macos dinput, macos wireless controller published published controller 4 yes 8.70 copper 20ms+ (rust) actively sold closed source mister / pc 054c:05c4 buy link nintendo switch pro [8bitdo usb adapter macos]"
        }
      ]
    },
    {
      "id": "published-microsoft-wireless-controller",
      "name": "Microsoft - Wireless Controller",
      "measurementName": "Microsoft - Wireless Controller [BT+AC600 Driver Free]",
      "deviceNorm": "microsoft wireless controller",
      "make": "Microsoft",
      "model": "Wireless Controller",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT+AC600 Driver Free",
      "outputMode": "",
      "connectionTag": "Wireless BT",
      "modeLabel": "Bluetooth",
      "modeDisplay": "Bluetooth",
      "rankMode": "Wireless Controller",
      "overallRank": 156,
      "modeRank": 15,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "Rust",
      "averageMs": 14.084,
      "sdMs": 7.232,
      "maxMs": 87.76,
      "minMs": 5.36,
      "p99Ms": 46.886,
      "sampleCount": 2403,
      "sameFramePct": 15.5,
      "observedSameFramePct": 24.1,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "microsoft - wireless controller microsoft wireless controller microsoft wireless controller bluetooth wireless bt+ac600 driver free wireless bt bluetooth bluetooth wireless controller wireless controller published published controller bronze rust 10-15ms (silver) unknown closed source mister / pc raw capture microsoft - wireless controller [bt+ac600 driver free] microsoft - wireless controller microsoft - wireless controller [bt+ac600 driver free] bluetooth wireless wireless bt bt+ac600 driver free bluetooth bluetooth ['wireless controller'] wireless controller bronze rust controller published published unknown closed source microsoft - wireless controller microsoft wireless controller microsoft wireless controller bluetooth wireless bt+ac600 driver free wireless bt bluetooth bluetooth wireless controller published published controller bronze rust 10-15ms (silver) unknown closed source mister / pc raw capture microsoft - wireless controller [bt+ac600 driver free]",
      "controllerGroupKey": "published|microsoft wireless controller",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-microsoft-wireless-controller",
          "name": "Microsoft - Wireless Controller",
          "measurementName": "Microsoft - Wireless Controller [BT+AC600 Driver Free]",
          "averageMs": 14.084,
          "averageTier": "Bronze",
          "p99Ms": 46.886,
          "p99Tier": "Rust",
          "sameFramePct": 15.5,
          "observedSameFramePct": 24.1,
          "sampleCount": 2403,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT+AC600 Driver Free",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 276,
          "modeRank": 49,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "microsoft - wireless controller microsoft wireless controller microsoft wireless controller bluetooth wireless bt+ac600 driver free wireless bt bluetooth bluetooth wireless controller published published controller bronze rust 10-15ms (silver) unknown closed source mister / pc raw capture microsoft - wireless controller [bt+ac600 driver free]"
        }
      ]
    },
    {
      "id": "published-aliexpress-gamecube-wireless",
      "name": "AliExpress - Gamecube Wireless",
      "measurementName": "AliExpress - Gamecube Wireless [2.4GHz]",
      "deviceNorm": "aliexpress gamecube wireless",
      "make": "AliExpress",
      "model": "Gamecube Wireless",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "2.4GHz Wireless",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "2.4GHz",
      "outputMode": "",
      "connectionTag": "Wireless 2.4GHz",
      "modeLabel": "2.4G",
      "modeDisplay": "2.4GHz Wireless",
      "rankMode": "Wireless Controller",
      "overallRank": 157,
      "modeRank": 16,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "Copper",
      "averageMs": 14.958,
      "sdMs": 3.042,
      "maxMs": 27.87,
      "minMs": 9.57,
      "p99Ms": 25.354,
      "sampleCount": 2108,
      "sameFramePct": 10.25,
      "observedSameFramePct": 13.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "aliexpress - gamecube wireless aliexpress gamecube wireless aliexpress gamecube wireless 2.4ghz wireless wireless 2.4ghz wireless 2.4ghz 2.4g 2.4ghz wireless wireless controller wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture aliexpress - gamecube wireless [2.4ghz] aliexpress - gamecube wireless aliexpress - gamecube wireless [2.4ghz] 2.4ghz wireless wireless wireless 2.4ghz 2.4ghz 2.4g 2.4ghz wireless ['wireless controller'] wireless controller bronze copper controller published published unknown closed source aliexpress - gamecube wireless aliexpress gamecube wireless aliexpress gamecube wireless 2.4ghz wireless wireless 2.4ghz wireless 2.4ghz 2.4g 2.4ghz wireless wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture aliexpress - gamecube wireless [2.4ghz]",
      "controllerGroupKey": "published|aliexpress gamecube wireless",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-aliexpress-gamecube-wireless",
          "name": "AliExpress - Gamecube Wireless",
          "measurementName": "AliExpress - Gamecube Wireless [2.4GHz]",
          "averageMs": 14.958,
          "averageTier": "Bronze",
          "p99Ms": 25.354,
          "p99Tier": "Copper",
          "sameFramePct": 10.25,
          "observedSameFramePct": 13.6,
          "sampleCount": 2108,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4GHz Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "2.4GHz",
          "outputMode": "",
          "modeLabel": "2.4G",
          "modeDisplay": "2.4GHz Wireless",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 281,
          "modeRank": 54,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "aliexpress - gamecube wireless aliexpress gamecube wireless aliexpress gamecube wireless 2.4ghz wireless wireless 2.4ghz wireless 2.4ghz 2.4g 2.4ghz wireless wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture aliexpress - gamecube wireless [2.4ghz]"
        }
      ]
    },
    {
      "id": "published-8bitdo-64-bluetooth-controller",
      "name": "8BitDo - 64 Bluetooth Controller",
      "measurementName": "8BitDo 64 Bluetooth Controller [BT (CSR8510)]",
      "deviceNorm": "8bitdo 64 bluetooth controller",
      "make": "8BitDo",
      "model": "64 Bluetooth Controller",
      "link": "https://amzn.to/46zf7tg",
      "amazon": "",
      "buyUrl": "https://amzn.to/46zf7tg",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT (CSR8510)",
      "outputMode": "",
      "connectionTag": "Wireless BT",
      "modeLabel": "Bluetooth",
      "modeDisplay": "Bluetooth",
      "rankMode": "Wireless Controller",
      "overallRank": 158,
      "modeRank": 17,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "",
      "dateAdded": "8/1/2025",
      "dateAddedSort": "2025-08-01",
      "platforms": [],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 14.964,
      "sdMs": 4.332,
      "maxMs": 30.63,
      "minMs": 3.8,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 10.22,
      "observedSameFramePct": 16.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "8bitdo - 64 bluetooth controller 8bitdo 64 bluetooth controller 8bitdo 64 bluetooth controller bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller wireless controller published published controller 6 yes bronze 10-15ms (silver) actively sold closed source buy link 8bitdo 64 bluetooth controller [bt (csr8510)] 8bitdo - 64 bluetooth controller 8bitdo 64 bluetooth controller [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless controller'] wireless controller bronze controller 6 yes published published actively sold closed source 8bitdo - 64 bluetooth controller 8bitdo 64 bluetooth controller 8bitdo 64 bluetooth controller bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 6 yes bronze 10-15ms (silver) actively sold closed source buy link 8bitdo 64 bluetooth controller [bt (csr8510)]",
      "controllerGroupKey": "published|8bitdo 64 bluetooth controller",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-8bitdo-64-bluetooth-controller",
          "name": "8BitDo - 64 Bluetooth Controller",
          "measurementName": "8BitDo 64 Bluetooth Controller [BT (CSR8510)]",
          "averageMs": 14.964,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 10.22,
          "observedSameFramePct": 16.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 282,
          "modeRank": 55,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "",
          "dateAdded": "8/1/2025",
          "dateAddedSort": "2025-08-01",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/46zf7tg",
          "link": "https://amzn.to/46zf7tg",
          "amazon": "",
          "joystickId": "",
          "searchText": "8bitdo - 64 bluetooth controller 8bitdo 64 bluetooth controller 8bitdo 64 bluetooth controller bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 6 yes bronze 10-15ms (silver) actively sold closed source buy link 8bitdo 64 bluetooth controller [bt (csr8510)]"
        }
      ]
    },
    {
      "id": "published-nintendo-switch-online-genesis",
      "name": "Nintendo Switch Online - Genesis",
      "measurementName": "Nintendo Switch Online - Genesis [BT]",
      "deviceNorm": "nintendo switch online genesis",
      "make": "Nintendo Switch Online",
      "model": "Genesis",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT",
      "outputMode": "",
      "connectionTag": "Wireless BT",
      "modeLabel": "Bluetooth",
      "modeDisplay": "Bluetooth",
      "rankMode": "Wireless Controller",
      "overallRank": 159,
      "modeRank": 18,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "10-15ms (Silver)",
      "averageTier": "Bronze",
      "p99Tier": "Copper",
      "averageMs": 14.968,
      "sdMs": 4.57,
      "maxMs": 31.82,
      "minMs": 0.04,
      "p99Ms": 22.845,
      "sampleCount": 3450,
      "sameFramePct": 10.19,
      "observedSameFramePct": 17.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "nintendo switch online - genesis nintendo switch online genesis nintendo switch online genesis bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture nintendo switch online - genesis [bt] nintendo switch online - genesis nintendo switch online - genesis [bt] bluetooth wireless wireless bt bt bluetooth bluetooth ['wireless controller'] wireless controller bronze copper controller published published unknown closed source nintendo switch online - genesis nintendo switch online genesis nintendo switch online genesis bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture nintendo switch online - genesis [bt]",
      "controllerGroupKey": "published|nintendo switch online genesis",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-nintendo-switch-online-genesis",
          "name": "Nintendo Switch Online - Genesis",
          "measurementName": "Nintendo Switch Online - Genesis [BT]",
          "averageMs": 14.968,
          "averageTier": "Bronze",
          "p99Ms": 22.845,
          "p99Tier": "Copper",
          "sameFramePct": 10.19,
          "observedSameFramePct": 17.3,
          "sampleCount": 3450,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 283,
          "modeRank": 56,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "nintendo switch online - genesis nintendo switch online genesis nintendo switch online genesis bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller published published controller bronze copper 10-15ms (silver) unknown closed source mister / pc raw capture nintendo switch online - genesis [bt]"
        }
      ]
    },
    {
      "id": "published-nintendo-switch-online-snes",
      "name": "Nintendo - Switch Online SNES",
      "measurementName": "Nintendo Switch Online SNES [BT (CSR8510)]",
      "deviceNorm": "nintendo switch online snes",
      "make": "Nintendo",
      "model": "Switch Online SNES",
      "link": "https://amzn.to/3TVQOvz",
      "amazon": "",
      "buyUrl": "https://amzn.to/3TVQOvz",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT (CSR8510)",
      "outputMode": "",
      "connectionTag": "Wireless BT",
      "modeLabel": "Bluetooth",
      "modeDisplay": "Bluetooth",
      "rankMode": "Wireless Controller",
      "overallRank": 160,
      "modeRank": 19,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "3.40",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "15-20ms (Bronze)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 15.629,
      "sdMs": 4.601,
      "maxMs": 47.272,
      "minMs": 6.46,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 6.23,
      "observedSameFramePct": 14.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "057e:2017",
      "searchText": "nintendo - switch online snes nintendo switch online snes nintendo switch online snes bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller wireless controller published published controller 4 no 3.40 bronze 15-20ms (bronze) actively sold closed source mister / pc 057e:2017 buy link nintendo switch online snes [bt (csr8510)] nintendo - switch online snes nintendo switch online snes [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless controller'] wireless controller bronze controller 4 no 3.40 published published actively sold closed source nintendo - switch online snes nintendo switch online snes nintendo switch online snes bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 no 3.40 bronze 15-20ms (bronze) actively sold closed source mister / pc 057e:2017 buy link nintendo switch online snes [bt (csr8510)] nintendo - switch online snes nintendo switch online snes [8bitdo usb adapter x-input] bluetooth wireless wireless bt 8bitdo usb adapter x-input dinput, xinput dinput, xinput dinput, xinput ['wireless controller'] wireless controller copper controller 4 no 3.40 published published actively sold closed source nintendo - switch online snes nintendo switch online snes nintendo switch online snes bluetooth wireless 8bitdo usb adapter x-input dinput, xinput wireless bt dinput, xinput dinput, xinput wireless controller published published controller 4 no 3.40 copper 15-20ms (bronze) actively sold closed source mister / pc 045e:028e buy link nintendo switch online snes [8bitdo usb adapter x-input] nintendo - switch online snes nintendo switch online snes [8bitdo usb adapter dinput] bluetooth wireless wireless bt 8bitdo usb adapter dinput dinput dinput dinput ['wireless controller'] wireless controller copper controller 4 no 3.40 published published actively sold closed source nintendo - switch online snes nintendo switch online snes nintendo switch online snes bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 2dc8:3100 buy link nintendo switch online snes [8bitdo usb adapter dinput]",
      "controllerGroupKey": "published|nintendo switch online snes",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-nintendo-switch-online-snes",
          "name": "Nintendo - Switch Online SNES",
          "measurementName": "Nintendo Switch Online SNES [BT (CSR8510)]",
          "averageMs": 15.629,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 6.23,
          "observedSameFramePct": 14.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 287,
          "modeRank": 59,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3TVQOvz",
          "link": "https://amzn.to/3TVQOvz",
          "amazon": "",
          "joystickId": "057e:2017",
          "searchText": "nintendo - switch online snes nintendo switch online snes nintendo switch online snes bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 no 3.40 bronze 15-20ms (bronze) actively sold closed source mister / pc 057e:2017 buy link nintendo switch online snes [bt (csr8510)]"
        },
        {
          "id": "published-nintendo-switch-online-snes-2",
          "name": "Nintendo - Switch Online SNES",
          "measurementName": "Nintendo Switch Online SNES [8BitDo USB Adapter X-Input]",
          "averageMs": 18.597,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 5.9,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter X-Input",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 307,
          "modeRank": 76,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "6/6/2020",
          "dateAddedSort": "2020-06-06",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3TVQOvz",
          "link": "https://amzn.to/3TVQOvz",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "nintendo - switch online snes nintendo switch online snes nintendo switch online snes bluetooth wireless 8bitdo usb adapter x-input dinput, xinput wireless bt dinput, xinput dinput, xinput wireless controller published published controller 4 no 3.40 copper 15-20ms (bronze) actively sold closed source mister / pc 045e:028e buy link nintendo switch online snes [8bitdo usb adapter x-input]"
        },
        {
          "id": "published-nintendo-switch-online-snes-3",
          "name": "Nintendo - Switch Online SNES",
          "measurementName": "Nintendo Switch Online SNES [8BitDo USB Adapter Dinput]",
          "averageMs": 20.892,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 3.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 320,
          "modeRank": 87,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.40",
          "dateAdded": "6/6/2020",
          "dateAddedSort": "2020-06-06",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3TVQOvz",
          "link": "https://amzn.to/3TVQOvz",
          "amazon": "",
          "joystickId": "2dc8:3100",
          "searchText": "nintendo - switch online snes nintendo switch online snes nintendo switch online snes bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 no 3.40 copper 20ms+ (rust) actively sold closed source mister / pc 2dc8:3100 buy link nintendo switch online snes [8bitdo usb adapter dinput]"
        }
      ]
    },
    {
      "id": "published-retro-bit-genesis-2-4-ghz",
      "name": "Retro-Bit - Genesis 2.4 GHz",
      "measurementName": "Retro-Bit Genesis 2.4 GHz [Wired USB Dinput]",
      "deviceNorm": "retro bit genesis 2 4 ghz",
      "make": "Retro-Bit",
      "model": "Genesis 2.4 GHz",
      "link": "https://amzn.to/36rUDBE",
      "amazon": "",
      "buyUrl": "https://amzn.to/36rUDBE",
      "connection": "2.4 GHz USB",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "Wired USB Dinput",
      "outputMode": "DInput",
      "connectionTag": "Wireless 2.4GHz",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wireless Controller",
      "overallRank": 161,
      "modeRank": 20,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "3.75",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "15-20ms (Bronze)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 16.604,
      "sdMs": 4.702,
      "maxMs": 30.168,
      "minMs": 6.488,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 0.38,
      "observedSameFramePct": 11.4,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:0011",
      "searchText": "retro-bit - genesis 2.4 ghz retro bit genesis 2 4 ghz retro-bit genesis 2.4 ghz 2.4 ghz usb wireless wired usb dinput dinput wireless 2.4ghz dinput dinput wireless controller wireless controller published published controller 6 yes 3.75 bronze 15-20ms (bronze) actively sold closed source mister / pc 0079:0011 buy link retro-bit genesis 2.4 ghz [wired usb dinput] retro-bit - genesis 2.4 ghz retro-bit genesis 2.4 ghz [wired usb dinput] 2.4 ghz usb wireless wireless 2.4ghz wired usb dinput dinput dinput dinput ['wireless controller'] wireless controller bronze controller 6 yes 3.75 published published actively sold closed source retro-bit - genesis 2.4 ghz retro bit genesis 2 4 ghz retro-bit genesis 2.4 ghz 2.4 ghz usb wireless wired usb dinput dinput wireless 2.4ghz dinput dinput wireless controller published published controller 6 yes 3.75 bronze 15-20ms (bronze) actively sold closed source mister / pc 0079:0011 buy link retro-bit genesis 2.4 ghz [wired usb dinput] retro-bit - genesis 2.4 ghz retro-bit genesis 2.4 ghz [wired usb xinput] 2.4 ghz usb wireless wireless 2.4ghz wired usb xinput dinput, xinput dinput, xinput dinput, xinput ['wireless controller'] wireless controller copper controller 6 yes 3.75 published published actively sold closed source retro-bit - genesis 2.4 ghz retro bit genesis 2 4 ghz retro-bit genesis 2.4 ghz 2.4 ghz usb wireless wired usb xinput dinput, xinput wireless 2.4ghz dinput, xinput dinput, xinput wireless controller published published controller 6 yes 3.75 copper 15-20ms (bronze) actively sold closed source mister / pc 045e:028e buy link retro-bit genesis 2.4 ghz [wired usb xinput] retro-bit - genesis 2.4 ghz retro-bit genesis 2.4 ghz [wired usb dinput] 2.4 ghz console wireless wireless 2.4ghz wired usb dinput dinput dinput dinput ['wireless controller'] wireless controller copper controller 6 yes 3.75 published published actively sold closed source retro-bit - genesis 2.4 ghz retro bit genesis 2 4 ghz retro-bit genesis 2.4 ghz 2.4 ghz console wireless wired usb dinput dinput wireless 2.4ghz dinput dinput wireless controller published published controller 6 yes 3.75 copper 20ms+ (rust) actively sold closed source mister / pc 2341:8036 buy link retro-bit genesis 2.4 ghz [wired usb dinput]",
      "controllerGroupKey": "published|retro bit genesis 2 4 ghz",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-retro-bit-genesis-2-4-ghz",
          "name": "Retro-Bit - Genesis 2.4 GHz",
          "measurementName": "Retro-Bit Genesis 2.4 GHz [Wired USB Dinput]",
          "averageMs": 16.604,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0.38,
          "observedSameFramePct": 11.4,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 293,
          "modeRank": 64,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "3.75",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/36rUDBE",
          "link": "https://amzn.to/36rUDBE",
          "amazon": "",
          "joystickId": "0079:0011",
          "searchText": "retro-bit - genesis 2.4 ghz retro bit genesis 2 4 ghz retro-bit genesis 2.4 ghz 2.4 ghz usb wireless wired usb dinput dinput wireless 2.4ghz dinput dinput wireless controller published published controller 6 yes 3.75 bronze 15-20ms (bronze) actively sold closed source mister / pc 0079:0011 buy link retro-bit genesis 2.4 ghz [wired usb dinput]"
        },
        {
          "id": "published-retro-bit-genesis-2-4-ghz-2",
          "name": "Retro-Bit - Genesis 2.4 GHz",
          "measurementName": "Retro-Bit Genesis 2.4 GHz [Wired USB Xinput]",
          "averageMs": 17.008,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 12.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Wired USB Xinput",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 297,
          "modeRank": 68,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "3.75",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/36rUDBE",
          "link": "https://amzn.to/36rUDBE",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "retro-bit - genesis 2.4 ghz retro bit genesis 2 4 ghz retro-bit genesis 2.4 ghz 2.4 ghz usb wireless wired usb xinput dinput, xinput wireless 2.4ghz dinput, xinput dinput, xinput wireless controller published published controller 6 yes 3.75 copper 15-20ms (bronze) actively sold closed source mister / pc 045e:028e buy link retro-bit genesis 2.4 ghz [wired usb xinput]"
        },
        {
          "id": "published-retro-bit-genesis-2-4-ghz-3",
          "name": "Retro-Bit - Genesis 2.4 GHz",
          "measurementName": "Retro-Bit Genesis 2.4 GHz [Wired USB Dinput]",
          "averageMs": 29.667,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 90.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz Console",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 332,
          "modeRank": 93,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "3.75",
          "dateAdded": "5/30/2020",
          "dateAddedSort": "2020-05-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/36rUDBE",
          "link": "https://amzn.to/36rUDBE",
          "amazon": "",
          "joystickId": "2341:8036",
          "searchText": "retro-bit - genesis 2.4 ghz retro bit genesis 2 4 ghz retro-bit genesis 2.4 ghz 2.4 ghz console wireless wired usb dinput dinput wireless 2.4ghz dinput dinput wireless controller published published controller 6 yes 3.75 copper 20ms+ (rust) actively sold closed source mister / pc 2341:8036 buy link retro-bit genesis 2.4 ghz [wired usb dinput]"
        }
      ]
    },
    {
      "id": "published-retro-bit-saturn-2-4-ghz",
      "name": "Retro-Bit - Saturn 2.4 GHz",
      "measurementName": "Retro-Bit Saturn 2.4 GHz [2.4GHz Saturn]",
      "deviceNorm": "retro bit saturn 2 4 ghz",
      "make": "Retro-Bit",
      "model": "Saturn 2.4 GHz",
      "link": "https://amzn.to/3edV3hq",
      "amazon": "",
      "buyUrl": "https://amzn.to/3edV3hq",
      "connection": "2.4 GHz USB",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "2.4GHz Saturn",
      "outputMode": "DInput",
      "connectionTag": "Wireless 2.4GHz",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wireless Controller",
      "overallRank": 162,
      "modeRank": 21,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "4.00",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "15-20ms (Bronze)",
      "averageTier": "Bronze",
      "p99Tier": "",
      "averageMs": 16.62,
      "sdMs": 4.814,
      "maxMs": 28.532,
      "minMs": 6.384,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 0.28,
      "observedSameFramePct": 11.7,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "retro-bit - saturn 2.4 ghz retro bit saturn 2 4 ghz retro-bit saturn 2.4 ghz 2.4 ghz usb wireless 2.4ghz saturn dinput wireless 2.4ghz dinput dinput wireless controller wireless controller published published controller 6 yes 4.00 bronze 15-20ms (bronze) actively sold closed source buy link retro-bit saturn 2.4 ghz [2.4ghz saturn] retro-bit - saturn 2.4 ghz retro-bit saturn 2.4 ghz [2.4ghz saturn] 2.4 ghz usb wireless wireless 2.4ghz 2.4ghz saturn dinput dinput dinput ['wireless controller'] wireless controller bronze controller 6 yes 4.00 published published actively sold closed source retro-bit - saturn 2.4 ghz retro bit saturn 2 4 ghz retro-bit saturn 2.4 ghz 2.4 ghz usb wireless 2.4ghz saturn dinput wireless 2.4ghz dinput dinput wireless controller published published controller 6 yes 4.00 bronze 15-20ms (bronze) actively sold closed source buy link retro-bit saturn 2.4 ghz [2.4ghz saturn] retro-bit - saturn 2.4 ghz retro-bit saturn 2.4 ghz [wired usb dinput] 2.4 ghz usb wireless wireless 2.4ghz wired usb dinput dinput dinput dinput ['wireless controller'] wireless controller copper controller 6 yes 4.00 published published actively sold closed source retro-bit - saturn 2.4 ghz retro bit saturn 2 4 ghz retro-bit saturn 2.4 ghz 2.4 ghz usb wireless wired usb dinput dinput wireless 2.4ghz dinput dinput wireless controller published published controller 6 yes 4.00 copper 15-20ms (bronze) actively sold closed source mister / pc 0079:0011 buy link retro-bit saturn 2.4 ghz [wired usb dinput] retro-bit - saturn 2.4 ghz retro-bit saturn 2.4 ghz [wired usb xinput] 2.4 ghz usb wireless wireless 2.4ghz wired usb xinput dinput, xinput dinput, xinput dinput, xinput ['wireless controller'] wireless controller copper controller 6 yes 4.00 published published actively sold closed source retro-bit - saturn 2.4 ghz retro bit saturn 2 4 ghz retro-bit saturn 2.4 ghz 2.4 ghz usb wireless wired usb xinput dinput, xinput wireless 2.4ghz dinput, xinput dinput, xinput wireless controller published published controller 6 yes 4.00 copper 15-20ms (bronze) actively sold closed source mister / pc 045e:028e buy link retro-bit saturn 2.4 ghz [wired usb xinput]",
      "controllerGroupKey": "published|retro bit saturn 2 4 ghz",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-retro-bit-saturn-2-4-ghz",
          "name": "Retro-Bit - Saturn 2.4 GHz",
          "measurementName": "Retro-Bit Saturn 2.4 GHz [2.4GHz Saturn]",
          "averageMs": 16.62,
          "averageTier": "Bronze",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0.28,
          "observedSameFramePct": 11.7,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "2.4GHz Saturn",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 294,
          "modeRank": 65,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.00",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3edV3hq",
          "link": "https://amzn.to/3edV3hq",
          "amazon": "",
          "joystickId": "",
          "searchText": "retro-bit - saturn 2.4 ghz retro bit saturn 2 4 ghz retro-bit saturn 2.4 ghz 2.4 ghz usb wireless 2.4ghz saturn dinput wireless 2.4ghz dinput dinput wireless controller published published controller 6 yes 4.00 bronze 15-20ms (bronze) actively sold closed source buy link retro-bit saturn 2.4 ghz [2.4ghz saturn]"
        },
        {
          "id": "published-retro-bit-saturn-2-4-ghz-2",
          "name": "Retro-Bit - Saturn 2.4 GHz",
          "measurementName": "Retro-Bit Saturn 2.4 GHz [Wired USB Dinput]",
          "averageMs": 16.677,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 11.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Wired USB Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 295,
          "modeRank": 66,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.00",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3edV3hq",
          "link": "https://amzn.to/3edV3hq",
          "amazon": "",
          "joystickId": "0079:0011",
          "searchText": "retro-bit - saturn 2.4 ghz retro bit saturn 2 4 ghz retro-bit saturn 2.4 ghz 2.4 ghz usb wireless wired usb dinput dinput wireless 2.4ghz dinput dinput wireless controller published published controller 6 yes 4.00 copper 15-20ms (bronze) actively sold closed source mister / pc 0079:0011 buy link retro-bit saturn 2.4 ghz [wired usb dinput]"
        },
        {
          "id": "published-retro-bit-saturn-2-4-ghz-3",
          "name": "Retro-Bit - Saturn 2.4 GHz",
          "measurementName": "Retro-Bit Saturn 2.4 GHz [Wired USB Xinput]",
          "averageMs": 16.822,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 11.5,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "2.4 GHz USB",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless 2.4GHz",
          "modeRaw": "Wired USB Xinput",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 296,
          "modeRank": 67,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "Yes",
          "weightOz": "4.00",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3edV3hq",
          "link": "https://amzn.to/3edV3hq",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "retro-bit - saturn 2.4 ghz retro bit saturn 2 4 ghz retro-bit saturn 2.4 ghz 2.4 ghz usb wireless wired usb xinput dinput, xinput wireless 2.4ghz dinput, xinput dinput, xinput wireless controller published published controller 6 yes 4.00 copper 15-20ms (bronze) actively sold closed source mister / pc 045e:028e buy link retro-bit saturn 2.4 ghz [wired usb xinput]"
        }
      ]
    },
    {
      "id": "published-flydigi-vader-2",
      "name": "FlyDigi - Vader 2",
      "measurementName": "FlyDigi - VADER2 Classic Mode [Edimax BLE]",
      "deviceNorm": "flydigi vader 2",
      "make": "FlyDigi",
      "model": "VADER2 Classic Mode",
      "link": "https://amzn.to/32dZVSZ",
      "amazon": "",
      "buyUrl": "https://amzn.to/32dZVSZ",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "Edimax BLE",
      "outputMode": "",
      "connectionTag": "Wireless BT",
      "modeLabel": "Bluetooth",
      "modeDisplay": "Bluetooth",
      "rankMode": "Wireless Controller",
      "overallRank": 163,
      "modeRank": 22,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "12/16/2021",
      "dateAddedSort": "2021-12-16",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "15-20ms (Bronze)",
      "averageTier": "Copper",
      "p99Tier": "Copper",
      "averageMs": 17.074,
      "sdMs": 12.36,
      "maxMs": 33.12,
      "minMs": 0.02,
      "p99Ms": 32.514,
      "sampleCount": 2832,
      "sameFramePct": 0,
      "observedSameFramePct": 34.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "1915:0040",
      "searchText": "flydigi - vader 2 flydigi vader 2 flydigi vader2 classic mode bluetooth wireless edimax ble wireless bt bluetooth bluetooth wireless controller wireless controller published published controller copper copper 15-20ms (bronze) actively sold closed source mister / pc 1915:0040 raw capture buy link flydigi - vader2 classic mode [edimax ble] flydigi - vader2 classic mode flydigi - vader2 classic mode [edimax ble] bluetooth wireless wireless bt edimax ble bluetooth bluetooth ['wireless controller'] wireless controller copper copper controller published published actively sold closed source flydigi - vader2 classic mode flydigi vader2 classic mode flydigi vader2 classic mode bluetooth wireless edimax ble wireless bt bluetooth bluetooth wireless controller published published controller copper copper 15-20ms (bronze) unknown closed source mister / pc raw capture flydigi - vader2 classic mode [edimax ble] flydigi - vader2 classic mode flydigi - vader2 classic mode [csr 4.0] bluetooth wireless wireless bt csr 4.0 bluetooth bluetooth ['wireless controller'] wireless controller copper copper controller published published actively sold closed source flydigi - vader2 classic mode flydigi vader2 classic mode flydigi vader2 classic mode bluetooth wireless csr 4.0 wireless bt bluetooth bluetooth wireless controller published published controller copper copper 15-20ms (bronze) unknown closed source mister / pc raw capture flydigi - vader2 classic mode [csr 4.0]",
      "controllerGroupKey": "published|flydigi vader 2",
      "modeVariantCount": 2,
      "modeVariants": [
        {
          "id": "published-flydigi-vader2-classic-mode",
          "name": "FlyDigi - VADER2 Classic Mode",
          "measurementName": "FlyDigi - VADER2 Classic Mode [Edimax BLE]",
          "averageMs": 17.074,
          "averageTier": "Copper",
          "p99Ms": 32.514,
          "p99Tier": "Copper",
          "sameFramePct": 0,
          "observedSameFramePct": 34.3,
          "sampleCount": 2832,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "Edimax BLE",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 298,
          "modeRank": 69,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "12/16/2021",
          "dateAddedSort": "2021-12-16",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/32dZVSZ",
          "link": "https://amzn.to/32dZVSZ",
          "amazon": "",
          "joystickId": "1915:0040",
          "searchText": "flydigi - vader2 classic mode flydigi vader2 classic mode flydigi vader2 classic mode bluetooth wireless edimax ble wireless bt bluetooth bluetooth wireless controller published published controller copper copper 15-20ms (bronze) unknown closed source mister / pc raw capture flydigi - vader2 classic mode [edimax ble]"
        },
        {
          "id": "published-flydigi-vader2-classic-mode-2",
          "name": "FlyDigi - VADER2 Classic Mode",
          "measurementName": "FlyDigi - VADER2 Classic Mode [CSR 4.0]",
          "averageMs": 17.802,
          "averageTier": "Copper",
          "p99Ms": 32.521,
          "p99Tier": "Copper",
          "sameFramePct": 0,
          "observedSameFramePct": 31.7,
          "sampleCount": 2787,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "CSR 4.0",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 299,
          "modeRank": 70,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "12/16/2021",
          "dateAddedSort": "2021-12-16",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/32dZVSZ",
          "link": "https://amzn.to/32dZVSZ",
          "amazon": "",
          "joystickId": "1915:0040",
          "searchText": "flydigi - vader2 classic mode flydigi vader2 classic mode flydigi vader2 classic mode bluetooth wireless csr 4.0 wireless bt bluetooth bluetooth wireless controller published published controller copper copper 15-20ms (bronze) unknown closed source mister / pc raw capture flydigi - vader2 classic mode [csr 4.0]"
        }
      ]
    },
    {
      "id": "published-emio-edge-gamepad-for-snes-mini",
      "name": "Emio - Edge Gamepad for SNES Mini",
      "measurementName": "Emio Edge Gamepad for SNES Mini [Wired USB]",
      "deviceNorm": "emio edge gamepad for snes mini",
      "make": "Emio",
      "model": "Edge Gamepad for SNES Mini",
      "link": "https://amzn.to/3F3XRM6",
      "amazon": "",
      "buyUrl": "https://amzn.to/3F3XRM6",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Controller Adapter",
      "overallRank": 164,
      "modeRank": 30,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller Adapter",
      "faceButtons": "4",
      "weightOz": "-",
      "dateAdded": "12/16/2021",
      "dateAddedSort": "2021-12-16",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Controller Adapter",
        "SNES Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "15-20ms (Bronze)",
      "averageTier": "Copper",
      "p99Tier": "",
      "averageMs": 17.861,
      "sdMs": 3.055,
      "maxMs": 23.37,
      "minMs": 12.38,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 0,
      "observedSameFramePct": 4.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "11c0:5500",
      "searchText": "emio - edge gamepad for snes mini emio edge gamepad for snes mini emio edge gamepad for snes mini wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller controller adapter published published controller adapter 4 no - copper 15-20ms (bronze) actively sold closed source mister / pc 11c0:5500 buy link emio edge gamepad for snes mini [wired usb] emio - edge gamepad for snes mini emio edge gamepad for snes mini [wired usb] wired usb wired wired wired usb dinput dinput dinput ['controller adapter', 'snes controller'] controller adapter copper controller adapter 4 no - published published actively sold closed source emio - edge gamepad for snes mini emio edge gamepad for snes mini emio edge gamepad for snes mini wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller published published controller adapter 4 no - copper 15-20ms (bronze) actively sold closed source mister / pc 11c0:5500 buy link emio edge gamepad for snes mini [wired usb]",
      "controllerGroupKey": "published|emio edge gamepad for snes mini",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-emio-edge-gamepad-for-snes-mini",
          "name": "Emio - Edge Gamepad for SNES Mini",
          "measurementName": "Emio Edge Gamepad for SNES Mini [Wired USB]",
          "averageMs": 17.861,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 4.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Controller Adapter",
            "SNES Controller"
          ],
          "rankMode": "Controller Adapter",
          "overallRank": 300,
          "modeRank": 68,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller Adapter",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "-",
          "dateAdded": "12/16/2021",
          "dateAddedSort": "2021-12-16",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3F3XRM6",
          "link": "https://amzn.to/3F3XRM6",
          "amazon": "",
          "joystickId": "11c0:5500",
          "searchText": "emio - edge gamepad for snes mini emio edge gamepad for snes mini emio edge gamepad for snes mini wired usb wired wired usb dinput wired dinput dinput controller adapter snes controller published published controller adapter 4 no - copper 15-20ms (bronze) actively sold closed source mister / pc 11c0:5500 buy link emio edge gamepad for snes mini [wired usb]"
        }
      ]
    },
    {
      "id": "published-retrousb-nes-wireless-gamepad",
      "name": "RetroUSB - NES Wireless Gamepad",
      "measurementName": "RetroUSB - NES Wireless Gamepad [CH3]",
      "deviceNorm": "retrousb nes wireless gamepad",
      "make": "RetroUSB",
      "model": "NES Wireless Gamepad",
      "link": "https://retrousb.com/products/USB_adapter",
      "amazon": "",
      "buyUrl": "https://retrousb.com/products/USB_adapter",
      "connection": "Wireless",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "CH3",
      "outputMode": "",
      "connectionTag": "Wireless",
      "modeLabel": "CH3",
      "modeDisplay": "CH3",
      "rankMode": "Wireless Controller",
      "overallRank": 165,
      "modeRank": 23,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "15-20ms (Bronze)",
      "averageTier": "Copper",
      "p99Tier": "Copper",
      "averageMs": 18.687,
      "sdMs": 7.414,
      "maxMs": 33.12,
      "minMs": 0.01,
      "p99Ms": 31.97,
      "sampleCount": 7001,
      "sameFramePct": 0,
      "observedSameFramePct": 12.9,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "retrousb - nes wireless gamepad retrousb nes wireless gamepad retrousb nes wireless gamepad wireless wireless ch3 wireless ch3 ch3 wireless controller wireless controller published published controller copper copper 15-20ms (bronze) actively sold closed source mister / pc raw capture buy link retrousb - nes wireless gamepad [ch3] retrousb - nes wireless gamepad retrousb - nes wireless gamepad [ch3] wireless wireless wireless ch3 ch3 ch3 ['wireless controller'] wireless controller copper copper controller published published actively sold closed source retrousb - nes wireless gamepad retrousb nes wireless gamepad retrousb nes wireless gamepad wireless wireless ch3 wireless ch3 ch3 wireless controller published published controller copper copper 15-20ms (bronze) actively sold closed source mister / pc raw capture buy link retrousb - nes wireless gamepad [ch3] retrousb - nes wireless gamepad retrousb - nes wireless gamepad [ch2] wireless wireless wireless ch2 ch2 ch2 ['wireless controller'] wireless controller copper copper controller published published actively sold closed source retrousb - nes wireless gamepad retrousb nes wireless gamepad retrousb nes wireless gamepad wireless wireless ch2 wireless ch2 ch2 wireless controller published published controller copper copper 15-20ms (bronze) actively sold closed source mister / pc raw capture buy link retrousb - nes wireless gamepad [ch2] retrousb - nes wireless gamepad retrousb - nes wireless gamepad [ch1] wireless wireless wireless ch1 ch1 ch1 ['wireless controller'] wireless controller copper copper controller published published actively sold closed source retrousb - nes wireless gamepad retrousb nes wireless gamepad retrousb nes wireless gamepad wireless wireless ch1 wireless ch1 ch1 wireless controller published published controller copper copper 15-20ms (bronze) actively sold closed source mister / pc raw capture buy link retrousb - nes wireless gamepad [ch1]",
      "controllerGroupKey": "published|retrousb nes wireless gamepad",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-retrousb-nes-wireless-gamepad",
          "name": "RetroUSB - NES Wireless Gamepad",
          "measurementName": "RetroUSB - NES Wireless Gamepad [CH3]",
          "averageMs": 18.687,
          "averageTier": "Copper",
          "p99Ms": 31.97,
          "p99Tier": "Copper",
          "sameFramePct": 0,
          "observedSameFramePct": 12.9,
          "sampleCount": 7001,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless",
          "modeRaw": "CH3",
          "outputMode": "",
          "modeLabel": "CH3",
          "modeDisplay": "CH3",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 308,
          "modeRank": 77,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://retrousb.com/products/USB_adapter",
          "link": "https://retrousb.com/products/USB_adapter",
          "amazon": "",
          "joystickId": "",
          "searchText": "retrousb - nes wireless gamepad retrousb nes wireless gamepad retrousb nes wireless gamepad wireless wireless ch3 wireless ch3 ch3 wireless controller published published controller copper copper 15-20ms (bronze) actively sold closed source mister / pc raw capture buy link retrousb - nes wireless gamepad [ch3]"
        },
        {
          "id": "published-retrousb-nes-wireless-gamepad-2",
          "name": "RetroUSB - NES Wireless Gamepad",
          "measurementName": "RetroUSB - NES Wireless Gamepad [CH2]",
          "averageMs": 18.826,
          "averageTier": "Copper",
          "p99Ms": 32.11,
          "p99Tier": "Copper",
          "sameFramePct": 0,
          "observedSameFramePct": 15.6,
          "sampleCount": 2086,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless",
          "modeRaw": "CH2",
          "outputMode": "",
          "modeLabel": "CH2",
          "modeDisplay": "CH2",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 309,
          "modeRank": 78,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://retrousb.com/products/USB_adapter",
          "link": "https://retrousb.com/products/USB_adapter",
          "amazon": "",
          "joystickId": "",
          "searchText": "retrousb - nes wireless gamepad retrousb nes wireless gamepad retrousb nes wireless gamepad wireless wireless ch2 wireless ch2 ch2 wireless controller published published controller copper copper 15-20ms (bronze) actively sold closed source mister / pc raw capture buy link retrousb - nes wireless gamepad [ch2]"
        },
        {
          "id": "published-retrousb-nes-wireless-gamepad-3",
          "name": "RetroUSB - NES Wireless Gamepad",
          "measurementName": "RetroUSB - NES Wireless Gamepad [CH1]",
          "averageMs": 19.331,
          "averageTier": "Copper",
          "p99Ms": 32.31,
          "p99Tier": "Copper",
          "sameFramePct": 0,
          "observedSameFramePct": 14.5,
          "sampleCount": 3545,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wireless",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless",
          "modeRaw": "CH1",
          "outputMode": "",
          "modeLabel": "CH1",
          "modeDisplay": "CH1",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 310,
          "modeRank": 79,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://retrousb.com/products/USB_adapter",
          "link": "https://retrousb.com/products/USB_adapter",
          "amazon": "",
          "joystickId": "",
          "searchText": "retrousb - nes wireless gamepad retrousb nes wireless gamepad retrousb nes wireless gamepad wireless wireless ch1 wireless ch1 ch1 wireless controller published published controller copper copper 15-20ms (bronze) actively sold closed source mister / pc raw capture buy link retrousb - nes wireless gamepad [ch1]"
        }
      ]
    },
    {
      "id": "published-hyperkin-gn6-genesis-controller",
      "name": "Hyperkin - GN6 Genesis Controller",
      "measurementName": "Hyperkin GN6 Genesis Controller [Wired USB]",
      "deviceNorm": "hyperkin gn6 genesis controller",
      "make": "Hyperkin",
      "model": "GN6 Genesis Controller",
      "link": "https://amzn.to/33ZI8y4",
      "amazon": "",
      "buyUrl": "https://amzn.to/33ZI8y4",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 166,
      "modeRank": 71,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "2.95",
      "dateAdded": "8/14/2020",
      "dateAddedSort": "2020-08-14",
      "platforms": [],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "20ms+ (Rust)",
      "averageTier": "Copper",
      "p99Tier": "",
      "averageMs": 21.184,
      "sdMs": 11.844,
      "maxMs": 42.044,
      "minMs": 0.432,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 0,
      "observedSameFramePct": 16.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0810:e501",
      "searchText": "hyperkin - gn6 genesis controller hyperkin gn6 genesis controller hyperkin gn6 genesis controller wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 no 2.95 copper 20ms+ (rust) actively sold closed source 0810:e501 buy link hyperkin gn6 genesis controller [wired usb] hyperkin - gn6 genesis controller hyperkin gn6 genesis controller [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller copper controller 6 no 2.95 published published actively sold closed source hyperkin - gn6 genesis controller hyperkin gn6 genesis controller hyperkin gn6 genesis controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 2.95 copper 20ms+ (rust) actively sold closed source 0810:e501 buy link hyperkin gn6 genesis controller [wired usb]",
      "controllerGroupKey": "published|hyperkin gn6 genesis controller",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-hyperkin-gn6-genesis-controller",
          "name": "Hyperkin - GN6 Genesis Controller",
          "measurementName": "Hyperkin GN6 Genesis Controller [Wired USB]",
          "averageMs": 21.184,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 16.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 322,
          "modeRank": 90,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "2.95",
          "dateAdded": "8/14/2020",
          "dateAddedSort": "2020-08-14",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/33ZI8y4",
          "link": "https://amzn.to/33ZI8y4",
          "amazon": "",
          "joystickId": "0810:e501",
          "searchText": "hyperkin - gn6 genesis controller hyperkin gn6 genesis controller hyperkin gn6 genesis controller wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 2.95 copper 20ms+ (rust) actively sold closed source 0810:e501 buy link hyperkin gn6 genesis controller [wired usb]"
        }
      ]
    },
    {
      "id": "published-reyann-zero-delay-arcade-usb-encoder",
      "name": "Reyann - Zero Delay Arcade USB Encoder",
      "measurementName": "Reyann Zero Delay Arcade USB Encoder [Wired USB]",
      "deviceNorm": "reyann zero delay arcade usb encoder",
      "make": "Reyann",
      "model": "Zero Delay Arcade USB Encoder",
      "link": "https://www.amazon.com/dp/B00UUROWWK",
      "amazon": "",
      "buyUrl": "https://www.amazon.com/dp/B00UUROWWK",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 167,
      "modeRank": 18,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "5/27/2020",
      "dateAddedSort": "2020-05-27",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "20ms+ (Rust)",
      "averageTier": "Copper",
      "p99Tier": "",
      "averageMs": 21.264,
      "sdMs": 11.888,
      "maxMs": 42.22,
      "minMs": 0.196,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 0,
      "observedSameFramePct": 16.8,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0079:0006",
      "searchText": "reyann - zero delay arcade usb encoder reyann zero delay arcade usb encoder reyann zero delay arcade usb encoder wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - - - copper 20ms+ (rust) actively sold closed source mister / pc 0079:0006 buy link reyann zero delay arcade usb encoder [wired usb] reyann - zero delay arcade usb encoder reyann zero delay arcade usb encoder [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder copper arcade stick encoder - - - published published actively sold closed source reyann - zero delay arcade usb encoder reyann zero delay arcade usb encoder reyann zero delay arcade usb encoder wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - copper 20ms+ (rust) actively sold closed source mister / pc 0079:0006 buy link reyann zero delay arcade usb encoder [wired usb]",
      "controllerGroupKey": "published|reyann zero delay arcade usb encoder",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-reyann-zero-delay-arcade-usb-encoder",
          "name": "Reyann - Zero Delay Arcade USB Encoder",
          "measurementName": "Reyann Zero Delay Arcade USB Encoder [Wired USB]",
          "averageMs": 21.264,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 16.8,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 323,
          "modeRank": 22,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "5/27/2020",
          "dateAddedSort": "2020-05-27",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.amazon.com/dp/B00UUROWWK",
          "link": "https://www.amazon.com/dp/B00UUROWWK",
          "amazon": "",
          "joystickId": "0079:0006",
          "searchText": "reyann - zero delay arcade usb encoder reyann zero delay arcade usb encoder reyann zero delay arcade usb encoder wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - copper 20ms+ (rust) actively sold closed source mister / pc 0079:0006 buy link reyann zero delay arcade usb encoder [wired usb]"
        }
      ]
    },
    {
      "id": "published-tata-kiwitata",
      "name": "Tata - Kiwitata",
      "measurementName": "Tata Kiwitata [Wired USB]",
      "deviceNorm": "tata kiwitata",
      "make": "Tata",
      "model": "Kiwitata",
      "link": "https://amzn.to/3dLmLSk",
      "amazon": "",
      "buyUrl": "https://amzn.to/3dLmLSk",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 168,
      "modeRank": 72,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "3.35",
      "dateAdded": "6/30/2020",
      "dateAddedSort": "2020-06-30",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "20ms+ (Rust)",
      "averageTier": "Copper",
      "p99Tier": "",
      "averageMs": 21.348,
      "sdMs": 11.879,
      "maxMs": 4.236,
      "minMs": 0.372,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 0,
      "observedSameFramePct": 16.6,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "0810:e501",
      "searchText": "tata - kiwitata tata kiwitata tata kiwitata wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no 3.35 copper 20ms+ (rust) actively sold closed source mister / pc 0810:e501 buy link tata kiwitata [wired usb] tata - kiwitata tata kiwitata [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller copper controller 4 no 3.35 published published actively sold closed source tata - kiwitata tata kiwitata tata kiwitata wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.35 copper 20ms+ (rust) actively sold closed source mister / pc 0810:e501 buy link tata kiwitata [wired usb]",
      "controllerGroupKey": "published|tata kiwitata",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-tata-kiwitata",
          "name": "Tata - Kiwitata",
          "measurementName": "Tata Kiwitata [Wired USB]",
          "averageMs": 21.348,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 16.6,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 324,
          "modeRank": 91,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "3.35",
          "dateAdded": "6/30/2020",
          "dateAddedSort": "2020-06-30",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3dLmLSk",
          "link": "https://amzn.to/3dLmLSk",
          "amazon": "",
          "joystickId": "0810:e501",
          "searchText": "tata - kiwitata tata kiwitata tata kiwitata wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no 3.35 copper 20ms+ (rust) actively sold closed source mister / pc 0810:e501 buy link tata kiwitata [wired usb]"
        }
      ]
    },
    {
      "id": "published-hyperkin-admiral-premium-wireless",
      "name": "Hyperkin - Admiral Premium Wireless",
      "measurementName": "Hyperkin - Admiral Premium Wireless [BT]",
      "deviceNorm": "hyperkin admiral premium wireless",
      "make": "Hyperkin",
      "model": "Admiral Premium Wireless",
      "link": "https://amzn.to/4eydijE",
      "amazon": "",
      "buyUrl": "https://amzn.to/4eydijE",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT",
      "outputMode": "",
      "connectionTag": "Wireless BT",
      "modeLabel": "Bluetooth",
      "modeDisplay": "Bluetooth",
      "rankMode": "Wireless Controller",
      "overallRank": 169,
      "modeRank": 24,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "20ms+ (Rust)",
      "averageTier": "Copper",
      "p99Tier": "Copper",
      "averageMs": 22.148,
      "sdMs": 7.854,
      "maxMs": 32.85,
      "minMs": 0.3,
      "p99Ms": 32.01,
      "sampleCount": 3041,
      "sameFramePct": 0,
      "observedSameFramePct": 10.2,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "hyperkin - admiral premium wireless hyperkin admiral premium wireless hyperkin admiral premium wireless bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller wireless controller published published controller 6 copper copper 20ms+ (rust) actively sold closed source mister / pc raw capture buy link hyperkin - admiral premium wireless [bt] hyperkin - admiral premium wireless hyperkin - admiral premium wireless [bt] bluetooth wireless wireless bt bt bluetooth bluetooth ['wireless controller'] wireless controller copper copper controller 6 published published actively sold closed source hyperkin - admiral premium wireless hyperkin admiral premium wireless hyperkin admiral premium wireless bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller published published controller 6 copper copper 20ms+ (rust) actively sold closed source mister / pc raw capture buy link hyperkin - admiral premium wireless [bt]",
      "controllerGroupKey": "published|hyperkin admiral premium wireless",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-hyperkin-admiral-premium-wireless",
          "name": "Hyperkin - Admiral Premium Wireless",
          "measurementName": "Hyperkin - Admiral Premium Wireless [BT]",
          "averageMs": 22.148,
          "averageTier": "Copper",
          "p99Ms": 32.01,
          "p99Tier": "Copper",
          "sameFramePct": 0,
          "observedSameFramePct": 10.2,
          "sampleCount": 3041,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 326,
          "modeRank": 90,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/4eydijE",
          "link": "https://amzn.to/4eydijE",
          "amazon": "",
          "joystickId": "",
          "searchText": "hyperkin - admiral premium wireless hyperkin admiral premium wireless hyperkin admiral premium wireless bluetooth wireless bt wireless bt bluetooth bluetooth wireless controller published published controller 6 copper copper 20ms+ (rust) actively sold closed source mister / pc raw capture buy link hyperkin - admiral premium wireless [bt]"
        }
      ]
    },
    {
      "id": "published-behar-bros-hayabusa-supergun",
      "name": "Behar Bros - Hayabusa Supergun",
      "measurementName": "Behar Bros Hayabusa Supergun [PSX - Hayabusa - MiSTercade]",
      "deviceNorm": "behar bros hayabusa supergun",
      "make": "Behar Bros",
      "model": "Hayabusa Supergun",
      "link": "https://www.beharbros.com/product-page/hayabusa",
      "amazon": "",
      "buyUrl": "https://www.beharbros.com/product-page/hayabusa",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "PSX - Hayabusa - MiSTercade",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Supergun",
      "overallRank": 170,
      "modeRank": 1,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Supergun",
      "faceButtons": "-",
      "weightOz": "",
      "dateAdded": "10/15/2022",
      "dateAddedSort": "2022-10-15",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Supergun"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "20ms+ (Rust)",
      "averageTier": "Copper",
      "p99Tier": "",
      "averageMs": 24.14,
      "sdMs": 7.159,
      "maxMs": 32.92,
      "minMs": 0.02,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 0,
      "observedSameFramePct": 3.3,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "behar bros - hayabusa supergun behar bros hayabusa supergun behar bros hayabusa supergun wired usb wired psx - hayabusa - mistercade dinput wired dinput dinput supergun supergun published published supergun - - copper 20ms+ (rust) actively sold closed source mister / pc buy link behar bros hayabusa supergun [psx - hayabusa - mistercade] behar bros - hayabusa supergun behar bros hayabusa supergun [psx - hayabusa - mistercade] wired usb wired wired psx - hayabusa - mistercade dinput dinput dinput ['supergun'] supergun copper supergun - - published published actively sold closed source behar bros - hayabusa supergun behar bros hayabusa supergun behar bros hayabusa supergun wired usb wired psx - hayabusa - mistercade dinput wired dinput dinput supergun published published supergun - - copper 20ms+ (rust) actively sold closed source mister / pc buy link behar bros hayabusa supergun [psx - hayabusa - mistercade]",
      "controllerGroupKey": "published|behar bros hayabusa supergun",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-behar-bros-hayabusa-supergun",
          "name": "Behar Bros - Hayabusa Supergun",
          "measurementName": "Behar Bros Hayabusa Supergun [PSX - Hayabusa - MiSTercade]",
          "averageMs": 24.14,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 3.3,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "PSX - Hayabusa - MiSTercade",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Supergun"
          ],
          "rankMode": "Supergun",
          "overallRank": 328,
          "modeRank": 1,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Supergun",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "",
          "dateAdded": "10/15/2022",
          "dateAddedSort": "2022-10-15",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://www.beharbros.com/product-page/hayabusa",
          "link": "https://www.beharbros.com/product-page/hayabusa",
          "amazon": "",
          "joystickId": "",
          "searchText": "behar bros - hayabusa supergun behar bros hayabusa supergun behar bros hayabusa supergun wired usb wired psx - hayabusa - mistercade dinput wired dinput dinput supergun published published supergun - - copper 20ms+ (rust) actively sold closed source mister / pc buy link behar bros hayabusa supergun [psx - hayabusa - mistercade]"
        }
      ]
    },
    {
      "id": "published-asd-jammasd",
      "name": "ASD - JammASD",
      "measurementName": "ASD JammASD [Wired USB]",
      "deviceNorm": "asd jammasd",
      "make": "ASD",
      "model": "JammASD",
      "link": "http://www.arcadeshop.de/product_info.php?products_id=829&language=en",
      "amazon": "",
      "buyUrl": "http://www.arcadeshop.de/product_info.php?products_id=829&language=en",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Arcade Stick Encoder",
      "overallRank": 171,
      "modeRank": 19,
      "homeButton": "-",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Arcade Stick Encoder",
      "faceButtons": "-",
      "weightOz": "-",
      "dateAdded": "6/16/2020",
      "dateAddedSort": "2020-06-16",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Arcade Stick Encoder"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "20ms+ (Rust)",
      "averageTier": "Copper",
      "p99Tier": "",
      "averageMs": 25.303,
      "sdMs": 2.601,
      "maxMs": 35.164,
      "minMs": 17.532,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 0,
      "observedSameFramePct": 0.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "04da:f3ad",
      "searchText": "asd - jammasd asd jammasd asd jammasd wired usb wired wired usb dinput wired dinput dinput arcade stick encoder arcade stick encoder published published arcade stick encoder - - - copper 20ms+ (rust) actively sold closed source mister / pc 04da:f3ad buy link asd jammasd [wired usb] asd - jammasd asd jammasd [wired usb] wired usb wired wired wired usb dinput dinput dinput ['arcade stick encoder'] arcade stick encoder copper arcade stick encoder - - - published published actively sold closed source asd - jammasd asd jammasd asd jammasd wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - copper 20ms+ (rust) actively sold closed source mister / pc 04da:f3ad buy link asd jammasd [wired usb]",
      "controllerGroupKey": "published|asd jammasd",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-asd-jammasd",
          "name": "ASD - JammASD",
          "measurementName": "ASD JammASD [Wired USB]",
          "averageMs": 25.303,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 0.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Arcade Stick Encoder"
          ],
          "rankMode": "Arcade Stick Encoder",
          "overallRank": 329,
          "modeRank": 23,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Arcade Stick Encoder",
          "faceButtons": "-",
          "homeButton": "-",
          "weightOz": "-",
          "dateAdded": "6/16/2020",
          "dateAddedSort": "2020-06-16",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "http://www.arcadeshop.de/product_info.php?products_id=829&language=en",
          "link": "http://www.arcadeshop.de/product_info.php?products_id=829&language=en",
          "amazon": "",
          "joystickId": "04da:f3ad",
          "searchText": "asd - jammasd asd jammasd asd jammasd wired usb wired wired usb dinput wired dinput dinput arcade stick encoder published published arcade stick encoder - - - copper 20ms+ (rust) actively sold closed source mister / pc 04da:f3ad buy link asd jammasd [wired usb]"
        }
      ]
    },
    {
      "id": "published-hori-fighting-commander-wii-classic",
      "name": "Hori - Fighting Commander Wii Classic",
      "measurementName": "Hori - Fighting Commander Wii Classic [Mayflash]",
      "deviceNorm": "hori fighting commander wii classic",
      "make": "Hori",
      "model": "Fighting Commander Wii Classic",
      "link": "https://amzn.to/3GxaUco",
      "amazon": "",
      "buyUrl": "https://amzn.to/3GxaUco",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Mayflash",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 172,
      "modeRank": 73,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "8/8/2021",
      "dateAddedSort": "2021-08-08",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "20ms+ (Rust)",
      "averageTier": "Copper",
      "p99Tier": "Rust",
      "averageMs": 29.248,
      "sdMs": 21.343,
      "maxMs": 103.67,
      "minMs": 6.06,
      "p99Ms": 83.285,
      "sampleCount": 2350,
      "sameFramePct": 0,
      "observedSameFramePct": 3.8,
      "sameFrameSource": "Adapter adjusted average-implied",
      "hasRawCapture": true,
      "metricSource": "Raw capture, adapter adjusted",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "-",
      "searchText": "hori - fighting commander wii classic hori fighting commander wii classic hori fighting commander wii classic wired usb wired mayflash dinput wired dinput dinput wired controller wired controller published published controller copper rust 20ms+ (rust) dinput actively sold closed source mister / pc - raw capture buy link hori - fighting commander wii classic [mayflash] hori - fighting commander wii classic hori - fighting commander wii classic [mayflash] wired usb wired wired mayflash dinput dinput dinput ['wired controller'] wired controller copper rust controller published published actively sold closed source hori - fighting commander wii classic hori fighting commander wii classic hori fighting commander wii classic wired usb wired mayflash dinput wired dinput dinput wired controller published published controller copper rust 20ms+ (rust) dinput actively sold closed source mister / pc raw capture buy link hori - fighting commander wii classic [mayflash]",
      "measuredAverageMs": 34.115,
      "adapterAverageMs": 4.867,
      "adapterMode": "DInput",
      "adapterSourceName": "Mayflash - Wii Classic to USB",
      "controllerGroupKey": "published|hori fighting commander wii classic",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-hori-fighting-commander-wii-classic",
          "name": "Hori - Fighting Commander Wii Classic",
          "measurementName": "Hori - Fighting Commander Wii Classic [Mayflash]",
          "averageMs": 29.248,
          "averageTier": "Copper",
          "p99Ms": 83.285,
          "p99Tier": "Rust",
          "sameFramePct": 0,
          "observedSameFramePct": 3.8,
          "sampleCount": 2350,
          "measuredAverageMs": 34.115,
          "adapterAverageMs": 4.867,
          "adapterMode": "DInput",
          "adapterSourceName": "Mayflash - Wii Classic to USB",
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Mayflash",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 331,
          "modeRank": 92,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "8/8/2021",
          "dateAddedSort": "2021-08-08",
          "hasRawCapture": true,
          "metricSource": "Raw capture, adapter adjusted",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/3GxaUco",
          "link": "https://amzn.to/3GxaUco",
          "amazon": "",
          "joystickId": "-",
          "searchText": "hori - fighting commander wii classic hori fighting commander wii classic hori fighting commander wii classic wired usb wired mayflash dinput wired dinput dinput wired controller published published controller copper rust 20ms+ (rust) dinput actively sold closed source mister / pc raw capture buy link hori - fighting commander wii classic [mayflash]"
        }
      ]
    },
    {
      "id": "published-logitech-dual-action-gamepad-usb",
      "name": "Logitech - Dual Action Gamepad USB",
      "measurementName": "Logitech Dual Action Gamepad USB [Wired USB]",
      "deviceNorm": "logitech dual action gamepad usb",
      "make": "Logitech",
      "model": "Dual Action Gamepad USB",
      "link": "https://amzn.to/2C2s5n7",
      "amazon": "",
      "buyUrl": "https://amzn.to/2C2s5n7",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 173,
      "modeRank": 74,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "",
      "dateAdded": "6/11/2020",
      "dateAddedSort": "2020-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "20ms+ (Rust)",
      "averageTier": "Copper",
      "p99Tier": "",
      "averageMs": 32.187,
      "sdMs": 6.102,
      "maxMs": 43.084,
      "minMs": 21.284,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 0,
      "observedSameFramePct": 10.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "046d:c216",
      "searchText": "logitech - dual action gamepad usb logitech dual action gamepad usb logitech dual action gamepad usb wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 4 no copper 20ms+ (rust) actively sold closed source mister / pc 046d:c216 buy link logitech dual action gamepad usb [wired usb] logitech - dual action gamepad usb logitech dual action gamepad usb [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller copper controller 4 no published published actively sold closed source logitech - dual action gamepad usb logitech dual action gamepad usb logitech dual action gamepad usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no copper 20ms+ (rust) actively sold closed source mister / pc 046d:c216 buy link logitech dual action gamepad usb [wired usb]",
      "controllerGroupKey": "published|logitech dual action gamepad usb",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-logitech-dual-action-gamepad-usb",
          "name": "Logitech - Dual Action Gamepad USB",
          "measurementName": "Logitech Dual Action Gamepad USB [Wired USB]",
          "averageMs": 32.187,
          "averageTier": "Copper",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 10.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 335,
          "modeRank": 93,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "No",
          "weightOz": "",
          "dateAdded": "6/11/2020",
          "dateAddedSort": "2020-06-11",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2C2s5n7",
          "link": "https://amzn.to/2C2s5n7",
          "amazon": "",
          "joystickId": "046d:c216",
          "searchText": "logitech - dual action gamepad usb logitech dual action gamepad usb logitech dual action gamepad usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 4 no copper 20ms+ (rust) actively sold closed source mister / pc 046d:c216 buy link logitech dual action gamepad usb [wired usb]"
        }
      ]
    },
    {
      "id": "published-nintendo-wii-u-pro",
      "name": "Nintendo - Wii U Pro",
      "measurementName": "Nintendo Wii U Pro [BT (CSR8510)]",
      "deviceNorm": "nintendo wii u pro",
      "make": "Nintendo",
      "model": "Wii U Pro",
      "link": "https://amzn.to/2WZcH2N",
      "amazon": "",
      "buyUrl": "https://amzn.to/2WZcH2N",
      "connection": "Bluetooth",
      "connectionKind": "Wireless",
      "wirelessConnection": "",
      "modeRaw": "BT (CSR8510)",
      "outputMode": "",
      "connectionTag": "Wireless BT",
      "modeLabel": "Bluetooth",
      "modeDisplay": "Bluetooth",
      "rankMode": "Wireless Controller",
      "overallRank": 174,
      "modeRank": 25,
      "homeButton": "Yes",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "4",
      "weightOz": "7.25",
      "dateAdded": "5/25/2020",
      "dateAddedSort": "2020-05-25",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wireless Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "20ms+ (Rust)",
      "averageTier": "Rust",
      "p99Tier": "",
      "averageMs": 35.276,
      "sdMs": 2.909,
      "maxMs": 49.328,
      "minMs": 27.584,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 0,
      "observedSameFramePct": 0.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Actively sold",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "057e:0330",
      "searchText": "nintendo - wii u pro nintendo wii u pro nintendo wii u pro bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller wireless controller published published controller 4 yes 7.25 rust 20ms+ (rust) actively sold closed source mister / pc 057e:0330 buy link nintendo wii u pro [bt (csr8510)] nintendo - wii u pro nintendo wii u pro [bt (csr8510)] bluetooth wireless wireless bt bt (csr8510) bluetooth bluetooth ['wireless controller'] wireless controller rust controller 4 yes 7.25 published published actively sold closed source nintendo - wii u pro nintendo wii u pro nintendo wii u pro bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 7.25 rust 20ms+ (rust) actively sold closed source mister / pc 057e:0330 buy link nintendo wii u pro [bt (csr8510)] nintendo - wii u pro nintendo wii u pro [8bitdo usb adapter x-input] bluetooth wireless wireless bt 8bitdo usb adapter x-input dinput, xinput dinput, xinput dinput, xinput ['wireless controller'] wireless controller rust controller 4 yes 7.25 published published actively sold closed source nintendo - wii u pro nintendo wii u pro nintendo wii u pro bluetooth wireless 8bitdo usb adapter x-input dinput, xinput wireless bt dinput, xinput dinput, xinput wireless controller published published controller 4 yes 7.25 rust 20ms+ (rust) actively sold closed source mister / pc 045e:028e buy link nintendo wii u pro [8bitdo usb adapter x-input] nintendo - wii u pro nintendo wii u pro [8bitdo usb adapter dinput] bluetooth wireless wireless bt 8bitdo usb adapter dinput dinput dinput dinput ['wireless controller'] wireless controller rust controller 4 yes 7.25 published published actively sold closed source nintendo - wii u pro nintendo wii u pro nintendo wii u pro bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 yes 7.25 rust 20ms+ (rust) actively sold closed source mister / pc 02dc8:3100 buy link nintendo wii u pro [8bitdo usb adapter dinput]",
      "controllerGroupKey": "published|nintendo wii u pro",
      "modeVariantCount": 3,
      "modeVariants": [
        {
          "id": "published-nintendo-wii-u-pro",
          "name": "Nintendo - Wii U Pro",
          "measurementName": "Nintendo Wii U Pro [BT (CSR8510)]",
          "averageMs": 35.276,
          "averageTier": "Rust",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 0.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "BT (CSR8510)",
          "outputMode": "",
          "modeLabel": "Bluetooth",
          "modeDisplay": "Bluetooth",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 337,
          "modeRank": 97,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "7.25",
          "dateAdded": "5/25/2020",
          "dateAddedSort": "2020-05-25",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2WZcH2N",
          "link": "https://amzn.to/2WZcH2N",
          "amazon": "",
          "joystickId": "057e:0330",
          "searchText": "nintendo - wii u pro nintendo wii u pro nintendo wii u pro bluetooth wireless bt (csr8510) wireless bt bluetooth bluetooth wireless controller published published controller 4 yes 7.25 rust 20ms+ (rust) actively sold closed source mister / pc 057e:0330 buy link nintendo wii u pro [bt (csr8510)]"
        },
        {
          "id": "published-nintendo-wii-u-pro-2",
          "name": "Nintendo - Wii U Pro",
          "measurementName": "Nintendo Wii U Pro [8BitDo USB Adapter X-Input]",
          "averageMs": 35.62,
          "averageTier": "Rust",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 0.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter X-Input",
          "outputMode": "DInput, XInput",
          "modeLabel": "DInput, XInput",
          "modeDisplay": "DInput, XInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 338,
          "modeRank": 98,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "7.25",
          "dateAdded": "6/6/2020",
          "dateAddedSort": "2020-06-06",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2WZcH2N",
          "link": "https://amzn.to/2WZcH2N",
          "amazon": "",
          "joystickId": "045e:028e",
          "searchText": "nintendo - wii u pro nintendo wii u pro nintendo wii u pro bluetooth wireless 8bitdo usb adapter x-input dinput, xinput wireless bt dinput, xinput dinput, xinput wireless controller published published controller 4 yes 7.25 rust 20ms+ (rust) actively sold closed source mister / pc 045e:028e buy link nintendo wii u pro [8bitdo usb adapter x-input]"
        },
        {
          "id": "published-nintendo-wii-u-pro-3",
          "name": "Nintendo - Wii U Pro",
          "measurementName": "Nintendo Wii U Pro [8BitDo USB Adapter Dinput]",
          "averageMs": 35.783,
          "averageTier": "Rust",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 0.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Bluetooth",
          "connectionKind": "Wireless",
          "wirelessConnection": "",
          "connectionTag": "Wireless BT",
          "modeRaw": "8BitDo USB Adapter Dinput",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wireless Controller"
          ],
          "rankMode": "Wireless Controller",
          "overallRank": 339,
          "modeRank": 99,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "4",
          "homeButton": "Yes",
          "weightOz": "7.25",
          "dateAdded": "6/6/2020",
          "dateAddedSort": "2020-06-06",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Actively sold",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "https://amzn.to/2WZcH2N",
          "link": "https://amzn.to/2WZcH2N",
          "amazon": "",
          "joystickId": "02dc8:3100",
          "searchText": "nintendo - wii u pro nintendo wii u pro nintendo wii u pro bluetooth wireless 8bitdo usb adapter dinput dinput wireless bt dinput dinput wireless controller published published controller 4 yes 7.25 rust 20ms+ (rust) actively sold closed source mister / pc 02dc8:3100 buy link nintendo wii u pro [8bitdo usb adapter dinput]"
        }
      ]
    },
    {
      "id": "published-microsoft-gamepad",
      "name": "Microsoft - Gamepad",
      "measurementName": "Microsoft - Gamepad",
      "deviceNorm": "microsoft gamepad",
      "make": "Microsoft",
      "model": "Gamepad",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 175,
      "modeRank": 75,
      "homeButton": "",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "",
      "weightOz": "",
      "dateAdded": "6/11/2026",
      "dateAddedSort": "2026-06-11",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "20ms+ (Rust)",
      "averageTier": "Rust",
      "p99Tier": "Rust",
      "averageMs": 40.709,
      "sdMs": 1.217,
      "maxMs": 43.26,
      "minMs": 38.18,
      "p99Ms": 42.974,
      "sampleCount": 56664,
      "sameFramePct": 0,
      "observedSameFramePct": 0.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": true,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "",
      "searchText": "microsoft - gamepad microsoft gamepad microsoft gamepad wired usb wired dinput wired dinput dinput wired controller wired controller published published controller rust rust 20ms+ (rust) unknown closed source mister / pc raw capture microsoft - gamepad microsoft - gamepad microsoft - gamepad wired usb wired wired dinput dinput dinput ['wired controller'] wired controller rust rust controller published published unknown closed source microsoft - gamepad microsoft gamepad microsoft gamepad wired usb wired dinput wired dinput dinput wired controller published published controller rust rust 20ms+ (rust) unknown closed source mister / pc raw capture microsoft - gamepad",
      "controllerGroupKey": "published|microsoft gamepad",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-microsoft-gamepad",
          "name": "Microsoft - Gamepad",
          "measurementName": "Microsoft - Gamepad",
          "averageMs": 40.709,
          "averageTier": "Rust",
          "p99Ms": 42.974,
          "p99Tier": "Rust",
          "sameFramePct": 0,
          "observedSameFramePct": 0.0,
          "sampleCount": 56664,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 340,
          "modeRank": 94,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "",
          "homeButton": "",
          "weightOz": "",
          "dateAdded": "6/11/2026",
          "dateAddedSort": "2026-06-11",
          "hasRawCapture": true,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "",
          "searchText": "microsoft - gamepad microsoft gamepad microsoft gamepad wired usb wired dinput wired dinput dinput wired controller published published controller rust rust 20ms+ (rust) unknown closed source mister / pc raw capture microsoft - gamepad"
        }
      ]
    },
    {
      "id": "published-microsoft-sidewinder-game-pad-usb",
      "name": "Microsoft - SideWinder Game Pad USB",
      "measurementName": "Microsoft SideWinder Game Pad USB [Wired USB]",
      "deviceNorm": "microsoft sidewinder game pad usb",
      "make": "Microsoft",
      "model": "SideWinder Game Pad USB",
      "link": "",
      "amazon": "",
      "buyUrl": "",
      "connection": "Wired USB",
      "connectionKind": "Wired",
      "wirelessConnection": "",
      "modeRaw": "Wired USB",
      "outputMode": "DInput",
      "connectionTag": "Wired",
      "modeLabel": "DInput",
      "modeDisplay": "DInput",
      "rankMode": "Wired Controller",
      "overallRank": 176,
      "modeRank": 76,
      "homeButton": "No",
      "resultType": "published",
      "resultLabel": "Published",
      "category": "Controller",
      "faceButtons": "6",
      "weightOz": "5.30",
      "dateAdded": "8/8/2021",
      "dateAddedSort": "2021-08-08",
      "platforms": [
        "MiSTer / PC"
      ],
      "deviceTypes": [
        "Wired Controller"
      ],
      "price": "",
      "priceNum": null,
      "sheetTier": "20ms+ (Rust)",
      "averageTier": "Rust",
      "p99Tier": "",
      "averageMs": 40.709,
      "sdMs": 1.217,
      "maxMs": 43.26,
      "minMs": 38.18,
      "p99Ms": null,
      "sampleCount": null,
      "sameFramePct": 0,
      "observedSameFramePct": 0.0,
      "sameFrameSource": "Average-implied",
      "hasRawCapture": false,
      "metricSource": "Direct measurement",
      "notes": "",
      "tester": "",
      "originalSystem": "",
      "saleStatus": "Unknown",
      "sourceStatus": "Closed Source",
      "isOpenSource": false,
      "sourceUrl": "",
      "joystickId": "045e:0007",
      "searchText": "microsoft - sidewinder game pad usb microsoft sidewinder game pad usb microsoft sidewinder game pad usb wired usb wired wired usb dinput wired dinput dinput wired controller wired controller published published controller 6 no 5.30 rust 20ms+ (rust) unknown closed source mister / pc 045e:0007 microsoft sidewinder game pad usb [wired usb] microsoft - sidewinder game pad usb microsoft sidewinder game pad usb [wired usb] wired usb wired wired wired usb dinput dinput dinput ['wired controller'] wired controller rust controller 6 no 5.30 published published unknown closed source microsoft - sidewinder game pad usb microsoft sidewinder game pad usb microsoft sidewinder game pad usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 5.30 rust 20ms+ (rust) unknown closed source mister / pc 045e:0007 microsoft sidewinder game pad usb [wired usb]",
      "controllerGroupKey": "published|microsoft sidewinder game pad usb",
      "modeVariantCount": 1,
      "modeVariants": [
        {
          "id": "published-microsoft-sidewinder-game-pad-usb",
          "name": "Microsoft - SideWinder Game Pad USB",
          "measurementName": "Microsoft SideWinder Game Pad USB [Wired USB]",
          "averageMs": 40.709,
          "averageTier": "Rust",
          "p99Ms": null,
          "p99Tier": "",
          "sameFramePct": 0,
          "observedSameFramePct": 0.0,
          "sampleCount": null,
          "measuredAverageMs": null,
          "adapterAverageMs": null,
          "adapterMode": null,
          "adapterSourceName": null,
          "connection": "Wired USB",
          "connectionKind": "Wired",
          "wirelessConnection": "",
          "connectionTag": "Wired",
          "modeRaw": "Wired USB",
          "outputMode": "DInput",
          "modeLabel": "DInput",
          "modeDisplay": "DInput",
          "deviceTypes": [
            "Wired Controller"
          ],
          "rankMode": "Wired Controller",
          "overallRank": 341,
          "modeRank": 95,
          "resultType": "published",
          "resultLabel": "Published",
          "category": "Controller",
          "faceButtons": "6",
          "homeButton": "No",
          "weightOz": "5.30",
          "dateAdded": "8/8/2021",
          "dateAddedSort": "2021-08-08",
          "hasRawCapture": false,
          "metricSource": "Direct measurement",
          "notes": "",
          "tester": "",
          "originalSystem": "",
          "saleStatus": "Unknown",
          "sourceStatus": "Closed Source",
          "isOpenSource": false,
          "sourceUrl": "",
          "buyUrl": "",
          "link": "",
          "amazon": "",
          "joystickId": "045e:0007",
          "searchText": "microsoft - sidewinder game pad usb microsoft sidewinder game pad usb microsoft sidewinder game pad usb wired usb wired wired usb dinput wired dinput dinput wired controller published published controller 6 no 5.30 rust 20ms+ (rust) unknown closed source mister / pc 045e:0007 microsoft sidewinder game pad usb [wired usb]"
        }
      ]
    }
  ]
};
